app.util = {};
app.sub = {};
app.util.remapCurrency = utils.remapCurrency;

app.util.triggerFldValidation = function (fldName, eventType) {
    var $elm, evt = {
        'click'  : 1,
        'change' : 1,
        'blur'   : 1
    };
    if (fldName && _.isString(fldName)) {
        $elm = $('#' + fldName);
        if ($elm.length) {
            if (evt[eventType]) {
                return $elm.trigger(eventType);
            } else {
                return app.util.validateField(fldName, $elm.val(), '', (eventType || 'custom'));
            }
        }
    }
};

app.util.normalizeValidationParamsObject = function(param, validatorKey){
    var params = $.extend(true, {}, param);
    params.formatter = app.formatter;
    params.message = app.msg[params.msgKey] || params.msgKey || '';
    params.roundingScale = app.roundingScale;
    params.currencyIso = app.lastSelectedCurrency;
    params.dccCurrencyIso = app.config.useDcc && (app.util.getDccSelectedCurrencyIso() || params.currencyIso);
    params.currency = app.util.remapCurrency(params.dccCurrencyIso || params.currencyIso); // <obsolete/> use params.formatter
    params.country = app.config.country;
    _.each(app.CONSTANTS.VALIDATE_FIELD_ALTERNATIVE_MESSAGE_KEYS, function (key) {
        if (params.hasOwnProperty(key)) {
            params[key.replace('Key', '')] = app.msg[params[key]] || params[key] || '';
        }
    });
    if (validatorKey === 'testCVV2') {
        params.alt_message = app.msg[params.unknownCCMsgKey];
        params.cc_type = getCurrentCardType();
    } else if ('isCardAcceptable' === validatorKey || 'isValidCardNumber' === validatorKey || 'isCurrencySupportedByTheCard' === validatorKey) {
        var cc_card = getCurrentCardType(true);
        params.cardInfo = cc_card;
        params.cc_brand = cc_card.is_dual_brand ? app.lastCardDetected : cc_card.master_brand;
        params.cc_brand_label = (app.msg[params.cc_brand] || "This");
        params.invalidCardIssuers = app.config.invalidCardIssuers;
        params.cardSupportedCurrencies = app.config.cardSupportedCurrencies;
        params.allowedCardCountries = app.config.allowedCardCountries;
        if (app.CONSTANTS.ACCEPTED_CC_BY_PM[app.lastSelectedMethodType.toUpperCase()]) {
            params.slave_cc_brand = cc_card.slave_brand || cc_card.master_brand;
            params.slave_cc_brand_label = (app.msg[params.slave_cc_brand] || "This");
            params.validCardIssuers = app.CONSTANTS.ACCEPTED_CC_BY_PM[app.lastSelectedMethodType.toUpperCase()];
        }
        params.isAstropayPrePaid = ("apmgw_AstropayPrePaid" === app.lastSelectedMethodType);
    }
    return params;
};

app.util.onValidationResult = function (fld, isValid, message, validatorKey, skipValidIndicator) {
    var indicator = $('#' + fld + '_validation');
    var fieldName = $('#' + fld).attr('placeholder');
    var parentRow = indicator.closest('.row');
    if (isValid && app._validationResult[fld]) {
        delete app._validationResult[fld];
    } else if (!isValid) {
        app._validationResult[fld] = {message: message, validatorKey: validatorKey};
    }
    if (app.popupValidation) {
        if (!app._popupValidation.hasError && !isValid) {
            app._popupValidation.hasError = 1;
            var _data = {
                text: message,
                field: fieldName || fld
            };
            app.showModalMessage({message: _data}, app.CONSTANTS.MODAL_MESSAGE_TYPE.VALIDATION_BOX, function () {
                app._popupValidation.hasError = 0;
            });
        }
    } else {
        if (isValid) {
            indicator.empty();
            indicator.removeClass('invalid_field');
            parentRow.removeClass('invalid');
            if (!skipValidIndicator) {
                indicator.addClass('valid_field');
                parentRow.addClass('valid');
            }
        } else {
            indicator.empty().append('<label data-for="' + fld + '" class="error">' + message + '</label>');
            indicator.removeClass('valid_field').addClass('invalid_field');
            parentRow.removeClass('valid').addClass('invalid');
        }
        app.util.applyScrollablePlugin();
    }
};

app.util.validateField = function (field, value, data, eventType, omitValidationMsgs) {
    if (_.has(app.validators, field)) {
        var checkPassed;
        var suffix = '';
        var value_trimmed = (field === "expiration_period") ? value : (value || '').trim();
        var fldDetail = app.currentMethodFields && app.currentMethodFields[field] || {};
        if (app._isOptionalField[field] || fldDetail.type === 'OPTIONAL' || fldDetail.visibilityMode === 'OPTIONAL') {
            suffix = '_opt';
        }
        if (fldDetail.isTmpDisabled) {
            suffix += '_dsbl';
        }
        if (suffix && !value_trimmed) {
            app.util.onValidationResult(field, true, '', null, (field === 'promoCode'));
            checkPassed = true;
        } else {
            var checks = app.validators[field].checks;
            checkPassed = _.every(checks, function (param, validatorKey) {
                var params, isValid = true;
                if (_.has(utils.checks, validatorKey)) {
                    params = app.util.normalizeValidationParamsObject(param, validatorKey);
                    isValid = utils.checks[validatorKey](value, params, data);
                    if (!omitValidationMsgs) {
                        app.util.onValidationResult(field, isValid, params.message, validatorKey);
                    }
                    if (!isValid) {
                        if (field === 'item_amount_1' && value) {
                            var limit = (parseFloat(value) < parseFloat(params.min)) ? 'under' : 'over';
                            pubsub.publish('app.event.amountNotInRange', [field, limit, eventType]);
                        }
                        pubsub.publish('app.event.fieldBlurFail', [field + suffix, validatorKey, eventType]);
                    }
                }
                if (!omitValidationMsgs) {
                    app.util.onValidationResult(field, isValid, (params && params.message || ''), validatorKey);
                }
                return isValid;
            });
        }
        if (checkPassed) {
            pubsub.publish('app.event.fieldBlurSuccess', [field + suffix, eventType, value]);
        }
        return checkPassed;
    } else {
        //console.warn('Validation for', field, 'is missing. Assuming it is valid');
        app.util.onValidationResult(field, true, '', '');
    }
    return true;
};

app.util.validateEvery = function (fld_arr, eventType) {
    var isValid = true;
    _.each(fld_arr, function (fldName) {
        isValid = app.util.triggerFldValidation(fldName, (eventType || 'custom')) && isValid;
    });
    return isValid;
};

app.util.attachFieldValidation = function (fldName) {
    if (app.popupValidation || !fldName || app.util.isDateField(fldName)) {
        return;
    }
    var inputElm = $('#' + fldName);
    if (inputElm.length) {
        if (inputElm.is(":checkbox") || inputElm[0].tagName === 'SELECT') {
             var fldType = inputElm[0].tagName === 'SELECT' ? "SELECT" : "CHECKBOX";
            inputElm.on('change', function (ev) {
                var isValid = app.util.validateField(this.id, this.value, null, ev.type);
                app.util.onFieldBlur(isValid, this.id, this.value, fldType);
            });
        } else {
            var lastValue;
			var lastBlurTime = 0;
			var ghostBlurElapsedTime = fldName === "cc_card_number" ? 500 : 50; // ms
            inputElm.on('blur', function (ev) {
				var time = Date.now();
				if (this.value !== lastValue || time - lastBlurTime >= ghostBlurElapsedTime) {
					var isValid = app.util.validateField(this.id, this.value, null, ev.type);
					app.util.onFieldBlur(isValid, this.id, this.value, 'INPUT');
					var me = $(this);
					if (!me.hasClass('blurred')) {
						me.addClass('blurred');
						me.on('keyup keypress', function (e) {
							app.util.validateField(this.id, this.value, null, e.type);
						});
					}
				}
				lastBlurTime = time;
				lastValue = this.value;
            });
        }
    } else {
        var $radioArr = $('input[type="radio"][name="' + fldName + '"]');
        if ($radioArr.length) {
            $radioArr.on('change', function (ev) {
                var val = app.util.getFieldValue(fldName);
                var isValid = app.util.validateField(fldName, val, null, ev.type);
                app.util.onFieldBlur(isValid, fldName, val, 'RADIO');
            });
        }
    }
};

app.util.notifyMerchantForOnlyZeroes = function () {
    var value = app.util.$getPmSpecificElement('cc_cvv2', app.lastSelectedMethodType).val();

    value && value.trim() === _.padLeft('0', value.trim().length, '0') && app.util.sendPostMessage({
        'action': 'submit',
        'payload': {
            'allZeroes': true
        }
    });
};

app.util.setLabelOpenAmountRangeHeader = function (amountLimits, currency) {
    var newHeader = '';
    if (_.isEmpty(amountLimits)) {
        newHeader = '&nbsp;';
    } else {
        var minAmount = app.formatter.formatCurrency(amountLimits['minValue'], currency, app.roundingScale);
        var maxAmount = app.formatter.formatCurrency(amountLimits['maxValue'], currency, app.roundingScale);
        newHeader = app.msg['amount_header']
            .replace(' - ', '&nbsp;-&nbsp;')
            .replace('{0}', minAmount)
            .replace('{1}', maxAmount);
    }
    $('#label_open_amount_range').html(newHeader);
};

app.util.getLightboxContentTemplate = function (templateName) {

    var defaultInfoTpl = '<% if(message.message_text) {%><p class="msg"><%- t(message.message_text) %></p><% } %>' +
        '<% if(message.auth_code) {%><p class="_code"><%= t("lightbox_label_auth_code")%>: <span><%- message.auth_code %></span></p><% } %>' +
        '<% if(message.reference) {%><p class="_ref"><%= t("lightbox_label_reference")%>: <span><%- message.reference %></span></p><% } %>' +
        '<% if(message.name_on_card) {%><p class="_name"><%= t("lightbox_label_name_on_card")%>: <span><%- message.name_on_card %></span></p><% } %>' +
        '<% if(message.card_number) {%><p class="_cc_nbr"><%= t("lightbox_label_card_number")%>: <span class="ltrNumber"><%- message.card_number %></span></p><% } %>' +
        '<%if (message.abuResponse) {%><p class="abuResponseInfo"><%= t(message.abuResponse.infoMessage)%> <%- t("asterisk_template")%> <%- t(message.abuResponse.lastFourDigits)%></p><%}%>' +
        '<% if(message.useIntl && message.amount && message.currency) {%><p class="_amount"><%= t("lightbox_label_total_amount")%>: <span><%- c.formatCurrency(message.amount, message.currency, null, true) %></span></p>' +
        '<%}else if(message.total_amount) {%><p class="_total"><%= t("lightbox_label_total_amount")%>: <span><%- message.total_amount %></span></p><% } %>' +
        '<% if(message.messageKey){ %><p class="_more"><%= t(message.messageKey)%><p><% } %>' +
        '<button class="modal_close btn on_confirm"><%= t("lightbox_success_button") %></button>';
    var default3dsTooltip = '<label for="show_card_tooltip" class="secure_<%- message.ccCardIssuer %> secure_tooltip_show"> <%- t("lightbox_3d_what_is_arg", [issuer_lbl]) %></label>' +
        '<input type="checkbox" id="show_card_tooltip"> <div id="secure_<%- message.ccCardIssuer %>_wrapper" class="secure_tooltip_wrapper" >' +
        '<label for="show_card_tooltip" class="secure_<%- message.ccCardIssuer %> secure_tooltip_hide"></label>' +
        '<div class="secure_<%- message.ccCardIssuer %> secure_tooltip_logo"></div>' +
        '<div class="secure_<%- message.ccCardIssuer %> secure_tooltip_content"><%= t( tooltip_txt )%></div></div>';
    var paTrxInfo = '<div class="bold"><%= t("lightbox_pa_success_header") %></div>' +
        '<% var params = (message.useIntl) ? [message.pa_trx.params[2], ""] : message.pa_trx.params; %>' +
        '<p class="info"><%= t("lightbox_pa_confirmation_msg", params) %></p><p class="info"><%= t("lightbox_pa_hint_msg") %></p><p class="info"><%= t("lightbox_pa_auto_approved_msg") %></p>';
    var trxInfoTpl = {
        ptUpoJustVerified: '<%if(message.ptUpoJustVerified === "true"){%><p><%= t("verified_account_message") %></p><%}%>',
        payment_method  : '<%if(message.payment_method){%><p class="li _pm"><span class="name"><%= t("payment_method_label")%>:</span> <span><%- app.msg[message.payment_method] %></span> <span class="method-logo upm-logo pm-logo <%if(message.processedCardBrand){%><%- message.processedCardBrand %><%} else {%><%- message.payment_method.toLowerCase() %><%}%>"></span></p><%}%>',
        upo_name        : '<%if(message.card_number){ %><p class="li _cc_nbr"><span class="name"><%= t("lightbox_label_card_number")%>:</span> <span><%- message.card_number %></span></p>' +
            '<%}else if(message.upo_name){%><p class="li _upo_name"><span class="name"><%= t("account_id_label")%>:</span> <span><%- message.upo_name %></span></p><%}%>' +
            '<%if (message.abuResponse) {%><p class="li abuResponseInfo"><%= t(message.abuResponse.infoMessage)%> <%- t("asterisk_template")%> <%- t(message.abuResponse.lastFourDigits)%></p><%}%>',
        reference       : '<%if(message.ApmReference){%><p class="li _apm_rf"><span class="name"><%= t("lightbox_label_reference")%>:</span> <span><%- message.ApmReference %></span></p>' +
            '<%}else if(message.reference){%><p class="li _rf"><span class="name"><%= t("lightbox_label_reference")%>:</span> <span><%- message.reference %></span></p><%}%>',
        apmReferenceId  : '<%if(message.apmReferenceId){%><p class="li apmReferenceId"><span class="name"><%= t("lightbox_label_apmReferenceId")%>:</span> <span class="value"><%- message.apmReferenceId %></span></p><%}%>',
        amount          : '<%if(message.amount && message.currency){%><p class="li _amount"><span class="name"><%= t("amount_label")%>:</span> <span><%- c.formatCurrency(message.amount, message.currency, null, true) %></span></p><%}%>',
        charged_amount  : '<%if(message.charged_amount && message.charged_currency && message.rate && message.markup && message.merchantDescriptor){ var markup = c.formatDecimal( parseFloat(message.markup)*100 ); %>' +
            '<p class="li _ch_amount"><span class="name"><%= t("charged_amount_label")%>:</span> <span><%- c.formatCurrency(message.charged_amount, message.charged_currency, null, true)%></span></p>' +
            '<p class="li _ch_rate"><span class="name"><%= t("charged_rate")%>:</span> <span class="rate">1 <%-message.currency%> = <%- c.formatDecimal(message.rate, null, 10) %> <%- message.charged_currency%></span> <span class="markup"><%- t("dcc_markup_fee", [markup])%></span></p>' +
            '<p class="li _dcc_info"><i class="info-icon"></i> <span class="dcc_info"><%= t("you_agree_to_pay_in", [message.charged_currency])%></span> <span class="dcc_info"><%- t("conversion_offered_by", [message.merchantDescriptor])%></span></p><%}%>',
        submittedMethodInfo: '<% var i = (message && message.info && message.info.showPmInfo && message.info.submittedMethod), card, pm;' +
            'if(i){card = i.card_detected !== "none" ? i.card_detected : ""; pm = card || i.pmName; %> <div class="trx_info">' +
                '<p class="li _pm"><span class="name"><%= t("payment_method_label")%>:</span> <span><%- app.msg[pm] %></span> <span class="method-logo upm-logo pm-logo <%- pm.toLowerCase() %>"></span></p>' +
                '<% if(i.isUpo && i.upoName){ %><p class="li _upo_name"><span class="name"><%= t(pm === card ? "lightbox_label_card_number" : "account_id_label")%>:</span> <span><%- i.upoName %></span></p> ' +
                '<%} else if(!i.isUpo && pm === card && message.card_number){ %><p class="li _cc_nbr"><span class="name"><%= t("lightbox_label_card_number")%>:</span> <span><%- message.card_number %></span></p>' +
                '<%} if(i.amount && i.currency){%><p class="li _amount"><span class="name"><%= t("amount_label")%>:</span> <span><%- c.formatCurrency(i.amount, i.currency, null, true) %></span></p><%}%>' +
            '</div><%}%>'
    };
    var removeUpoInfo = '<div id="pm_info"><span class="ico <%- message.upmType %>"></span><span><%- message.name %></span>' +
        '<% if(message.cc_exp_year != ""){%><span><%- t("lightbox_exp_abbr")%><span class="bold" ><%- message.cc_exp_month %>/<%- message.cc_exp_year %></span></span><%}%></div>';

    var content_tpl_text = {
        trxInfoHtml:  '<%var message = {info: info}; %>' + trxInfoTpl.submittedMethodInfo,
        verification_failed: '<div class="modal-icon <%- message.trxStatus%>"></div>' +
            trxInfoTpl.payment_method + trxInfoTpl.upo_name + trxInfoTpl.amount + trxInfoTpl.reference + trxInfoTpl.apmReferenceId +
            '<p class="li _nvf_txt"><%= t("lightbox_nvf_txt") %></p>' +
            '<div class="buttons">' +
            '<button class="on_cancel modal_close btn"><%- t("lightbox_close_button") %></button> ' +
            '<button class="on_confirm modal_close btn _nvf"><%- t("lightbox_contact_support_button") %></button>' +
            '</div>',
        kyc: '<div class="modal-icon <%- message.trxStatus%>"></div>' +
            '<% var uploadUrl = (message.kycResponse && message.kycResponse.documentUploadUrl);' +
            'var kycApproved = (message.kycResponse && message.kycResponse.status.toLowerCase() === "approved");' +
            'var account_status_str = (uploadUrl || !kycApproved )?"not_approved":"approved";  var ok_btn = "lightbox_success_button", docv_class_name="";%>' +
            '<%if(message.message_text) {%><p class="msg"><%- message.message_text%></p><% } %>' +
            '<%if(message.pa_trx){ account_status_str = (uploadUrl || !kycApproved)?"not_verified":"verified"; %>' + paTrxInfo + '<%}%>' +
            '<%if(message.kycResponse){%><p class="info"><%= t("lightbox_kyc_" + account_status_str) %>' +
            '<% if(uploadUrl){ docv_class_name = "docv"; ok_btn = "lightbox_continue_button"; %><br/><%= t("lightbox_kyc_click_continue")%><%}%>' +
            '</p><div class="buttons"><%if(uploadUrl){%><button class="on_cancel modal_close btn"><%- t("lightbox_cancel_button") %></button><%}%> ' +
            '<button class="on_confirm modal_close btn <%- docv_class_name%>"><%- t(ok_btn) %></button>' +
            '</div><%}%>',
        error_fatal: '<%= t( message ) %>',
        error_blocking: '<p><%= t( message.text ) %></p>',
        error: '<div class="modal-icon error">&#xf05c;</div>' +
            trxInfoTpl.submittedMethodInfo +
            '<h3> <% var msg = message || {};' +
            'if(msg.apmErrorMsg){%> <%= msg.apmErrorMsg%> <%}else if(_.isString(msg)){%> <%= msg%> ' +
            '<%}else if(msg.text){%> <%= t(msg.text)%> <%}else{%> <%= t("lightbox_error_header")%> <%}%>' +
            '</h3><button class="modal_close on_confirm btn"><%= t("lightbox_success_button") %></button>'
        ,
        'error-suggest': '<h3><%if(message.apmErrorMsg){%><%= message.apmErrorMsg %><br><%}else if(message.error){%><%= message.error %><br><%}else{%><%= t("lightbox_transaction_declined")%><%}%> <%= t("lightbox_error_suggest")%></h3>' +
            trxInfoTpl.submittedMethodInfo +
            '<ul class="try_pm"><% _.each(message, function(item ){ %> <li><%= item %></li><%});%></ul>',
        pending: '<% var pmName = message.payment_method ? message.payment_method : app.lastSelectedMethodType %>' +
            '<div class="modal-icon pending">&#xf05a;</div> ' +
            '<% var key = "lightbox_pending_" + pmName; var text = t(key); if(key !== text){%>' +
            '<p><%= text%></p><button class="modal_close btn on_confirm"><%= t("lightbox_success_button") %></button>' +
            '<%}else{%>' + defaultInfoTpl + '<%}%>',
        success: '<div class="modal-icon success">&#xf05d;</div>' + defaultInfoTpl,
        extended_success: '<div class="modal-icon success">&#xf05d;</div>' +
            '<% var info = t(message.message_text || "lightbox_extended_success_info");%>' +
            '<% if(info !== "lightbox_extended_success_info"){%><p class="msg"><%= info %></p><%}%>' +
            trxInfoTpl.payment_method +
            trxInfoTpl.upo_name +
            trxInfoTpl.reference +
            trxInfoTpl.apmReferenceId +
            trxInfoTpl.amount +
            trxInfoTpl.charged_amount +
            '<div class="buttons">' +
            '<button class="modal_close btn on_confirm"><%= t("lightbox_success_button") %></button>' +
            '</div>'
        ,
        warning: '<div class="modal-icon warning">&#xf05a;</div>' +
            '<% if (_.isArray(message.blockers) && !_.isEmpty(message.blockers)) { %>' +
            '<div id="lb_blocked_method_messages_list">' +
            '<% _.each(message.blockers, function(val, key) { %>' +
            '<p><%= t(val) %></p>' +
            '<% }); %>' +
            '</div>' +
            '<% } else { %>' +
            '<p><%= t(message.messageKey)%></p>' +
            '<% } %>' +
            '<% if(message && message.closeable){ %>' +
            '<button class="modal_close btn"><%= t("lightbox_success_button") %></button>' +
            '<% } else if (_.isArray(message.blockers) && !_.isEmpty(message.blockers) && !message.closeable) { %>' +
            '<button type="button" class="send_message btn" data-msg-key="isBlocked"><%= t("lightbox_ok_button") %></button>' +
            '<% } %>',
        confirm_upo_removal: '<span class="modal_close on_cancel"></span><h3><%- t("confirm_upo_removal") %></h3>' +
            '<p class="bold"><%- t("lightbox_confirm_removal_message") %></p>' +
            removeUpoInfo +
            '<div class="buttons"><button class="modal_close cancel btn on_cancel"><%- t("lightbox_cancel_button") %></button> ' +
            '<button class="on_confirm btn"><%- t("lightbox_remove_button") %></button></div>'
        ,
        upo_was_removed: '<p class="msg"><%- t("upo_was_removed") %></p>' +
            removeUpoInfo +
            '<div class="buttons"><button class="modal_close btn on_confirm"><%= t("lightbox_close_button") %></button></div>'
        ,
        confirm : '<div class="header"><% var h=message.header||"";%><%= t(h)%></div>'+
            '<div class="msg"><%var args=message.args || {}; _.each(message.msgArr || [], function(v,i){%><%= t(v, args[i])%><%})%></div>' +
            '<div class="buttons"><% if(message.confirmBtn.isVisible){%>' +
            '<button class="on_confirm modal_close_X btn"><%- t(message.confirmBtn.txt)%></button>' +
            '<%} if(message.cancelBtn.isVisible){%>' +
            '<button class="on_cancel modal_close btn" ><%- t(message.cancelBtn.txt)%></button> ' +
            '<%}%></div> <div id="confirmation_footer"></div>',
        validation_box: '<span class="modal_close on_confirm"></span><h3><%- t("deposit_error") %></h3>' +
            '<p><%- message.text  %><%if(message.field !== "expiration_period"){%> (<span><%- message.field  %></span>)<%}%></p>' +
            '<div class="buttons"><button class="modal_close on_confirm btn"><%- t("lightbox_ok_button") %></button></div>'
        ,
        pa_trx: '<div class="content-wrap"><div class="modal-icon <%- message.pa_trx.status %>"></div>' + paTrxInfo + '</div>' +
            '<div class="buttons"><button class="on_confirm modal_close btn"><%- t("lightbox_pa_ok_button") %></button>' +
            '<button class="on_cancel modal_close btn"><%- t("lightbox_pa_cancel_button") %></button>' +
            '</div>'
        ,
        deposit_confirmations: '<div class="content-wrap">' +
            '<% _.each(message.msgArr || [], function(v){%><div class="msg"><%= t(v)%></div><%});%>' +
            '</div> <div class="buttons">' +
            '<button class="on_confirm modal_close btn"><%- t("lightbox_yes_button") %></button> ' +
            '<button class="on_cancel modal_close btn"><%- t("lightbox_cancel_button") %></button></div>'
        ,
        info: '<p><%- message.text  %></p><button class="modal_close btn"><%- t("lightbox_ok_button") %></button>',
        webmoney_lightbox: '<span class="close on_cancel"></span>' +
            '<p><%= message.text  %></p><button class="ok on_confirm"><%= message.btn_text %></button>'
        ,
        secure_before: '<% var issuer_lbl = t("lightbox_3d_card_issuer_lbl_" + message.ccCardIssuer), tooltip_txt = "lightbox_3d_tooltip_" + message.ccCardIssuer; %>' +
            '<div id="secure_before_dialog" title="<%- issuer_lbl %>" class="secure_<%- message.ccCardIssuer %>"> <div class="secure_<%- message.ccCardIssuer %> secure_tooltip_logo"></div>' +
            '<div class="dialog-content"> <%= t("lightbox_3d_ask_secure_payment_arg", [issuer_lbl]) %> </div><div class="buttons">' +
            '<button class="on_confirm modal_close btn"><%- t("lightbox_yes_button") %></button> ' +
            '<button class="on_cancel modal_close btn"><%- t("lightbox_no_button") %></button></div>' + default3dsTooltip + '</div>'
        ,
        secure_aborted: '<% var issuer_lbl = t("lightbox_3d_card_issuer_lbl_" + message.ccCardIssuer); %>' +
            '<div id="secure_aborted_dialog" title="<%- issuer_lbl %> aborted" class="secure_<%- message.ccCardIssuer %>">' +
            '<div class="secure_<%- message.ccCardIssuer %> secure_tooltip_logo"></div>' +
            '<div class="dialog-content"><%- t("lightbox_3d_ask_pay_without_arg", [issuer_lbl]) %></div>' +
            '<div class="buttons"><button class="on_confirm modal_close btn"><%- t("lightbox_continue_button") %></button> ' +
            '<button class="on_cancel modal_close btn"><%- t("lightbox_cancel_button") %></button></div></div>'
        ,
        iframe_info: '<% var issuer_lbl = t("lightbox_3d_card_issuer_lbl_" + message.ccCardIssuer), tooltip_txt = "lightbox_3d_tooltip_" + message.ccCardIssuer; %>' +
            ' <div id="iframe_info"><div id="secure_protection_dialog_footer" class="dialog-footer-text"><%= t("lightbox_3d_please_submit")%></div>' +
            default3dsTooltip + '<div class="buttons">' +
            '<button id="try_another_option" class="btn"><%- t("try_another_option") %></button> <% if (!message.secure3dMandatory && !!message.use3dsSkipOption){ %>' +
            '<button id="skip_3d_secure" class="btn"><%- t("lightbox_3d_continue_without") %></button><% } %></div></div>'
        ,
        pt_currency_exchange: '<div class="converted-amount-text <%if(message.originalCurrencyInList){%>originalCurrencyInList<%}%>"><%= t("converted_amount")%></div><div class="converted-amount-container">' +
            '<input type="text" id="pref_currency_amount" name="pref_currency_amount" readonly="readonly" value=""></div>' +
            '<div class="converted-currency-container"><select data-plugin="cSelect" name="preferred_currency" id="preferred_currency">' +
			'<% _.each( message.currencies, function(item, key){%><option  data-rate="<%- item.rate%>" ' +
			'value="<%- item.iso%>" <%if( item.iso == message.preferredCurrency ){%>selected<%}%> ><%- item.iso%></option><%}); %></select></div>'
		,
		dcc_exchange          : '<% var name="agreeDcc", opt={checked: message.dccCheckboxState, lbl_txt: t("agree_dcc")}; %>' +
            '<div class="dcc_container <%- message.dccClassName%>" > ' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL +
            '<div class="dcc_closable"> <div class="agree_dcc_hint"><%= t("agree_dcc_hint")%></div> ' +
            '<div class="converted-amount-text"><%= t("converted_amount")%></div>' +
            '<div class="dcc_main"> ' +
            '<div class="converted-amount-container"><input type="text" id="pref_currency_amount" name="pref_dcc_currency_amount" readonly="readonly" value=""></div>' +
			'<div class="converted-currency-container"><select data-plugin="cSelect" name="selectedCurrency" id="preferred_currency">' +
			'<% _.each(message.currencies, function(item, key){ var selected = (item.iso == message.preferredCurrency)?" selected":""; %>' +
			'<option  data-rate="<%- item.rate%>" value="<%- item.iso%>" <%-selected%> ><%- item.iso%></option>' +
			'<%}); %></select></div>' +
			'<div id="conversion_rate_info" class="conversion_rate_info"></div>' +
			'</div></div></div>'
		,
		dcc_rate              :
			'<span class="rate">1 <%- message.originalCurrency%> = <% if(app.config.useCurrencyExchangeFormatting){ %> <%- c.formatDecimal(message.rate, null, 10) %> <% } else { %> <%- message.rate %>  <% } %>  <%- message.newCurrency%></span> ' +
			'<span class="markup"><%= t("dcc_markup_fee", [message.markup])%></span>'
        ,
        pending_wd_list: '<% if (_.isArray(message.blockers) && !_.isEmpty(message.blockers)) { %>' +
            '<div id="lb_blocked_method_messages_list">' +
            '<% _.each(message.blockers, function(val, key) { %>' +
            '<p><%= t(val) %></p>' +
            '<% }); %>' +
            '</div>' +
            '<% } %>' +
            '<p><%- t("you_have_pending_wd") %></p><p><%- t("reverse_pending_wd") %></p><div class="withdraw-wrapper" data-plugin-type="lb_withdrawals"></div><% if(message && message.closeable){ %><button class="modal_close btn on_confirm"><%- t("go_to_deposit") %></button><% } else if (_.isArray(message.blockers) && !_.isEmpty(message.blockers) && !message.closeable) { %><button type="button" class="send_message btn" data-msg-key="isBlocked"><%= t("lightbox_ok_button") %></button><% } %>' +
            '<% if(message.returnToMerchant){ %><button class="backBtn btn" onclick="app.util.onBackToMerchantSiteClicked()"><%- t("return_to_store") %></button><% } %>',
        unknown: '<ul><% _.each(message, function(item ){%> <li><% if(_.isObject(item)){ _.each(item, function(i){%> <span><%= i%></span><% });}else{%> <%= item %> <%}%></li><%});%></ul>',
        pm_redirect_iframe: '<div class="pm_redirect_wrapper <%- message.pm_class %>">' +
        '<iframe src="<%= message.url %>" name="pm_redirect_iframe" allow="clipboard-write" width="100%" height="100%" scrolling="auto"/>' +
        '</div>',
        mvp_nuvei_card: '<div>' +
            '<div class="mvp_nuvei_card_image"></div>' +
            '<div class="mvp_nuvei_card_info"><%- t("mvp_nuvei_card_info_text")%></div>' +
            '<div class="mvp_nuvei_card_order_button_wrapper"><button class="btn"><%= t("mvp_nuvei_card_order_card_btn_text")%></button></div>' +
            '<div class="mvp_nuvei_card_enter_details_text"><%= t("mvp_nuvei_card_enter_details_text")%></div>' +
        '</div>',
    };

    var $currContentTplElm = $(['#', templateName, '-msg-content'].join(''));
    var contentTemplate = $currContentTplElm.length ? $currContentTplElm.text() : (content_tpl_text[templateName] || content_tpl_text['unknown']);
    return _.template(contentTemplate);
};

app.util.getLightboxTitleTemplate = function (templateName) {
    var defaultTitleTpl = '<h2><% if(message && message.titleKey){ %><%= t(message.titleKey)%>' +
        '<% }else{ %><%= t("lightbox_title_" + type)%><% }%></h2><span class="modal_close on_cancel"></span>';
    var title_tpl_text = {
        verification_failed: defaultTitleTpl,
        error: defaultTitleTpl,
        error_blocking: "<h2><%= t( message.titleKey ) %></h2>",
        'error-suggest': defaultTitleTpl,
        pending: defaultTitleTpl,
        success: defaultTitleTpl,
        warning: '<h2><% if(message && message.titleKey){ %><%= t(message.titleKey)%><% } %></h2> ' +
            '<% if(message && message.closeable){ %><span class="modal_close on_cancel"></span><% } %>'
        ,
        pm_redirect_iframe: '<h2><% if(message && message.titleKey){ %><%= t(message.titleKey)%>' +
            '<% }else{ %><%= t("lightbox_title_" + type)%><% } if(message && message.closeable){ %><span class="modal_close on_cancel">&#215;</span><%}%></h2>',
        confirm_upo_removal: "<h2><%= t(type)%></h2>",
        upo_was_removed: defaultTitleTpl,
        confirm: defaultTitleTpl,
        validation_box: "<h2><%= t(type)%></h2>",
        pa_trx: defaultTitleTpl,
        deposit_confirmations: "<h2><%= t(message.titleKey)%></h2>",
        info: "<h2><%= t(message.titleKey)%></h2>",
        webmoney_lightbox: "<h2><%= t(message.titleKey)%></h2>",
        secure_before: defaultTitleTpl,
        secure_aborted: '<% var arg = t(message.titleKey);%>' +
            '<h2><%= t("lightbox_title_secure_aborted", [arg])%></h2><span class="modal_close on_cancel"></span>'
        ,
        pending_wd_list: '<h2><%= t("pending_wd_list") %></h2> ' +
            '<% if(message && message.closeable){ %><span class="modal_close on_cancel"></span><% } %>'
        ,
        mvp_nuvei_card: '<h2><%- t("mvp_nuvei_card_modal_title")%></h2><span class="modal_close"></span>'
        ,
        unknown: "<h2><%= t(type)%></h2>"
    };

    var $currTitleTplElm = $(['#', templateName, '-msg-title'].join(''));
    var titleTemplate = $currTitleTplElm.length ? $currTitleTplElm.text() : (title_tpl_text[templateName] || title_tpl_text['unknown']);
    return _.template(titleTemplate);
};

/**
 *
 * @param feeObj
 * @param raw_amount
 * @param currency
 * @returns {*}
 */
app.util.getFeeRenderingData = function (feeObj, raw_amount, currency) {

    if (!_.isEmpty(feeObj)) {
        var amount = parseFloat(raw_amount);
        var fee_value = parseFloat(feeObj.feeValue);
        var fee_amount = 0, net_amount = 0, total_amount = 0, isInRange = 1;

        if (amount >= 0) {
            if (feeObj.feeValueType === app.CONSTANTS.FEE.VALUE_TYPE_FIXED) {
                fee_amount = parseFloat(fee_value);
            } else {
                fee_amount = Math.round((amount * fee_value)) / 100;
            }

            if (feeObj.feeMinValue && (parseFloat(feeObj.feeMinValue) > fee_amount)) {
                fee_amount = parseFloat(feeObj.feeMinValue);
                isInRange = 0;
            } else if (feeObj.feeMaxValue && (fee_amount > parseFloat(feeObj.feeMaxValue))) {
                fee_amount = parseFloat(feeObj.feeMaxValue);
                isInRange = 0;
            }

            if (feeObj.noFeeAmount && (amount >= parseFloat(feeObj.noFeeAmount))) {
                fee_amount = 0;
                isInRange = 0;
            }

            if (feeObj.feeType === app.CONSTANTS.FEE.TYPE_ADDING) {
                net_amount = amount;
                total_amount = amount + fee_amount;
            } else {
                net_amount = amount - fee_amount;
                total_amount = amount;
            }
        }
        // ??? // net_amount = (net_amount >= 0) ? net_amount : 0;
        var roundingScale = app.roundingScale;
        var fee_value_roundingScale = (feeObj.feeValueType !== app.CONSTANTS.FEE.VALUE_TYPE_FIXED && isInRange) ? 2 : app.roundingScale;
        return {
            feeType      : feeObj.feeType,
            feeValueType : feeObj.feeValueType,
            fee          : fee_value.toFixed(fee_value_roundingScale),
            amount       : (amount || 0).toFixed(roundingScale),
            fee_amount   : fee_amount.toFixed(roundingScale),
            net_amount   : net_amount.toFixed(roundingScale),
            total_amount : total_amount.toFixed(roundingScale),
            is_in_range  : isInRange,
            currency     : currency ? app.util.remapCurrency(currency) : '',
            currencyIso  : currency || '',
            raw          : {
                amount         : amount || 0,
                fee_amount     : fee_amount,
                net_amount     : net_amount,
                total_amount   : total_amount,
                no_fee_amount  : feeObj.noFeeAmount,
                fee_min_amount : feeObj.feeMinValue && parseFloat(feeObj.feeMinValue),
                fee_max_amount : feeObj.feeMaxValue && parseFloat(feeObj.feeMaxValue)
            }
        };
    }
    return false;
};

app.util.handleFee = function (feeObj) {
    var $feeWrapper = $('#fee-wrapper');
    var $feeValueInput = $('input#feeValue');

    if (_.isEmpty(feeObj)) { // CLEAR STATE
        $feeValueInput.remove();
        $feeWrapper.empty();
        return;
    }
    if ($feeValueInput.length) {
        $feeValueInput.val(feeObj.feeValue);
    } else {
        $('#PPPParametersForm').append($('<input type="hidden" name="feeValue" id="feeValue" value="' + feeObj.feeValue + '">'));
    }
    var amount = parseFloat($('#item_amount_1').val());
    var tpl = {
        old  : '<div><% if(feeValueType !== "FIXED" && is_in_range){%><strong><%-fee%> % <%-t("fee")%></strong> <%}else{%> ' +
            '<strong><%-t("fee")%></strong> (<%- currency %>) <span><%- fee_amount %></span><%}%></div>' +
            '<div> <% if(feeType === "ADDING"){ %>' +
            '<strong><%-t("total_amount")%>:</strong> (<%- currency %>) <span><%- total_amount %></span>' +
            '<%} else {%>' +
            '<strong><%-t("net_amount")%>:</strong> (<%- currency %>) <span><%- net_amount %></span><%}%></div>'
        ,
        intl : '<div><% if(feeValueType !== "FIXED" && is_in_range){%><strong><%-fee%> % <%-t("fee")%></strong> <%}else{%> ' +
            '<strong><%-t("fee")%></strong> <span><%- c.formatCurrency(raw.fee_amount, currencyIso)%></span><%}%></div>' +
            '<div> <% if(feeType === "ADDING"){ %>' +
            '<strong><%-t("total_amount")%></strong> <span><%- c.formatCurrency(raw.total_amount, currencyIso)%></span>' +
            '<%} else {%>' +
            '<strong><%-t("net_amount")%></strong> <span><%- c.formatCurrency(raw.net_amount, currencyIso)%></span><%}%></div>'
    };
    var $customFeeTemplate = $('#fees');
    var fee_tpl_txt = ($customFeeTemplate.length ? $customFeeTemplate.text() : (app.config.useIntlFormatter ? tpl.intl : tpl.old));
    var payload = app.util.getFeeRenderingData(feeObj, amount, app.lastSelectedCurrency);
    var html = payload ? _.template(fee_tpl_txt)(payload) : '';
    $feeWrapper.html(html);
    app.recalcUserDetailsArea();
};

app.util.getPMFields = function (pmOptionsFields) {
    var _pmFields = {};
    _.each(pmOptionsFields, function (item) {
        if (!item.countries || item.countries.indexOf(app.country) > -1) {
            var pms = item['usedByPms'].split(',');
            _.each(pms, function (pm) {
                var pm_name = pm.trim();
                if (!_pmFields[pm_name]) {
                    _pmFields[pm_name] = {};
                }
                if (!app.CONSTANTS.UPM_ONLY_FIELDS[item.name]) {
                    _pmFields[pm_name][item.name] = {name: item.name, type: item.visibility, label: item.label};
                }
            })
        }
    });
    var transformer = app.transformPM || _.identity;
    _.each(_pmFields, function (item, key) {
        _pmFields[key] = transformer(item, key);
    });
    return _pmFields;
};

app.util.isCardPM = function (data) {
    var isCard = false;
    if (_.isString(data)) {
        isCard = app.CONSTANTS.CC_CARDS_DB[data];
    } else if (_.has(data, 'userPaymentMethodName') || _.has(data, 'name') || _.has(data, 'value')) {
        var name = data['userPaymentMethodName'] || data.name || data.value;
        isCard = app.CONSTANTS.CC_CARDS_DB[name];
    }
    return !!isCard;
};

app.util.getURLParameter = function (name) {
    var param = decodeURIComponent(
        (new RegExp(name + '=' + '(.+?)(&|$)').exec(location.search) || [, null])[1]
    );
    if (param) {
        return param.replace(/\+/g, ' ');
    }
};

app.util.getCurrenciesPromise = function (pmData) {
    var upoData = pmData.upoId && app._upoList[pmData.upoId];
    if (app.config.useDcc && upoData && upoData.rejectDCC) {
        /** app.renderCurrencyExchange() with no params is equal to 'clear state' */
        app.renderCurrencyExchange();
        return app.util.rejectedPromise('upo_rejects_DCC');
    } else {
        return $.getJSON('getCurrenciesForPM.do', {
            msid			: app.msid,
            ssid			: app.config.ssid,
            selCurrency		: app.lastSelectedCurrency,
            originalCurrency: app.currency,
            countryIso		: app.country,
            selPaymentMethod: pmData.selPaymentMethod,
            upoId			: pmData.upoId,
            detectedCardType: pmData.detectedCardType
        });
    }
};

app.util.getCustomLimitsAndFees = function (cb) {
    var def = $.Deferred();
    var url = "/ppp/getCustomLimistAndFees.do";
    // if (!app.ptRequestId && app.config_getSrvFeesAndLimits) {
    // 	url = "/ppp/getCustomFee.do";
    // }
    var data = {
        msid: app.msid,
        ssid: app.ssid,
        type: 1,
        paymentMethod: app.lastSelectedMethodType
    };

    $.ajax({
        url: url,
        data: data,
        dataType: "json",
        success: cb,
        error: cb
    }).done(function (resp) {
        var limitsAndFees = app.util.assertAjaxResponseTypeJSON(resp) && resp;
        def.resolve(limitsAndFees);
    }).fail(function () {
        def.resolve(false);
    });
    return def.promise();
};

app.util.prepareProductListData = function (data, shouldSkipGT) {
    if (data && data.selectedItems) {
        return {
            currency: data.currency,
            roundingScale: data.roundingScale,
            selectedItems: data.selectedItems,
            crosssellData: data.crossSales,
            upsellData: data.upSales,
            summaryData: data.selectedItems.itemsInfoTotal,
            skipGT: !!shouldSkipGT
        };
    }
};

app.util.doProductListAction = function (action, cb, data) {
	var urls = {
		getItems       : "items/getItemsInfo.do?ssid=",            // data: none
		addCrossSale   : "items/addCrossSaleItem.do?ssid=",        // data: {"ids":[24607, 24611]}
		removeFromCart : "items/removeCrossSaleItem.do?ssid=",     // data: {"ids":[24607, 24611]}
		changeQuantity : "items/changeAddedItemsQuantity.do?ssid=",// data: [{"id":24607, "quantity":3}]
		changeCurrency : "items/changeCurrency.do?ssid=",          // data: {"currency":"EUR" /*, "openAmount":"amount"*/}
		applyCoupon    : "items/applyCoupon.do?ssid=",             // data: {"coupon":"PBW2EDGJ9X"}
		makeUpSell     : "items/setUpSaleItem.do?ssid="            // data: {"id": 24607}
	};
    var url = urls.getItems;
    var pmType = app.util.isUpo(app.lastSelectedMethodId) ? 'userPaymentOptionId' : 'paymentOptionName';
    var data_to_send;
    if (data) {
        if (action === "addCrossSale" || action === "removeFromCart") {
            url = urls[action];
            data_to_send = {"ids": [data.uniqueId]};
        } else if (action === "changeQuantity") {
            url = urls[action];
            data_to_send = [{"id": data.uniqueId, "quantity": data.new_quantity}];
        } else if (action === "changeCurrency") {
            url = urls[action];
            data_to_send = {"currency": (data.newCurrency || app.lastSelectedCurrency)}; // TODO: data.newCurrency
            data_to_send[pmType] = app.lastSelectedMethodId;
            if (app.config.isOpenAmount) {
                data_to_send.openAmount = app.lastSelectedAmount; // $('#item_amount_1').val();
            }
        } else if (action === "makeUpSell") {
            url = urls[action];
            data_to_send = {"id": data.uniqueId};
            data_to_send[pmType] = app.lastSelectedMethodId;
        } else if (action === "applyCoupon") {
            url = urls[action];
            data_to_send = {"coupon": data.couponVal};
        }
    }

    url = url + app.ssid;
    $.ajax({
        type: 'POST',
        url: url,
        data: JSON.stringify(data_to_send),
        contentType: "application/json",
        dataType: "json",
        success: cb,
        error: cb
    });
};

app.util.getItemsInfo = function (cb, data) {
    app.util.doProductListAction("getItems", cb, data);
};

app.util.changeCurrency = function (cb, data) {
    app.util.doProductListAction("changeCurrency", cb, data);
};

app.util.getChangeCurrencyCb = function (onChangeCurrencyResponse) {
    return function (result) {
        if (!result || !result.selectedItems) {
            app.showFinalMessage("general_error_text");
            return;
        }
        var summaryData = result.selectedItems.itemsInfoTotal;
        /** ensure proper maxFractionLength */
        var extendedAmount = parseFloat(parseFloat(summaryData.extendedAmount).toFixed(result.roundingScale));
        var data = {
            roundingScale: result.roundingScale,
            currency: result.currency,
            item_amount_1: extendedAmount,
            item_min_amount_1: extendedAmount,
            item_max_amount_1: extendedAmount,
            revert_label: (app.msg.revert_to_original_currency || "Revert to original currency"),
            currency_changed_label: (app.msg.currency_has_been_changed || "Selected currency has been changed."),
            currency_popup: ""
        };

        if ($('div[data-plugin-type="productlist"]').length) {
            var subscribeObject = pubsub.subscribe('app.event.productlist.postRender', function () {
                onChangeCurrencyResponse(data);
                pubsub.unsubscribe(subscribeObject);
            });
            var shouldSkipGT = true;
            var dataObj = app.util.prepareProductListData(result, shouldSkipGT);
            pubsub.publish('products-available', [dataObj]);
        } else {
            onChangeCurrencyResponse(data);
        }
    };
};

app.util.updateGrandTotalAmount = function (data) {
    app.roundingScale = (data.hasOwnProperty("roundingScale") && !isNaN(parseInt(data.roundingScale))) ? parseInt(data.roundingScale) : app.roundingScale;
    var extendedAmount = (data.hasOwnProperty("item_amount_1") && !isNaN(parseFloat(data.item_amount_1))) ? parseFloat(data.item_amount_1) : data.selectedItems.itemsInfoTotal.extendedAmount;
    /** ensure proper maxFractionLength */
    app.lastSelectedAmount = parseFloat(parseFloat(extendedAmount).toFixed(app.roundingScale));
    app.util.setAmountValue(app.lastSelectedAmount, ['change']);
    $('#amount').val(app.lastSelectedAmount);
    app.util.applyFixedAmountRestrictions();
    if (app.config_getSrvFeesAndLimits) {
        app.util.handleFee(app.current_pm_feeObj);
    }
};

app.util.updatePMLimits = function (limits, pm_type, currency, source) {
    if (limits
        && !_.isEmpty(limits)
        && _.has(limits, "minAmount")
        && _.has(limits, "maxAmount")
        && pm_type === app.lastSelectedMethodType
        && currency === app.lastSelectedCurrency) {
        var newObj = {};
        var defaultAmount;// = app.lastSelectedAmount || limits["defaultAmount"] || app.amount;

        if (app.config.useDefaultPmAmountOnPmChange) {
            defaultAmount = limits["defaultAmount"] || app.lastSelectedAmount || app.amount;
        } else {
            defaultAmount = app.lastSelectedAmount || limits["defaultAmount"] || app.amount;
        }

        /// if(source !== "changeCurrency"){ defaultAmount = limits["defaultAmount"] || app.lastSelectedAmount || app.amount;}

        newObj['amountLimits'] = {
            currencyIso: currency,
            maxValue: limits["maxAmount"],
            minValue: limits["minAmount"],
            defaultAmount: defaultAmount
        };

        if (limits['pricePoints']) {
            var pricePoints = [];
            var ppOnlyArray = _.filter(limits['pricePoints'], {'type': "PRICE_POINT"});
            var collection = ppOnlyArray.length ? ppOnlyArray : limits['pricePoints'];
            var newObjKey = ppOnlyArray.length ? 'pricePoints' : 'suggestedAmounts';
            _.each(collection, function (item) {
                pricePoints.push({
                    currencyIso: currency,
                    pointValue: item.value,
                    active: (item.value === defaultAmount)
                });
            });
            if (pricePoints.length > 0) {
                newObj[newObjKey] = pricePoints;
                //if (newObjKey === 'pricePoints') { //// Create proper suggestedAmounts:
                //	newObj['suggestedAmounts'] = pricePoints.slice(0, 6);//_.slice(pricePoints, 0, 6);
                //}
            }
        }
        app.pmLimits[pm_type] = app.pmLimits[pm_type] || {};
        app.pmLimits[pm_type].amountLimits = newObj.amountLimits;
        app.pmLimits[pm_type].suggestedAmounts = newObj.suggestedAmounts;
        app.pmLimits[pm_type].pricePoints = newObj.pricePoints;
    }
};

app.util.setPMAmountLimits = function (amountLimits) {
    if (amountLimits) {
        if (!app.pmLimits[app.lastSelectedMethodType]) {
            app.pmLimits[app.lastSelectedMethodType] = {};
        }
        app.pmLimits[app.lastSelectedMethodType].amountLimits = amountLimits;
    }
};

app.util.getAmountElmTpl = function () {
    var $amountTpl = $('#fld_item_amount_1');
	var amountDefaultTpl = '<input type="text" inputmode="decimal" id="item_amount_1" class="amount open_amount_input" autocomplete="off" name="item_amount_1" />';
	var maskedAmountDefaultTpl = '<input type="text" inputmode="decimal" id="masked_item_amount_1" class="amount open_amount_input" autocomplete="off" name="masked_item_amount_1" />';
	var itemAmountDefaultTpl = app.util.maskedItemAmountPlugin ?  amountDefaultTpl + maskedAmountDefaultTpl  : amountDefaultTpl;
    var $tpl  = $(itemAmountDefaultTpl);
    if($amountTpl.length) {
        var $wrapper = $('<div>');
        $wrapper.append(_.template($amountTpl.text())());
        if(app.util.maskedItemAmountPlugin && !$wrapper.find("#masked_item_amount_1").length) {
            var itemAmount1 = $wrapper.find("#item_amount_1");
            var maskedAmount = itemAmount1.clone();
            maskedAmount
                        .attr('name', 'masked_item_amount_1')
                        .attr('id', 'masked_item_amount_1')
                        .attr('type', 'text')
                        .attr('inputmode', 'decimal');

            itemAmount1.after(maskedAmount);
        }

        $tpl = $wrapper.html();
    }

    return $tpl;
}

app.util.appendPrefCurrencyAmountMask = function () {
    if(app.config.useIntlFormatter && app.config.useCurrencyExchangeFormatting && $('#formatted_pref_currency_amount').length < 1) {
        var elm = $('#pref_currency_amount');
        var elmName = elm.attr('name');
        var formattedElmName = 'formatted_' + elmName;
        var formattedElm = elm.clone()
                                    .attr('name', formattedElmName)
                                    .attr('id', 'formatted_pref_currency_amount');
        elm.before(formattedElm);
    }
};

app.util.setAmountValue = function (amount, eventsArr, source) {
    var events = eventsArr || ['change', 'setValue'];
    var itemAmountElm =  $('#item_amount_1');
    itemAmountElm.val(amount);
    _.each(events, function (ev) {
        itemAmountElm.trigger(ev);
    });

    if(app.util.maskedItemAmountPlugin && _.isFunction(app.util.maskedItemAmountPlugin.setValue) && source !== 'maskedAmount') {
        app.util.maskedItemAmountPlugin.setValue(amount);
    }
}

app.util.setAmountElmEvents = function ($itemAmountElm) {
    if ($itemAmountElm
        && $itemAmountElm.length
        && ($itemAmountElm[0].tagName === 'INPUT'
            || $itemAmountElm[0].tagName === 'SELECT')
    ) {
        $itemAmountElm.on('keyup keypress blur maskedAmountUserInput change', function (ev) {
            var $this = $(this);
            var amount = $this.val();
            app.util.handleFee(app.current_pm_feeObj);
            app.lastSelectedAmount = amount;
            pubsub.publish('app.event.AmountChange', [amount, ev.type, $itemAmountElm[0].tagName]);

            if (app.suggestPointsPlugin) {
                app.suggestPointsPlugin.setValue(parseFloat(amount));
            }
            if (ev.type === "blur" || ev.type === "change") {
                $this.addClass('blurred');
                app.util.validateField(this['id'], amount, null, ev.type);
                app.util.reInitVisaCheckout();
            } else if ($this.hasClass('blurred')) {
                app.util.validateField(this['id'], amount, null, ev.type);
            }
        });
    }
};

app.util.showIFrameBlockUI = function (topLoc) {
    $.blockUI({
        message: $('#targetIFrame'),
        css: {
            width: '100%',
            height: '100%',
            padding: '0px',
            left: ($(document).width() <= 480 ? 0 : ($(document).width() - 480) / 2) + 'px',
            top: topLoc + 'px'
        }
    });
};

app.util.applyFixedAmountRestrictions = function () {
    if (!app.isOpenAmount) {
        app.lastSelectedAmount = app.lastSelectedAmount || app.amount;
        app.util.setMinMaxValidationLimits({
            currencyISO: app.lastSelectedCurrency,
            minValue: app.lastSelectedAmount,
            maxValue: app.lastSelectedAmount
        });
        var $itemAmountElm = $('#item_amount_1');
        if ($itemAmountElm.length === 0 || ($itemAmountElm.length && !($itemAmountElm.attr('readonly') || $itemAmountElm.attr('type') === 'hidden'))) {
            app.util.clearFormAmountState();
            $itemAmountElm.remove();
            $('#item_amount_1_validation, #label_open_amount_range, .hide_open_amount_item').remove();
            var payload = {amount: app.lastSelectedAmount, currency: app.lastSelectedCurrency};
            var $fixedTpl = $('#fld_fixed_amount_1');
            $itemAmountElm = $('<input type="hidden" name="item_amount_1" id="item_amount_1" class="hidden" value="' + app.lastSelectedAmount + '">');
            var $fixedAmountElm = $(_.template($fixedTpl.length ? $fixedTpl.text() : '<input type="text" readonly data-amount="<%-amount%>"  id="fixed_amount_1" class="amount" value="<%-amount%>">')(payload));
            $('#PPPParametersForm').append($itemAmountElm);
            $('.amount-container').append($fixedAmountElm);
        } else {
            app.util.setAmountValue(app.lastSelectedAmount, []);
            $('#fixed_amount_1').val(app.lastSelectedAmount);
        }
        // Presentation ONLY :
        app.util.setDomElmValue($('#fixed_amount_placeholder'), app.formatter.formatCurrency(app.lastSelectedAmount, app.lastSelectedCurrency, app.roundingScale, true));
        app.util.setDomElmValue($('#fixed_deposit_amount'), app.formatter.formatDecimal(app.lastSelectedAmount, app.lastSelectedCurrency, app.roundingScale, true));
        app.util.setDomElmValue($('#c_symbol'), app.formatter.getCurrencySymbol(app.lastSelectedCurrency));

        pubsub.publish('app.event.FixedAmountRestrictionsApplied', [app.lastSelectedAmount]);
    }
};

app.util.setDomElmValue = function ($elm, value) {
    if ($elm.length) {
        if ($elm[0].tagName === 'INPUT' || $elm[0].tagName === 'SELECT') {
            $elm.val(value);
        } else {
            $elm.html(value);
        }
    }
}

app.util.clearFormAmountState = function () {
    var amountContainer = $('.amount-container');
    var amountParentRow = amountContainer.closest('.row').removeClass('invalid valid');
    $('#item_amount_1_validation').empty().removeClass('invalid_field');
    $('.invalid, .valid, .valid_field, .invalid_field', amountParentRow).removeClass('invalid valid valid_field invalid_field');
    $('[data-mode="Table"] .suggested-points, [data-mode="Points"]  .suggest-points tr').empty();
    amountContainer.empty();
};

app.util.setMinMaxValidationLimits = function (amountLimits) {
    if (amountLimits && !_.isEmpty(amountLimits)) {
        $('#item_min_amount_1').val(amountLimits['minValue']);
        $('#item_max_amount_1').val(amountLimits['maxValue']);
        app.validators.item_amount_1.checks.inRange.min = amountLimits['minValue'];
        app.validators.item_amount_1.checks.inRange.max = amountLimits['maxValue'];
    }
};

app.util.setAmountElmMinMaxLimits = function (amountLimits) {
    if (amountLimits && !_.isEmpty(amountLimits)) {
        var maxIntLen = app.ptRequestId ? app.config.PT_MAX_INT_AMOUNT_LEN_BEFORE_DECIMAL : Math.min((parseInt(amountLimits['maxValue']) + '').length, app.CONSTANTS.MAX_INT_AMOUNT_LEN);
        $('input#item_amount_1')
            // .attr('maxlength', maxIntLen + app.roundingScale + 1)
            .attr('min', amountLimits['minValue'])
            .attr('max', amountLimits['maxValue'])
        ;
        if(app.util.maskedItemAmountPlugin) {
            $('#masked_item_amount_1').prop('min', amountLimits['minValue'])
                                      .prop('max', amountLimits['maxValue']);
        }
        app.util.setAmountElmNumberMask(maxIntLen);
    }
};

app.util.setAmountElmNumberMask = function (maxIntLen) {
    maxIntLen = maxIntLen || (app.ptRequestId ? app.config.PT_MAX_INT_AMOUNT_LEN_BEFORE_DECIMAL : app.CONSTANTS.MAX_INT_AMOUNT_LEN);
    var itemAmountElm = $('input#item_amount_1');
    if (itemAmountElm.attr('type') !== 'number') {
        var numberMaskOpts = {
            type        : app.roundingScale == 0 ? 'int' : 'float',
            beforePoint : maxIntLen,
            afterPoint  : app.roundingScale,
            decimalMark : '.'
        };
        var plugin = itemAmountElm.data('plugin_numberMask');
        if (plugin) {
            plugin.setNumberMask(numberMaskOpts);
        } else {
            itemAmountElm.numberMask(numberMaskOpts);
        }
    }

    if(itemAmountElm.length && app.util.maskedItemAmountPlugin) {
        app.util.maskedItemAmountPlugin.createMask({
            maxLength: maxIntLen
        });
        app.bodyElm.addClass('use_masked_amount');
    }
};

app.util.shouldSkipLightbox = function (type) {
    var showInNoneMode = ['validation_box', 'warning'];
    return !(app.config.messagesMode !== app.CONSTANTS.MESSAGES_MODE.NONE || _.indexOf(showInNoneMode, type) >= 0);
};

app.util.presentPostponedTrxOnApmClose = function presentPostponedTrxOnApmClose() {
    while(app.postponedTrxOnApmClose.length) {
        app.onTransactionComplete(app.postponedTrxOnApmClose.shift());
    }
};

app.util.handleTrxCompletePopups = function (data, type, onConfirmFn, onCancelFn, shouldRedirect, className, modalWrapper) {
    // TODO: Remove setTimeout  After ServerFix
    var timeout = 0;
    var isLastTrxDataModal = data && data.isLastTrxDataModal;
    if (!isLastTrxDataModal && app.config.ptRequestId && (type === 'error' || type === 'success' || type === 'pending')) {
        // $.blockUI();
        timeout = 3000;
    }
    setTimeout(function (onConfirm, onCancel) {
        if(modalWrapper !== 'lightbox_ws') {
            $('.targetIframeWrap_overlay').stop().hide(); // hide 3d-secure Iframe blockUI
        }
        $.unblockUI();
        var pa_trx, kyc, verification_failed, classList = className ? type + " " + className : type;
        if (data && data.details) {
            pa_trx = data.details.pa_trx;
            kyc = data.details.kycResponse;
            if (pa_trx) {
                pa_trx.status = type;
                pa_trx.params = [
                    parseFloat(pa_trx.amount).toFixed(app.roundingScale),
                    app.util.remapCurrency(pa_trx.currency),
                    app.formatter.formatCurrency(pa_trx.amount, pa_trx.currency, null, true)
                ];
            }
            if (kyc) {
                /** ensure proper trxStatus */
                data.details.trxStatus = type;
                if (data.details.kycResponse.documentUploadUrl) {
                    onConfirm = function () {
                        app.util.triggerDocUpload(data.details.kycResponse);
                        app.util.sendPostMessage(type, app.config.parentUrl);
                    };
                }
            }
            if (data.trxStatus === app.CONSTANTS.TRX_STATUS.APPROVED) {
                switch (data.details.upoVerificationStatus) {
                    case app.CONSTANTS.VERIFICATION_STATUS.NEW :
                        data.details.message_text = app.msg['lightbox_name_verification_new'];
                        break;
                    case app.CONSTANTS.VERIFICATION_STATUS.PENDING :
                        data.details.message_text = app.msg['lightbox_name_verification_pending'];
                        break;
                    case app.CONSTANTS.VERIFICATION_STATUS.VERIFIED :
                        data.details.message_text = app.msg['lightbox_name_verification_ok'];
                        break;
                    case app.CONSTANTS.VERIFICATION_STATUS.NOT_VERIFIED :
                        verification_failed = app.CONSTANTS.MODAL_MESSAGE_TYPE.UPO_VERIFICATION_FAILED;
                        classList = verification_failed + " error " + (className || '');
                        break;
                    default :
                        break;
                }
            }

            if (app.util.getCustomTrxCompleteMessageText && typeof app.util.getCustomTrxCompleteMessageText === 'function') {
                data.details.message_text = app.util.getCustomTrxCompleteMessageText(data);
            }
            data.details.useIntl = app.config.useIntlFormatter;
        }

        if (kyc) { /** ( kyc || kyc && pa_trx ) */
            app.showModalMessage(data, "kyc", onConfirm, onCancel, classList);
        } else if (pa_trx) {
            app.showModalMessage(data, "pa_trx", app.util.onPartialApprovalAction('confirm'), app.util.onPartialApprovalAction('cancel'), classList);
        } else if (verification_failed) {
            var redirectUrl = data.redirectUrl;
            var dataObj = {
                "eventType": data.eventType,
                "payment_method": data.details ? data.details.payment_method : ''
            }
            app.showModalMessage(data, verification_failed, app.util.onVerificationFailedAction('contactSupport', redirectUrl, dataObj), app.util.onVerificationFailedAction('cancel', redirectUrl, dataObj), classList, modalWrapper);
        } else if (app.config.showTrxCompletePopups) {
            app.showModalMessage(data, type, onConfirm, onCancel, className, modalWrapper);
        } else {
            if (!shouldRedirect) {
                var srvMsg = _.isObject(data.message) ? data.message.errorCode : data.message || '';
                app.util.showToastMessage(type, srvMsg);
            }
            onConfirm = onConfirm || function () {
                app.util.sendPostMessage(type, app.config.parentUrl);
            };
            onConfirm();
        }
    }, timeout, onConfirmFn, onCancelFn);
};

app.util.showToastMessage = function (type, msg) {
    var raw = {
        amount      : app.lastSelectedAmount || app.amount,
        currencyIso : app.lastSelectedCurrency,
        useIntl     : app.config.useIntlFormatter,
    };
    var payload = {
        message : {
            msgKey : (msg || ("toast_trx_msg_" + type)),
            params : [app.formatter.formatDecimal(app.lastSelectedAmount || app.amount), app.formatter.getCurrencySymbol(app.lastSelectedCurrency)],
            type   : type,
            raw    : raw
        }
    };
    utils.showToastMessage(payload);
};

app.util.onPartialApprovalAction = function (action) {
    var isConfirmedUserAction = (action == 'confirm');
    return function () {
        var silent = true;
        var customAction = 'partialChoice.do';
        if (!isConfirmedUserAction) {
            app.util.addTmpFormData({cancelPartialApproval : true});
        }
        app.continueButtonHandler(null, silent, customAction);
        pubsub.publish("app.event.paUserChoice", [{action: action}]);
    };
};

app.util.onVerificationFailedAction = function (action, redirectUrl, data) {
    var isWSEvent = data.eventType === "websocket";
    var paymentMethodLabel = isWSEvent ? data.payment_method : app.lastSelectedMethodType;
    var payload = {
        "label": paymentMethodLabel,
        "verification_status": "FAILED"
    };
    return function () {
        pubsub.publish('app.event.failedNameVerification', [{action:action}]);
        app.util.sendPostMessage("success"); // STRANGE ?!!!
        app.util.sendPostMessage({
            "action" : "failedNameVerification",
            "payload": payload
        });
        if(action === 'contactSupport'){
            // pubsub.publish('app.event.drContactSupport'); // inappropriate!!!
            app.util.sendPostMessage({
                "action" : "contactSupport",
                "payload": payload
            });
        }
        if (app.config.nextDepositURL) {
            app.util.updateCSRFToken(app.reloadPMs);
        } else if (redirectUrl){
            window.location.href = redirectUrl;
        } else if (isWSEvent) {
            app.reloadPMs();
        } else {
            $.blockUI();
        }
    };
};

app.util.onRemoveUpoSuccess = function (srvData, upoInfo) {
    var handler = function () {
        app.util.closeLightbox();
        app.reloadPMs();
    };
    if (app.config.showPostRemoveUpoPopup) {
        app.showModalMessage({message: upoInfo}, app.CONSTANTS.MODAL_MESSAGE_TYPE.UPO_WAS_REMOVED, handler, handler, "success");
    } else {
        handler();
    }
};

app.util.onRemoveUpoError = function (srvData, upoInfo) {
    /**  param [upoInfo] is added because of the customisations **/
    if (srvData.message === app.CONSTANTS.SRV_RESPONSE.MSG_SESSION_EXPIRED) {
        app.showFinalMessage(srvData.message);
    } else {
        var msg = {
            text: srvData.message,
            titleKey: "pm_removal_failed"
        };
        app.showModalMessage({message: msg}, app.CONSTANTS.MODAL_MESSAGE_TYPE.ERROR);
    }
};

app.util.sendPostMessage = function (msg, url) {
    url = url || ('*');
    msg = JSON.stringify(msg);
    if (app._webViewSDK && app._webViewSDK.postMessage) {
        app._webViewSDK.postMessage(msg);
    } else if (window.opener) {
        window.opener.postMessage(msg, url);
    } else {
        parent.postMessage(msg, url);
    }
};

app.util.loadMainLayout = function () {
    var bodyElm = $('body');
    var htmlElm = $('html');
    var mainLayout;
    bodyElm.removeClass('fixed_amount rebilling registration_page rtl');
    htmlElm.removeClass('regularDeposit quickDeposit');

    if (!app.config.isOpenAmount) {
        bodyElm.addClass('fixed_amount');
    }
    if (app.config.isRebilling) {
        bodyElm.addClass('rebilling');
    }
    if (app.CONSTANTS.RTL_LOCALES[app.config.locale]) {
        bodyElm.addClass('rtl');
    }
    if (app.config.showRegisterPage) {
        bodyElm.addClass('registration_page');
    }


    if (app.quickDeposit.isShow) {
        if (app.config.zoomFactor) {
            htmlElm.addClass('zoom-factor-' + app.config.zoomFactor);
        }
        mainLayout = $('#quick-deposit-layout');
        htmlElm.addClass('quickDeposit');
    } else {
        mainLayout = $('#theme-layout');
        htmlElm.addClass('regularDeposit');
    }

    if (mainLayout.length) {
        bodyElm.empty();
        var layoutTemplate = _.template(mainLayout.text());
        bodyElm.append(layoutTemplate(app));
    }
};

app.util.filterCitadelFields = function (pmFieldsArr, countryISO) {
    countryISO = countryISO || app.country || '';
    var citadelRestrictedFields = {
        'DEFAULT': ['citadel_account_numberCA', 'citadel_account_numberAU', 'citadel_branch_codeCA', 'citadel_bank_codeCA', 'citadel_branch_codeAU', 'citadel_ibanMX'],// 1.2.3.4.5
        'CA': ['citadel_iban', 'citadel_swift_code', 'citadel_account_numberAU', 'citadel_branch_codeAU', 'citadel_ibanMX'], 										// 1.4.5.6.8.9
        'AU': ['citadel_iban', 'citadel_swift_code', 'citadel_account_numberCA', 'citadel_branch_codeCA', 'citadel_bank_codeCA', 'citadel_ibanMX'],					// 1.4.5.7.10
        'MX': ['citadel_iban', 'citadel_swift_code', 'citadel_bank_city', 'citadel_account_numberCA', 'citadel_account_numberAU', 'citadel_branch_codeCA', 'citadel_bank_codeCA', 'citadel_branch_codeAU']	// 1.5.11
    };
    var restrictedFields = citadelRestrictedFields[countryISO] || citadelRestrictedFields['DEFAULT'];
    return _.filter(pmFieldsArr, function (obj) {
        obj['usedByPms'] = obj['usedByPms'] || '';
        var pms = obj['usedByPms'].split(',');
        if (_.indexOf(pms, "apmgw_Citadel") >= 0) {
            return (_.indexOf(restrictedFields, obj.name) < 0);
        } else {
            return true;
        }
    });
};

/**
 * filter out Unsupported DirectFlow Fields
 */
app.util.filterDirectFlowFields = function (pmFieldsArr) {
    var fld2PM = app.CONSTANTS.DIRECT_FLOW_FIELDS_2_PMS;
    return _.filter(pmFieldsArr, function (obj) {
        var fld_name = obj['name'] || '';
        return !(fld2PM[fld_name] && !app.config.pmSettings[fld2PM[fld_name]].supportDirectFlow)
    });
};

app.util.applyScrollablePlugin = function () {
    var scrollable = {};
    scrollable.elm = $('[data-plugin="scrollable"]');
    scrollable.otherFixedHeight = parseInt(scrollable.elm.attr('data-reduce_height') || 0);     // 218+20

    var getHeightOfReduceElms = function (ids) {
        var totalHeight = 0;
        if (ids === '') {
            return totalHeight;
        }
        var reduceIds = ids.split(' ');
        _.each(reduceIds, function (elmId) {
            var elm = $('#' + elmId);
            if (elm.length === 1) {
                var opt = (elm.css('display') !== "table-row"); /* Fix Firefox behaviour */
                totalHeight += parseInt(elm.outerHeight(opt) || 0);
            }
        });
        return totalHeight;
    };

    scrollable.otherFixedHeight += getHeightOfReduceElms(scrollable.elm.attr('data-reduce_by_id') || '');

    var detailsHeight = viewportSize.getHeight() - scrollable.otherFixedHeight;
    var childContHeight = $('[data-plugin="scrollable"] > div').outerHeight(true);
    if (!scrollable.elm.attr('data-height_floatable') || (childContHeight > detailsHeight)) {
        scrollable.elm.css('height', detailsHeight + 'px');
    } else {
        scrollable.elm.css('height', childContHeight + 'px');
    }

    if (childContHeight > detailsHeight) {
        if (scrollable.elm.length && !app.scroller) {
            var scrollOpt = $.extend(true, {}, {
                scrollX: false,
                scrollY: true,
                mouseWheel: true,
                scrollbars: true,
                interactiveScrollbars: true,
                shrinkScrollbars: 'scale'
            }, app && app.pluginOpts && app.pluginOpts.Scrollable || {});
            app.scroller = new IScroll('[data-plugin="scrollable"]', scrollOpt);
        }
    } else {
        if (app.scroller && app.scroller.destroy) {
            app.scroller.scrollTo(0, 0, 0);
            app.scroller.destroy();
            delete app.scroller;
        }
    }

    if (app.scroller && app.scroller.refresh) {
        app.scroller.refresh();
    }
};

app.util.handlePMPreSelection = function (upmData, pmData) {
    upmData || (upmData = []);
    pmData || (pmData = []);
    var allowApplePayAutoSelect = false;
    var validId;

    if (app.submittedMethod && _pmExist(app.submittedMethod.id)) {
        validId = app.submittedMethod.id;
    } else if (!app._flag.firstPreselectionDone) {
        if (app.config.preselectPmType) {
            validId = _findFirstIdByPmName(upmData, app.config.preselectPmType, "upm") || _findFirstIdByPmName(pmData, app.config.preselectPmType, "pm");
        }
        if (!validId && app.config.promotePaymentMethod.isActive) {
            validId = _getPromotedPmId();
        }
    }
    if (!validId) {
        validId = (upmData[0] && upmData[0].userPaymentOptionId) || (pmData[0] && pmData[0].value);
        var showApplePayInline = app.config.pmSettings.ppp_ApplePay && app.config.pmSettings.ppp_ApplePay.showApplePayInline;
        allowApplePayAutoSelect = !showApplePayInline && !app.submittedMethod; // AutoSelect ApplePay only once (on page load)
    }

    if (app.config.useSubpages) {
        app._flag.isReload = true;
        app.lastSelectedMethodId = null;
        if (app.config.preserveSubpageOnReload) {
            var hash = window.location.hash;
            if (!app.config.preventPMAutoSelect && !(hash && (hash.startsWith(app.CONSTANTS.HASH.PM) || hash.startsWith(app.CONSTANTS.HASH.DETAILS)))) {
                window.location.hash = app.CONSTANTS.HASH.PM + validId;
            }
        } else if (!app.config.preventPMAutoSelect) {
            window.location.hash = app.CONSTANTS.HASH.PM + validId;
        }
        Path.listen();
    } else if (!app.config.preventPMAutoSelect) {
        app.selectPM(validId, allowApplePayAutoSelect);
    }
    app._flag.firstPreselectionDone = true;
    app.submittedMethod = false;

    /***************  handlePMPreSelection helpers Start  *************/
    function _findFirstIdByPmName(arr, pmName, type) {
        var id;
        if (pmName && arr) {
            var item = _.find(arr, (type === "upm" ? {'paymentOptionName': pmName} : {'value': pmName}));
            id = item && item[type === "upm" ? 'userPaymentOptionId' : 'value'];
        }
        return id;
    }

    function _pmExist(id) {
        return !!(id && (app._upoList[id] || app._poList[id]));
    }

    function _getPromotedPmId() {
        var id, upoId, poId;
        if (app.config.promotePaymentMethod.isActive && app.config.quickDeposit.isShow === false) {
            upoId = app.config.promotePaymentMethod.userPaymentOptionId;
            poId = app.config.promotePaymentMethod.payment_method;
            id = (app._upoList[upoId] && upoId) || (app._poList[poId] && poId);
        }
        return id;
    }

    /***************  handlePMPreSelection helpers End  *************/
};

/**
 *
 * @param showUserPMs
 * @param showMerchantPMs
 */
app.util.retrievePaymentMethods = function (showUserPMs, showMerchantPMs) {
    if (!(showUserPMs || showMerchantPMs)) {
        return;
    }

    var upmRequestParams = {
        ssid: app.ssid,
        country: app.country,
        ts: (new Date).getTime()
    };
    if (app.ptRequestId) {
        upmRequestParams.ptRequestId = app.ptRequestId;
    }
    var pmRequestParams = {
        countryIso: app.country,
        ssid: app.ssid,
        msid: app.msid,
        amount: app.amount,
        isRebillingHidden: $("#isRebillingHidden").val(),
        currency: app.currency,
        locale: app.locale,
        ptRequestId: app.ptRequestId,
        ts: (new Date).getTime()
    };
    var customPMFilter = _.isFunction(app.config.customPMFilter) ? app.config.customPMFilter : _.identity;
    var upmRetriever, pmRetriever, upmData = [], pmData = [];

    if (showUserPMs && showMerchantPMs) {
        upmRetriever = $.getJSON('getUserPaymentOptions.do', upmRequestParams);
        pmRetriever = $.getJSON('getPaymentOptions.do', pmRequestParams);
        $.when(upmRetriever, pmRetriever).done(function (upmRetrieverRes, pmRetrieverRes) {
            if (
                (upmRetrieverRes && upmRetrieverRes[0] && upmRetrieverRes[0].status === app.CONSTANTS.SRV_RESPONSE.STATUS_FAIL
                    && upmRetrieverRes[0].message === app.CONSTANTS.SRV_RESPONSE.MSG_SESSION_EXPIRED)
                ||
                (pmRetrieverRes && pmRetrieverRes[0] && pmRetrieverRes[0].status === app.CONSTANTS.SRV_RESPONSE.STATUS_FAIL
                    && pmRetrieverRes[0].message === app.CONSTANTS.SRV_RESPONSE.MSG_SESSION_EXPIRED)
            ) {
                app.showFinalMessage(app.CONSTANTS.SRV_RESPONSE.MSG_SESSION_EXPIRED);
                return;
            }
            upmData = customPMFilter(upmRetrieverRes[0].upoList || [], 'upm');
            upmData = _.sortBy(upmData, 'uiOrder');
            pmData = customPMFilter(pmRetrieverRes[0] || [], 'pm');

            var upmFilteringTask = app.onUserPaymentOptionAvailable(upmData);
            var pmFilteringTask = app.onPaymentOptionsAvailable(pmData);
            $.when(upmFilteringTask, pmFilteringTask).done(function (filteredUpmData, filteredPmData) {
                pubsub.publish('app.event.PMDataAvailable', [filteredUpmData, filteredPmData]);
                app.util.handlePMPreSelection(filteredUpmData, filteredPmData);
            });
        });
    } else if (showMerchantPMs) {
        pmRetriever = $.getJSON('getPaymentOptions.do', pmRequestParams);
        $.when(pmRetriever).done(function (pmRetrieverRes) {
            if (pmRetrieverRes && pmRetrieverRes.status === app.CONSTANTS.SRV_RESPONSE.STATUS_FAIL
                && pmRetrieverRes.message === app.CONSTANTS.SRV_RESPONSE.MSG_SESSION_EXPIRED
            ) {
                app.showFinalMessage(app.CONSTANTS.SRV_RESPONSE.MSG_SESSION_EXPIRED);
                return;
            }
            pmData = customPMFilter(pmRetrieverRes || [], 'pm');
            app.onPaymentOptionsAvailable(pmData).then(function (filteredPmData) {
                pubsub.publish('app.event.PMDataAvailable', [upmData, filteredPmData]);
                app.util.handlePMPreSelection(upmData, filteredPmData);
            });
        });
    } else if (showUserPMs) {
        upmRetriever = $.getJSON('getUserPaymentOptions.do', upmRequestParams);
        $.when(upmRetriever).done(function (upmRetrieverRes) {
            upmData = customPMFilter(upmRetrieverRes && upmRetrieverRes.upoList || [], 'upm');

            if (upmData.length > 0) {
                upmData = _.sortBy(upmData, 'uiOrder');

                // Reduce UPMs in "quick deposit" mode
                if (app.quickDeposit.isShow && app.quickDeposit.upmCount <= upmData.length) {
                    upmData = _.slice(upmData, 0, app.quickDeposit.upmCount || 1);
                }

                app.onUserPaymentOptionAvailable(upmData).then(function (filteredUpmData) {
                    pubsub.publish('app.event.PMDataAvailable', [filteredUpmData, pmData]);
                    app.util.handlePMPreSelection(filteredUpmData, pmData);
                });
            } else if (upmRetrieverRes && upmRetrieverRes.status === app.CONSTANTS.SRV_RESPONSE.STATUS_FAIL && upmRetrieverRes.message === app.CONSTANTS.SRV_RESPONSE.MSG_SESSION_EXPIRED) {
                app.showFinalMessage(app.CONSTANTS.SRV_RESPONSE.MSG_SESSION_EXPIRED);
            } else {
                app.showModalMessage({
                    message: {
                        text: app.config.showRegisterPage ? 'no_payment_options' : 'you_do_not_have_quick_deposit_methods',
                        titleKey: 'no_payment_data'
                    }
                }, 'error_blocking');
            }
            app.submittedMethod = false;
        });
    }
};

/* Default PM data filtering */
app.util.filterPmData = function (pm_data) {
    var isAndroidPaySdk = (function () {
        if (window['AndroidPay'] && window['AndroidPay'].isSupported) {
            console.log('We have android pay', window['AndroidPay'].isSupported());
            return window['AndroidPay'].isSupported();
        }
        return false;
    }());
    var isPrApi = window.PaymentRequest && navigator.userAgent.match(/Android/i);
    var enableAndroidPay = isAndroidPaySdk || isPrApi;

    pm_data = _.filter(pm_data, function (pmItem) {
        if (pmItem.value === 'ppp_ApplePay') {
            return app.util.isApplePayEnabled();
        } else if (pmItem.value === app.CONSTANTS.PM_NAME.GOOGLE_PAY) {
            return app.util.GooglePay.isReadyToPay();
        } else if (pmItem.value === 'ppp_AndroidPay') {
            return enableAndroidPay;
        } else if (pmItem.value === app.CONSTANTS.PM_NAME.WIRE_TRANSFER) {
            return (app['calienteWTPaymentReference'] !== 'false');
        }
        return true;
    });

    pm_data = _.map(pm_data, function (pmItem) {
        if (pmItem.value === 'ppp_ApplePay') {
            pmItem.label = 'Apple Pay';
            pmItem.attributes = pmItem.attributes || {};
            pmItem.attributes.isIframe = !app.openedInIframeMode;
        } else if (pmItem.value === app.CONSTANTS.PM_NAME.GOOGLE_PAY) {
            pmItem.label = 'Google Pay';
            pmItem.attributes = pmItem.attributes || {};
            pmItem.attributes.isIframe = !app.openedInIframeMode;
        } else if (pmItem.value === 'ppp_AndroidPay') {
            pmItem.label = 'Android Pay';
            pmItem.attributes = pmItem.attributes || {};
            if (pmItem.attributes.publicKey) {
                androidPay.setPublicKey(pmItem.attributes.publicKey)
            }
            /** @namespace pmItem.attributes.googleMerchantId */
            if (pmItem.attributes.googleMerchantId) {
                androidPay.setMerchantId(pmItem.attributes.googleMerchantId)
            }
        }
        return pmItem;
    });

    var apIndexInPM = _.findIndex(pm_data, function (o) {
        return o.value === 'ppp_AndroidPay';
    });
    if (isPrApi && apIndexInPM > -1 && document.location.protocol === 'https:') { // Ensure 'PaymentRequest' secure context
        var apDetails = pm_data[apIndexInPM]['attributes'];
        app.util.androidPayDetails = apDetails;
        var supportedInstruments = [{
            supportedMethods: ['https://android.com/pay'],
            data: {
                merchantName: document.title, // get it from somewhere else
                merchantId: apDetails.googleMerchantId, //'16665456132746676627', ///merchantId,
                environment: 'TEST',
                allowedCardNetworks: ['AMEX', 'DISCOVER', 'MASTERCARD', 'VISA'],
                paymentMethodTokenizationParameters: {
                    tokenizationType: 'NETWORK_TOKEN',
                    parameters: {
                        'publicKey': apDetails.publicKey
                    }
                }
            }
        }];

        var details = {
            total: {label: 'Pay', amount: {currency: app.config.currency, value: app.config.amount}},
            displayItems: [{
                label: 'Pay via Safecharge',
                amount: {currency: app.config.currency, value: app.config.amount}//,
            }]
        };
        var request = new PaymentRequest(supportedInstruments, details);
        if (request.canMakePayment) {
            request.canMakePayment().then(function (result) {
                isPrApi = result;
                pm_data = _.filter(pm_data, function (pmItem) {
                    return !(!isAndroidPaySdk && !isPrApi && pmItem.value === 'ppp_AndroidPay');
                });
            }).catch(function () {
                isPrApi = false;
                pm_data = _.filter(pm_data, function (pmItem) {
                    return !(!isAndroidPaySdk && !isPrApi && pmItem.value === 'ppp_AndroidPay');
                });
                app._filteredPmData = _.uniq(pm_data, 'value');
                return app._filteredPmData;
            });
        } else if (isPrApi) {
            isPrApi = false;
            pm_data = _.filter(pm_data, function (pmItem) {
                return !(!isAndroidPaySdk && !isPrApi && pmItem.value === 'ppp_AndroidPay');
            });
        }
    }
    app._filteredPmData = _.uniq(pm_data, 'value');
    return app._filteredPmData;
};

app.util.handleSubPages = function (useSubpages) {
    if (useSubpages) {
        $('[data-page="1"], [data-page="2"]').hide();
        if (app.config.preventPMAutoSelect) {
            $('[data-page="1"]').show();
        }
        Path.map(app.CONSTANTS.HASH.DETAILS + ":payment").to(function () {
            var uniqueId = parseInt(this.params["payment"]) || this.params["payment"];
            if (!app.lastSelectedMethodId || app.lastSelectedMethodId !== uniqueId) {
                app.selectPM(uniqueId);
            }
            $('[data-page="1"]').hide();
            $('[data-page="2"]').show();
            window.scrollTo(0, 0);
            pubsub.publish('subpage-select', [{'id': '2'}]);
        });
        Path.map(app.CONSTANTS.HASH.PM + ":payment").to(function () {
            var uniqueId = parseInt(this.params["payment"]) || this.params["payment"];
            pubsub.publish('cmd-select-pm', [{uniqueId: uniqueId}, window], this);
            if (app.lastSelectedMethodId !== uniqueId && !app._flag.setDefaultMethodId) {
                app.selectPM(uniqueId);
            }
            $('[data-page="1"]').show();
            $('[data-page="2"]').hide();
            window.scrollTo(0, 0);
            pubsub.publish('subpage-select', [{'id': '1'}]);
        });
        $('body').on("click", '[data-page="back"]', function () {
            if (app.config.useVirtualSubpageBackNav && window.location.hash.startsWith(app.CONSTANTS.HASH.DETAILS)) {
                window.location.hash = app.CONSTANTS.HASH.PM + app.lastSelectedMethodId;
            } else {
                window.history.back();
            }
        });
        pubsub.subscribe('select-pm-attempt', function (data) {
            if (window.location.hash === (app.CONSTANTS.HASH.PM + data.uniqueId)) {
                window.location.hash = app.CONSTANTS.HASH.DETAILS + data.uniqueId;
            } else if (app._flag.setDefaultMethodId || window.location.hash.startsWith(app.CONSTANTS.HASH.PM)) {
                app._flag.setDefaultMethodId = false;
                window.location.hash = app.CONSTANTS.HASH.PM + app.lastSelectedMethodId;
            } else if (window.location.hash.length < 4) {
                window.location.hash = app.CONSTANTS.HASH.PM + data.uniqueId;
                window.location.hash = app.CONSTANTS.HASH.DETAILS + data.uniqueId;
            }
        });
    }
};

app.util.transformLightboxContent = function ($lightbox, data) {
    /** add some extra properties & reattach events to the parent **/
    var info = data && data.message && data.message.info;
    var feRef = info && info.feRef;
    $lightbox || ($lightbox = $('#lightbox'));
    var $lightbox_content = $lightbox.find('.lightbox-content');
    $lightbox_content.find('.dr_pm_logo, #dr-another-card, #smaller-amount, .resubmit, #try-next-pm, #select-other-pm, #contact-issuer-bank, #dr-try-url')
        .each(function (i, elm) {
            var $e = $(elm), f = $e.attr('onclick'), pf = _parseDrFnString(f), csmsAction = $e.attr('data-csms-action');
            $e.parent()
                .attr('data-action', pf.actionType)
                .attr('data-ref', feRef)
                .addClass('wrap_' + (elm.id || ""))
                .on('click', function (e) {
                    var $this = $(this);
                    var actionType = pf.actionType || $this.attr('data-action');
                    if (actionType && _isDrActionAllowed(actionType) && app.declineRecovery[actionType]) {
                        var args = pf.args ? pf.args.slice() : [];
                        var metaInfo = {
                            actionType: actionType,
                            drOptionPosition: $this.attr('data-position'),
                            submittedFeRef: feRef,
                            submittedPmId: info && info.submittedMethod && info.submittedMethod.id,
                            submittedPmName: info && info.submittedMethod && info.submittedMethod.pmName
                        };
                        args.push(metaInfo);
                        app.declineRecovery[actionType].apply(this, args);
                        app.util.sendCsmsActionSelected(csmsAction, feRef, metaInfo.submittedPmName);
                    }
                });
            $e.removeAttr('data-csms-action');
            $e.removeAttr('onclick');
            $e.removeAttr('title');
        });
    $lightbox_content.find('.try_pm').on('click', function () {
        $lightbox.find('.modal_close').trigger('click');
    });
    var $cs = $lightbox_content.find('.contact-support');
    if ($cs.length) {
        var $cs_parent = $cs.parent(), cs_html;
        var $dr_cs_tpl = $('#dr_contact_support_tpl');
        if (app.config.useCsmsMessages) {
            $cs.removeClass();
            cs_html = $cs_parent.html();
        } else if ($dr_cs_tpl.length) {
            var payload = {
                "message"  : $cs_parent.text() + ' {0}',
                "phone_to" : app.msg && app.msg.phone_to ? app.msg.phone_to : "",
                "mail_to"  : app.msg && app.msg.mail_to ? app.msg.mail_to : ""
            }
            cs_html = _.template($dr_cs_tpl.text())(payload);
        } else if (app.msg && (app.msg.phone_to || app.msg.mail_to)) {
            cs_html = '<div>' + $cs_parent.text() + ':</div>' + (app.msg.mail_to || '') + (app.msg.phone_to || '');
        } else {
            cs_html = '<div>' + $cs_parent.text() + '</div>';
        }
        $cs_parent
            .html(cs_html)
            .attr('data-action', 'contactSupport')
            .attr('data-ref', feRef)
            .addClass('support');
    }
    if (app.config.useIntlFormatter) {
        var tryLowerAmount = $lightbox_content.find('#smaller-amount');
        var amt = tryLowerAmount.data('amount');
        if (tryLowerAmount.length && amt) {
            tryLowerAmount.text(app.formatter.formatCurrency(amt, app.lastSelectedCurrency, null, true));
        }
    }
    var $resubmit = $lightbox_content.find('.resubmit');
    if ($resubmit.length) {
        $resubmit.parent()
            .attr('data-action', 'tryAgain')
            .attr('data-ref', feRef)
            .addClass("drResubmitButton");
    }
    if ($lightbox.hasClass('error-suggest')) {
        $lightbox_content.find('.try_pm > div, .try_pm > li').each(function (i, elm) {
            $(elm).attr('data-position', i + 1);
        });
    }

    /***************  transformLightboxContent helpers Start  *************/
    function _parseDrFnString(str) {
        var keyWords = {
            "this": this,
            "null": null,
            "undefined": null,
        };
        var ret = {}
        if (str && _.isString(str)) {
            var s = str.trim();
            var actionType = s.substring(0, s.indexOf('(')) || '';
            ret.actionType = _isDrActionAllowed(actionType) && actionType;
            if (ret.actionType) {
                ret.args = [];
                var args = s.substring(s.indexOf('(') + 1, s.lastIndexOf(')')).split(',');
                args.forEach(function (v, i, arr) {
                    var v1 = v && v.trim().replace(/(^\')|(\'$)/g, '');
                    v1 && ret.args.push(keyWords[v1] || v1);
                });
            }
        }
        return ret;
    }

    function _isDrActionAllowed(action_type) {
        var allowedDrActions = {
            'suggestOtherPaymentMethod': 1,
            'suggestMyMethod': 2,
            'suggestAddNewCard': 3,
            'lowerOpenAmount': 4,
            'contactSupport': 5,
            'tryAgain': 6,
            'tryNextPm': 7,
            'tryAnotherPm': 8,
            'contactIssuerBank': 9,
            'redirectToUrl': 10
        };
        return !!allowedDrActions[action_type];
    }

    /***************  transformLightboxContent helpers End  *************/
};

app.util.sendCsmsActionSelected = function(csmsAction, feRef, submittedPmName) {
    if (
        csmsAction === "SELECT_ANOTHER_OPTION" ||
        csmsAction === "TRY_LOWER_AMOUNT" ||
        csmsAction === "TRY_AGAIN" ||
        csmsAction === "TRY_NEXT_PM" ||
        csmsAction === "TRY_FIXED_PM"
    ) {
        $.ajax({
            "url": "/ppp/csmsActionSelected?ssid=" + app.ssid,
            "method": "POST",
            "headers": {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            "data": {
                "ssid": app.ssid,
                "feRef": feRef,
                "selectedAction": csmsAction,
                "selectedPm": submittedPmName || ''
            }
        });
    }
};

/**
 *
 * @param response
 * @returns {boolean}
 */
app.util.assertAjaxResponseTypeJSON = function (response) {
    var msg;
    if (response && response.responseText && response.responseText.substring(0, 5) === "<html") {
        msg = $('<div>').html(response.responseText).find('p');
    } else if (response && (typeof response === 'string') && response.substring(0, 5) === "<html") {
        msg = $('<div>').html(response).find('p');
    } else {
        return true;
    }
    app.showFinalMessage(msg || "Error");
    return false;
};

app.util.makeWMFinishPaymentRequest = function (ssid, val, cb) {
    var url = '/ppp/finishPayment.do';//  "/ppp/initPayment.do";
    var data = {
        ssid: ssid
    };
    if (val) {
        data.webmoney_sms_code = val;
    }
    $.ajax({
        url: url,
        data: data,
        dataType: 'json',
        success: cb,
        error: cb
    });
};

app.util.closeLightbox = function () {
    $('body').removeClass('overflowed');
    $('#lightbox').hide();
    $('[role="lbx_wrapper"]').empty().removeClass();
    $('.modalOverlay.lightbox_overlay').stop().fadeOut();
    $.unblockUI();
    app.onNotificationEnd();
};

app.util.closePopUpWindow = function (pm, initiator) {
    if (pm && (!app.submittedMethod || app.submittedMethod.pmName === pm)) {
        if (app._popupWnd && app._popupWnd.close) {
            app._popupWnd.close();
            app._popupWnd = false;
            pubsub.publish("popupWndClose", [{pmName: pm, initiator: initiator}]);
        }
    }
};

app.util.clearCardFields = function (fields) {
    fields = fields || {};
    _.each(fields, function (fieldObj, key) {
        var elm = $("#" + key);
        if (elm.length && fieldObj.type === "REQUIRED") {
            elm.val('');
            if (elm[0].tagName === 'SELECT') {
                var c_select = elm.closest('div[data-type="cSelect"]');
                $('div', c_select).text($('option', elm).first().text());
            }
        }
    })
};

app.util.clearValidationState = function () {
    $('.row.valid, .row.invalid, .validation_image.valid_field, .validation_image.invalid_field')
        .removeClass('invalid valid valid_field invalid_field');
    $('.validation_image').empty();
    app._validationResult = {};
};

app.util.updateCSRFToken = function (cb) {
    if (app.config.nextDepositURL) {
        $.get(app.config.nextDepositURL, function (htmlData) {
            delete app.config.nextDepositURL;
            var csrfRegex = /name="CSRFToken"\s+value="(\w+)"\/>/gm;
            var result = csrfRegex.exec(htmlData) || [];
            var newCSRFToken = result[1];
            $('input[name=CSRFToken]').val(newCSRFToken);
            if (cb) {
                cb();
            }
        });
    }
};

app.util.toggleSPointsClass = function (hasSuggestedAmounts, hasPricePoints) {
    var classes = {
        toAdd: '',
        toRemove: '', // prevent remove all classes
    };
    classes[(hasPricePoints ? 'toAdd' : 'toRemove')] += ' has_ppoints';
    classes[((app.suggestPointsPlugin && hasSuggestedAmounts) ? 'toAdd' : 'toRemove')] += ' has_spoints';
    app.bodyElm.removeClass(classes.toRemove).addClass(classes.toAdd);
    app.util.applyScrollablePlugin();
};

app.util.isFbtLikePm = function (type) {
    return (_.indexOf(app.config.fbtLikePMs, type) >= 0 || _.indexOf(app.config.allowZeroAmountPMs, type) >= 0);
};

app.util.isStaticPm = function (id, type) {
    var isUpo = app.util.isUpo(id);
    var pmWithStaticUpo = {
        'apmgw_PayNearMe': 1
    };
    return (isUpo ? pmWithStaticUpo[type] : app.CONSTANTS.STATIC_PMS[id]);
};

app.util.isRestrictedCardType = function (type) {
    return (_.indexOf((app.config.invalidCardIssuers || []), type) >= 0);
};

app.util.applySuggestPointsPlugin = function () {
    app.suggestPointsPlugin = 0;
    if (app.config.isOpenAmount && !app.config.useMerchantManagedAmount) {
        var $suggestElm = $('.suggested-amounts-holder');
        if ($suggestElm.length) {
            if (!app.suggestPointsPlugin || app.suggestPointsPlugin.element !== $suggestElm[0]) {
                var suggestMode = $suggestElm.data('mode') || 'Points';
                var suggestPointsParams = $.extend(true, {
                    data: [],
                    currency: app.currency,
                    onChange: function (oldVal, newValue) {
                        var itemAmountElement = $('#item_amount_1');
                        var currentValue = itemAmountElement.val();
                        if (parseFloat(currentValue) - newValue !== 0) {
                            app.util.setAmountValue(newValue, ['setValue']);
                            newValue = newValue || '';
                            app.util.validateField('item_amount_1', newValue.toString(), null, 'change');
                            app.util.handleFee(app.current_pm_feeObj);      // pubsub.publish('amount-change', [oldVal, newValue]);
                            app.lastSelectedAmount = newValue;
                            var tag_name = itemAmountElement[0] && itemAmountElement[0].tagName;
                            pubsub.publish('app.event.AmountChange', [newValue, 'setValue', tag_name]);
                        }
                    }
                }, app.pluginOpts['suggest' + suggestMode]);
                app.suggestPointsPlugin = $suggestElm['suggest' + suggestMode](
                    suggestPointsParams
                ).data('plugin_suggest' + suggestMode);
            }
        }
    }
    return app.suggestPointsPlugin;
};

app.util.on3dIfameReady = function (data) {
    $.unblockUI();

    function load3dsPage(dataToSend) {
        dataToSend = dataToSend || {
            details: {},
            status: 'PROCEED_3D_SECURE'
        };
        pubsub.publish('safecharge.to_3d_iframe', [dataToSend]);
        if (dataToSend.details.url) { // skip 3dSecure
            $.blockUI();
        } else {
            if (app.lastSelectedMethodType === 'ppp_ApplePay' && app.config.use3dsForApple) {
                app.util.ApplePayTrxStatus({trxStatus: app.CONSTANTS.TRX_STATUS.APPROVED});
            }
            if (data.details && data.details.use3dsManagement) {
                appendIframeInfoHtml();
            }
            app.show3DIFrame({
                iframeMaxHeight: 750,
                iframeWidth: 950
            });
        }
    }

    function appendIframeInfoHtml() {
        var infoHtml = app.util.getLightboxContentTemplate('iframe_info')({message: data.details});
        var $targetIframeWrapper = $('.targetIframeWrap');
        $('#iframe_info', $targetIframeWrapper).remove();
        $targetIframeWrapper.append($(infoHtml));
        $('#skip_3d_secure').on('click', function () {
            onSkip3dSecure(data.details);
        });
        $('#try_another_option').on('click', function () {
            $("#continueButton").off().on("click", app.continueButtonHandler);
            pubsub.unsubscribe(data.details.subscribeObject);
        });
    }

    function onSecureBeforeYes() {
        load3dsPage();
    }

    function onSecureBeforeNo() {
        if (!data.details.secure3dMandatory && data.details.use3dsSkipOption) {
            if (data.details.use3dsPostdialog) {
                loadSecureAbortedDialog();
            } else {
                onSecureAbortedContinue();
            }
        } else { // DO Nothing === tryAnotherOption
            $("#continueButton").off().on("click", app.continueButtonHandler);
        }
    }

    function onSecureAbortedContinue() {
        var dataToSend = {
            details: {url: "gateway.do?skip3dSecure=true"},
            status: 'PROCEED_3D_SECURE'
        };
        load3dsPage(dataToSend);
    }

    function loadSecureAbortedDialog() {
        app.showModalMessage({details: data.details}, 'secure_aborted',
            onSecureAbortedContinue,
            function () { // BACK = Close
                $("#continueButton").off().on("click", app.continueButtonHandler);
                pubsub.unsubscribe(data.details.subscribeObject);
            }
        );
    }

    function onSkip3dSecure(details) {
        if (details.use3dsSkipOption && details.use3dsPostdialog) {
            loadSecureAbortedDialog();
        } else {
            onSecureAbortedContinue();
        }
    }

    function init3ds() {
        if (data.details.use3dsManagement && data.details.use3dsPredialog) {
            app.showModalMessage({details: data.details}, 'secure_before', onSecureBeforeYes, onSecureBeforeNo);
        } else {
            load3dsPage();
        }
    }

    if (data && data.status === 'IFRAME_READY') {
        app.tree_d_details = data.details;
        init3ds();
    }
};

app.util.closeTargetIframe = function () {
    app.bodyElm.removeClass('overflowed');
    $('#targetIframeWrap').hide().find('#iframe_info').empty().remove();
    $('.modalOverlay.targetIframeWrap_overlay').stop().hide();
    $('#targetIFrame').attr('src', ' ');
    app._flag.lastApmOpenedInFrame = false;
    pubsub.publish('targetIframeClose', []);
};

app.util.extendSession = (function () {
    var run = true;
    return function (minutes) {
        if (run) {
            minutes = _.isNaN(parseInt(minutes)) ? 60 : parseInt(minutes);
            var endTime = (new Date()).getTime() + minutes * 60 * 1000;
            var interval = setInterval(function () {
                if ((new Date()).getTime() >= endTime) {
                    clearInterval(interval);
                } else {
                    $.getJSON('getCountryStates.do', {ssid: app.config.ssid, countryIso: app.config.country})
                        .done(function () {
                            if ((new Date()).getTime() >= endTime) {
                                clearInterval(interval);
                            }
                        });
                }
            }, 5 * 60 * 1000);
            run = false;
        }
    }
})();

app.util.getCountryStates = function (countryISO) {
    var def = $.Deferred();
    if (app._countryStates && app._countryStates[countryISO]) { // cash_L1
        def.resolve(app._countryStates[countryISO]);
    } else if (app.CONSTANTS.STATES[countryISO]) { // cash_L2
        app._countryStates[countryISO] = app.util.remapPropsAs({
            "iso": "value",
            "name": "text"
        }, app.CONSTANTS.STATES[countryISO]);
        def.resolve(app._countryStates[countryISO]);
    } else if (app.CONSTANTS.KNOWN_STATES_FOR_COUNTRY[countryISO]) {
        var ajx = $.getJSON('/ppp/getCountryStates.do', {countryIso: countryISO, ssid: app.config.ssid});
        ajx.done(function (states) {
            app._countryStates[countryISO] = app.util.remapPropsAs({"iso": "value", "name": "text"}, states || []);
            def.resolve(app._countryStates[countryISO]);
        });
    } else {
        app._countryStates[countryISO] = [];
        def.resolve(app._countryStates[countryISO]);
    }
    return def.promise();
};

/**
 * @param opt - {oldPropName_1: newPropName_1 [, oldPropName_2: newPropName_2]}
 * @param objArr - array of objects to be transformed
 * @returns {[]} - new Array with transformed objects
 */
app.util.remapPropsAs = function (opt, objArr) {
    var arr = [];
    _.each(objArr, function (item, i) {
        var newItem = {};
        _.each(Object.keys(item), function (k) {
            var newKey = opt[k] || k;
            newItem[newKey] = item[k];
        });
        arr.push(newItem);
    });
    return arr;
};

app.util.getDccSelectedCurrencyIso = function () {
    var $agreeDcc, iso = false;
    if(app.config.useDcc) {
        $agreeDcc = $('#agreeDcc');
        iso = !$agreeDcc.attr('disabled') && $agreeDcc.is(':checked') && $('#preferred_currency').val();
    }
    return iso;
};

app.util.storeCurrentMethodCurrencies = function (data) {
    app._currentMethodCurrencies = data;
    return app._currentMethodCurrencies;
};

app.util.prepareDccData = function (dataArr) {
    var arr = [], obj = {};
    _.each(dataArr, function (o, i) {
        if (o.iso !== app.config.currency) {
            arr.push(o);
            obj[o.iso] = i;
        }
    });
    _.sortBy(arr, [function (o) {
        return o.iso;
    }]);
    return {
        obj : obj,
        arr : arr
    };
};

app.util.currencyExchange = (function () {
    var _g = {};
    var cfg = {
        originalCurrencyIso       : 'EUR',
        originalCurrencyPrecision : 2,
        preselectAgreeDcc         : false,
        useFixedFraction          : false,
        PT_tpl                    : JSON.stringify,
        DCC_tpl                   : JSON.stringify,
        DCC_rate_tpl              : JSON.stringify
    };
    var CONST = {
        ROUNDING : {
            CLP: 0, DJF: 0, ISK: 0, JPY: 0, KRW: 0, PYG: 0, UGX: 0, VND: 0, VUV: 0, XAF: 0, XOF: 0, YEN: 0, BYR: 0, GNF: 0, MMK: 0, RWF: 0, XPF: 0, IDR: 0, COP: 0,
            BHD: 3, IQD: 3, JOD: 3, KWD: 3, OMR: 3, TND: 3,
        },
        PT_FLOW  : "PT",
        DCC_FLOW : "DCC"
    };
    CONST.DCC_MINIMIZED_CLASS_NAME = "dcc_minimized";
    CONST.DCC_HIDDEN_CLASS_NAME = "hidden";
    CONST.DCC_CARDPM_CLASS_NAME = "card_pm";
    CONST.MULTIPLIERS = [1, 10, 100, 1000, 10000, 100000];
    /** take one more fraction digit - in order to perform more Accurate rounding */
    CONST.EXTRA_MULTIPLIER = 10;
    /** Floating-point error correction */
    CONST.EPSILON = 0.000001;

    var subscribe = (function () {
        var types = {
            onAmountChange        : 'onAmountChange',
            onRecognitionComplete : 'onRecognitionComplete'
        };
        var subscribers = {
            onAmountChange        : {},
            onRecognitionComplete : {}
        };
        var addHandler = function (type, guid, handler) {
            if (typeof handler === 'function') {
                subscribers[type][guid] = handler;
            }
        };
        var removeHandler = function (type, guid) {
            if (subscribers[type][guid]) {
                delete subscribers[type][guid];
            }
        };
        var execute = function (amount) {
            _.each(subscribers['onAmountChange'], function (item) {
                item(amount);
            });
        };
        var executeCardRecognitionComplete = function (obj) {
            _.each(subscribers['onRecognitionComplete'], function (item) {
                item(obj.resp);
            });
        };
        pubsub.subscribe('app.event.AmountChange', execute);
        pubsub.subscribe('app.event.RestrictionsApplied', execute);
        pubsub.subscribe('app.event.card_recognition_complete', executeCardRecognitionComplete);
        return {
            types         : types,
            addHandler    : addHandler,
            removeHandler : removeHandler
        };
    })();

    function setup(config) {
        if (config && _.isObject(config)) {
            _.keys(config).forEach(function (prop, i) {
                cfg[prop] = config[prop];
            });
        }
        cfg.originalCurrencyPrecision = _normalizePrecision(cfg.originalCurrencyPrecision, cfg.originalCurrencyIso);
    }

    function selectCurrency(currency) {
        if (_g.$preferred_currency_select
            && _g.$preferred_currency_select.val() !== currency
            && _g.currencies
            && _g.currencies[currency]) {
            _g.$preferred_currency_select.val(currency).trigger('change');
        }
    }

    function _init(flow, currencyData, preferredCurrency, isCardPM) {
        var normalized = _normalizeCurrencies(currencyData);
        var currenciesCopy = normalized && normalized.currencyObj && $.extend(true, {}, normalized.currencyObj);

        pubsub.publish('app.event.pm_normalized_currencies', [currenciesCopy]);

        var prefCurrencyIso = _getPreferredCurrency(flow, normalized, preferredCurrency);
        var minimizeDccSection = (preferredCurrency === cfg.originalCurrencyIso);

        _renderCurrencyExchangeHtml(flow, _getRenderingData(normalized, prefCurrencyIso, minimizeDccSection));
        app.util.appendPrefCurrencyAmountMask();
        _updateGlobals({
            currentFlow                : flow,
            currencies                 : normalized && normalized.currencyObj,
            prefCurrencyIso            : prefCurrencyIso,
            $currency_exchange_wrapper : $('#currency_exchange_wrapper'),
            $pref_currency_amount      : $('#pref_currency_amount'),
            $preferred_currency_select : $('#preferred_currency')
        });

        var error = _getErrors(normalized);
        if (error) {
            _clearState(flow, error);
            return;
        }

        _g.$preferred_currency_select.cSelect();

        _initDccSection(minimizeDccSection, isCardPM);
        _showConvertedAmount();
        _attachEvents(flow);
    }

    /**=================== currencyExchange helpers ===================*/

    function _initDccSection(minimizeDccSection, isCardPM) {
        if (_g.currentFlow === CONST.DCC_FLOW) {
            if (minimizeDccSection) {
                _setAgreeDccPropCheckedTo(false);
                if (isCardPM) {
                    _hideDccSection();
                } else {
                    _minimizeDccSection();
                }
            }
            if (isCardPM && !app.config.showAllDccCurrenciesOnCC) {
                _g.$currency_exchange_wrapper.find('.dcc_container').addClass(CONST.DCC_CARDPM_CLASS_NAME);
                _hideDccNonSelectedCurrencies(); // remove currencies except selected
            }
        }
    }

    function _showConvertedAmount() {
        var selectedCurrencyIso = _g.$preferred_currency_select.val();
        var currencyObj = _g.currencies && _g.currencies[selectedCurrencyIso] || {};
        var amount, formatted_amount, converted_amount, rate, precision;

        amount = parseFloat($('#item_amount_1').val() || $('#fixed_amount_1').val() || 0);
        amount = _roundAmountTo(amount, cfg.originalCurrencyPrecision);
        rate = currencyObj.rate || 1.0;
        precision = _normalizePrecision(currencyObj.scale, selectedCurrencyIso);
        converted_amount = _convertAmount(amount, rate, precision);
        converted_amount = cfg.useFixedFraction ? converted_amount.toFixed(precision) : converted_amount;
        formatted_amount = app.formatter.formatDecimal(converted_amount, selectedCurrencyIso, precision, cfg.useFixedFraction);

        _updateConvertedAmount(converted_amount, formatted_amount);

        if (_g.currentFlow === CONST.DCC_FLOW) {
            var payload = {
                originalCurrency : cfg.originalCurrencyIso,
                newCurrency      : selectedCurrencyIso,
                rate             : rate,
                markup           : (_roundAmountTo(parseFloat(currencyObj.markup || 0) * 100, 3))
            };
            _updateConversionRateInfo(payload);
        }
    }

    function _onCardRecognitionResponse(resp) {
        /** Relevant for Card PMs only !!! */
        if (_g.currentFlow === CONST.DCC_FLOW) {
            if (resp.isCardAllowed
                && resp.dccSupport
                && resp.currency
                && resp.currency !== cfg.originalCurrencyIso
                && _g.currencies && _g.currencies[resp.currency]
            ) {
                selectCurrency(resp.currency);
                _setAgreeDccPropCheckedTo(cfg.preselectAgreeDcc);
                if (!app.config.showAllDccCurrenciesOnCC) {
                    _hideDccNonSelectedCurrencies(); // remove currencies except resp.currency
                }
                _maximizeDccSection();
                _showDccSection();
            } else {
                _setAgreeDccPropCheckedTo(false);
                _hideDccSection();  // hide entire section
                /*OR Old way (v1)*/
                // // Keep selecting the right currency so we're ready if someone checks the checkbox
                // selectCurrency(_g.prefCurrencyIso);
                // _minimizeDccSection();
            }
        }
    }

    function _updateGlobals(obj) {
        _g = $.extend(true, {}, _g, obj);
    }

    function _getErrors(normalized) {
        var error_msg;
        if (!_g.$currency_exchange_wrapper.length) {
            error_msg = "ERROR! Missing #currency_exchange_wrapper!";
        } else if (!normalized
            || !normalized.currencyArr.length
            || (normalized.currencyArr.length === 1 && _g.prefCurrencyIso === cfg.originalCurrencyIso)
        ) {
            error_msg = "WARNING! No currency conversion data!";
        } else if (!(_g.$pref_currency_amount.length && _g.$preferred_currency_select.length)) {
            error_msg = "ERROR! Invalid Conversion Template";
        }
        return error_msg;
    }

    function _roundAmountTo(amount, precision) {
        amount = parseFloat(amount || 0);
        precision = _normalizePrecision(precision);
        var newAmount, multiplier;
        multiplier = CONST.MULTIPLIERS[precision];
        newAmount = Math.round(parseInt(amount * (multiplier * CONST.EXTRA_MULTIPLIER) + CONST.EPSILON) / CONST.EXTRA_MULTIPLIER) / multiplier;
        return newAmount;
    }

    function _convertAmount(amount, rate, precision) {
        var multiplier, converted_amount = amount;
        if (amount) {
            precision = _.isNumber(precision) && precision >= 0 && precision < 5 ? precision : 2;
            rate = parseFloat(rate);
            rate = (rate === 0) ? 0 : (rate || 1);
            multiplier = CONST.MULTIPLIERS[precision];
            converted_amount = Math.round(parseInt(amount * (rate * (multiplier * CONST.EXTRA_MULTIPLIER)) + CONST.EPSILON) / CONST.EXTRA_MULTIPLIER) / multiplier;
        }
        return converted_amount;
    }

    function _normalizeCurrencies(data) {
        var isArray = _.isArray(data);
        if (!data || (isArray && !data.length)) {
            return;
        }
        var ret = {
            currencyArr : [],
            currencyObj : {}
        };
        var idx = 0;
        _.forEach(data, function (item, k) {
            var o = (isArray) ? item : {
                iso    : k,
                rate   : item,
                markup : 0,
                scale  : (CONST.ROUNDING[k] !== undefined ? CONST.ROUNDING[k] : 2)
            };
            ret.currencyArr.push(o);
            ret.currencyObj[o.iso] = $.extend(true, {}, o, {uiOrder : idx});
            idx++;
        });
        return ret;
    }

    function _normalizePrecision(precision, currencyIso) {
        return _.isNumber(precision) && precision >= 0 && precision < 5 ? precision : (CONST.ROUNDING[currencyIso] !== undefined ? CONST.ROUNDING[currencyIso] : 2);
    }

    function _getPreferredCurrency(flow, data, prefIso) {
        var iso = prefIso;
        if (data && data.currencyObj && data.currencyArr) {
            if (flow === CONST.DCC_FLOW && !data.currencyObj[iso]) {
                /** DCC flow preselectOrder = ["requested", "EUR", "USD", "first drop down option"] */
                if (data.currencyObj["EUR"]) {
                    iso = "EUR";
                } else if (data.currencyObj["USD"]) {
                    iso = "USD";
                }
            }
            if (!data.currencyObj[iso]) {
                iso = data.currencyArr[0] && data.currencyArr[0].iso;
            }
        }
        return iso;
    }

    function _getRenderingData(data, selectedCurrency, minimizeDccSection) {
        return data && {
            message : {
                currencies             : data.currencyArr,
                preferredCurrency      : selectedCurrency,
                originalCurrencyInList : !!data.currencyObj[cfg.originalCurrencyIso],
                dccClassName           : (minimizeDccSection ? CONST.DCC_MINIMIZED_CLASS_NAME : ''),
                dccCheckboxState       : (cfg.preselectAgreeDcc && !minimizeDccSection ? 'checked' : '')
            }
        };
    }

    function _attachEvents(flow) {
        var handlerId = flow + "_CurrencyExchange";
        _g.$preferred_currency_select.on('change', function (e) {
            var selectedCurrencyIso = $(this).val();
            _showConvertedAmount();
            pubsub.publish('app.event.preferred_currency_change', [{
                flow        : flow,
                newCurrency : selectedCurrencyIso
            }]);
        });
        subscribe.addHandler(subscribe.types.onAmountChange, handlerId, _showConvertedAmount);

        if (flow === CONST.DCC_FLOW) {
            _g.$currency_exchange_wrapper.find('input[name="agreeDcc"]').on('change', function (e) {
                var isChecked = $(this).is(':checked');
                if (isChecked) {
                    _maximizeDccSection();
                }
                pubsub.publish('app.event.agreeDcc_change', [{flow : flow, isChecked : isChecked}]);
            });
            subscribe.addHandler(subscribe.types.onRecognitionComplete, handlerId, _onCardRecognitionResponse);
        }
    }


    /** modify UI */

    function _updateConvertedAmount(newAmount, formattedAmount) {
        if (_g.$pref_currency_amount[0].tagName === 'INPUT' || _g.$pref_currency_amount[0].tagName === 'SELECT') {
            _g.$pref_currency_amount.val(newAmount);
            if (app.config.useCurrencyExchangeFormatting) {
                $('#formatted_pref_currency_amount').val(formattedAmount);
            }
        } else {
            _g.$pref_currency_amount.html(newAmount);
        }
    }

    function _clearState(flow, msg) {
        var handlerId = flow + "_CurrencyExchange";
        msg && console.log(msg);
        $('#currency_exchange_wrapper').html('');
        subscribe.removeHandler(subscribe.types.onAmountChange, handlerId);
        subscribe.removeHandler(subscribe.types.onRecognitionComplete, handlerId);
        _g = {};
    }

    function _renderCurrencyExchangeHtml(flow, payload) {
        var html = payload ? cfg[flow + '_tpl'](payload) : '';
        $('#currency_exchange_wrapper').html(html);
    }


    /** change DCC UI */
    function _updateConversionRateInfo(payload) {
        if (!app.config.hideDccMarginAndRate) {
            var html = cfg['DCC_rate_tpl']({message : payload});
            $('#conversion_rate_info').html(html);
        }
    }

    function _setAgreeDccPropCheckedTo(checked) {
        checked = !!checked;
        if (_g.$currency_exchange_wrapper && _g.$currency_exchange_wrapper.length) {
            var ceckbox = _g.$currency_exchange_wrapper.find('input[name="agreeDcc"]');
            if (checked !== !!ceckbox.prop("checked")) {
                ceckbox.prop("checked", checked).trigger('change');
            }
        }
    }

    function _hideDccNonSelectedCurrencies() {
        if (_g.$preferred_currency_select) {
            var selectedIso = _g.$preferred_currency_select.val();
            _g.$preferred_currency_select.find('option').each(function () {
                var elm = $(this);
                if (elm.val() !== selectedIso) {
                    elm.addClass('hidden');
                } else {
                    elm.removeClass('hidden');
                }
            });
        }
    }

    function _hideDccSection() {
        _g.$currency_exchange_wrapper && _g.$currency_exchange_wrapper.find('.dcc_container').addClass(CONST.DCC_HIDDEN_CLASS_NAME);
    }

    function _showDccSection() {
        _g.$currency_exchange_wrapper && _g.$currency_exchange_wrapper.find('.dcc_container').removeClass(CONST.DCC_HIDDEN_CLASS_NAME);
    }

    function _maximizeDccSection() {
        _g.$currency_exchange_wrapper && _g.$currency_exchange_wrapper.find('.dcc_container').removeClass(CONST.DCC_MINIMIZED_CLASS_NAME);
    }

    function _minimizeDccSection() {
        _g.$currency_exchange_wrapper && _g.$currency_exchange_wrapper.find('.dcc_container').addClass(CONST.DCC_MINIMIZED_CLASS_NAME);
    }

    return {
        setup          : setup,
        selectCurrency : selectCurrency,
        renderIMS      : function (data, preferredCurrency, isCardPM) {
            _init(CONST.PT_FLOW, data, preferredCurrency, isCardPM);
            app.recalcUserDetailsArea();
        },
        renderDCC      : function (data, preferredCurrency, isCardPM) {
            _init(CONST.DCC_FLOW, data, preferredCurrency, isCardPM);
            app.recalcUserDetailsArea();
        }
    };
})();

app.util.setCVVLength = function (data) {
    var len = 3;
    if (!data
        || !data.card_type
        || data.card_type === 'amex'
        || data.card_type === 'none'
        || data.card_type === 'astropay_card') {
        len = 4;
    }
    var $cvv = app.util.$getPmSpecificElement('cc_cvv2', app.lastSelectedMethodType);
    if ($cvv.length) {
        $cvv.attr('maxlength', len);
    }
};

app.util.getPmSpecificFldName = (function (CONSTANTS) {
    return function (baseFieldName, pmName) {
        if (!pmName) {
            return baseFieldName;
        }
        var prefix = CONSTANTS.PREFIXABLE_FIELDS[baseFieldName] && CONSTANTS.FIELD_PREFIXES_PER_PM[pmName] || '';
        if ("visa_checkout" === pmName && baseFieldName !== 'cc_cvv2') {
            /* "visa_checkout" has ONLY "cc_cvv2" prefixed field
            => e.g. ONLY "visa_checkout_cc_cvv2" */
            prefix = '';
        }
        return (prefix + baseFieldName);
    }
})(app.CONSTANTS);

app.util.$getPmSpecificElement = function (baseFieldName, pm_name) {
    var prefixedFldName = app.util.getPmSpecificFldName(baseFieldName, pm_name);
    var ret = $("#" + baseFieldName);
    return ret.length ? ret : $("#" + prefixedFldName);
};

app.util.setCVVTooltip = function (data) {
    var len = '3';
    var message = app.msg.cvv_hint_exact_digits || '';
    if (data.card_type === 'none' || data.card_type === 'cc_card') {
        message = app.msg.cvv_hint || '';
    } else if (data && (data.card_type === 'amex' || data.card_type === 'astropay_card')) {
        len = '4';
    }
    message = message.replace('{0}', len);
    $("#cvv_hint").html(message);
};

app.util.showValidationResult = function () {
    var messages = [];
    _.each(app._validationResult, function (val, key) {
        messages.push((app.msg[key] || key) + ': ' + val.message);
    });
    app.util.showToastMessage(app.CONSTANTS.MODAL_MESSAGE_TYPE.ERROR, messages.join('; '));
};

app.util.onDeclineRecoveryMessage = function (data, error, apmErrorMsg, className, trxRef, modalWrapper, title, info) {
    if (_.isArray(data) && data.length) {
        // we might need condition if we are coming from websocket
        $('.targetIframeWrap_overlay').hide(); // hide 3d-secure Iframe blockUI
        if (data[0] === 'invalidCVV') {
            app.util.onDeclineRecoverySpecificMessage(data);
            return;
        }
        // catch ppp_wiretransfer
        var wtRegex = /dr-pm-ppp_wiretransfer/gi;
        var filterOut = app.config['calienteWTPaymentReference'] === 'false';
        data = _.filter(data, function (item) {
            return !(filterOut && wtRegex.test(item));
        });
        if (apmErrorMsg) {
            data.apmErrorMsg = apmErrorMsg;
        }
        if (_.isString(error)) {
            data.error = error;
        }
        if(trxRef) {
            data.reference  = trxRef;
        }
        if (error.errorCode) {
            data.errorCode = error.errorCode;
        }
        if (title) {
            data.titleKey = title;
        }
        if (info) {
            data.info = info;
            data.trxInfoHtml = app.util.getLightboxContentTemplate('trxInfoHtml')({info: info});
        }
        var _trxStatus = _.isObject(error) && error.trxStatus || 'CANCEL';
        app.showModalMessage({details: data, trxStatus: _trxStatus}, app.CONSTANTS.MODAL_MESSAGE_TYPE.ERROR_SUGGEST, null, null, className, modalWrapper);
    } else {
        var type = app.CONSTANTS.MODAL_MESSAGE_TYPE.ERROR;
        var handler = function () {
            app.util.sendPostMessage(type, app.config.parentUrl);
        };

        var payload = {message: error};
        if (app.config.showTrxCompletePopups) {
            if (_.isObject(error)) {
                payload = error;
                payload.trxStatus = error.trxStatus || 'CANCEL';
                if (!_.isObject(error.details)) {
                    payload.details = $.extend(true, {}, error);
                }
                apmErrorMsg && (payload.details.apmErrorMsg = apmErrorMsg);
            } else {
                var err = _.isString(error) ? error : '';
                payload = {
                    trxStatus: 'CANCEL',
                    source: "onDeclineRecoveryMessage",
                    details: {
                        apmErrorMsg: apmErrorMsg || err
                    }
                }
            }
            if (title) {
                payload.details.titleKey = title;
            }
            if(trxRef) {
                payload.details.reference = trxRef;
            }
            if (info) {
                payload.details.info = info;
                payload.details.trxInfoHtml = app.util.getLightboxContentTemplate('trxInfoHtml')({info: info});
            }
        }
        app.util.handleTrxCompletePopups(payload, app.CONSTANTS.MODAL_MESSAGE_TYPE.ERROR, handler, handler, false, className, modalWrapper);
    }
};

app.util.convertCsmsDeclineRecoveryData = function(data) {
    function formatRuleActionMessage(rule, paramValue) {
        var formattedStr;
        if (rule.ruleActionMessage && rule.parameterName) {
            if (rule.parameterValue  || paramValue) {
                if (!paramValue) {
                    paramValue = rule.parameterValue;
                }
                formattedStr = rule.ruleActionMessage.replace(new RegExp("{" + rule.parameterName + "}", 'g'), paramValue);
            }
            else {
                formattedStr = rule.ruleActionMessage.replace(new RegExp("{" + rule.parameterName + "}", 'g'), "");
            }
            return formattedStr;
        }

        return rule.ruleActionMessage;
    }

    function formatContacSupportParameterValue(paramValue) {
        var paramJson;
        var retStr = "";
        var res = {
            email: '',
            phone: '',
            message: ''
        };

        if (paramValue) {
            try {
                paramJson = JSON.parse(paramValue);
            }
            catch (err) {
                console.warn("Fail to parse JSON for CSMS Decline Recovery Rule: Contact Support");
            }
        }

        if (paramJson && paramJson.email) {
            res.email = $("<a>")
                        .attr('href', 'mailto:' + paramJson.email)
                        .text(paramJson.email)
                        .prop('outerHTML');
            retStr = res.email;
        }
        if (paramJson && paramJson.phone && paramJson.phone.countryCallingCode && paramJson.phone.phoneNumber) {
            var phoneNumStr = "+" + paramJson.phone.countryCallingCode + " " + paramJson.phone.phoneNumber;
            res.phone =  $("<a>")
                                 .attr('href', 'tel:' + phoneNumStr)
                                 .text(phoneNumStr)
                                 .prop('outerHTML');
            retStr += res.phone;
        }
        res.message = retStr;

        return res;
    }

    function createSuggestOtherPmHtml(rule, pmId, pmLogoClass, isUpo, pmName, csmsAction) {
        var retStr = "";
        var onClickVal;

        if (isUpo) {
            onClickVal = 'suggestMyMethod(' + pmId + ')';
        }
        else if (app._poList[pmId]) {
            onClickVal = 'suggestOtherPaymentMethod(' + '$("#' + pmId + '"),' + pmId + ')';
        }
        else {
            return "";
        }

        retStr = $('<span class="dr-popup-text">').text(formatRuleActionMessage(rule, pmName)).prop('outerHTML');
        retStr += $('<div class="dr_pm_logo">')
                    .attr('id', "dr-pm-" + pmLogoClass)
                    .attr('onclick', onClickVal)
                    .attr('data-csms-action', csmsAction)
                    .addClass('dr_pm_' + pmLogoClass.toLowerCase())
                    .prop('outerHTML');

        return retStr;
    }

    function findNextPM(currentPmId, feRef) {
        var currentPmIndex = -1;
        var nextPmIndex = -1;
        var isNextPmUpo;
        if (!app._filteredUpmData && !app._filteredPmData || !currentPmId) {
            return {};
        }

        if (app.util.isUpo(currentPmId)) {
            currentPmIndex = (app._filteredUpmData || []).findIndex(function(x) {return x.userPaymentOptionId === currentPmId});
            if (currentPmIndex > -1 && currentPmIndex === app._filteredUpmData.length - 1) {
                isNextPmUpo = !(app._filteredPmData && app._filteredPmData.length);
                nextPmIndex = 0;
            } else {
                isNextPmUpo = true;
                nextPmIndex = currentPmIndex + 1;
            }
        }
        else {
            currentPmIndex = (app._filteredPmData || []).findIndex(function (x) {return x.value === currentPmId});
            if (currentPmIndex > -1 && currentPmIndex === app._filteredPmData.length - 1) {
                isNextPmUpo = app._filteredUpmData && app._filteredUpmData.length;
                nextPmIndex = 0;
                if (isNextPmUpo) { // if next pm is upo we check if the upo is the same pm that we just tryed to skip it
                    var feRefData = app.util.FeRef.getRefData(feRef);

                    if (feRefData && feRefData.submittedMethod && feRefData.submittedMethod.id === app._filteredUpmData[nextPmIndex].paymentOptionName) {
                        nextPmIndex++;
                        if (nextPmIndex >= app._filteredUpmData.length) {
                            nextPmIndex = 0;
                            if(app._filteredPmData.length) {
                                isNextPmUpo = false;
                            }
                        }
                    }
                }
            } else {
                isNextPmUpo = false;
                nextPmIndex = currentPmIndex + 1;
            }
        }

        if (isNextPmUpo) {
            return {
                pmId:           app._filteredUpmData[nextPmIndex].userPaymentOptionId,
                pmLogoClass:    app._filteredUpmData[nextPmIndex].className.replace('_my_methods', ''),
                pmName:         app._filteredUpmData[nextPmIndex].name,
                isUpo:          isNextPmUpo
            };
        }
        else {
            return {
                pmId:           app._filteredPmData[nextPmIndex].value,
                pmLogoClass:    app._filteredPmData[nextPmIndex].value.toLowerCase(),
                pmName:         app._filteredPmData[nextPmIndex].label,
                isUpo:          isNextPmUpo
            };
        }
    }

    var retArr = [];
    var ruleActionHtml = "";
    if (data.ruleActions) {
        data.ruleActions.sort(function(a, b) { return a.orderInActionSet - b.orderInActionSet });
    }

    _.forEach(data.ruleActions, function(rule) {
        if (rule.ruleActionType === "TRY_AGAIN") {
            ruleActionHtml = $('<span class="dr-popup-text resubmit" onclick="tryAgain()" data-csms-action="TRY_AGAIN">').text(rule.ruleActionMessage).prop('outerHTML');
        }
        else if (rule.ruleActionType === "TRY_FIXED_PM") {
            if (app._poList[rule.parameterValue]) {
                ruleActionHtml = createSuggestOtherPmHtml(rule, rule.parameterValue, rule.parameterValue, false, app._poList[rule.parameterValue].label, rule.ruleActionType);
            }
        }
        else if (rule.ruleActionType === "REDIRECT_URL") {
            ruleActionHtml = $('<span id="dr-try-url" class="dr-popup-text" data-csms-action="REDIRECT_URL" onclick="redirectToUrl(\'' + rule.parameterValue + '\')">')
                .html(
                    formatRuleActionMessage(
                        rule,
                        $('<a>')
                            .text(rule.parameterValue)
                            .prop('outerHTML')
                    )
                ).prop('outerHTML');
        }
        else if (rule.ruleActionType === "TRY_NEXT_PM") {
            var nextPm = findNextPM(app.lastSelectedMethodId, data.feRef);
            ruleActionHtml = createSuggestOtherPmHtml(rule, nextPm.pmId, nextPm.pmLogoClass, nextPm.isUpo, nextPm.pmName, rule.ruleActionType);
        }
        else if (rule.ruleActionType === "SELECT_ANOTHER_OPTION") {
            ruleActionHtml = $('<span id="select-other-pm" class="dr-popup-text" data-csms-action="SELECT_ANOTHER_OPTION" onclick="tryAnotherPm();">').text(rule.ruleActionMessage).prop('outerHTML');
        }
        else if (rule.ruleActionType === "TRY_LOWER_AMOUNT") {
            ruleActionHtml = $('<span class="dr-popup-text resubmit" data-csms-action="TRY_LOWER_AMOUNT" onclick="tryAgain()">').text(rule.ruleActionMessage).prop('outerHTML');
        }
        else if (rule.ruleActionType === "CONTACT_SUPPORT") {
            var mailAndPhoneObj = formatContacSupportParameterValue(rule.parameterValue);
            if (!mailAndPhoneObj.message) {
                rule.parameterValue = "";
            }
            var html = formatRuleActionMessage(rule, mailAndPhoneObj.message);
            var $dr_cs_tpl = $('#dr_contact_support_tpl');
            if($dr_cs_tpl.length) {
                var payload = {
                    message: '',
                    mail_to: mailAndPhoneObj.email || '',
                    phone_to: mailAndPhoneObj.phoneNumStr || ''
                }
                if(rule.ruleActionMessage) {
                    payload.message = rule.ruleActionMessage.replace('{'+ rule.parameterName + '}', '{0}');
                }
                html = _.template($dr_cs_tpl.text())(payload);
            }

            ruleActionHtml = $('<div class="dr-popup-text contact-support" data-csms-action="CONTACT_SUPPORT">')
                        .html(html)
                        .prop('outerHTML');
        }
        else if (rule.ruleActionType === "CONTACT_ISSUER_BANK") {
            ruleActionHtml = $('<span id="contact-issuer-bank" class="dr-popup-text" onclick="contactIssuerBank();" data-csms-action="CONTACT_ISSUER_BANK">')
                        .text(formatRuleActionMessage(rule))
                        .prop('outerHTML');
        }

        if (ruleActionHtml) {
            retArr.push(ruleActionHtml);
            ruleActionHtml = '';
        }
    });

    return retArr;
};

app.util.onDeclineRecoverySpecificMessage = function (data) {
    pubsub.publish('safecharge.decline.recovery.specific.msg', data);
    $('#PPPParametersForm').attr('target', '_self');
    app.showModalMessage({details: (app.msg['lightbox_dr_specific_error'] || data[0])}, app.CONSTANTS.MODAL_MESSAGE_TYPE.ERROR);
};

app.util.selectFirstMPM = function () {
    if ($('[data-pms-type="vertical"]').length || $('[data-pms-type="horizontal"]').length || $('[data-pms-type="table"]').length || $('[data-pms-type="dropdown"] select').length) {
        pubsub.publish('dr-select-pm', [{uniqueId: "auto_select", type: 'pm', skipFldClear: true}]);
    }
};

app.util.changeLanguage = function (merchantLocale) {
    var merchantLocaleElm = $('#merchantLocale');
    if (!merchantLocaleElm.length) {
        merchantLocaleElm = $('<input type="hidden" name="merchantLocale"  id="merchantLocale"/>');
        merchantLocaleElm.val(app.config.locale);
        $('#PPPParametersForm').append(merchantLocaleElm);
    }
    if (merchantLocale) {
        merchantLocaleElm.val(merchantLocale);
    }
    document.forms[0].action = "changeLanguage.do";
    document.forms[0].submit();
};

/*  // TODO REMOVE_ME:
app.util.paydotcomOnSubmit = function (utmMedium) {
    var utm_medium = utmMedium || 'redirect';
    var utm_source = app.mid && app.msid ? app.mid + '_' + app.msid : '';
    var locale = app.locale || 'en_US';
    var arr = [];
    for (var i = 0; i < srvUserFields.length; i++) {
        arr.push(srvUserFields[i].name + '=' + encodeURIComponent(srvUserFields[i].value));
    }
    var params = arr.join('&') +
        '&currency=' + encodeURIComponent(app.currency || '') +
        '&source=cashier-deposit' +
        '&merchant_site_id=' + encodeURIComponent(app.msid || '') +
        '&user_token_id=' + encodeURIComponent(app.userTokenId || '') +
        '&referral=' + encodeURIComponent(app.msid || '') +
        '&utm_source=' + encodeURIComponent(utm_source) +
        '&utm_medium=' + encodeURIComponent(utm_medium) +
        '&utm_campaign=cashier-deposit' +
        '&locale=' + encodeURIComponent(locale);
    utils.paydotcom.submit({
        params: params,
        type: app.config.paydotcomType,
        locale: locale,
        country: app.config.country
    });
};

app.util.paydotcomOnSuccess = function () {
    app.reloadPMs();
    console.log('success and refresh');
};
*/
window.androidPay = (function () {
    var pubKey = '';
    var googleMerchantId = '';
    return {
        setPublicKey: function (pkey) {
            pubKey = pkey;
        },
        setMerchantId: function (gmid) {
            googleMerchantId = gmid;
        },
        getToken: function () {
            var amount = $('#item_amount_1').val() || $('#amount').val();
            AndroidPay.executeTokenRequest(JSON.stringify({
                "currency": (app.lastSelectedCurrency || app.currency),
                "amount": amount,
                "publicKey": pubKey,
                "onSuccess": "androidPay.onTokenAvailable",
                "onFail": "androidPay.onFail"
            }));
        },
        onTokenAvailable: function (result) {
            if (!$('#androidPayJson').length) {
                $('form').append('<input type="hidden" id="androidPayJson" name="androidPayJson" value="">');
            }

            $('#androidPayJson').val(JSON.stringify(result));
            $('#inIframeMode').val('true');
            $('#inPopupMode').val('false');
            submitInIframe();
        },
        onFail: function (error) {
            $.unblockUI();
        }
    };

}());

app.util.androidPayDetails = {};

app.util.handleAndroidPay = function () {
    var amount = $('#item_amount_1').val() || $('#amount').val();
    var supportedInstruments = [{
        supportedMethods: ['https://android.com/pay'],
        data: {
            merchantName: document.title,
            merchantId: app.util.androidPayDetails.googleMerchantId,
            environment: 'TEST',
            allowedCardNetworks: ['AMEX', 'DISCOVER', 'MASTERCARD', 'VISA'],
            paymentMethodTokenizationParameters: {
                tokenizationType: 'NETWORK_TOKEN',
                parameters: {
                    'publicKey': app.util.androidPayDetails.publicKey
                }
            }
        }
    }];
    var details = {
        total: {label: 'Pay', amount: {currency: app.config.currency, value: amount}},
        displayItems: [
            {
                label: 'Pay via Safecharge',
                amount: {currency: app.config.currency, value: amount}
            }
        ]
    };
    window._androidPayRequest = new PaymentRequest(supportedInstruments, details);
    window._androidPayRequest.show().then(function (apres) {
        if (apres.methodName === 'https://android.com/pay') {
            $('#payment_method').val('ppp_AndroidPay');
            if (!$('#androidPayJson').length) {
                $('form').append('<input type="hidden" id="androidPayJson" name="androidPayJson" value="">');
            }
            console.log(apres.details.paymentMethodToken);
            $('#androidPayJson').val(apres.details.paymentMethodToken);
            $('#inIframeMode').val('true');
            $('#inPopupMode').val('false');
            submitInIframe();
            window._apres = apres;
        }
    }).catch(function () {
        $.unblockUI();
    });
};

app.util.hasPTPredepositCheckForPM = function (pmName) {
    return app.config.ptRequestId && 
					(app.config.ptPredepositCheck.upos[pmName] || app.config.ptPredepositCheck.pos[pmName]);
};
app.util.doPreDepositCheck = function (preDepositCheckUrl) {
    var dataToSend = {
        amount: app.lastSelectedAmount,
        pmName: app.lastSelectedMethodType,
        ssid: app.config.ssid
    };
    return $.ajax({
        type: "POST",
        url: utils.addQueryStringParams(preDepositCheckUrl, {"ssid": app.config.ssid}),
        data: JSON.stringify(dataToSend),
        contentType: 'application/json',
        dataType: 'json',
        timeout: 40000
    });
};
app.util.handlePreDepositCheckResponse = function (ajaxData) {
    var def = new $.Deferred();
    if (ajaxData && ajaxData.depositConfirmations) {
        var onConfirm = function () {
            app.util.addConfirmedUserActions(ajaxData.depositConfirmations, ajaxData.orderTransactionId);
            def.resolve();
        };
        app.util.showDepositConfirmations(ajaxData.depositConfirmations, ajaxData.orderTransactionId, onConfirm, def.reject);
    } else if (ajaxData && ajaxData.status === 'FAIL') {
        var errorTxt = ajaxData.errorText;
        if (errorTxt && typeof errorTxt === "string") {
            if(app.lastSelectedMethodType === "ppp_GooglePay") {
                errorTxt = errorTxt.replace(/GooglePayviaSC/, "Google Pay")
            }
        }
        var payload = {
            apmErrorMsg: errorTxt,
            errorCode: ajaxData.errorCode
        }
        app.showModalMessage({message: payload}, app.CONSTANTS.MODAL_MESSAGE_TYPE.ERROR, def.reject, def.reject);
    } else {
        def.resolve();
    }

    return def.promise();
};
app.util.handlePredepositChecks = function (proceed) {
    $.blockUI();
    app.util.doPreDepositCheck(app.CONSTANTS.PREDEPOSIT_CHECK_URL)
        .then(app.util.handlePreDepositCheckResponse)
        .then(proceed)
        .fail(function () {
            pubsub.publish('app.event.predepositConfirmationDeclined');
        });
};

pubsub.subscribe('safecharge.transaction.complete', function (data) {
    var isAndroidPaySdk = (function () {
        if (window['AndroidPay'] && window['AndroidPay'].isSupported) {
            console.log('We have android pay', window['AndroidPay'].isSupported());
            return window['AndroidPay'].isSupported();
        }
        return false;
    }());
    if (app.lastSelectedMethodType === 'ppp_AndroidPay' && !isAndroidPaySdk) {
        if (data && data.trxStatus) {
            if (data.trxStatus === app.CONSTANTS.TRX_STATUS.APPROVED) {
                window._apres.complete('success');
            } else {
                window._apres.complete('fail');
            }
        } else {
            window._apres.complete('unknown');
        }
    }
});

app.util.preApplePayPaymentCheck = function (amount, ssid, flow) {
    return $.getJSON('/ppp/getAppleValidationJson.do?ssid=' + ssid + '&amount=' + amount + '&mobilePayFlow=' + flow);
};

app.util.appendToTmpDomElement = function(html){
    var $tmpDiv = $('#tmpDepositConfirmations');
    if(!$tmpDiv.length ){
        $tmpDiv = $('<div id="tmpDepositConfirmations" class="hidden"></div>');
        $('#PPPParametersForm').append($tmpDiv);
    }
    return $tmpDiv.append(html);
};

app.util.addTmpFormData = function (flattenDataObject) {
    if (flattenDataObject && _.isObject(flattenDataObject)) {
        var hiddenInputs = $('<div>');
        var $PPPParametersForm = $('#PPPParametersForm');
        _.each(flattenDataObject, function (v, k, o) {
            if (flattenDataObject.hasOwnProperty(k) && !_.isObject(v) && !$PPPParametersForm.find('input#' + k).length) {
                var i = $('<input id="' + k + '" type="hidden" name="' + k + '" value="">');
                i.val(v);
                hiddenInputs.append(i);
            }
        });
        app.util.appendToTmpDomElement(hiddenInputs);
    }
};

app.util.addConfirmedUserActions = function (depositConfirmations, orderTransactionId) {
    if (depositConfirmations && _.isObject(depositConfirmations)) {
        var hiddenInputs = '';
        _.each(depositConfirmations, function (v, k, o) {
            if (depositConfirmations.hasOwnProperty(k)) {
                hiddenInputs += '<input id="' + k + '" type="hidden" name="' + k + '">';
            }
        });
        if (orderTransactionId) {
            hiddenInputs += '<input id="orderTransactionId" type="hidden" value="' + orderTransactionId + '" name="orderTransactionId">';
        }
        app.util.appendToTmpDomElement(hiddenInputs);
    }
};

app.util.showDepositConfirmations = function (depositConfirmations, orderTransactionId, onConfirm, onCancel) {
    if (depositConfirmations && _.isObject(depositConfirmations)) {
        var message = {
            titleKey : 'deposit_confirmation',
            msgArr   : []
        };
        _.each(depositConfirmations, function (v, k, o) {
            if (depositConfirmations.hasOwnProperty(k) && v && _.isString(v)) {
                message.msgArr.push(v);
                message[k] = v;
            }
        });
        onConfirm = onConfirm || function () {
            app.util.addConfirmedUserActions(depositConfirmations, orderTransactionId);
        };
        if (message.msgArr.length) {
            app.showModalMessage({message : message}, app.CONSTANTS.MODAL_MESSAGE_TYPE.DEPOSIT_CONFIRMATIONS, onConfirm, onCancel);
        } else {
            app._logger.log('ERROR: showDepositConfirmations invoked with invalid params');
        }
    }
};

app.util.handleApplePay = function (evt, silent) {
    if (!silent) {
        pubsub.publish('app.event.DepositClicked', []);
    }
    if (!app.validateForm()) {
        return;
    }
    if (app.util.handlePreDepositLightboxes(doProceed, {silent: silent, customAction: ''})) {
        doProceed();
    }

    function doProceed() {
        app._applePayCanMakePaymentsWithActiveCardPromise = null;
        var amount = app.lastSelectedAmount;
        if (app.current_pm_feeObj) {
            var feeObj = app.util.getFeeRenderingData(app.current_pm_feeObj, app.lastSelectedAmount, app.lastSelectedCurrency);
            if (feeObj && feeObj.raw && feeObj.raw.total_amount && feeObj.raw.total_amount > amount) {
                amount = feeObj.raw.total_amount;
            }
        }
        amount = parseFloat(amount).toFixed(app.roundingScale);
        if (app.applePayDeviceSupport && window.webkit && window.webkit.messageHandlers) {
            window.webkit.messageHandlers.APSDK.postMessage({
                event: 'initiatePayment',
                amount: amount,
                currency: app.lastSelectedCurrency,
                onTokenAvailable: 'applePay.submitFormWithApplePayToken',
                onCancel: 'applePay.onCancel'
            });
        } else { // Apple Pay for Web
            var appleCfg = app.config.pmSettings.ppp_ApplePay || {};
            var apiVer = appleCfg._version || 1;
            var request = _createAppleRequestObject(amount, appleCfg);

            if (app.openedInIframeMode && app._parentSupportApplePay) {
                if (app.config.useDepositConfirmations) {
                    $.blockUI();
                    var currAmount = $('#item_amount_1').val();
                    request.delay = true;
                    app.util.ApplePayConnector.doPay({details: request, ver: apiVer});
                    /** it is (flow = "js") on purpose in order to make PT create transaction on server */
                    var flow = (app.ptRequestId) ? 'js' : app.CONSTANTS.APPLE_PAY_FLOW_4;
                    app.util.preApplePayPaymentCheck(currAmount, app.ssid, flow)
                        .always(function (verifyResp) {
                            if (verifyResp.depositConfirmations) {
                                var onConfirm = function () {
                                    app.util.addConfirmedUserActions(verifyResp.depositConfirmations, verifyResp.orderTransactionId);
                                    request.delay = false;
                                    app.util.ApplePayConnector.restartDoPay({details: request, ver: apiVer});
                                };
                                app.util.showDepositConfirmations(verifyResp.depositConfirmations, verifyResp.orderTransactionId, onConfirm);
                            } else if (verifyResp.status && verifyResp.status === 'FAIL') {
                                // kill Apple session & show error
                                app.util.ApplePayConnector.completeTrx({
                                    trxStatus: "cancelled",
                                    msg: "preApplePayPaymentCheck_FAIL"
                                });
                                if (verifyResp.error && typeof verifyResp.error === "string") {
                                    verifyResp.error = verifyResp.error.replace(/ApplePayviaSC/, "Apple Pay")
                                }
                                app.showModalMessage({message: verifyResp.error}, app.CONSTANTS.MODAL_MESSAGE_TYPE.ERROR);
                            } else { // proceed to payment
                                request.delay = false;
                                app.util.ApplePayConnector.doBegin({details: {"msg": "begin session"}});
                            }
                        });
                } else {
                    app.util.ApplePayConnector.doPay({details: request, ver: apiVer});
                }
            } else if (app.util.isApplePayEnabled()) {  // opened in main Window
                window._apple_session = new ApplePaySession(apiVer, request);
                var paymentAuthorizationStarted = false;
                var paymentCanceled = false;
                window._apple_session.onvalidatemerchant = function (event) {
                    var promise = app.util.performApplePayMerchantValidationPromise(event.validationURL, app.config.ssid, false);
                    promise.then(function (merchantSession) {
                        window._apple_session.completeMerchantValidation(merchantSession)
                    });
                };
                window._apple_session.onpaymentauthorized = function (event) {
                    paymentAuthorizationStarted = true;
                    applePay.submitFormWithApplePayToken(event.payment);
                };
                window._apple_session.oncancel = function (event) {
                    paymentCanceled = true;
                    if (!paymentAuthorizationStarted) {
                        applePay.onCancel();
                    }
                };
                window._apple_session.begin();
            }
        }
    }

    /***************  handleApplePay helpers Start  *************/
    function _createAppleRequestObject(_amount, _appleCfg) {
        var req = {
            countryCode: app.config.country,
            currencyCode: app.lastSelectedCurrency,
            supportedNetworks: _appleCfg._supportedNetworks,
            merchantCapabilities: ['supports3DS'],
            total: {
                label: app.msg['merchant_descriptor'],
                amount: _amount
            }
        };
        if (_appleCfg.collectContactFields) {
            req.requiredBillingContactFields = ['name', 'postalAddress'];
            req.requiredShippingContactFields = ['phone', 'email'];
        }
        var exceededCreditCardLimit = app.config.maxCreditCardDepositBalance && (app.config.creditCardDepositBalance + parseFloat(_amount)) > app.config.maxCreditCardDepositBalance;
        if ((app.config.creditRestricted && !app.config.debitRestricted) || (exceededCreditCardLimit && !app.config.debitRestricted)) {
            req.merchantCapabilities = ['supports3DS', 'supportsDebit'] // allow only debit
        }
        if (app.config.debitRestricted && !app.config.creditRestricted) {
            req.merchantCapabilities = ['supports3DS', 'supportsCredit'] // allow only credit
        }
        if (_appleCfg.supportedCountries && _appleCfg.supportedCountries.length) {
            req.supportedCountries = _appleCfg.supportedCountries.slice();
        }
        return req;
    }

    /***************  handleApplePay helpers End  *************/
};

app.util.normalizeApplePayConfig = function (cfg, isCrossBrowserSdkReady) {
    if (_.isEmpty(cfg)) {
        return {};
    }
    cfg._version = _getAppleSessionVersion(cfg);
    cfg._supportedNetworks = _getSupportedNetworks(cfg, cfg._version);
    cfg._applePayDeviceSupport = app.config.applePayDeviceSupport;
    cfg._parentSupportApplePay = (app.openedInIframeMode && app._parentSupportApplePay);
    cfg._isCrossBrowserSdkReady = isCrossBrowserSdkReady;
    if (cfg.useApplePaySdk && isCrossBrowserSdkReady && cfg.applePayMerchantId && ApplePaySession && ApplePaySession.applePayCapabilities) {
        try {
            ApplePaySession.applePayCapabilities(cfg.applePayMerchantId).then(function (capabilities) {
                cfg._applePayCapabilities = capabilities.paymentCredentialStatus;
            });
        } catch (e) {
           cfg._applePayCapabilities = "applePayUnsupported";
        }
    }

    /***************  getAppleSupportedNetworksAndVersion helpers Start  *************/
    function _getAppleSessionVersion(cfg) {
        var _version = (cfg.tryToUseVersion || 1);
        var _maxSupportedVersion = 1;
        if (app.openedInIframeMode && app._parentSupportApplePay) {
            _maxSupportedVersion = app._parentApplePayMaxSupportedVersion || 1;
        } else if (app.applePayDeviceSupport) {
            // todo: update SDK helper
            _maxSupportedVersion = 1;
        } else if (window.ApplePaySession && !app.openedInIframeMode) {
            var v = _version >= 1 ? _version : 1;
            try {
                while (v) {
                    if (ApplePaySession.supportsVersion(v)) {
                        _maxSupportedVersion = v;
                        v = false;
                    } else {
                        v--;
                    }
                }
            } catch (e) {
                _maxSupportedVersion = 1;
            }
        }
        return Math.min(_maxSupportedVersion, _version);
    }

    function _getSupportedNetworks(cfg, _version) {
        return (cfg.allowedCardNetworks || []).filter(function (net) {
                return (cfg.cardNetworkPerVersion && cfg.cardNetworkPerVersion[net] && cfg.cardNetworkPerVersion[net] <= _version);
            }
        );
    }
    /***************  getAppleSupportedNetworksAndVersion helpers End  *************/

    return cfg;
};

app.util.ApplePayTrxStatus = function (data) {
    var isApplePayForWeb = function () {
        var cfg = app.config.pmSettings.ppp_ApplePay;
        if (cfg && "applePayUnsupported" ===  cfg._applePayCapabilities) {
            return false;
        }
        if (window.ApplePaySession && !app.openedInIframeMode) {
            try {
                return ApplePaySession.canMakePayments();
            } catch (e) {
                return false;
            }
        }
        return false;
    };
    var triggerState = function (state) {
        window.webkit.messageHandlers.APSDK.postMessage({
            event: 'finishPayment',
            status: state
        });
    };
    if (app.applePayDeviceSupport && window.webkit && window.webkit.messageHandlers) {
        if (data && data.trxStatus === 'APPROVED') {
            triggerState('SUCCESS');
        } else {
            triggerState('CANCELED');
        }
    } else if (app.openedInIframeMode && app._parentSupportApplePay) {
        app.util.ApplePayConnector.completeTrx({trxStatus: data && data.trxStatus});
    } else if (isApplePayForWeb()) {
        if (data && data.trxStatus === 'APPROVED') {
            try {
                window._apple_session.completePayment(ApplePaySession.STATUS_SUCCESS);
            } catch (e) {
            }
        } else {
            try {
                window._apple_session.completePayment(ApplePaySession.STATUS_FAILURE);
            } catch (e) {
            }
        }
    }
};

app.util.withdrawalRequests = function () {
    var data = 'ssid=' + app.config.ssid + '&merchant_site_id=' + app.config.msid +
        '&merchantLocale=' + app.config.locale +
        '&user_token_id=' + app.config.userTokenId +
        '&offset=0&limit=100000&ts=' + _.now();
    if (app.config.ptRequestId) {
        data += '&ptRequestId=' + app.config.ptRequestId;
    }
    $.ajax('/ppp/withdrawal/getUserWithdrawRequests.do', {
        data: data,
        dataType: "json",
        success: function (data) {
            if (data) {
                app._wdList = data;
                var cancelableWDs = _.filter(data.withdrawalRequests, function (w) {
                    return w.renderingState === 'CANCELABLE' && w.status !== 'CANCELED';
                });
                if (data.withdrawalRequests && !cancelableWDs.length && app.ptWarnings && app.ptWarnings.showWithdrawalsOnDeposit) {
                    $('.modal_close').click();
                }
                pubsub.publish('withdraws-available', [app.util.parseWdRequests(data.withdrawalRequests)]);
            }
        }
    });
};

app.util.parseWdRequests = function (withdrawalRequests) {
    return _.map(withdrawalRequests, function (wds, index) {
        var item = (wds.orders && wds.orders.length) ? wds.orders[0] : wds.params;
        if (item.poName === app.CONSTANTS.PM_NAME.PAY_WITH_MY_BANK) {
            utils.pwmb.formatSrvData(item, item.upoName);   /** modify item */
        }
        return wds;
    });
}

app.util.withdrawalCancelRequest = function () {
    var url = '/ppp/withdrawal/cancel.do';
    var data = 'ssid=' + app.config.ssid +
        '&user_token_id=' + app.config.userTokenId +
        '&wdRequestIdToCancel=' + app.config.wdRequestIdToCancel +
        '&merchantSiteId=' + app.config.msid +
        '&_=' + (new Date()).getTime();
    if (app.config.ptRequestId) {
        data += '&ptRequestId=' + app.config.ptRequestId;
    }
    $.ajax(url, {
        data: data,
        dataType: "json",
        success: function (data) {
            if (data && data.wdRequest) {
                pubsub.publish('app.event.wdCancelSuccess', [data]);
                app.util.withdrawalRequests();
            }
        }
    });
};

app.util.withdrawalCancel = function (data) {
    pubsub.publish('withdraw-cancel-start', [{buttonId: data.id}]);
    app.config.wdRequestIdToCancel = data.id;
    app.util.withdrawalCancelRequest();
};

/**
 * 3DS_V2 flow OR ApmSubscriptionPopup (e.g. PayPal redirect flow)
 */
app.util.onPubsubSubscriptionComplete = function (result) {
    if (result && result.source !== "3dSubscriptionResponse") {
        /** skip app.getNextStepDo() **/
        app._flag.ommitPostSubmitCheck = true;
    }
    if (app.sub._apmPopupWnd) {
        app.sub._apmPopupWnd.close();
        delete app.sub._apmPopupWnd;
    }
    app.util.closeTargetIframe();
    if (!result || !result.subscriptionResult) {
        app.showFinalMessage((result && result.message) || app.msg.session_expired);
    }
    app.sub.onSubscriptionComplete(result && result.subscriptionResult);
};

////   SUBSCRIPTION   ////

app.sub.doSubscribe = function () {
    $.blockUI();
    var shouldInitAuth3d = app.config.use3dsv2 && app.CONSTANTS.PM_SUPPORTS_3DSV2[app.lastSelectedMethodType];

    var doProceed = (function (_shouldInitAuth3d) {
        function submit(extra_data) {
            var submitUrl = "processCashierRebilling.do";
            // PBI_61809 - "processCashierRebilling.do" send billing details if available
            var data = app.util.getFormDataAsObject($('#PPPParametersForm'));
            var data_to_send = extra_data ? $.extend(true, data, extra_data) : data;
            app.submittedMethod = app.util.getCurrentMethodInfo();
            pubsub.publish('app.event.formSubmit', [$.extend(true, {}, app.submittedMethod)]);
            $.post(
                submitUrl,
                data_to_send,
                app.sub.onSubscriptionComplete,
                'json'
            ).fail(function () {
                app.showFinalMessage(app.msg.session_expired);
            });
            pubsub.publish('post-form-submit', [$.extend(true, {}, app.submittedMethod)]);
        }

        return function () {
            if (_shouldInitAuth3d) {
                app.initAuth3d().then(function (extra_data) {
                    submit(extra_data);
                });
            } else {
                submit();
            }
        }
    })(shouldInitAuth3d);

    var proceed = app.util.handleSccLightbox(doProceed);
    if (proceed) {
        doProceed();
    }
};

app.sub.openApmSubscriptionPopup = function (pmRedirectURL) {
    var popupName = 'pppApmSubscriptionWindow_' + (new Date()).getTime()
    app.sub._apmPopupWnd = app.util.createPopupWindow(app.lastSelectedMethodType, pmRedirectURL, popupName);
    if (app.config.backToRedirectPage) {
        app.util.backToRedirectPageHandler(app.sub._apmPopupWnd);
    }
    setTimeout(function () {
        try {
            $.blockUI();
            app.sub._apmPopupWnd.focus();
        } catch (e) {
        }
        waitPopupClose(app.sub._apmPopupWnd, apmPopupClosedCallback);
    }, 200);
};

app.sub.onSubscriptionComplete = function (result) { // ~ok
    _closeApplePaySheet(result);
    if (!result) {
        return;
    }
    var details = result.details || {};
    details.message_text = app.msg['subscription_status_' + result.status.toLowerCase()];   // result.message || app.msg['subscription_status_' + result.status.toLowerCase()];
    var modalWrapper = (result.eventType === "websocket") ? "lightbox_ws" : "";
    var lbxOverlaySelector = (result.eventType === "websocket") ? '.lightbox_ws_overlay' : '.lightbox_overlay'; // Check name
    var onClose = function () {
        $(lbxOverlaySelector).stop().show();
        app.util.sendPostMessage({
            status: result.status,
            message: result.message
        }, app.config.parentUrl);
    };
    if (result.status === 'SESSION_EXPIRED') {
        app.showFinalMessage(app.msg.session_expired);
    } else if (result.status === 'GENERAL_ERROR') {
        app.showFinalMessage(result.message || app.msg.session_expired);
    } else if (result.pmRedirectURL && result.pmRedirectURL.length > 3) {
        /** Intermediate state => Do Redirect in order to complete transaction (e.g. PayPal redirect flow) */
        if (app.config.isNative && app.config.isNativeExceptions.indexOf(app.lastSelectedMethodType) === -1) {
            window.location.href = result.pmRedirectURL;
        } else {
            app.sub.openApmSubscriptionPopup(result.pmRedirectURL);
        }
    } else if (result.redirectTo && result.redirectTo.length > 3) {
        details.text = details.message_text;
        var dataToSend = {
            trxStatus: result.status,
            redirectUrl: result.redirectTo,
            message: result.message,
            eventType: result.eventType,
            // message_text: details.message_text,
            details: details
        };
        pubsub.publish('app.event.performRedirect', [dataToSend]);
    } else if (result.challengeUrl && result.challengeUrl.length > 3) {
        app.util.setupTargetIFrame();
        app.show3DIFrame({
            iframeMaxHeight: 750,
            iframeWidth: 950
        });
        $('#targetIFrame').attr('src', result.challengeUrl);
        pubsub.publish('app.event.subscription3dChallenge', [app.lastSelectedMethodType, app.currency, $("#item_amount_1").val() || app.amount]);
    } else {
        if (result.CSRFToken) {
            $('input#CSRFToken').val(result.CSRFToken);
            app.CSRFToken = result.CSRFToken;
        }
        if (result.status === 'APPROVED') {
            pubsub.publish('app.event.subscriptionSuccess', [app.lastSelectedMethodType, app.currency, $("#item_amount_1").val() || app.amount]);
            app.showModalMessage({details: details}, 'success', onClose, onClose, "subscription_status", modalWrapper);
        } else if (result.status === 'PENDING') {
            app.showModalMessage({details: details}, 'pending', onClose, onClose, "subscription_status", modalWrapper);
        } else if (result.status === 'CANCEL') {
            pubsub.publish('app.event.subscriptionFailure', [app.lastSelectedMethodType, app.currency, ($("#item_amount_1").val() || app.amount)]);
            var data = result.drMessages || [];
            var apmErrorMsg = details.apmErrorMsg;
            var feRef = result.details && result.details.feRef;
            var info;
            if (app.util.FeRef.isValid(feRef)) {
                info = {feRef: app.util.FeRef.isValid(feRef) && feRef, isWS: (result.eventType === "websocket"), source: 'onSubscriptionComplete'};
                info.submittedMethod = app.util.FeRef.getRefData(feRef).submittedMethod;
                info.showPmInfo = false; // or app.config.useCsmsMessages;
            }
            app.util.onDeclineRecoveryMessage(data, details.message_text, apmErrorMsg, "subscription_status", details.reference, modalWrapper, info);
        }
    }

    /***************  onSubscriptionComplete helpers Start  *************/
    function _closeApplePaySheet(_result) {
        if (app.lastSelectedMethodType === 'ppp_ApplePay') {
            var showStatus = _result && _result.status || app.CONSTANTS.TRX_STATUS.CANCEL;
            if (_result && _result.challengeUrl && _result.challengeUrl.length > 3) {
                showStatus = app.CONSTANTS.TRX_STATUS.APPROVED;
            }
            app.util.ApplePayTrxStatus({trxStatus: showStatus});
        }
    }

    /***************  onSubscriptionComplete helpers End  *************/
};

app.util.getBillingDetails = function () {
    var userFields = window.srvUserFields;
    if (app.config.ptRequestId) {
        var isUpm = (!isNaN(parseInt(app.lastSelectedMethodId, 10))) ? true : 0;
        var showBillingDetailsPerCurrentPM = (app.config.ptBillingDetailsForPM.indexOf(app.lastSelectedMethodType) > -1); // app.util.isCardPM({name: app.lastSelectedMethodType});
        if (isUpm && showBillingDetailsPerCurrentPM) {
            /** @namespace app._upoList[app.lastSelectedMethodId].billingDetails */
            var billingInfoObj = app._upoList[app.lastSelectedMethodId] ? app._upoList[app.lastSelectedMethodId].billingDetails || {} : {};
            userFields = app.extendUserPmFields(window.srvUserFields, billingInfoObj);
        }
        var visibility = "HIDDEN";
        if (app.config.ptShowBillingDetails && showBillingDetailsPerCurrentPM) {
            if (app.config.ptBillingDetailsReadOnly) {
                visibility = 'DISABLED';
            } else {
                visibility = 'REQUIRED';
            }
        }
        _.each(userFields, function (item) {
            item.visibility = visibility;
        });
    }
    return _.sortBy(userFields, 'uiOrder');
};

app.util.getShippingDetails = function () {
    var fields = [];
    _.each(window.srvShippingDetails, function (item) {
        fields.push({
            name: item.field,
            visibility: item.visibility,
            uiOrder: item.uiOrder,
            value: item.value
        })
    });
    return _.sortBy(fields, 'uiOrder');
};

app.util.getOtherDetails = function () {
    var otherFields = window.srvOtherFields;
    return _.sortBy(otherFields, 'uiOrder');
};

app.util.renderUserFields = function (type, wrapperSelector, data) {
    // console.log('renderUserDetails DATA', type,  data);
    if (data && (type === 'billing' || type === 'shipping')) {
        var $wrapper = $(wrapperSelector);
        app.reduceCustomValidationFieldsBy(app['_' + type + 'FieldsForValidation']);
        app['_' + type + 'FieldsForValidation'] = [];
        var fields_for_validation = [];
        var selectedCountry = false;
        var dataObj = {};
        var normalizedData = data;
        var fld_maxlength = {
            phone1      : 20,
            email       : 100,
            first_name  : 50,
            last_name   : 50,
            city        : 50,
            zip         : 10,
            address1    : 60,
            address2    : 60
        };
        var billingTemplates = {
            default_rw          : '<div class="row <%-visibility%> <%-name%>"><label for="<%-name%>" class="label_<%-name%> <%-lbl_class%>" data-optional="<%-t(\"optional\")%>"><%- t(name)%></label><div class="pmf-icon <%-name%>"></div><input autocomplete="off" type="text"  id="<%-name%>" name="<%-name%>" value="<%-value%>" placeholder="<%- t(name)%>" title="<%- t(name)%>" maxlength="<%-maxlength%>"><div id="<%-name%>_validation" class="validation_image"></div></div>',
            phone1_rw           : '<div class="row <%-visibility%> <%-name%>"><label for="<%-name%>" class="label_<%-name%> <%-lbl_class%>" data-optional="<%-t(\"optional\")%>"><%- t(name)%></label><div class="pmf-icon <%-name%>"></div><input autocomplete="off" type="tel"   id="<%-name%>" name="<%-name%>" value="<%-value%>" placeholder="<%- t(name)%>" title="<%- t(name)%>" maxlength="<%-maxlength%>"><div id="<%-name%>_validation" class="validation_image"></div></div>',
            email_rw            : '<div class="row <%-visibility%> <%-name%>"><label for="<%-name%>" class="label_<%-name%> <%-lbl_class%>" data-optional="<%-t(\"optional\")%>"><%- t(name)%></label><div class="pmf-icon <%-name%>"></div><input autocomplete="off" type="email" id="<%-name%>" name="<%-name%>" value="<%-value%>" placeholder="<%- t(name)%>" title="<%- t(name)%>" maxlength="<%-maxlength%>"><div id="<%-name%>_validation" class="validation_image"></div></div>',
            dateOfBirth_rw      : '<div class="row <%-visibility%> <%-name%>"><label for="<%-name%>" class="label_<%-name%> <%-lbl_class%>" data-optional="<%-t(\"optional\")%>"><%- t(name)%></label><div class="pmf-icon <%-name%>"></div><input autocomplete="off" type="text"  id="<%-name%>" name="<%-name%>" value="<%-value%>" placeholder="<%- t("date_of_birth_placeholder") %>" title="<%- t(name)%>" maxlength="10" ><div id="<%-name%>_validation" class="validation_image"></div></div>',
            country_rw          : '<div class="row <%-visibility%> <%-name%>"><label for="<%-name%>" class="label_<%-name%> <%-lbl_class%>" data-optional="<%-t(\"optional\")%>"><%- t(name)%></label><div class="pmf-icon <%-name%>"></div><select id="<%-name%>" data-plugin="cSelect" name="<%-name%>"></select><div id="<%-name%>_validation" class="validation_image"></div></div>',
            shippingCountry_rw  : '<div class="row <%-visibility%> <%-name%>"><label for="<%-name%>" class="label_<%-name%> <%-lbl_class%>" data-optional="<%-t(\"optional\")%>"><%- t(name)%></label><div class="pmf-icon <%-name%>"></div><select id="<%-name%>" data-plugin="cSelect" name="<%-name%>"></select><div id="<%-name%>_validation" class="validation_image"></div></div>',

            country_ro          : '<div class="row readOnly <%-name%>"><label for="<%-name%>" class="label_ro_<%-name%> <%-lbl_class%>"><%- t(name)%></label><div class="pmf-icon <%-name%>"></div><div id="<%-name%>_read_only_text" class="cSelect_read_only_text" title="<%- t(name)%>"> </div><select id="<%-name%>" name="<%-name%>"></select></div>',
            shippingCountry_ro  : '<div class="row readOnly <%-name%>"><label for="<%-name%>" class="label_ro_<%-name%> <%-lbl_class%>"><%- t(name)%></label><div class="pmf-icon <%-name%>"></div><div id="<%-name%>_read_only_text" class="cSelect_read_only_text" title="<%- t(name)%>"> </div><select id="<%-name%>" name="<%-name%>"></select></div>',
            default_ro          : '<div class="row readOnly <%-name%>"><label for="<%-name%>" class="label_ro_<%-name%> <%-lbl_class%>"><%- t(name)%></label><div class="pmf-icon <%-name%>"></div><input autocomplete="off" type="text" id="<%-name%>" name="<%-name%>" value="<%-value%>" placeholder="<%- t(name)%>" title="<%- t(name)%>" readonly="readonly" ></div>'
        };
        // Phone
        billingTemplates.phone2_rw = billingTemplates.phone1_rw;
        billingTemplates.phone3_rw = billingTemplates.phone1_rw;
        billingTemplates.shippingPhone_rw = billingTemplates.phone1_rw;
        // Email
        billingTemplates.confirmEmail_rw = billingTemplates.email_rw;
        billingTemplates.shippingMail_rw = billingTemplates.email_rw;

        var html = '';
        _.each(data, function (item) {
            var view_type = 'ro';
            var obj = _.clone(item);
            dataObj[obj.name] = obj;
            obj.lbl_class = obj.value ? 'focusedInput' : '';
            obj.maxlength = obj.maxlength || (fld_maxlength[obj.name] || 160);
            obj.normalizedData = normalizedData;
            if (obj.visibility === 'HIDDEN') {
                html += _.template('<input type="hidden" id="<%- name%>" name="<%- name%>" value="<%- value%>">')(obj);
                return;
            } else if (obj.visibility !== 'DISABLED') {
                view_type = 'rw';
                if (obj.visibility === 'OPTIONAL') {
                    app.util.setAsOptionalFld(obj.name);
                }
                fields_for_validation.push(obj.name);
            }
            if ((obj.name === 'country') || (obj.name === 'shippingCountry')) {
                selectedCountry = obj.value;
            }
            html += _getFldTemplate(obj.name, type, view_type)(obj);
        });
        $wrapper.html(html);
        app['_' + type + 'FieldsForValidation'] = fields_for_validation;
        app.addCustomValidationFields(fields_for_validation);

        var stateFldName = 'billing' === type ? 'state' : 'shippingState';
        var countryFldName = 'billing' === type ? 'country' : 'shippingCountry';
        var $countryElm = $("#" + countryFldName, $wrapper);

        if ($countryElm.length) {
            utils.getCountries().then(function (countries) {
                _updateCountryDropdownOptions($countryElm, countries);
                _updateCountryStateField($countryElm.val(), stateFldName);
                _onUserFieldsRenderDone();
            });
            $countryElm.on("change", function (ev) {
                _updateCountryStateField($countryElm.val(), stateFldName);
            });
        } else {
            _updateCountryStateField(app.config.country, stateFldName);
            _onUserFieldsRenderDone();
        }
    }

    /***************  renderUserFields helpers Start  *************/
    function _onUserFieldsRenderDone() {
        app.applycSelectPlugin();
        var countrySelect_ro = $("#" + countryFldName + '_read_only_text', $wrapper);
        if (countrySelect_ro.length) {
            $countryElm.hide();
            countrySelect_ro.text($countryElm.children('option:selected').text());
        }
        app.recalcUserDetailsArea();
        pubsub.publish('post-' + type + '_details-render', [data]);
    }

    function _getFldTemplate(_fldName, _type, _viewType) {
        var hashKey = _fldName + '_' + _viewType;
        var $custom_tpl = $('#' + _type + '_fld_' + hashKey);
        var tpl_txt = $custom_tpl.length ? $custom_tpl.text() : billingTemplates[hashKey];
        if (!tpl_txt) {
            var $generic_tpl = $('#' + _type + '_fld_default_' + _viewType); // e.g. #shipping_fld_default_ro OR #billing_fld_default_rw
            tpl_txt = $generic_tpl.length ? $generic_tpl.text() : billingTemplates['default_' + _viewType];
        }
        return _.template(tpl_txt);
    }

    function _updateCountryDropdownOptions($selectElm, countries) {
        var optTpl = _.template('<option value="<%- iso%>" <%- selected%>><%- name%></option>');
        var optHtml = '';
        _.each(countries, function (item) {
            if (item.iso) {
                var obj = _.clone(item);
                obj.selected = (selectedCountry === item.iso ? 'selected' : ' ');
                optHtml += optTpl(obj);
            }
        });
        $selectElm.html(optHtml);
    }

    function _enrichOptionsText(arr) {
        var new_arr = [];
        _.each(arr, function (obj, i) {
            new_arr.push({value: obj.value, text: obj.text + ' (' + obj.value + ')'});
        });
        return new_arr;
    }

    function _updateCountryStateField(_selectedCountry, _stateFldName) {
        var $stateElm = $("#" + _stateFldName, $wrapper);
        if (!dataObj || !dataObj[_stateFldName] || dataObj[_stateFldName].visibility === 'HIDDEN' /* || dataObj[_stateFldName].visibility === 'DISABLED'*/ || !$stateElm.length) {
            return;
        }
        if (_selectedCountry) {
            app.util.getCountryStates(_selectedCountry).then(function (countryStates) {
                var $newElm;
                var hasStates = countryStates && countryStates.length;
                var payload = dataObj[_stateFldName];
                payload.states = hasStates && [{
                    value: "",
                    text: "select_state"
                }].concat(_enrichOptionsText(countryStates));
                if (hasStates) {
                    var state_dd_tpl_rw = '<% if(states){ var opt = {lbl_class:"focusedInput", val: (value || app.config.user.state || states[0].value), data: states, withSearch: true };%> ' + app.CONSTANTS.DEFAULT_SELECT_TPL + '<%}%>';
                    $newElm = $(_.template(state_dd_tpl_rw)(payload)).addClass(payload.visibility);
                    $stateElm.closest('.row').replaceWith($newElm);
                    app.applycSelectPlugin();
                } else if ($stateElm[0].tagName === 'SELECT') {
                    $newElm = _getFldTemplate(_stateFldName, type, 'rw')(payload);
                    $stateElm.closest('.row').replaceWith($newElm);
                }
            });
        }
    }
    /***************  renderUserFields helpers End  *************/
};

app.util.renderOtherDetails = function (selector, data) {
    var type = 'other';
    app.reduceCustomValidationFieldsBy(app['_' + type + 'FieldsForValidation']);
    app['_' + type + 'FieldsForValidation'] = [];
    var fields_for_validation = [];
    var normalizedData = data;
    var billingTemplates = {
        promoCode_ro: _.template('<div class="row <%-visibility%> <%-name%>"><div class="pmf-icon">&#xe800;</div><input autocomplete="off" type="text" maxlength="70" id="<%-name%>" name="<%-name%>" placeholder="<%-label%>" title="<%-label%>" value="<%-value%>" readonly="readonly" ><div id="<%-name%>_validation" class="validation_image"></div></div>'),
        promoCode_rw: _.template('<div class="row <%-visibility%> <%-name%>"><div class="pmf-icon">&#xe800;</div><input autocomplete="off" type="text" maxlength="70" id="<%-name%>" name="<%-name%>" placeholder="<%-label%>" title="<%-label%>" value="<%-value%>" ><div id="<%-name%>_validation" class="validation_image"></div></div>'),
        default_rw: _.template('<div class="row <%-visibility%> <%-name%>"><label for="<%-name%>" class="label_<%-name%>" data-optional="<%-t(\"optional\")%>"><%- t(name)%></label><div class="pmf-icon <%-name%>"></div><input autocomplete="off" type="text" id="<%-name%>" name="<%-name%>" value="<%-value%>" placeholder="<%- t(name)%>" title="<%- t(name)%>" maxlength="160"><div id="<%-name%>_validation" class="validation_image"></div></div>'),
        default_ro: _.template('<div class="row readOnly <%-name%>"><label for="<%-name%>" class="label_ro_<%-name%>"><%- t(name)%></label><div class="pmf-icon <%-name%>"></div><input autocomplete="off" type="text" id="<%-name%>" name="<%-name%>" value="<%-value%>" placeholder="<%- t(name)%>" title="<%- t(name)%>" readonly="readonly" ></div>')
    };
    var html = '';
    _.each(data, function (item) {
        var view_type = 'ro';
        var obj = _.clone(item);
        obj.normalizedData = normalizedData;
        if (obj.visibility === 'HIDDEN') {
            html += _.template('<input type="hidden" id="<%- name%>" name="<%- name%>" value="<%- value%>">')(obj);
            return;
        } else if (obj.visibility !== 'DISABLED') {
            view_type = 'rw';
            if (obj.visibility === 'OPTIONAL') {
                app.util.setAsOptionalFld(obj.name);
            }
            fields_for_validation.push(obj.name);
        }
        var hashKey = item.name + '_' + view_type;
        var elm = $('#' + type + '_fld_' + hashKey);
        var tpl = (elm.length) ? _.template(elm.text()) : billingTemplates[hashKey];
        if (tpl) {
            html += tpl(obj);
        } else {
            var generic_elm = $('#' + type + '_fld_default_' + view_type); // e.g. #shipping_fld_default_ro OR #billing_fld_default_rw
            var generic_template = (generic_elm.length) ? _.template(generic_elm.text()) : billingTemplates['default_' + view_type];
            html += generic_template(obj);
        }
    });

    var $wrapper = $(selector || '#OtherDetails');
    if ($wrapper.length) {
        $wrapper.html(html);
    } else {
        $('.PMINFO').append($(html));
    }
    app['_' + type + 'FieldsForValidation'] = fields_for_validation;
    app.addCustomValidationFields(fields_for_validation);
};

app.util.getBillingDetailsRenderer = function (options) {
    var defaults = {
        template: {
            change_details_checkbox: _.template(
                '<input type="checkbox" class="toggle_checkbox" value="None" id="user_details" name="check" <%- checked %> />' +
                '<label for="user_details" class="checkbox_label"><span class="text"  data-no="<%-t("lightbox_no_button")%>" data-yes="<%-t("lightbox_yes_button")%>"></span><%- t("change_billing_address")%></label>'
            ),
            shipping_details_checkbox: _.template(
                '<input type="checkbox"  class="toggle_checkbox" value="true" id="isCustomShippingHidden" name="isCustomShippingHidden" <%- checked %> />' +
                '<label for="isCustomShippingHidden" class="checkbox_label"><span class="text"  data-no="<%-t("lightbox_no_button")%>" data-yes="<%-t("lightbox_yes_button")%>"></span><%- t("change_shipping_address")%></label>'
            ),
            billing_as_shipping_checkbox: _.template(
                '<input type="checkbox" class="toggle_checkbox" value="true" id="billingSameAsShipping_checkbox" name="billingSameAsShipping" <%- checked %> />' +
                '<label for="billingSameAsShipping_checkbox" class="checkbox_label"><span class="text" data-no="<%-t("lightbox_no_button")%>" data-yes="<%-t("lightbox_yes_button")%>"></span><%- t("change_billing_address")%></label>'
            ),
            billing_header: _.template(
                '<div class="billingDetailsHeader"><%- t("billingDetailsHeader")%></div>'
            ),
            shipping_header: _.template(
                '<div class="shippingDetailsHeader"><%- t("shippingDetailsHeader")%></div>'
            ),
            main: _.template(
                '<div id="userDetailsSection" class=" row userDetailsSection <%- mainElmClass%>"><%= contentHtml %></div>'
            ),
            content_section: _.template('<div class="content_section <%= content_section_class%>"></div>')
        },
        wrapper_selector: '.PMINFO',
        billing_info_placeholder_selector: '#userDetailsSection .content_section.billingDetails',
        shipping_info_placeholder_selector: '#userDetailsSection .content_section.shippingDetails',
        section_hidden_class: 'hidden'
    };

    app.has_shipping_values = false;
    if (window.srvShippingDetails && app.config.userDetails.useShippingDetails) {
        srvShippingDetails.forEach(function (obj) {
            if (app.config.userDetails.showBillingAsShippingCheckbox) {  // NOVO
                obj.visibility = "DISABLED";
            }
            if (obj.value && obj.value.trim()) {
                app.has_shipping_values = true;
            }
        });
    }
    app.has_billing_details = window.srvUserFields && srvUserFields.length;
    app._flag.showBillingAsShippingCheckbox = app.config.userDetails.showBillingAsShippingCheckbox && app.has_shipping_values && app.has_billing_details;

    $(document).on('change', '#billingEqShipping_checkbox', function () {
        if ($(this).is(':checked')) {
            app.reduceCustomValidationFieldsBy(app._billingFieldsForValidation);
        } else {
            app.addCustomValidationFields(app._billingFieldsForValidation);
        }
    });

    var opt = $.extend(true, {}, defaults, (options || {}));

    function _getBillingHtml() {
        var html = '';
        if (window.srvUserFields && srvUserFields.length) {
            if (app.config.userDetails.isBillingInfoOpen) {
                html = opt.template.billing_header();
            } else {
                html = opt.template.change_details_checkbox({checked: ' '});
            }
            html += (" " + opt.template.content_section({content_section_class: 'more_user_details billingDetails'}));
        }
        return html;
    }

    function _getShippingHtml() {
        var html = '';
        if (window.srvShippingDetails && srvShippingDetails.length) {
            if (app.config.userDetails.isCustomShippingHidden) {
                html = opt.template.shipping_details_checkbox({checked: ''});
            } else {
                html = opt.template.shipping_details_checkbox({checked: 'checked'});
            }
            html += (" " + opt.template.content_section({content_section_class: 'shippingDetails'}));
        }
        return html;
    }
    function _emptyCustomBillingWrapper() {
        var $pminfo = $(opt.wrapper_selector);
        if (opt.wrapper_selector !== '.PMINFO' && $pminfo.length) {
            $pminfo.empty();
        }
    }

    pubsub.subscribe('billingDetailsRenderer.clearDom', _emptyCustomBillingWrapper);

    return function () {
        if (!app.config.quickDeposit.isShow && window.srvUserFields && srvUserFields.length > 0) {
            var main_elm_class = '';
            var header_html = '';
            var content_section_html = '';
            var content_html = '';
            var $pminfo = $(opt.wrapper_selector);
            if (opt.wrapper_selector !== '.PMINFO' && $pminfo.length) {
                $pminfo.empty();
            }

            if (app.config.ptRequestId) {
                var showBillingDetailsPerCurrentPM = (app.config.ptBillingDetailsForPM.indexOf(app.lastSelectedMethodType) > -1);
                if (app.config.ptShowBillingDetails && showBillingDetailsPerCurrentPM) {
                    header_html = opt.template.change_details_checkbox({checked: ' '});
                } else {
                    main_elm_class = opt.section_hidden_class;
                    // header_html = '';
                }
                content_section_html = opt.template.content_section({content_section_class: 'more_user_details billingDetails'});
                content_html = header_html + " " + content_section_html;
            } else if (app.config.userDetails.showBillingAsShippingCheckbox) { // NOVO
                if (app._flag.showBillingAsShippingCheckbox) {
                    content_html = opt.template.billing_as_shipping_checkbox({checked: 'checked'});
                    main_elm_class = 'missingEqualsCheckbox';
                }
                if (app.has_shipping_values) {
                    header_html = opt.template.shipping_header();
                    content_section_html = opt.template.content_section({content_section_class: 'shippingDetails'});
                    content_html += (" " + header_html + " " + content_section_html);
                }
                if (app.has_billing_details) {
                    header_html = opt.template.billing_header();
                    content_section_html = opt.template.content_section({content_section_class: 'billingDetails'});
                    content_html += (" " + header_html + " " + content_section_html);
                }
            } else if (app.config.userDetails.useShippingDetails && window.srvShippingDetails) {
                content_html = '';
                _.each((categoryOrder || []), function (cat) {
                    if (cat === 'USERDETAILS') {
                        content_html = _getBillingHtml();
                    }
                    if (cat === 'SHIPPINGDETAILS') {
                        content_html += _getShippingHtml();
                    }
                });
            } else if (app.has_billing_details) {
                content_html = _getBillingHtml();
            }

            if (content_html.length > 2) {
                var payload = {
                    mainElmClass: main_elm_class,
                    contentHtml: content_html,
                    opt: opt
                };
                $pminfo.append(opt.template.main(payload));
                var $remove_upo = $('.removeUPM', $pminfo);
                if ($remove_upo.length) {
                    $pminfo.append($remove_upo);
                }
                if (app.config.userDetails.showBillingAsShippingCheckbox || app.config.userDetails.useShippingDetails) {
                    app.util.renderUserFields('shipping', opt.shipping_info_placeholder_selector, app.util.getShippingDetails());
                }
                app.util.renderUserFields('billing', opt.billing_info_placeholder_selector, app.util.getBillingDetails());
                if (app.config.userDetails.showBillingAsShippingCheckbox) {
                    if (app._flag.showBillingAsShippingCheckbox) {
                        app.reduceCustomValidationFieldsBy(app._billingFieldsForValidation);
                    } else {
                        app.addCustomValidationFields(app._billingFieldsForValidation);
                    }
                }
            }
        } else {
            app.recalcUserDetailsArea();
        }
    }
};

app.util.renderRebillingTerms = function () {
	var type = 'rebilling';
    var $wrapper = $('#rebilling_terms_wrapper');
	app.reduceCustomValidationFieldsBy(app['_' + type + 'FieldsForValidation']);
    if (app.config.isRebilling && app.config.rebillingTermsUrl && $wrapper.length) {
        var tpl = '<div class="row rebilling_terms"> ' +
            '<input type="checkbox" class="toggle_checkbox" value="true" id="rebilling_terms_checkbox"  <%- checked %> />' +
            '<label for="rebilling_terms_checkbox" class="checkbox_label" data-terms_read="<%-terms_read%>">' +
            '<span class="text" data-no="<%-t("lightbox_no_button")%>" data-yes="<%-t("lightbox_yes_button")%>"></span><%= t("rebilling_terms_label")%>' +
            '</label> <div id="rebilling_terms_checkbox_validation" class="validation_image"></div></div>';
        $wrapper.html(_.template(tpl)({
            url        : app.config.rebillingTermsUrl,
            checked    : '',
            terms_read : '0'
        }));
        app['_' + type + 'FieldsForValidation'] = ['rebilling_terms_checkbox'];
        app.addCustomValidationFields(['rebilling_terms_checkbox']);
    }
};

app.util.showRebillingTermsLightbox = function(e){
    if (app.config.isRebilling && app.config.rebillingTermsUrl){
        app.util.setupTargetIFrame();
        $('.targetIframeWrap').prepend(
        	'<div id="iframe_info"><div  class="header"><label id="close_terms" class="btn close_terms">&#215;</label></div></div>');
        $('#targetIFrame').attr('src', app.config.rebillingTermsUrl);
        app.show3DIFrame({
            iframeMaxHeight: 750,
            iframeWidth: 600
        });
    }
};

app.util.onRebillingTermsCheckboxChange = function (e) {
    var $this = $(this);
    if ($this.data('terms_read') === 0) {
        app.util.showRebillingTermsLightbox();
        $(this).data('terms_read', '1');
    }
};

app.util.onRebillingTermsLinkClicked = function (e) {
    e.preventDefault();
    e.stopPropagation();
    app.util.showRebillingTermsLightbox();
    var label = $('label[for="rebilling_terms_checkbox"]');
    if (label.data('terms_read') === 0) {
        label.data('terms_read', '1');
    }
};

app.util.handleWireTransfer = function () {
    var cfg = app.config;
    var $el = $('#wire-transfer-template');
    var htmlTpl = '<div id="wire_payment_info">' +
        '<div id="wire_payment_info_header" class="row wt_row"><%- data.header %></div>' +
        '<div class="row wt_row">' +
        '<div id="wtId" class="wtPayRefText"><%= msg.wt_payment_reference_label %><span class="wtPayRef"> <%- ref %></span></div>' +
        '</div>' +
        '<div id="wt_payment_instructions" class="row wt_row"><%= msg.wt_payment_instructions %></div>' +
        '<div id="wire_payment_info_detail">' +
        '<div class="row wt_row">' +
        '<label class="label wt_label" for="wtCurrency"><%- msg.wt_account_select_currency %></label>' +
        '<select data-plugin="cSelect" id="wtCurrency" name="wtCurrency">' +
        '<%= currencies %>' +
        '</select>' +
        '</div>' +
        '<div class="row wt_row">' +
        '<label class="label wt_label" for="wtAccount"><%- msg.wt_account_select_amount %></label>' +
        '<select data-plugin="cSelect" id="wtAccount" name="wtAccount"></select>' +
        '</div>' +
        '<div class="row wt_row">' +
        '<div id="selectedWtAccountInfo" class="selectedWtAccountInfo"></div>' +
        '</div>' +
        '</div>' +
        '</div>';

    var tpl = ($el.length) ? _.template($el.text()) : _.template(htmlTpl);

    var currencyOptions = '';
    var wtData = [];

    var handleResponse = function (data) {
        var currencies = data.accountsForCurrency || [];

        for (var i = 0; i < currencies.length; i++) {
            var current = currencies[i];
            currencyOptions += '<option value="' + current.currency + '">' + current.currency + '</option>';
            var arr = [];
            for (var j = 0; j < current.accounts.length; j++) {
                arr.push(current.accounts[j]);
            }
            wtData[current.currency] = arr;
        }
    };

    var currencyChange = function () {
        var currency = $("#wtCurrency").val();
        var accountSelect = $("#wtAccount");

        accountSelect.find('option').remove();

        if (wtData[currency]) {
            var accounts = wtData[currency];
            var options = '';
            $.each(accounts, function (i, item) {
                options += '<option value="' + item.accountId + '">' + item.displayName + '</option>';
            });
            accountSelect.append(options);
            $('#wtAccount').data('plugin_cSelect').update();
            accountChange();
        }
    };

    var accountChange = function () {
        var currency = $("#wtCurrency").val();
        var account = $('#wtAccount').val();

        var item = _.find(wtData[currency], function (item) {
            return parseInt(item.accountId) === parseInt(account);
        }) || {};
        $("#selectedWtAccountInfo").html(item.message);
    };

    $.getJSON('getWTAccounts.do', {
        msid: cfg.msid,
        ssid: cfg.ssid,
        countryIso: cfg.country,
        currencyIso: cfg.currency,
        locale: cfg.locale
    }).done(function (data) {
        if (data) {
            handleResponse(data);
            $('.PMINFO').prepend(tpl({
                data: data,
                ref: app.config.pmSettings.ppp_WireTransfer.yourWTPaymentReference, //  app.config.yourWTPaymentReference,
                msg: app.msg,
                currencies: currencyOptions
            }));
            app.applycSelectPlugin();
            $('#wtCurrency').on('change', currencyChange).change();
            $('#wtAccount').on('change', accountChange).change();
            app.recalcUserDetailsArea();
        }
    });
};

app.util.renderOfflineMethods = function (data, pmName) {
    var pmName = pmName.toLowerCase();
    var templates = {
        default: '<div><%- console.log(data) %></div>'
    };
    var $el = $('#' + pmName + '-template');
    var tempName = templates[pmName] || templates['default'];
    var tpl = ($el.length) ? _.template($el.text()) : _.template(tempName);

    $('.PMINFO').empty().prepend(tpl({
        data: data,
        msg: app.msg,
        cfg: app.config
    }));
};

app.util.handleOfflineMethods = function (data, pmName) {
    var cfg = app.config;
    data['ssid'] = cfg.ssid;
    data['paymentMethodName'] = app.lastSelectedMethodType;
    $.getJSON('api/getPaymentMethodDynamicParams.do', data).done(function (res) {
        if (res && !_.isEmpty(res)) {
            app.util.renderOfflineMethods(res, pmName);
        }
    });
};

pubsub.subscribe('pre-pm-render', function (pm) {
    if (pm && pm.value === app.CONSTANTS.PM_NAME.WIRE_TRANSFER) {
        app.util.handleWireTransfer();
    } else if (pm && app.CONSTANTS.OFFLINE_METHODS[pm.value]) {
        var data = {};
        var pmName = pm.value.replace(/apmgw_|ppp_/g, '');
        app.util.handleOfflineMethods(data, pmName);
    }
});

app.util.oneRowExpDate = function (target, wrapper, opt) {
    var $wrapper = $(wrapper);
    var $expDate = $(target);
    var expDateOnKeyup = false;
    var expDateValidation;
    var defaults = {
        useHelper: true,
        expMonthId: 'cc_exp_month',
        expYearId: 'cc_exp_year'
    };
    opt = $.extend(defaults, opt);
    $expDate.setMask('exp_date');
    $wrapper.off('blur keyup').on('blur keyup', target, function (e) {
        var event = e.type;
        var date = $(target).val().split('/');
        var exp_month_val = $('#' + opt.expMonthId).val(date[0]);
        var exp_year_val = $('#' + opt.expYearId).val(date[1]);
        if (event === 'focusout' && !expDateOnKeyup) {
            expDateValidation = new Date((parseInt(exp_year_val.val()) + 2000), parseInt(exp_month_val.val()), 1, 0, 0, 0, -1);
            app.util.validateField('expiration_period', expDateValidation, null, null);
            expDateOnKeyup = true;
        } else if (event === 'keyup' && expDateOnKeyup) {
            expDateValidation = new Date((parseInt(exp_year_val.val()) + 2000), parseInt(exp_month_val.val()), 1, 0, 0, 0, -1);
            app.util.validateField('expiration_period', expDateValidation, null, null);
        }
    });
    if(opt.useHelper){
        utils.oneRowExpDateHelper($expDate);
    }
    $wrapper.one('change', '#' + opt.expMonthId + ', #' + opt.expYearId, function () {
        var exp_month_val = $('#' + opt.expMonthId).val() || '';
        var exp_year_val = $('#' + opt.expYearId).val() || '';
        if (exp_month_val && exp_year_val) {
            $expDate.val(exp_month_val + '/' + exp_year_val);
        }
    });
    $('#' + opt.expMonthId).trigger('change');
};

app.util.postMessageListener = (function () {
    var _hasPostMsgListener;
    return function () {
        if (_hasPostMsgListener) {
            return;
        }
        _hasPostMsgListener = true;
        window.addEventListener('message', function (e) {
            var data = e.data;
            try {
                data = JSON.parse(e.data);
            } catch (er) {
            }
            if (!data || data.action === 'analytics') {
                return;
            }
            var isFromFriendlyOrigin = (app.config.friendlyOrigins[e.origin] || e.origin === document.location.origin);
            var isFromLegitParent = (e.origin === document.location.origin || e.origin === app.config.parentUrl || app.config.parentUrl === '*');
            if (data.promocode) {
                var promoCode$ = $('#promoCode');
                promoCode$.val(data.promocode).trigger('setValue');
                _.each(window.srvOtherFields, function (fieldData) {
                    if (fieldData && fieldData.name === "promoCode") {
                        fieldData.value = data.promocode;
                    }
                });
                app.util.openPromoCodeToggleIfItHasValue();
                app.util.handleTogglePromocodeValidation();
            } else if (app.config.useAmountListener && data.amountValue && isFromLegitParent) {
                app.util.setAmountValue(data.amountValue, ['change', 'setValue']);
            } else if (data.closeLightbox === 'lbx_scc_terms') {
                /* when scc_terms are in separate lbx */
                $('#lightbox.lbx_scc_terms .modal_close').trigger('click');
                /* when scc_terms are inside the confirmation lbx */
                $('#lightbox #confirmation_footer').empty();
            } else if (data.action === 'close_pm_redirect_iframe'
                && data.closeLightbox && data.closeLightbox.startsWith('lbx_')
                && isFromFriendlyOrigin
            ) {
                $('#lightbox.pm_redirect_iframe.' + data.closeLightbox + ' .modal_close').trigger("click");
                if (app.lastSelectedMethodType === app.CONSTANTS.PM_NAME.PLAY_PLUS && data.closeLightbox === "lbx_" + app.CONSTANTS.PM_NAME.PLAY_PLUS.toLowerCase()) {
                    // Refresh the balance of the user in case they topped it up in the "Fund Play+" lightbox
                    if (app.util.isUpo(app.lastSelectedMethodId)) {
                        app.util.getUpmExtraDetails(app.lastSelectedMethodId, {});
                    } else {
                        app.util.getPmExtraDetails(app.lastSelectedMethodId, {});
                    }
                }
            } else if (data.action === 'close_iframe') {
                var ifrm = $('#targetIFrame')[0];
                if (ifrm && ifrm.contentWindow === e.source || isFromFriendlyOrigin) {
                    if (data.trxData) {
                        pubsub.publish('safecharge.transaction.complete', [data.trxData]);
                    } else {
                        app.util.closeTargetIframe();
                        apmPopupClosedCallback();
                    }
                }
            } else if (data.action === 'appReturnLinkUsed' && isFromLegitParent) {
                app.util.onAppReturnLinkUsed();
            } else if (data.action === 'open_in_browser'
                && data.url && data.url.length > 3
                && app.config.appReturnLink && app.config.nativeAppFlow === '1'
                && isFromFriendlyOrigin
            ) { // resend message to parent
                (app._webViewSDK || app.openedInIframeMode) && app.util.sendPostMessage(data, app.config.parentUrl);
            } else if (data.iframeName && data.sender === "pwmb_frame") {
                utils.pwmb.onMessage(data, e.origin);
            } else if (data && data.sender === "venmo_frame") {
                app.util.Venmo.onMessage(data, e.origin);
            } else if (data.sender === "gp_proxy"){
                app.util.GooglePay.onMessage(data, e.origin);
            } else if (data.sender === "bancontact_page"){
                app.util.Bancontact.onMessage(data, e.origin);
            }
        });
    }
})();

app.util.onAppReturnLinkUsed = function () {
    if (app.config.appReturnLink
        && app.submittedMethod && (app.submittedMethod.id === app.lastSelectedMethodId)
        && app.util.shouldOpenInExternalBrowser(app.submittedMethod && app.submittedMethod.id)
    ) {
        if (app.config.nativeAppFlow === '1'
            && app._flag.lastApmOpenedInFrame
            && app.lastSelectedMethodType === app._flag.lastApmOpenedInFrame
        ) {
            app.util.closeTargetIframe();
        }
        apmPopupClosedCallback();
    }
};

app.util.shouldOpenInExternalBrowser = function (uniqueId) {
    var item = uniqueId && app.config.appReturnLink && (app.util.isUpo(uniqueId) ? app._upoList[uniqueId] : app._poList[uniqueId] && app._poList[uniqueId].attributes);
    return (item && item.openInExternalBrowser);
};

app.util.isUpo = function (id) {
    return !isNaN(parseInt(id));
};

app.util.isDeletable = function (id) {
    return (app.config.allowDeleteUPO && app._upoList[id] && app._upoList[id]["deletable"]);
};

app.util.handleDankortVisa = function () {
    var $dankort_acq = $('input#dankort_acq');
    if ($dankort_acq.length) {
        var isCC = app.util.isCardPM({name: app.lastSelectedMethodType});
        if (isCC && (app.lastCardDetected === "dankort_visa" || app.lastSelectedMethodType === "dankort_visa")) {
            $dankort_acq.attr('disabled', false);
        } else {
            $dankort_acq.attr('disabled', true);
        }
    }
};

app.util.handleIsraeliCardsPresentation = function (cardInfo) {
    var isIL = (cardInfo && cardInfo.slave_brand === "israeli_card");
    var card_holder_id = $('#israeli_card_holder_id');
    var passport = $('#passportNumber');

    if(card_holder_id.length) {
        if (isIL) {
            app.util.unsetAsOptionalFld('israeli_card_holder_id');
            app.util.setAsOptionalFld('passportNumber');
            card_holder_id.attr('disabled', false);
            passport.val('').attr('disabled', true);
        } else {
            app.util.setAsOptionalFld('israeli_card_holder_id');
            app.util.unsetAsOptionalFld('passportNumber');
            card_holder_id.val('').attr('disabled', true);
            passport.attr('disabled', false);
        }
    }
};

app.util.updateDetectedCardBrand = (function IIFE () {
    var last_brand = 'none';
    return function updateBrand(ccType, cardInfo, initiator) {
        ccType || (ccType = 'none');
        app.lastCardDetected = ccType;
        if (cardInfo) {
            app._cardInfo = cardInfo;
        } else if (ccType = 'none') {
            app._cardInfo = {master_brand: 'none'};
        } else {
            // keep the last _cardInfo
        }
        if (last_brand !== ccType) {
            app.bodyElm.attr('data-cc_brand', ccType);
            pubsub.publish('app.event.cardBrandChanged', [{oldBrand: last_brand, newBrand: ccType, initiator: initiator}]);
            last_brand = ccType;
        }
    };
})();

app.util.onCardDetected = function ($cc_elm, ccType, cardInfo, initiator) {
    var $pminfo = $('.PMINFO');
    app.util.updateDetectedCardBrand(ccType, cardInfo, initiator);
    $cc_elm && $cc_elm.removeClass(app.CONSTANTS.CARD_LOGO_CLASSES).addClass(ccType + "Logo");
    $pminfo.removeClass(app.CONSTANTS.CARD_LOGO_CLASSES).addClass(ccType + 'Logo');
    if (cardInfo && cardInfo.slave_brand === "israeli_card") {
        $pminfo.addClass('il_card');
    }
    if (!app.util.isRestrictedCardType(ccType)) {
        app.util.handleDankortVisa();
        app.util.setCVVTooltip({card_type: ccType});
        app.util.handleIsraeliCardsPresentation(cardInfo);
        app.util.useInstallments(cardInfo);
        var data = app.pmLimits[ccType];
        var blockersData = data;
        if (app.util.isUpo(app.lastSelectedMethodId)) {
            blockersData = app._upoList[app.lastSelectedMethodId];
        }
        utils.renderBlockedPMReasons(blockersData);
        if (data) {
            app.applyRestrictions(data, initiator);
        }
        app.util.updateCurrencySelect(ccType);
    }
    app.util.handleCvvVisibility(ccType, cardInfo && cardInfo.server_class);
    app.util.handleCardHolderNameVisibility(ccType);
};

app.util.addDualBrandCardSelector = function(cardInfo, initiator) {
    var $dualBrandRadioBtnWrapper =  $('#dualBrandRadioBtnWrapper');
    var $ccCardNumRow = $('.row.cc_card_number');
    var fakeCardInfo;
    if (utils.useDualCardBrands() && cardInfo && cardInfo.isDualBrand) {
        var options = {
            masterBrandSelected: false,
            slaveBrandSelected: false,
            masterBrandAllowed: cardInfo.isBrand1Allowed && app.lastSelectedMethodType !== "bancontact_cc_card",
            slaveBrandAllowed: cardInfo.isBrand2Allowed && (app.lastSelectedMethodType !== "bancontact_cc_card" || cardInfo.cardBrand2 === 'bancontact')
        };

        if (options.masterBrandAllowed) {
            if ((cardInfo.lastUsedBrand && cardInfo.cardBrand === cardInfo.lastUsedBrand) || !cardInfo.lastUsedBrand) {
                options.masterBrandSelected = true;
            }
        }
        if (options.slaveBrandAllowed) {
            if ((cardInfo.lastUsedBrand && cardInfo.cardBrand2 === cardInfo.lastUsedBrand) || !options.masterBrandAllowed) {
                options.slaveBrandSelected = true;
            }
        }

        var dualBrandSelector =
        '<div class="row dualBrandRadioBtnWrapper <% if (!options.masterBrandAllowed && !options.slaveBrandAllowed) {%>both_disabled<%}%>" id="dualBrandRadioBtnWrapper">' +
            '<input type="radio" value="<%- cardInfo.cardBrand %>" name="selectedBrand" id="masterBrandRadioBtn" <%if (options.masterBrandSelected) {%> checked="checked" <%} if (!options.masterBrandAllowed) {%> disabled="disabled"<%}%> >' +
            '<label for="masterBrandRadioBtn" class="dualBrandCardLogo <%- cardInfo.cardBrand %>" <%if (!options.masterBrandAllowed) {%> disabled="disabled" <%}%> ></label>' +
            '<input type="radio" value="<%- cardInfo.cardBrand2 %>" name="selectedBrand" id="secondaryBrandRadioBtn" <%if (options.slaveBrandSelected) {%> checked="checked" <%} if (!options.slaveBrandAllowed) {%> disabled="disabled" <%}%> >' +
            '<label for="secondaryBrandRadioBtn" class="dualBrandCardLogo <%- cardInfo.cardBrand2 %>" <%if (!options.slaveBrandAllowed) {%> disabled="disabled" <%}%>></label>' +
        '</div>';

        var hasProperDOM = ($('#masterBrandRadioBtn').val() === cardInfo.cardBrand && $('#secondaryBrandRadioBtn').val() === cardInfo.cardBrand2);
        if (!hasProperDOM) {
            $dualBrandRadioBtnWrapper.remove();
            if ($ccCardNumRow.length) {
                $ccCardNumRow.after(_.template(dualBrandSelector)({cardInfo: cardInfo, options: options}));
            } else {
                $('.PMINFO').append(_.template(dualBrandSelector)({cardInfo: cardInfo, options: options}));
            }
            var selectedBrand = options.masterBrandSelected ? cardInfo.cardBrand : cardInfo.cardBrand2;
            var server_class = options.masterBrandSelected ? (cardInfo.cardBrand + "_" + cardInfo.cardBrand2) : (cardInfo.cardBrand2 + "_" + cardInfo.cardBrand);
            var isUpo = app.util.isUpo(app.lastSelectedMethodId);
            fakeCardInfo = {
                full_class      : server_class + "_dual",
                server_class    : server_class,
                master_brand    : cardInfo.cardBrand,
                slave_brand     : cardInfo.cardBrand2,
                is_dual_brand	: true
            };
            app.util.onCardDetected($ccCardNumRow.find('#cc_card_number'), selectedBrand, fakeCardInfo, 'brand_selection');
            app.util.validateRoCardField('dualBrandRadioBtnCreated');
            
            $('#dualBrandRadioBtnWrapper input[type=radio][name=selectedBrand]').change(function () {
                fakeCardInfo.server_class = this.value === cardInfo.cardBrand ? (cardInfo.cardBrand + "_" + cardInfo.cardBrand2) : (cardInfo.cardBrand2 + "_" + cardInfo.cardBrand);
                fakeCardInfo.full_class = fakeCardInfo.server_class + "_dual";
                app.util.onCardDetected($ccCardNumRow.find('#cc_card_number'), this.value, fakeCardInfo, 'brand_selection');
                app.util.triggerFldValidation('cc_card_number');
                app.util.validateRoCardField('dualBrandRadioBtnChange');
                app.util.handleBancontactOneClickCheckbox(cardInfo, this.value);
                pubsub.publish('app.event.changeDualBrandedCardBrand', [{selectedBrand: this.value, pmType: app.lastSelectedMethodType, uniqueId: app.lastSelectedMethodId, isUpo: isUpo}]);
            });
        }
        return true;
    } else {
        $dualBrandRadioBtnWrapper.remove();
        return false;
    }
};

app.util.handleCvvVisibility = function(lastCardDetected, server_class) {
    var shouldDisableCvvForCardBrand = app.config.disableCvvForCardBrands[lastCardDetected] || app.config.disableCvvForCardBrands[server_class];
    if(shouldDisableCvvForCardBrand)  {
        app.util.disableField('cc_cvv2');
    } else {
        app.util.enableField('cc_cvv2');
    }
};

app.util.handleCardHolderNameVisibility = function (lastCardDetected) {
    var shouldDisableCardHolderNameForCardBrand = app.util.isUpo(app.lastSelectedMethodId) && app.config.disableCardholderNameForCardBrands[lastCardDetected] && app.currentMethodFields['cc_name_on_card'] && !app.currentMethodFields['cc_name_on_card'].value;
    if(shouldDisableCardHolderNameForCardBrand) {
        app.util.disableField('cc_name_on_card');
    } else {
        app.util.enableField('cc_name_on_card');
    }
};

app.util.handleBancontactOneClickCheckbox = function(data, brandChangedTo) {
    if (data.oneClickPaymentSelectorLastValue) { // value can be "true", "false" or the property to be absent; the data var comes from the selectUPO response
        var isOneClickFlow = brandChangedTo === 'bancontact';
        if (!brandChangedTo && data.isDualBrand && data.lastUsedBrand === 'bancontact') {
            isOneClickFlow = true;
        }
        else if (!brandChangedTo && data.card_type === 'bancontact') {
            isOneClickFlow = true;
        } 

        if (isOneClickFlow) {
            var oneClickToggle ='<div id="bancontactOneClickToggleWrapper" class="row bancontactOneClickToggleWrapper toggleRow">' +
                                '<input id="bancontactOneClickToggle" name="oneClickPaymentSelector" type="checkbox" class="toggle_checkbox" <%if (defaultValue) {%>checked="checked"<%}%>>' + 
                                '<label for="bancontactOneClickToggle" class="checkbox_label"><span class="text" data-no="<%- t("checkbox_no")%>" data-yes="<%- t("checkbox_yes")%>"></span> <%- t("bancontact_one_click_label")%></label>' +
                            '</div>';
            var $dualBrandRadioBtnWrapper = $('#dualBrandRadioBtnWrapper');
    
            if ($dualBrandRadioBtnWrapper.length) {
                $dualBrandRadioBtnWrapper.after(_.template(oneClickToggle)({defaultValue: data.oneClickPaymentSelectorLastValue === "true"}));
            }
            else {
                // TODO: check this
                $('.PMINFO').append(_.template(_.template(oneClickToggle)({defaultValue: data.oneClickPaymentSelectorLastValue === "true"})));
            }
        }
        else {
            $('#bancontactOneClickToggleWrapper').remove();
        }
    }
    else {
        $('#bancontactOneClickToggleWrapper').remove();
    }
    app.recalcUserDetailsArea();
};

app.util.validateRoCardField = function (trigger) {
    var isCardUpo = app.util.isUpo(app.lastSelectedMethodId) && app.CONSTANTS.CC_CARDS_DB[app.lastSelectedMethodType];
    var cardNumberFld = isCardUpo && app._pmFields[app.lastSelectedMethodId] && app._pmFields[app.lastSelectedMethodId].cc_card_number;
    var cardFieldVisibility = cardNumberFld && cardNumberFld.fieldRenderInfo && cardNumberFld.fieldRenderInfo.visibilityMode;
    if (cardFieldVisibility === "DISABLED" || cardFieldVisibility === "HIDDEN") {
        var isValid = app.util.validateField('cc_card_number_upo_ro', '', '', 'custom');
        if (!isValid) {
            app.util.addSuspendedPmBlocker(app.lastSelectedMethodId, false, "upoCardCurrencyBlocker", app._validationResult.cc_card_number_upo_ro.message);
        } else {
            app.util.removePmBlocker(app.lastSelectedMethodId, 'upoCardCurrencyBlocker');
        }
        if (trigger !== 'post-upm-render') {
            utils.renderBlockedPMReasons(app._upoList[app.lastSelectedMethodId]);
        }
    }
};

app.util.renderSaveUpoToggle = function (selector, selectedMethodId, selectedMethodType) {
    if (!app.config.showSaveUpoToggle) {
        return;
    }
    var $wrapper = $(selector || '#save_upo_wrapper');
    if ($wrapper.length) {
        $wrapper.empty();
    }
    if (!app.util.isUpo(selectedMethodId) && !app.CONSTANTS.PMS_WITH_NO_SAVE_UPO_CHECKBOX[selectedMethodId]) {
        var $tplElm = $('#save_upo_button');
        var defaultValue = app.config.saveUpoDefaultValue ? 'checked' : '';
        var tplTxt = '<div class="row allowSaveUpo"><input type="checkbox" id="allowSaveUpo" name="allowSaveUpo" value="true" class="toggle_checkbox" ' + defaultValue + '/><label for="allowSaveUpo"><span class="text" data-no="<%-t("lightbox_no_button")%>" data-yes="<%-t("lightbox_yes_button")%>"></span><%= t("save_upo_toggle_text")%></label></div>';
        if ($tplElm.length) {
            tplTxt = $tplElm.text();
        }
        var html = _.template(tplTxt)({
            uniqueId: selectedMethodId,
            methodName: selectedMethodType
        });
        if ($wrapper.length) {
            $wrapper.html(html);
        } else {
            $('.PMINFO').append($(html));
        }
    }
};

app.util.addRemoveUpmButton = function (selector, selectedMethodId, selectedMethodType) {
    var $wrapper = $(selector || '#remove_upo_wrapper');
    if ($wrapper.length) {
        $wrapper.empty();
    }
    if (app.util.isUpo(selectedMethodId)
        && app.util.isDeletable(selectedMethodId)
        && selectedMethodType) {
        var $tplElm = $('#remove_upo_button');
        var tplTxt = '<span class="removeUPM" data-value="<%-uniqueId%>" data-method="<%-methodName%>"><%- t("remove_upm_button_text")%></span>';
        if ($tplElm.length) {
            tplTxt = $tplElm.text();
        }
        var html = _.template(tplTxt)({
            uniqueId: selectedMethodId,
            methodName: selectedMethodType
        });
        if ($wrapper.length) {
            $wrapper.html(html);
        } else {
            $('.PMINFO').append($(html));
        }
    }
};

app.util.onDrContactSupport = (function () {
    var _lastEventTimestamp;
    return function (e) {
        var currentTime = (new Date()).getTime();
        if (currentTime - _lastEventTimestamp < 30) {
            _lastEventTimestamp = currentTime;
            e.preventDefault();
            return true;
        }
        var $this = $(this);
        var feRef = $this.attr('data-ref')
        var submittedMethod = (feRef && app.util.FeRef.getRefData(feRef) || {}).submittedMethod;
        var data_to_send = {
            metaInfo: {
                actionType: this && $this.attr('data-action') || 'contactSupport',
                drOptionPosition: this && $this.attr('data-position') || '1',
                submittedFeRef: feRef,
                submittedPmId: submittedMethod && submittedMethod.id,
                submittedPmName: submittedMethod && submittedMethod.pmName
            }
        };
        pubsub.publish('app.event.drContactSupport', [data_to_send]);
        _lastEventTimestamp = currentTime;
    }
})();

app.util.onFormCanceledByUser = function () {
    $.blockUI({ignoreIfBlocked: true});
    $('#continueButton').off();
    pubsub.publish('app.event.canceledByUser', []);
    app.util.sendPostMessage("canceledByUser", app.config.parentUrl);
    document.forms[0].action = "cancel.do";
    document.forms[0].pppAction.value = 'cancelByUser';
    document.forms[0].submit();
    return true;
};

app.util.onBackToMerchantSiteClicked = function () {
    if (app.config.useCancelAsBackBtn) {
        app.util.onFormCanceledByUser();
    } else {
        $.blockUI({ignoreIfBlocked: true});
        $('#continueButton').off();
        pubsub.publish('app.event.backToMerchantSite', []);
        app.util.sendPostMessage("backToMerchantSite", app.config.parentUrl);
        document.forms[0].action = "back.do";
        document.forms[0].pppAction.value = 'backToMerchantSite';
        document.forms[0].submit();
    }
    return true;
};

app.util.entropayRegistrationFlow = function () {
    var getField = function (field) {
        return _.find(srvUserFields, function (i) {
            return i.name == field;
        });
    };
    var getTimestamp = function () {
        return (new Date()).toISOString().replace(/[^\d]/g, "").slice(0, 14);
    };

    var dob = (app.config.user && app.config.user.dateOfBirth && app.config.user.dateOfBirth.split('-')) || '';
    var params = 'method=start' +
        '&referrerID=' + app.msg['entropay_referrerId'] +
        '&timestamp=' + getTimestamp() +
        '&pref_currency=' + encodeURIComponent(app.config.currency || '') +
        '&pref_language=' + encodeURIComponent(app.config.locale || '') +
        '&aff_email=' + encodeURIComponent(getField('email') ? getField('email').value : '') +
        '&aff_firstName=' + encodeURIComponent(getField('first_name') ? getField('first_name').value : '') +
        '&aff_lastName=' + encodeURIComponent(getField('last_name') ? getField('last_name').value : '') +
        '&aff_dobDay=' + encodeURIComponent(dob[2] || '') +
        '&aff_dobMonth=' + encodeURIComponent(dob[1] || '') +
        '&aff_dobYear=' + encodeURIComponent(dob[0] || '') +
        '&aff_address1=' + encodeURIComponent(getField('address1') ? getField('address1').value : '') +
        '&aff_zipCode=' + encodeURIComponent(getField('zip') ? getField('zip').value : '') +
        '&aff_town=' + encodeURIComponent(getField('city') ? getField('city').value : '') +
        '&aff_country=' + encodeURIComponent(getField('country') ? getField('country').value : '') +
        '&aff_phoneNumber=' + encodeURIComponent(getField('phone1') ? getField('phone1').value : '');
    var url = app.msg['entropay_url'] + params;
    $(this).attr('href', url).attr('target', '_blank');
};

app.util.backToRedirectPageHandler = function (popupWindow) {
    var $el = $('#backToRedirectPage-template');
    var htmlTpl = _.template(
        '<div class="btrp_info">' +
        '<div class="btrp_pmLogo <%- pmName %>"></div>' +
        '<div class="btrp_msg"><%- msg %></div>' +
        '<div class="btrp_continue"><%- btn_continue %></div>' +
        '</div>'
    );
    var tpl = ($el.length) ? _.template($el.text()) : htmlTpl;
    var html = tpl({
        pmName: app.lastSelectedMethodType.toLowerCase(),
        msg: app.msg['back_to_redirect_page'].format(app.msg[app.lastSelectedMethodType] || ''),
        btn_continue: app.msg['back_to_redirect_button']
    });

    $('.blockUI.blockMsg')
        .addClass('blockUI_backToRedirectPage')
        .html(html);
    $('.blockUI.blockOverlay').addClass('blockOverlay_backToRedirectPage');
    $(document).on('click', '.btrp_continue', function () {
        popupWindow.focus();
    });
};

app.util.paypalFraudNetHandler = function () {
    var initIframe = function (ssid, paypal_fraudnet_id, isSandbox) {
        var dom, doc;
        var iframe = document.createElement('iframe');
        iframe.src = "about:blank";
        iframe.title = "";
        iframe.role = "presentation";
        (iframe.frameElement || iframe).style.cssText = "width: 0; height: 0; border: 0";
        document.body.appendChild(iframe);
        try {
            doc = iframe.contentWindow.document;
        } catch (e) {
            dom = document.domain;
            iframe.src = "javascript:var d=document.open();d.domain='" + dom + "';void(0);";
            doc = iframe.contentWindow.document;
        }
        doc.open()._l = function () {
            var s1 = this.createElement('script');
            var s2 = this.createElement("script");
            s1.id = 'paypal_fraudnet_data';
            s1.type = 'application/json';
            s1.setAttribute('fncls', 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99');
            s1.text = '{"f":"' + ssid + '", "s":"' + paypal_fraudnet_id + '", "sandbox":' + isSandbox + '}';
            s2.id = "paypal_fraudnet_js";
            s2.src = 'https://c.paypal.com/da/r/fb.js';
            if (dom) {
                this.domain = dom;
            }
            this.body.appendChild(s1);
            this.body.appendChild(s2);
        };
        doc.write('<body onload="document._l();">');
        doc.close();
    };
    if (!window.isPPFraudNetActivated) {
        initIframe(app.ssid, app.config.pmSettings.apmgw_expresscheckout.paypal_fraudnet_id, "production" !== app.config.analyticsConfig.env);
        window.isPPFraudNetActivated = true;
    }
};

app.util.showPaymentMethodHint = function (pmName, pmHintContainer) {
    var cfg = app.config.pmHintConfig;
    var pmHint = app.msg.pm_hint[pmName] || "";
    var isUpo = app.util.isUpo(app.lastSelectedMethodId);
    $('[data-role="pm_hint"]').remove();

    if (isUpo && app.msg.pm_hint.hasOwnProperty("upm_" + pmName)) {
        pmHint = app.msg.pm_hint["upm_" + pmName] || '';
    }

    if (cfg.showTableHint && app.CONSTANTS.REDIRECT_PAYMENT_METHODS_TYPES[app.lastSelectedMethodType]) {
        var payload = {
            'pmType' : app.CONSTANTS.REDIRECT_PAYMENT_METHODS_TYPES[app.lastSelectedMethodType],
            'pmHint' : (app.lastSelectedMethodType === 'apmgw_MuchBetter' && isUpo) ? '' : pmHint
        };
        pmHint = _.template(app.CONSTANTS.TABLE_PM_HINT_TPL)(payload);
    }

    if (pmHint && cfg) {
        var tpl = '<div class="pm-hint"><%= hint%></div>';
        var custom_tpl = $('#pm_hint_template');
        pmHintContainer = pmHintContainer ? $(pmHintContainer) : $('.PMINFO').parent();
        if (custom_tpl.length) {
            tpl = custom_tpl.text();
        }

        var $html = $(_.template(tpl)({hint : pmHint})).attr('data-role', 'pm_hint');
        if ('ALL' === cfg.topRenderExeption[0] || cfg.topRenderExeption.indexOf(pmName) > -1) {
            pmHintContainer.prepend($html);
        } else {
            pmHintContainer.append($html);
        }

        app.recalcUserDetailsArea();
    }
};

app.util.isApplePayEnabled = function () {
    var cfg = app.config.pmSettings.ppp_ApplePay;
    var hasSupportedNetworks = (cfg && cfg._supportedNetworks && cfg._supportedNetworks.length);
    var hasAllowedCardTypes = (!app.config.creditRestricted || !app.config.debitRestricted);
    if (!hasSupportedNetworks || !hasAllowedCardTypes) {
        return false;
    }
    //if sccardscanner is detected do not touch ApplePaySession as it could trigger security policy breaking scanCard
    // functionality
    var haveNativeScanCard = window.sccardscanner || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.scanCard);
    if ( haveNativeScanCard ){
        return app.applePayDeviceSupport;
    }
    var isApplePayForWeb = function () {
        if (cfg && "applePayUnsupported" ===  cfg._applePayCapabilities) {
            return false;
        }
        if (window.ApplePaySession && !app.openedInIframeMode) {
            try {
                return ApplePaySession.canMakePayments();
            } catch (e) {
                return false;
            }
        }
        return false;
    };
    return (app.applePayDeviceSupport || (app.openedInIframeMode && app._parentSupportApplePay) || isApplePayForWeb());
};

app.util.performApplePayMerchantValidationPromise = function (valURL, ssid, flow) {
    return new Promise(function (resolve, reject) {

        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            try {
                var data = JSON.parse(this.responseText);
                resolve(data.appleResponse);
            } catch (e) {
                if (window._apple_session) {
                    window._apple_session.completePayment(ApplePaySession.STATUS_FAILURE);
                } else {
                    reject();
                }
            }
        };
        xhr.onerror = reject;
        xhr.timeout = 20000;
        xhr.ontimeout = reject;

        var searchStr = '?validationUrl=' + valURL + '&ssid=' + ssid;
        searchStr += flow ? ('&mobilePayFlow=' + flow) : '';
        searchStr += ('&ts=' + (new Date()).getTime());
        xhr.open('GET', '/ppp/getAppleValidationJson.do' + searchStr);
        xhr.send();
    });
};

app.util.ApplePayConnector = (function () {
    var seq = setSEQ();
    var req_next = Math.round((Math.random() + .1) * 10000);
    var origin = false;
    var reqList = {};
    var hasHandshake = false;
    var parentSupportApplePay = false;
    var parentApplePayMaxSupportedVersion = 1;
    var paymentInProgress = false;
    var paymentAuthorizationStarted = false;
    var verifyMerchantViaProxyScript = !app._doNotVerifyMerchantViaApplepayProxyScript;
    var activeCardPromiseResolver;
    var connect_promise;
    var expectMessage = false;
    var req_actions = {
        "sync": {timeout: 2000, callback: cb_sync, url: "*", extraTimeout: 2000},
        "ack": {},
        "begin": {timeout: 15000, callback: cb_pay},
        "pay": {timeout: 15000, callback: cb_pay, extraTimeout: 5000},
        "vmr": {timeout: 180000, callback: cb_pay},
        "canMakePaymentsWithActiveCard": {timeout: 15000, callback: cb_canMakePaymentsWithActiveCard},
        "completeTrx": {timeout: 3000}
    };

    function setSEQ() {
        seq = Math.round(Math.random() * 10000);
        return seq;
    }

    function getReqID() {
        var req_id = req_next;
        req_next += 1;
        return req_id;
    }

    function initState() {
        setSEQ();
        req_next = Math.round((Math.random() + .1) * 10000);
        origin = false;
        reqList = {};
        hasHandshake = false;
        parentSupportApplePay = false;
        expectMessage = true;
    }

    function sendRequest(action, dataObj) {
        if (action && req_actions[action]) {
            var data = dataObj || {};
            if (req_actions[action].data) {
                Object.keys(req_actions[action].data).forEach(function (key) {
                    var val = req_actions[action].data[key];
                    if (_.isFunction(val)) {
                        val = val();
                    }
                    data[key] = val;
                });
            }
            var req_id = getReqID();
            data.action = action;
            data.id = req_id;
            data.timestamp = Date.now();
            reqList[req_id] = {
                action: action,
                callback: (req_actions[action].callback || function (a) {
                    return a;
                })
                , details: data
            };
            app.util.sendPostMessage(data, origin || '*');
            if (req_actions[action].hasOwnProperty("timeout")) {
                reqList[req_id].timeout = setTimeout(function () {
                    if (reqList[req_id]) {
                        onResponseTimeout(req_id);
                    }
                }, req_actions[action].timeout);
            }
        }
    }

    function getFormattedResponse(e) {
        var res = e.data;
        try {
            res = JSON.parse(e.data);
        } catch (er) {
        }
        return res;
    }

    function checkOrigin(e) {
        return !(origin && e.origin !== origin);
    }

    function onResponseReceived(res, e) {
        if (reqList[res.req_id] && !reqList[res.req_id].state) {
            clearTimeout(reqList[res.req_id].timeout);
            reqList[res.req_id].state = "completed";
            reqList[res.req_id].callback && reqList[res.req_id].callback(res, e);
        } else if(reqList[res.req_id] && reqList[res.req_id].state){
            if (reqList[res.req_id].action === "pay" && reqList[res.req_id].state === "timeout" ) {
                paymentInProgress = false;
            }
            app._logger.log('ApplePayConnector => Response ERROR: Expired (or Invalid) response received! for req_id:' + res.req_id);
        }
    }

    function onResponseTimeout(req_id) {
        var req = reqList[req_id];
        if (req && !req.state) {
            var action = req.action;
            if (action === "sync") {
                connect_promise.reject({parentSupportApplePay: parentSupportApplePay, timeout: true});
                expectMessage = false;
                app._logger.log('ApplePayConnector => Missing Script in Parent! ...timeout');
                console.log("+++++++++++>>> Missing Script in Parent!");
            } else if (action === "canMakePaymentsWithActiveCard") {
                app._logger.log('ApplePayConnector => canMakePaymentsWithActiveCard response ...timeout');
                cb_canMakePaymentsWithActiveCard();
            }
            req.state = "timeout";
        }
    }

    function cb_sync(res, e) {
        if (res && res.hasOwnProperty('supportApplePay') && res.ack === (seq + 1)) {
            parentSupportApplePay = res.supportApplePay;
            parentApplePayMaxSupportedVersion = res.maxSupportedVersion || 1;
            if (!origin && e.origin) {
                origin = e.origin;
            }
            hasHandshake = true;
            if (res.action === "sync_ack" && res.seq) {
                sendRequest("ack", {ref_id: res.id, ack: res.seq + 1});
            }
            connect_promise.resolve({parentSupportApplePay: parentSupportApplePay, parentApplePayMaxSupportedVersion: parentApplePayMaxSupportedVersion});
        } else {
            connect_promise.reject({parentSupportApplePay: parentSupportApplePay});
            expectMessage = false;
        }
    }

    function cb_canMakePaymentsWithActiveCard(res, e) {
        var hasActiveCard = true;
        if (res && res.action === "has_active_card" && res.hasOwnProperty('canMakePaymentsWithActiveCard')) {
            if (res.action === "has_active_card" && res.hasOwnProperty('canMakePaymentsWithActiveCard')) {
                hasActiveCard = res.canMakePaymentsWithActiveCard;
            } else if (res.action === "INVALID_REQUEST"){
                app._logger.log('ApplePayConnector => canMakePaymentsWithActiveCard response ...ERROR');
            }
        }
        if (activeCardPromiseResolver) {
            activeCardPromiseResolver(hasActiveCard);
            activeCardPromiseResolver = null;
        }
    }

    function cb_pay(res) {
        if (paymentInProgress) {
            if (res.action === "CANCELLED" || res.action === "vmr") {
                paymentInProgress = false;
                if (res.action === "CANCELLED" && !paymentAuthorizationStarted) {
                    window.applePay.onCancel();
                }
            } else if (res.action === "vm") {
                var ssid = app.config.ssid;
                var flow = app.CONSTANTS.APPLE_PAY_FLOW_4;
                if(verifyMerchantViaProxyScript) {
                    /** DEFAULT flow
                     * leave to the proxy script the verification of the merchant
                     * as endpoint currently uses referer to determine domain send to Apple
                     * */
                    var url = [document.location.protocol, '//', document.location.host, "/ppp/getAppleValidationJson.do"].join('');
                    sendRequest("vmr", {
                        ref_id: res.id,
                        _intData: {url: url, valURL: res.validationURL, ssid: ssid, flow: flow},
                        status: "SUCCESS"
                    });
                } else {
                    var promise = app.util.performApplePayMerchantValidationPromise(res.validationURL, ssid, flow);
                    promise.then(function (merchantSession) {
                        var mso = JSON.stringify(merchantSession);
                        sendRequest("vmr", {ref_id: res.id, mso: mso, status: "SUCCESS"});
                    }, function (err) {
                        sendRequest("vmr", {ref_id: res.id, status: "FAIL"});
                    });
                }
            } else if (res.action === "paut") {
                paymentAuthorizationStarted = true;
                var applePayJson = JSON.parse(res.applePayJson);
                window.applePay.submitFormWithApplePayToken(applePayJson);
            }
        }
    }

    function onMessage(e) {
        if (expectMessage && checkOrigin(e)) {
            var res = getFormattedResponse(e);
            if (res && res.req_id) {
                onResponseReceived(res, e);
            }
        }
    }

    function doPay(data) {
        if (hasHandshake && parentSupportApplePay && !paymentInProgress) {
            paymentInProgress = true;
            paymentAuthorizationStarted = false;
            sendRequest('pay', data);
        }
    }

    function doBegin(data) {
        if (hasHandshake && parentSupportApplePay && paymentInProgress) {
            sendRequest('begin', data);
        }
    }

    function restartDoPay(data) {
        if (hasHandshake && parentSupportApplePay && !paymentAuthorizationStarted) {
            if (paymentInProgress && data) {
                paymentInProgress = false;
                data.restart = true;
                doPay(data);
            }
            doPay(data);
        }
    }

    function connect(obj) {
        if (!connect_promise) {
            connect_promise = $.Deferred();
            initState();
            var syncData = {seq: seq};
            if (obj.isCrossBrowser && obj.merchantIdentifier) {
                syncData.isCrossBrowser = obj.isCrossBrowser;
                syncData.merchantIdentifier = obj.merchantIdentifier;
                req_actions.sync.timeout = req_actions.sync.timeout + req_actions.sync.extraTimeout;
                if (verifyMerchantViaProxyScript) {
                    req_actions.pay.timeout = req_actions.pay.timeout + req_actions.pay.extraTimeout;
                }
            }
            sendRequest('sync', syncData);
            return connect_promise.promise(obj);
        }
        return connect_promise;
    }

    function canMakePaymentsWithActiveCard(merchantIdentifier) {
        var p1;
        if (hasHandshake && parentSupportApplePay && !paymentInProgress && !activeCardPromiseResolver) {
            p1 = new Promise(function (resolve, reject) {
                activeCardPromiseResolver = resolve;
                sendRequest('canMakePaymentsWithActiveCard', {details: {merchantIdentifier: merchantIdentifier}});
            });
        } else {
            p1 = Promise.resolve(true);
        }
        return p1;
    }

    function completeTrx(data) {
        sendRequest('completeTrx', data);
        paymentInProgress = false;
    }

    if (window.addEventListener) {
        window.addEventListener("message", onMessage, false);
    } else {
        window.attachEvent("onmessage", onMessage);
    }

    return {
        connect: connect,
        doPay: doPay,
        doBegin: doBegin,
        restartDoPay: restartDoPay,
        completeTrx: completeTrx,
        getFormattedResponse: getFormattedResponse,
        canMakePaymentsWithActiveCard: canMakePaymentsWithActiveCard,
        getReqList: function () {
            return JSON.stringify(reqList);
        },
        hasHandshake: function () {
            return JSON.stringify({hasHandshake: hasHandshake, origin: origin});
        }
    }
})();

app.util.reInitVisaCheckout = function () {
    if (app.lastSelectedMethodType === 'visa_checkout' && app.vcoInit && typeof V !== 'undefined') {
        var currency = (app.config.ptRequestId ? app.currency : app.lastSelectedCurrency);
        var isUpo = app.util.isUpo(app.lastSelectedMethodId);
        if (defaults.visaCheckout.amount !== app.lastSelectedAmount ||
            defaults.visaCheckout.currency !== currency ||
            defaults.visaCheckout.isUpo !== isUpo) {
            app.vcoInit(app.lastSelectedAmount, currency, isUpo);
        }
    }
};

app.util.getLogger = function () {
    var _log = {}, _logLevel = 0;

    function log(data, logLevel) {
        if (logLevel === 0 || _logLevel >= logLevel)
            _log[Date.now().toString()] = JSON.stringify(data);
    }

    return {
        log: function (data) {
            log(data, 0); // log always
        },
        log_1: function (data) {
            log(data, 1);
        },
        log_2: function (data) {
            log(data, 2); // log only when _logLevel >= 2
        },
        showLog: function () {
            var ret = {};
            _.each(Object.keys(_log), function (x) {
                if (_log.hasOwnProperty(x)) {
                    try {
                        ret[x] = JSON.parse(_log[x]);
                    } catch (e) {
                        console.log('invalid json');
                    }
                }
            });
            return ret;
        },
        setLogLevel: function (level) {
            return _logLevel = level;
        }
    };
};

app.util.onEditVco = function (payment) {
    var vcoCallId = payment && payment.callid;
    if (vcoCallId) {
        $('#vcoCallId').val(vcoCallId);
        var data = {
            'ssid': app.ssid,
            'vcoCallId': vcoCallId,
            'vcoPaymentMethodType': (payment.paymentMethodType || '')
        };
        $.blockUI();
        $.getJSON('editVcoUpoByCallId.do', data).done(function (res) {
            app._logger.log({msg : 'onEditVco res', data : res});
            if (!res || _.isEmpty(res)) {
                unblockUI();
                return;
            }
            if (res.status == "OK") {
                app.reloadPMs();
            } else if (res.status == "FAIL" && res.message) {
                if (res.message === app.CONSTANTS.SRV_RESPONSE.MSG_SESSION_EXPIRED) {
                    app.showFinalMessage(app.CONSTANTS.SRV_RESPONSE.MSG_SESSION_EXPIRED);
                } else {
                    app.showModalMessage({details: app.msg[res.message] || res.message}, app.CONSTANTS.MODAL_MESSAGE_TYPE.ERROR);
                }
            }
            unblockUI();
        }).fail(function () {
            app._logger.log('onEditVco fail ...');
            unblockUI();
        });
    }
};

app.util.loadVcoScript = function () {
    if (app.lastSelectedMethodType === 'visa_checkout') {
        $.getScript(app.config.vcoSdkUrl, function (data, textStatus, jqxhr) {
            if (jqxhr.status === 200) {
                $('#vco, a.v-button').css({"visibility": 'visible'});
                $(window).trigger('resize');
            }
        });
    }
};

app.util.setApplePayBtn = function (color, withText, buttonType) {
    color = color || (app.useLightBtn ? 'white' : 'black');  //// (color VALUES: "black" | "white" )
    var _atempts = 0;
    var txt = withText ? app.msg['buy'] || 'Buy with' : '';
    if (buttonType && buttonType !== "plain" && app.msg[buttonType]) {
        txt = app.msg[buttonType];
    }
    var payload = {
        color: color,
        buttonTypeClass: buttonType ? "apple-pay-button-type-" + buttonType : "",
        type: buttonType || "plain",
        text: txt,
        locale: (app.locale || "en-US").replace('_', '-')
    };
    var tpl = {
        regular : '<div id="apple-pay-button" class="apple-pay-button apple-pay-button-<%-color%> <%-buttonTypeClass%>"></div>',
        withText: '<div id="apple-pay-button" class="apple-pay-button-with-text apple-pay-button-<%-color%>-with-text"><span class="text"><%-text%></span><span class="logo"></span></div>',
        sdkBtn  : '<apple-pay-button id="apple-pay-button"  buttonstyle="<%-color %>" type="<%-type%>" locale="<%-locale%>" ></apple-pay-button>',
        crossBrowserFallbackBtn: '<div id="apple-pay-button" class="crossBrowserBtn apple-pay-button apple-pay-button-<%-color%> <%-buttonTypeClass%>" style="text-align: center;">' +
            '<span id="flex_container" style="display: flex;justify-content: center;align-items: center;height: 100%;">' +
            '<span class="text" style="color:<%-color === "black" ? "#FFF" : "#000" %>; font-size: 1.5rem;font-weight: 500;font-family: -apple-system, apple-pay-btn-es-ES, BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;"><%-text%></span>' +
            '<svg id="svg-logo" viewBox="0 0 35 15" style="max-height: 100%;max-width: 100%;">\n' +
            '<svg id="svg-logo" x="0" y="3.85" height="7.3" width="35" class="logo" viewBox="0 0 105 43" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
            '    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n' +
            '        <g fill="<%-color === "black" ? "#FFF" : "#000" %>">\n' +
            '            <path d="M19.4028,5.5674 C20.6008,4.0684 21.4138,2.0564 21.1998,0.0004 C19.4458,0.0874 17.3058,1.1574 16.0668,2.6564 C14.9538,3.9414 13.9688,6.0374 14.2258,8.0074 C16.1948,8.1784 18.1618,7.0244 19.4028,5.5674"></path>\n' +
            '            <path d="M21.1772,8.3926 C18.3182,8.2226 15.8872,10.0156 14.5212,10.0156 C13.1552,10.0156 11.0642,8.4786 8.8022,8.5196 C5.8592,8.5626 3.1282,10.2276 1.6342,12.8746 C-1.4378,18.1696 0.8232,26.0246 3.8112,30.3376 C5.2622,32.4716 7.0102,34.8206 9.3142,34.7366 C11.4912,34.6506 12.3442,33.3266 14.9902,33.3266 C17.6352,33.3266 18.4042,34.7366 20.7082,34.6936 C23.0972,34.6506 24.5922,32.5586 26.0422,30.4226 C27.7072,27.9906 28.3882,25.6426 28.4312,25.5126 C28.3882,25.4706 23.8232,23.7186 23.7812,18.4676 C23.7382,14.0706 27.3652,11.9786 27.5362,11.8496 C25.4882,8.8196 22.2872,8.4786 21.1772,8.3926"></path>\n' +
            '            <path d="M85.5508,43.0381 L85.5508,39.1991 C85.8628,39.2421 86.6158,39.2871 87.0158,39.2871 C89.2138,39.2871 90.4558,38.3551 91.2108,35.9581 L91.6548,34.5371 L83.2428,11.2321 L88.4368,11.2321 L94.2958,30.1421 L94.4068,30.1421 L100.2668,11.2321 L105.3278,11.2321 L96.6048,35.7141 C94.6078,41.3291 92.3208,43.1721 87.4828,43.1721 C87.1048,43.1721 85.8838,43.1271 85.5508,43.0381"></path>\n' +
            '            <path d="M42.6499,19.3555 L48.3549,19.3555 C52.6829,19.3555 55.1469,17.0255 55.1469,12.9855 C55.1469,8.9455 52.6829,6.6375 48.3769,6.6375 L42.6499,6.6375 L42.6499,19.3555 Z M49.6869,2.4425 C55.9009,2.4425 60.2289,6.7265 60.2289,12.9625 C60.2289,19.2225 55.8129,23.5285 49.5309,23.5285 L42.6499,23.5285 L42.6499,34.4705 L37.6779,34.4705 L37.6779,2.4425 L49.6869,2.4425 Z"></path>\n' +
            '            <path d="M76.5547,25.7705 L76.5547,23.9715 L71.0287,24.3275 C67.9207,24.5275 66.3007,25.6815 66.3007,27.7015 C66.3007,29.6545 67.9887,30.9195 70.6287,30.9195 C74.0027,30.9195 76.5547,28.7665 76.5547,25.7705 M61.4617,27.8345 C61.4617,23.7285 64.5917,21.3755 70.3627,21.0205 L76.5547,20.6425 L76.5547,18.8675 C76.5547,16.2705 74.8457,14.8495 71.8057,14.8495 C69.2967,14.8495 67.4777,16.1375 67.0997,18.1125 L62.6167,18.1125 C62.7497,13.9615 66.6567,10.9435 71.9387,10.9435 C77.6207,10.9435 81.3267,13.9175 81.3267,18.5345 L81.3267,34.4705 L76.7327,34.4705 L76.7327,30.6305 L76.6217,30.6305 C75.3127,33.1395 72.4267,34.7145 69.2967,34.7145 C64.6807,34.7145 61.4617,31.9625 61.4617,27.8345"></path>\n' +
            '        </g>\n' +
            '    </g>\n' +
            '</svg></svg></span></div>'
    };
    var appleCfg = app.config.pmSettings.ppp_ApplePay;
    var tplName = withText ? 'withText' : 'regular';
    if (appleCfg && appleCfg.useApplePaySdk) {
        tplName = appleCfg._isCrossBrowserSdkReady || window.customElements.get('apple-pay-button') ? 'sdkBtn' : 'crossBrowserFallbackBtn';
    }
    var btn = _.template(tpl[tplName])(payload);
    app.util.getCustomBtnContainer().append(btn).removeClass('_invisible');
    $('#apple-pay-button').on('click', app.util.handleApplePay);
    if (tplName === 'sdkBtn' && (appleCfg._applePayDeviceSupport || appleCfg._parentSupportApplePay)) {
        setTimeout(_showAppleBtn, 300);
    }

    function _showAppleBtn() {
        if (tplName === 'sdkBtn' && _atempts < 3 && 'ppp_ApplePay' === app.lastSelectedMethodType) {
            $('#apple-pay-button').removeAttr('hidden disabled aria-hidden');
            setTimeout(_showAppleBtn, 200);
        }
        _atempts++;
    }
};

app.util.onPreRenderClearDOM = function () {
    app.bodyElm.removeClass('custom_btn main_visa_checkout main_venmo main_apple_pay main_google_pay has_spoints has_ppoints disable_cvv disable_cc_name_on_card');
    $('#VmeCheckout').remove();         // VCO Pop-Up
    $('#apple-pay-button, #google-pay-button, #vco, #venmo-button').remove();
    $('#tmpDepositConfirmations, #whole_screen_overlay').remove();
    $('#customBtnContainer, #store_card_wrapper').empty();
    $('#agreeDcc').attr('disabled', true); // we do not remove the entire DCC section to reduce blinking
    $('#userPaymentOptionId').val('');  // fix Pt Server Confusion
    $('#payment_method').val('');
    $('[data-role="pm_hint"]').remove();
    $('[data-role="inline_info_msg"]').remove();
    app.util.imsAnalytics.deleteScanCardAnalyticsObj();
};

app.util.onTrxCompleteClearDOM = function () {
    $('body').removeClass('overflowed');
    $('#whole_screen_overlay').remove();
    $('#targetIFrame').parent().hide();
    $('#PPPParametersForm').attr('target', '_self');
    $('#continueButton').blur();        // prevent resubmit by pressing Space bar or Enter
};

app.util.getDateFieldNames = function (pmData) {
    var retObj = {};
    if (_.has(pmData, 'expiration_period')) {
        Object.keys(pmData['expiration_period']).forEach(function (k) {
            if (k.endsWith('cc_exp_month')) {
                retObj.expMonthId = k;
            } else if (k.endsWith('cc_exp_year')) {
                retObj.expYearId = k;
            }
        });
        if (!retObj.expMonthId || !retObj.expYearId) {
            retObj = {};
        }
    } else {
        var mFldName = app.util.getPmSpecificFldName('cc_exp_month', app.lastSelectedMethodType);
        var yFldName = app.util.getPmSpecificFldName('cc_exp_year', app.lastSelectedMethodType);
        if (_.has(pmData, mFldName)) {
            /** we have month & year fields directly attached to the pmData */
            retObj.expMonthId = mFldName;
            retObj.expYearId = yFldName;
        }
    }
    return retObj;
};

app.util.setDateValidation = function (pmData) {
    var names = app.util.getDateFieldNames(pmData);
    if (names.expMonthId) {
        if ((_.has(pmData, names.expMonthId) && pmData[names.expMonthId].type !== 'DISABLED') ||
            (_.has(pmData, 'expiration_period')
                && pmData['expiration_period'][names.expMonthId].type !== 'DISABLED'
                && !app.popupValidation)
        ) {
            $('#' + names.expMonthId + ', #' + names.expYearId).on('change', function (ev) {
                var exp_year = $('#' + names.expYearId);
                var exp_month = $('#' + names.expMonthId);
                var exp_year_val = parseInt(exp_year.val());
                var exp_month_val = parseInt(exp_month.val());
                var exp_date = (exp_month_val < 0 || exp_month_val > 12) ? new Date('Invalid Date') : new Date((exp_year_val + 2000), exp_month_val, 1, 0, 0, 0, -1);
                var showValidation = false;
                if (this.id.endsWith('cc_exp_month')) {
                    exp_month.addClass('blured');
                    if ((!isNaN(exp_year_val) && exp_year_val > 0) || exp_year.hasClass('blured')) {
                        showValidation = true;
                    }
                } else {
                    exp_year.addClass('blured');
                    if (!isNaN(exp_month_val) || exp_month.hasClass('blured')) {
                        showValidation = true;
                    }
                }
                if (showValidation) {
                    app.util.validateField('expiration_period', exp_date, null, ev.type);
                }
            });
        }
        return true;
    }
};

app.util.isDateField = function (fieldName) {
    var isDateField = fieldName && (fieldName.endsWith('exp_month') || fieldName.endsWith('exp_year') || fieldName.endsWith('expiration_period'));
    return isDateField;
};

app.util.fixExpPeriodFormat = function (rawData) {
    var retObj = {};
    _.each(rawData, function (item, key) {
        if (key.endsWith('cc_exp_month') || key.endsWith('cc_exp_year')) {
            if (!retObj['expiration_period']) {
                retObj['expiration_period'] = {};
            }
            retObj['expiration_period'][key] = item;
            retObj['expiration_period'].type = item.type; // ? year.type !== month.type ?
        } else {
            retObj[key] = item;
        }
    });
    return retObj;
};

app.util.handleCardFields = function (pmData) {
    var cardInfo, ccType, creditCardInputElm;
    var cc_card_id = app.util.getPmSpecificFldName('cc_card_number', app.lastSelectedMethodType);

    if (_.has(pmData, cc_card_id)) {
        if (pmData[cc_card_id].type !== 'DISABLED') {
            creditCardInputElm = $('#' + cc_card_id);
            if (app.config.useCleaveForCardNumber && window.Cleave) {
                if (app._cleaveCreditCard) {
                    app._cleaveCreditCard.destroy();
                }
                app._cleaveCreditCard = new Cleave('#' + cc_card_id, {
                    creditCard: true
                });
            } else {
                creditCardInputElm.setMask('cc');
            }
            cardInfo = _checkCardType(creditCardInputElm.val());
            ccType = cardInfo.server_class;
            var upoLastUsedBrand = app.util.isUpo(app.lastSelectedMethodId) && app.lastSelectedMethodData && app.lastSelectedMethodData.lastUsedBrand;
            creditCardInputElm.bind("change keyup keypress", function () {
                var info = _checkCardType($(this).val());
                var cc_type = info.server_class;
                if (upoLastUsedBrand && info.is_dual_brand) {
                    // When isUpo && same dualBranded card => keep using selected brand
                    cc_type = (upoLastUsedBrand === info.slave_brand || upoLastUsedBrand === info.master_brand) ? upoLastUsedBrand : cc_type;
                }
                app.util.onCardDetected($(this), cc_type, info, "card_fld_change");
            });
            creditCardInputElm.on('paste', function () {
                pubsub.publish('app.event.cc_card_number_pasted', []);
            });
        } else {
            var cardData  = app.util.extractCardInfo(pmData[cc_card_id].card_type, pmData._cardData);
            ccType = cardData.selectedBrand;
            cardInfo = cardData.cardInfo;
            if (pmData.bin && pmData.bin.length > 4 && !cardInfo.is_dual_brand) {
                cardInfo.slave_brand = _checkCardType(pmData.bin).slave_brand;
            }
        }
        app.util.onCardDetected(creditCardInputElm, ccType, cardInfo);
    }
    $("#cc_cvv2, #astro_pay_prepaid_cc_cvv2, #visa_checkout_cc_cvv2 ")
        .on("cut copy paste contextmenu", function (e) {
            e.preventDefault();
        });
};

app.util.extractCardInfo = function (server_class, _cardData) {
    server_class = server_class || 'none';
    var dualBrandedSlaveBrand = '';
    var masterBrand = server_class;
    var retObj = {
        selectedBrand: server_class,
        cardInfo: {
            full_class      : server_class,
            server_class    : server_class,
            master_brand    : server_class,
        }
    };

    if (_cardData && _cardData.cardBrand) {
        retObj.cardInfo.master_brand = _cardData.cardBrand;
        retObj.cardInfo.slave_brand = _cardData.cardBrand2 || _cardData.cardBrand;
        retObj.cardInfo.full_class = server_class + (_cardData.isDualBrand ? "_dual" : "");
        retObj.cardInfo.is_dual_brand = _cardData.isDualBrand;
        var brand = server_class;
        if (_cardData.isDualBrand) {
            brand = _cardData.lastUsedBrand || _cardData.cardBrand;
            if (brand === _cardData.cardBrand && !_cardData.isBrand1Allowed) {
                brand = _cardData.cardBrand2;
            }
        }
        retObj.selectedBrand = brand;
    }
    else {
        app.CONSTANTS.DUAL_BRANDED_CARD_SLAVE_BRANDS.forEach(function (brand) {
            if (server_class.indexOf(brand + '_') >= 0) {
                dualBrandedSlaveBrand = brand;
                masterBrand = server_class.replace(brand + '_', '');
                retObj.selectedBrand = brand;
            }
            else if (server_class.indexOf('_' + brand) >= 0) {
                dualBrandedSlaveBrand = brand;
                masterBrand = server_class.replace('_' + brand, '');
                retObj.selectedBrand = masterBrand;
            }
        });

        if (dualBrandedSlaveBrand) {
            retObj.cardInfo = {
                full_class      : server_class + "_dual",
                server_class    : server_class,
                master_brand    : masterBrand,
                slave_brand     : dualBrandedSlaveBrand,
                is_dual_brand	: true
            };
        }
    }

    var $dualBrandRadioBtnWrapper = $('#dualBrandRadioBtnWrapper');
    var $masterBrandRadioBtn = $dualBrandRadioBtnWrapper.find('#masterBrandRadioBtn');
    var $secondaryBrandRadioBtn = $dualBrandRadioBtnWrapper.find('#secondaryBrandRadioBtn');

    if ($dualBrandRadioBtnWrapper.length && retObj.cardInfo.slave_brand && $masterBrandRadioBtn.val() === retObj.cardInfo.master_brand && $secondaryBrandRadioBtn.val() === retObj.cardInfo.slave_brand) {
        retObj.selectedBrand = $masterBrandRadioBtn.is(':checked') ? $masterBrandRadioBtn.val() : $secondaryBrandRadioBtn.val()
    }

    return retObj;
};

app.util.setupTargetIFrame = function () {
    var h  = app.util.normalizePixelValue(410);
    if (!$('#targetIFrame').length) {
        $('body').append('<div id="targetIframeWrap" class="targetIframeWrap" ' +
            'style="display:none;position:fixed;z-index: 100000;top: 50%; left: 50%; width: 90%; ' +
            'height: ' + h +'px; margin-top: -' + h/2 + 'px;-webkit-overflow-scrolling:touch; overflow: auto">' +
            '<iframe id="targetIFrame" width="99%" height="99%" allow="clipboard-read; clipboard-write" src="about:blank" name="targetIFrame" frameborder="0"></iframe><' +
            '/div>');
    } else { // clear app.show3DIFrame influence
        $('#targetIFrame').parent().css({'height' : h, "margin-top" : -h / 2});
    }
};

app.util.triggerDocUpload = function (data) {
    if (data && data.documentUploadUrl) {
        app.util.setupTargetIFrame();
        app.show3DIFrame({
            iframeMaxHeight: 556,
            iframeWidth: 750
        });
        $('#targetIFrame').attr('src', data.documentUploadUrl);
    }
};

app.util.prepareRebillingData = function (data) {
    if (data) {
        function formatDate(unit, val) {
	        var u = (unit === 'day' && val && val % 7 === 0) ? 'week' : unit,
		        v = (u === 'week') ? Math.floor(val / 7) : val;
	        return {
		        unit  : (v > 1) ? u + 's' : u,
		        value : v
	        }
        }

        var newData = $.extend(true, {}, defaults.RebillingData, {imageUrl: data.imageUrl || false});
        _.each(['start', 'rebilling', 'end'], function (prefix) {
            newData[prefix + 'Interval'] = {arr : []};
            _.each(['year', 'month', 'day'], function (period) {
                if (data[prefix + '_' + period + 's']) {
                    var date = formatDate(period, data[prefix + '_' + period + 's']);
                    newData[prefix + 'Interval'].arr.push(date);
                }
            });
        });
        return newData;
    }
};

app.util.updateCurrencySelect = function (card_type) {
    var isCardPM = app.util.isCardPM({name: app.lastSelectedMethodType});
    var wrapper = app.config.useDcc ? $('#currency_exchange_wrapper') : $('#currency_lbl');
    var select = wrapper.find('select');
    var div = wrapper.find('.cSelect > div');
    var supported = app.config.cardSupportedCurrencies[card_type];

    div.removeClass(app.CONSTANTS.INAPPROPRIATE_CURRENCY_CLASS_NAME);
    select.find('option').each(function () {
        var elm = $(this);
        if (isCardPM && supported && !supported[elm.val()]) {
            elm.addClass(app.CONSTANTS.INAPPROPRIATE_CURRENCY_CLASS_NAME);
        } else {
            elm.removeClass(app.CONSTANTS.INAPPROPRIATE_CURRENCY_CLASS_NAME);
        }
        //elm.attr('disabled', isCardPM && !supported[val] && val !== app.lastSelectedCurrency);
    });
    if (isCardPM && supported && !supported[select.val()]) {
        div.addClass(app.CONSTANTS.INAPPROPRIATE_CURRENCY_CLASS_NAME);
    }
};

app.util.getThemeBackgroundColor = function (key, selector) {
    key = key || app.themeBgColor_key || 'c5';
    selector = selector || app.themeBgColor_selector || 'html';
    var $elm = $(selector);
    var str = '';
    if (app.selectors && app.currentColors && app.currentColors[key]) {
        str = app.currentColors[key];
    } else if ($elm.length && window.getComputedStyle) {
        var compStyles = window.getComputedStyle($elm[0]);
        str = compStyles.backgroundColor;
        if (selector === 'html' && str === "rgba(0, 0, 0, 0)") {
           return  app.util.getThemeBackgroundColor(null, 'body');
        }
    }
    return str;
};

app.util.initColorSettings = function (bg_color) {
    bg_color = bg_color || app.util.getThemeBackgroundColor();
    var colorSettings = utils.getColorSettings(bg_color);
    colorSettings.apple_btn_style = app.config.appleBtnStyle || colorSettings.apple_btn_style;      // 'white' | 'black'
    colorSettings.google_btn_style = app.config.googleBtnStyle || colorSettings.google_btn_style;   // 'white' | 'black'
    colorSettings.venmo_btn_style = app.config.venmoBtnStyle || colorSettings.venmo_btn_style;      // 'white' | 'blue'
    colorSettings.vco_btn_style = app.config.vcoButtonColor || colorSettings.vco_btn_style;         // 'neutral' | 'standard'
    app.colorSettings = colorSettings;
    return app.colorSettings;
};

app.util.injectDefaultCss = function() {
    var DisplayNoneSelector = ".hidden" +
        ", body.main_visa_checkout #preSubmitButton, body.main_visa_checkout #continueButton, body.main_visa_checkout .row.vcoCallId" +
        ", body.main_apple_pay #preSubmitButton, body.main_apple_pay #continueButton" +
        ", body.main_google_pay #preSubmitButton, body.main_google_pay #continueButton" +
        ", body.custom_btn #preSubmitButton, body.custom_btn #continueButton" +
        ", body.main_venmo #preSubmitButton, body.main_venmo #continueButton";
    var cssObj = {
        ".v-button": {
            width: "21.3rem",
            height: "4.7rem"
        },
        "img.venmo-button": {
            "max-width": "100%",
            cursor: "pointer"
        },

        ".sfc_paywithmybank_widget_iframe": {
            "max-width": "100%"
        },
        ".overall": {
            width: "100%",
            height: "100%"
        },
        "._invisible": {
            visibility: "hidden"
        },
        "#whole_screen_overlay": {
            position: "fixed",
            width: "100%",
            height: "100%",
            top: '0',
            left: '0',
            "background-color": "rgba(10, 10, 10, 0.2)",
            "z-index": "4"
        }
    };
    var nuveiCardCcCardNumBgCss = convertNuveiCardLogoForCcCardNumber();
    if (nuveiCardCcCardNumBgCss) {
        cssObj['input.nuvei_cardLogo#cc_card_number'] = {'background-image': nuveiCardCcCardNumBgCss};
    }
    cssObj[DisplayNoneSelector] = {
        display: 'none'
    };
    $.injectCSS(cssObj);

    function convertNuveiCardLogoForCcCardNumber() {
        if (app.config.pmSettings.nuvei_card.logoName) {
            var $input = $('<input type="hidden" class="nuvei_cardLogo"/>');
            $('body').append($input);
            var backGrImg = $input.css('background-image').replace('mvp.svg', app.config.pmSettings.nuvei_card.logoName + '.svg');
            $input.remove();
            return backGrImg;
        }
    }
};

app.util.handleBlikOneClick = function ($elm) {
    var $field;
    if ('apmgw_BLIK' === app.lastSelectedMethodType) {
        $field = $elm || $('#blik_useOneClick');
        if (app.util.isUpo(app.lastSelectedMethodId)
            && app._pmFields[app.lastSelectedMethodId]['hasReferenceId']
            && ($field.is(':checked') || $field.is('[type="hidden"]'))) {
            app.util.disableField('blik_code');
        } else {
            app.util.enableField('blik_code');
        }
    }
};

app.util.onCheckboxChange = function (e) {
    var $elm = $(this);
    var fldName = this.id;

    if ("blik_useOneClick" === fldName) {
        app.util.handleBlikOneClick($elm);
    } else if(app.CONSTANTS.DIRECT_FLOW_FIELDS_2_PMS[fldName]) {
        pubsub.publish('app.event.directFlowCheckbox.change', [{field: fldName, isChecked: $elm.is(':checked')}]);
        app.util.updateContinueButtonAction($elm);
    } else if ("oktowallet_consent" === fldName) {
        app.util.handleOktoWalletConsent();
    }
};

app.util.updateContinueButtonAction = function ($elm, data) {
    $elm = $elm || $('.directFlowCheckbox');
    var new_data = _.cloneDeep(data || app._pmFields[app.lastSelectedMethodId] || app._poList[app.lastSelectedMethodId]);
    if (!_.has(new_data, 'isIframe') && app._poList[app.lastSelectedMethodId]) {
        new_data.isIframe = new_data.isIframe || app._poList[app.lastSelectedMethodId].attributes.isIframe;
    }
    $elm.each(function (i, e) {
        var fldName = e.id;
        if (app.CONSTANTS.DIRECT_FLOW_FIELDS_2_PMS[fldName] === app.lastSelectedMethodType) {
            new_data.isIframe = ($(e).is(':checked') && new_data.hasReferenceId);
        }
    });
    setContinueButtonAction(new_data);
};

app.util.clearFieldValidation = function (fieldName) {
    var indicator = $('#' + fieldName + '_validation');
    var parentRow = indicator.closest('.row');

    delete app._validationResult[fieldName];

    indicator.empty();
    indicator.removeClass('invalid_field valid_field');
    parentRow.removeClass('invalid valid');
    app.recalcUserDetailsArea();
};

app.util.disableField = function (fldName, is_hideable) {
    var $elm = $('#' + fldName);
    var isHideable = {
        blik_code : 1,
        debit_type: 1,
        installment_program: 1,
        number_of_installments: app.config.installmentConfig.isActive
    };
    if ($elm.length) {
        app.currentMethodFields[fldName].isTmpDisabled = true;
        $elm.attr('disabled', true);
        if (is_hideable || isHideable[fldName]) {
            $elm.closest('.row.' + fldName).addClass('hidden');
            app.recalcUserDetailsArea();
        }
        if (fldName === 'cc_cvv2') {
            app.bodyElm.addClass('disable_cvv');
            app.util.clearFieldValidation('cc_cvv2');
        }
        if (fldName === 'cc_name_on_card') {
            app.bodyElm.addClass("disable_cc_name_on_card");
            app.util.clearFieldValidation('cc_name_on_card');
        }
    } else { // radio fields
        var $row = $(".radio." + fldName);
        if ($row.length) {
            app.currentMethodFields[fldName].isTmpDisabled = true;
            $row.find('input[name="' + fldName + '"]').attr('disabled', true);
            if (is_hideable || isHideable[fldName]) {
                $row.addClass('hidden');
                app.recalcUserDetailsArea();
            }
        }
    }
};

app.util.enableField = function (fldName, is_hideable) {
    var $elm = $('#' + fldName);
    var isHideable = {
        blik_code : 1,
        debit_type: 1,
        installment_program: 1,
        number_of_installments: app.config.installmentConfig.isActive
    };
    if ($elm.length) {
        app.currentMethodFields[fldName].isTmpDisabled = false;
        if (app.currentMethodFields[fldName].type !== "DISABLED") {
            $elm.attr('disabled', false);
        }
        if (is_hideable || isHideable[fldName]) {
            $elm.closest('.row.' + fldName).removeClass('hidden');
            app.recalcUserDetailsArea();
        }
        if (fldName === 'cc_cvv2') {
            app.bodyElm.removeClass('disable_cvv');
            app.util.clearFieldValidation('cc_cvv2');
        }
        if (fldName === 'cc_name_on_card') {
            app.bodyElm.removeClass("disable_cc_name_on_card");
            app.util.clearFieldValidation('cc_name_on_card');
        }
    } else { // radio fields
        var $row = $(".radio." + fldName);
        if ($row.length) {
            app.currentMethodFields[fldName].isTmpDisabled = false;
            if (app.currentMethodFields[fldName].type !== "DISABLED") {
                $row.find('input[name="' + fldName + '"]').attr('disabled', false);
            }
            if (is_hideable || isHideable[fldName]) {
                $row.removeClass('hidden');
                app.recalcUserDetailsArea();
            }
        }
    }
};

app.util.resetTmpDisabledFields = function () {
    _.forEach(app.currentMethodFields, function (field) {
        if (_.isObject(field) && field.isTmpDisabled) {
            field.isTmpDisabled = false;
        }
    });
};

app.util.handlePromotedPmHint = function () {
    var $promotedPMHint = $('.promotedPMHint');
    var isPromotedPm = app.lastSelectedMethodData && app.lastSelectedMethodData.attributes && app.lastSelectedMethodData.attributes.promotedPM;
    if (isPromotedPm && !app.util.isUpo(app.lastSelectedMethodId)) {
        if (!$promotedPMHint.length) {
            $promotedPMHint = $('<div class="promotedPMHint"></div>');
            $('.PMINFO').prepend($promotedPMHint);
        }
        $promotedPMHint.html(_.template('<span class="promotedPMIcon"></span><div><%= t("promoted_pm_hint")%></div>'));
    } else {
        $promotedPMHint.empty();
    }
};

app.util.handleTogglePromocodeValidation = function () {
    if(app.config.showPromoCode) {
        var promocodeCheckbox$ = $('#promoCode_checkbox'),
            promocode$ =  $('#promoCode'),
            isCheckbox = promocodeCheckbox$.length > 0;

        if(isCheckbox) {
            if(promocodeCheckbox$.is(':checked')) {
                promocode$.prop('disabled', '');
                promocode$.data('skipValidation', false);
            } else {
                promocode$.prop('disabled', 'true');
                promocode$.data('skipValidation', true);
            }
        }
    }
};

app.util.openPromoCodeToggleIfItHasValue = function () {
    if(app.config.showPromoCode) {
        _.each(window.srvOtherFields, function(fieldData) {
            if(fieldData && fieldData.name === "promoCode") {
                if(fieldData.value) {
                    $('#promoCode_checkbox').prop('checked', true);
                }
            }
        });
    }
};

app.util.usePromoBox = function (promoBoxSrc, promoBoxCase, promoBoxContainer, promoBoxUrlExtend) {

    if ((promoBoxCase === "1" || promoBoxCase === "3") && promoBoxSrc.length) {

        var _defaultContainer = '#promoBoxContainer';

        var url = promoBoxSrc;

        var _container = promoBoxContainer || _defaultContainer;

        if(promoBoxUrlExtend){
            promoBoxSrc = _srcHandler(url)
        }

        var promoBox =
            '<div id="promoBox-wrapper" class="hide-box">' +
            '<iframe id="promoBox-iframe" name="promoBox-iframe" scrolling="no" src="' + promoBoxSrc + '"></iframe>' +
            '</div>';

        function _addIframe() {
            if (!$(_container).length) {
                $('#currency_exchange_wrapper').after('<div id="' + _defaultContainer.substr(1) + '"></div>');
            }
            $(_container).html(promoBox);
        }

        function _sendValue(amountValue) {
            $('#promoBox-iframe')[0].contentWindow.postMessage(JSON.stringify({'amountValue': amountValue}), '*');
        }

        function _apply() {
            $('body').addClass('promoBoxCase-' + promoBoxCase);
            _addIframe();
            $(document).on('blur', '#item_amount_1', function () {
                _sendValue($(this).val());
            });
        }

        function _srcHandler (url){
            var url         = (url || '').trim(),
                userTokenId = app.userTokenId,
                temptoken   = app.ptTempToken,
                queryString   = "userTokenId=" + encodeURIComponent(userTokenId) + "&temporaryToken=" + encodeURIComponent(temptoken);
            if(url.indexOf('?') > -1) {
                if(url[url.length-1]=== '?') {
                    return url + queryString;
                } else {
                    return url + '&' + queryString;
                }
            } else {
                return url + '?' + queryString;
            }
        }

        pubsub.subscribe('select-pm', _apply);
        if (promoBoxCase == "3") {
            pubsub.subscribe('suggest-point-selected', function (data) {
                if (data) {
                    _sendValue(data.selectedValue);
                }
            });
        }
        window.addEventListener('message', function (e) {
            var data = e.data;
            try {
                data = JSON.parse(e.data);
            } catch (er) {
            }
            if (data) {
                if (data.amountValue) {
                    if (app.config.useIntlFormatter /* && app.config.useAmountListener*/) {
                        $('#deposit-amount').html(app.formatter.formatCurrency(data.amountValue, app.lastSelectedCurrency));
                        $('#deposit-currency').html('');
                    } else {
                        $('#deposit-amount').text(data.amountValue);
                    }
                } else if (data.status === 'OK') {
                    $('#promoBox-wrapper').removeClass('hide-box');
                    utils.getDomModificationHandler();
                    app.util.applyScrollablePlugin();
                }
            }
        });
        return {
            sendValue: _sendValue
        };
    }
};

app.util.showDisableFieldValidationIcon = function (currentMethodFields, pmName) {
    var config = pmName && app.config.allowSkipFieldValidationsPerEnv && app.config.allowSkipFieldValidationsPerEnv[pmName];
    if (config) {
        _.each(currentMethodFields, function(fieldData) {
            var fieldName = fieldData && fieldData.name;
            var allowSkipFieldValidationsEnvs = config[fieldName];
            var validations = fieldName && app.validators[fieldName] && app.validators[fieldName].checks;
            if (allowSkipFieldValidationsEnvs && validations && _.includes(allowSkipFieldValidationsEnvs, app.config.analyticsConfig.env)) {
                var $fldWrapper = $('.row.' + fieldName);
                $fldWrapper.addClass('toggleable_validation');
                $fldWrapper.append(_.template(app.CONSTANTS.DISABLE_FIELD_VALIDATION_ICON_TPL)({ fieldName: fieldName }));
            }
        });
    }
};

app.util.toggleCompositePhoneValidation = function (fieldName) {
    var $fld = fieldName && $('input#' + fieldName);
    var $fldWrapper = $fld.length && $fld.closest('.row.' + fieldName);
    var fldType = $fld.length && $fld.data('type');
    var fldChecks = app.validators[fieldName] && app.validators[fieldName].checks;
    var $countryPhoneCodeSelect = $fldWrapper.find('#country_phone_code');
    if (fldType === 'composite_phone_hidden' && $countryPhoneCodeSelect.length && $fldWrapper.length) {
        if (fldChecks && _.keys(fldChecks).length) {
            app.validators[fieldName].originalChecks = fldChecks;
            app.validators[fieldName].checks = {};
            app.util.clearFieldValidation(fieldName);
            $fldWrapper.addClass("validation_off");
            $countryPhoneCodeSelect
                .data("children", $countryPhoneCodeSelect.children())
                .empty()
                .append(
                    _.map(utils.filterPhoneCodesByPm().slice(1), function (c) {
                        return $("<option>")
                            .attr("data-country", c.iso)
                            .val(c.phoneCode)
                            .text("+" + c.phoneCode);
                    })
                )
                .trigger('change');
        } else if (app.validators[fieldName].originalChecks && $countryPhoneCodeSelect.data("children")) {
            $fldWrapper.removeClass("validation_off");
            app.validators[fieldName].checks = app.validators[fieldName].originalChecks;
            $countryPhoneCodeSelect.empty().append($countryPhoneCodeSelect.data("children")).trigger('change');
        }
    }
};

app.util.resetPmFieldValidations = function (pmName) {
    if (pmName && app.config.allowSkipFieldValidationsPerEnv && app.config.allowSkipFieldValidationsPerEnv[pmName]) {
        var fields = _.keys(app.config.allowSkipFieldValidationsPerEnv[pmName]);
        _.each(fields, function (fieldName) {
            if (app.validators[fieldName] && app.validators[fieldName].checks && app.validators[fieldName].originalChecks) {
                app.validators[fieldName].checks = app.validators[fieldName].originalChecks;
                delete app.validators[fieldName].originalChecks;
            }
        });
    }
};

app.util.getMuchBetterPhoneCodes = function (codes) {
    if(app.lastSelectedMethodId === "apmgw_MBWAY"){
        return app.util.getFilteredPhoneCodes(codes, "apmgw_MBWAY");
    }
    return app.util.getFilteredPhoneCodes(codes, 'apmgw_MuchBetter');
};

app.util.getFilteredPhoneCodes = function (codes, pmName) {
    pmName || (pmName = app.lastSelectedMethodType);
    return utils.filterPhoneCodesByPm(codes, pmName);
};

app.util.getFormDataAsObject = function ($form) {
    var dataObj = {};
    $.map($form && $form.serializeArray(), function (o) {
        dataObj[o['name']] = o['value'];
    });
    return dataObj;
};

app.util.getPrePopulationRules = function () {
    var rules = {
        "cc_name_on_card"         : {
            from  : ["firstName", "lastName"],
            forPM : $.extend(true, {}, app.CONSTANTS.CC_CARDS_DB),
            skip  : !app.config.shouldPrefillCCNameOnCard
        },
        "echeck_firstName"        : {
            from  : ["firstName"],
            forPM : {"apmgw_eCheck" : 1}
        },
        "echeck_lastName"         : {
            from  : ["lastName"],
            forPM : {"apmgw_eCheck" : 1}
        },
        "echeck_address"          : {
            from  : ["address"],
            forPM : {"apmgw_eCheck" : 1}
        },
        "echeck_city"             : {
            from  : ["city"],
            forPM : {"apmgw_eCheck" : 1}
        },
        "echeck_zip"              : {
            from  : ["zip"],
            forPM : {"apmgw_eCheck" : 1}
        },
        "echeck_phoneNumber"      : {
            from  : ["phone"],
            forPM : {"apmgw_eCheck" : 1}
        },
        "echeck_dateOfBirth"      : {
            from  : ["dateOfBirth"],
            forPM : {"apmgw_eCheck" : 1}
        },
        "mazooma_dob"      : {
            from  : ["dateOfBirth"],
            forPM : {"apmgw_eCheckSelect_DOB" : 1}
        },
        "mazooma_state"      : {
            from  : ["state"],
            forPM : {"apmgw_eCheckSelect_DOB" : 1}
        },
        "fortumo_phone_number"      : {
            from  : ["phone"],
            forPM : {"apmgw_Fortumo" : 1}
        },
        "verification_email"      : {
            from  : ["verificationEmail"],
            forPM : {"apmgw_Sepa" : 1, "apmgw_KlarnaCheckout" : 1}
        },
        "interac_eTransfer_mobilePhone" : {
            from  : ["phone"],
            forPM : {"apmgw_Interac_eTransfer" : 1}
        },
        "interac_eTransfer_email" : {
            from  : ["payer_email"],
            forPM : {"apmgw_Interac_eTransfer" : 1}
        },
        "interac_Combined_mobilePhone" : {
            from  : ["phone"],
            forPM : {"apmgw_Interac_Combined" : 1}
        },
        "interac_Combined_email" : {
            from  : ["payer_email"],
            forPM : {"apmgw_Interac_Combined" : 1}
        },
        "interac_instant_email" : {
            from  : ["payer_email"],
            forPM : {"apmgw_INTERAC_Instant" : 1}
        },
        "nequi_phone_number" : {
            from  : ["phone"],
            forPM : {"apmgw_NEQUI_CO" : 1}
        },
        "oktowallet_email" : {
            from  : ["payer_email"],
            forPM : {"apmgw_OKTO_WALLET" : 1}
        },
        "saltarpay_firstName" : {
            from  : ["firstName"],
            forPM : {"apmgw_Visa_Vouchers" : 1}
        },
        "saltarpay_lastName" : {
            from  : ["lastName"],
            forPM : {"apmgw_Visa_Vouchers" : 1}
        },
        "saltarpay_dateOfBirth" : {
            from  : ["dateOfBirth"],
            forPM : {"apmgw_Visa_Vouchers" : 1}
        },
        "saltarpay_email" : {
            from  : ["payer_email"],
            forPM : {"apmgw_Visa_Vouchers" : 1}
        },
        "saltarpay_address" : {
            from  : ["address"],
            forPM : {"apmgw_Visa_Vouchers" : 1}
        },
        "saltarpay_city" : {
            from  : ["city"],
            forPM : {"apmgw_Visa_Vouchers" : 1}
        },
        "saltarpay_postcode" : {
            from  : ["zip"],
            forPM : {"apmgw_Visa_Vouchers" : 1}
        },
        "smart2pay_phone_number"      : {
            from  : ["phone"],
            forPM : {"apmgw_Equitel" : 1, "apmgw_PesaLink": 1, "apmgw_NIBSS": 1, "apmgw_Tingg_Wallet": 1}
        },
        "paymentasia_email" : {
            from  : ["payer_email"],
            forPM : {"apmgw_DragonPay" : 1, "apmgw_SugarPay": 1, "apmgw_Bank_Transfer_Malaysia": 1, "apmgw_Local_Payments_Indonesia": 1, "apmgw_Local_Payments_Vietnam": 1}
        },
        "paymentasia_phone" : {
            from  : ["phone"],
            forPM : {"apmgw_DragonPay" : 1, "apmgw_SugarPay": 1, "apmgw_Bank_Transfer_Malaysia": 1, "apmgw_Local_Payments_Indonesia": 1, "apmgw_Local_Payments_Vietnam": 1}
        },
        "paymentez_bankCode" : {
            from  : ["paymentez_bankCode"],
            forPM : {"apmgw_PSE_PZ": 1}
        },
        "payretailers_personalId" : {
            from  : ["personal_id_pt"],
            forPM : {"apmgw_PayRetailers": 1, "apmgw_PayRetailers_CC": 1, "apmgw_Banco_Nacional": 1}
        },
        "pix_personal_id" : {
            from  : ["personal_id_pt"],
            forPM : {"apmgw_PIX": 1, "apmgw_PIX_BankTransfer": 1}
        },
        "bancomatPay_mobileNumber" : {
            from  : ["phone"],
            forPM : {"apmgw_BancomatPay": 1}
        },
        "elementpay_userPhone" : {
            from  : ["phone"],
            forPM : {
                "apmgw_Bangkok_Bank_ATM": 1,
                "apmgw_SCB_ATM": 1,
                "apmgw_KBANK_ATM": 1,
                "apmgw_KBANK_Mobile": 1,
                "apmgw_SCB_Bank_Mobile": 1,
                "apmgw_Bangkok_Bank_Mobile": 1,
                "apmgw_Bangkok_Bank_iPay": 1,
                "apmgw_Cross_Bank_QR": 1
            }
        },
        "elementpay_nid" : {
            from  : ["personal_id_pt"],
            forPM : {
                "apmgw_Bangkok_Bank_ATM": 1,
                "apmgw_SCB_ATM": 1,
                "apmgw_KBANK_ATM": 1,
                "apmgw_KBANK_Mobile": 1,
                "apmgw_SCB_Bank_Mobile": 1,
                "apmgw_Bangkok_Bank_Mobile": 1,
                "apmgw_Bangkok_Bank_iPay": 1,
                "apmgw_Cross_Bank_QR": 1
            }
        },
        "elementpay_userName" : {
            from  : ["firstName", "lastName"],
            forPM : {
                "apmgw_Bangkok_Bank_ATM": 1,
                "apmgw_SCB_ATM": 1,
                "apmgw_KBANK_ATM": 1
            }
        }
    };
    return app.config && app.config.customPrepopulationRules ? $.extend(true, rules, app.config.customPrepopulationRules) : rules;
};

app.util.prePopulateFields = function (fields, pmType, data, rules) {
    data = data || app.user || {};
    rules = rules || app.util.getPrePopulationRules() || {};
    _.each(fields, function (fld_obj, fld_name) {
        var rule = rules[fld_name];
        if (fld_name && rule && rule.forPM[pmType] && !rule.skip && !fld_obj.value) {
            var value = '';
            if (_.isArray(rule.from)) {
                value = _.reduce(rule.from, function (result, field, k) {
                    if (data[field]) {
                        result.push(data[field]);
                    }
                    return result
                }, []).join(' ');
            }
            var $fld = $('input#' + fld_name);
            if (value && $fld.attr('data-type') === "composite_phone_hidden") {
                value = value.replace(/\s/g, '').trim();
                var $code = $("#country_phone_code");
                var code = $code.val();
                var phone = '';
                var split = value.split('-');
                if (split.length === 2) {
                    code = $code.val(split[0]).val();
                    phone = split[1];
                    code && $code.trigger('update');
                } else if (code && value.startsWith(code)) {
                    phone = value.substring(code.length);
                }
                $("#composite_phone_suffix").val(phone);
                value = phone ? (code + "-" + phone) : "";
            }
            $fld.val(value);
        }
    });
};

app.util.normalizePixelValue = function (v) {
    var zf = app.config.zoomFactor && parseInt(app.config.zoomFactor) || 100;
    var val = parseInt(v);
    var new_v = v;
    if (val && 50 < zf && zf < 500) {
        new_v = Math.round(val * (zf / 100));
    }
    return new_v;
};

app.util.normalizePluginOpts = function (opts) {
    if (opts && opts.cssCreator) {
        if (!opts.cssCreator.language) {
            opts.cssCreator.language = app.config.locale.substr(0, 2);
        }
        if (app.config.pmSettings.ppp_ApplePay && app.config.pmSettings.ppp_ApplePay.showApplePayInline && !opts.cssCreator.hasOwnProperty('showAapplePayLogo')) {
            opts.cssCreator.showAapplePayLogo = true;
        }
        if (app.config.pmSettings.nuvei_card.logoName) {
            if (opts.cssCreator.pmLogos && !opts.cssCreator.pmLogos.nuvei_card) {
                opts.cssCreator.pmLogos.nuvei_card = app.config.pmSettings.nuvei_card.logoName;
            } else if (!opts.cssCreator.pmLogos) {
                opts.cssCreator.pmLogos = {nuvei_card: app.config.pmSettings.nuvei_card.logoName};
            }
        }
    }
    if (opts && app.config.pmSettings.ppp_ApplePay && app.config.pmSettings.ppp_ApplePay.showApplePayInline) {
        if (!opts.hasOwnProperty('showApplePayInline')) {
            opts.showApplePayInline = true;
        }
        if (!opts.hasOwnProperty('reduceApplePayPriority')) {
            opts.reduceApplePayPriority = true;
        }
    }
    return opts;
};

app.util.normalizePMWithdrawListOpts = function (opts) {
    var wd_list_opts = $.extend(true, {}, opts);
    wd_list_opts.useIntl = app.config.useIntlFormatter;
    if (app.config.useIntlFormatter && !wd_list_opts.currencyFormatter) {
        wd_list_opts.currencyFormatter = function (currency, value) {
            return app.formatter.formatCurrency(value, currency, null, true);
        }
    }
    return app.util.normalizePluginOpts(wd_list_opts);
};

app.util.isEligibleCardForInstallments = function (currentCardType, allowedCardType) {
    if(allowedCardType === "NO_RESTRICTIONS") {
        return true;
    }

    if(allowedCardType === "CREDIT_CARDS") {
        return currentCardType === app.CONSTANTS.ASYNC_CHECK_CARD_TYPE.CREDIT_CARD;
    }

    if(allowedCardType === "DEBIT_CARDS") {
        return currentCardType === app.CONSTANTS.ASYNC_CHECK_CARD_TYPE.DEBIT_CARD;
    }
}
app.util.handleInstallmentsForCardTypeWarning = function (currentCardType, allowedCardType) {
    $('#installments_for_card_type_warning').remove();

    var message = '';
    if(allowedCardType === "DEBIT_CARDS" && currentCardType === app.CONSTANTS.ASYNC_CHECK_CARD_TYPE.CREDIT_CARD) {
        message = app.msg.installments_warning_credit;
    }

    if(allowedCardType === "CREDIT_CARDS" && currentCardType === app.CONSTANTS.ASYNC_CHECK_CARD_TYPE.DEBIT_CARD) {
        message = app.msg.installments_warning_debit;
    }

    if(message) {
        var template =  '<div id="installments_for_card_type_warning" class="row">' +
                            '<p><%- t(message) %></p>' +
                        '</div>';

        $('.row.number_of_installments').after(_.template(template)({ "message": message}));
    }
}

app.util.disableInstallmentsForCardType = function() {
    var maxNumInstallments$ = $('#number_of_installments');

    app.util.disableField('number_of_installments');
    maxNumInstallments$.prop("selectedIndex", 0).trigger('change');
}
app.util.enableInstallmentsForCardType = function () {
    var maxNumInstallments$ = $('#number_of_installments');

    maxNumInstallments$.html(app.util.getMaxNumberOfInstallmentsOptions(app.config.max_num_installments));
    app.util.enableField('number_of_installments');
}
/**
 * Generates the html for number_of_installments field first time  it's called
 * on  subsequent call only returns the options
 */
app.util.getMaxNumberOfInstallmentsOptions = (function () {
    var options = "";

    return function(max_num_of_installments) {
        if(!options) {
            for (var i = 1; i <= max_num_of_installments; i += 1) {
                options += '<option value="' + i + '">' + i + '</option>';
            }
        }

        return options;
    }
}());

/**
 *  Israeli card flow can work with allow_installments  disabled/enabled and allow_special_debit disabled/enabled
 *  at least one of the above should be enabled for israeli flow
 *  Credit/Debit card flow requires allow_installments to be enabled and allow_installments_for_card_type !== "DISABLED"
 */
app.util.useInstallments = function (cardInfo)  {
    var isIsraeliCard = (cardInfo && cardInfo.slave_brand === "israeli_card");

    if (app.config.installmentConfig.isActive) {
        app.util.disableField('debit_type'); // the field is irrelevant in case we have installmentConfig.isActive

        var $instProgram = $('#installment_program');
        if(!$instProgram.data('isInitialized')) {
            $instProgram.data('isInitialized', true);
            $instProgram.trigger('change');
        }
    } else if(isIsraeliCard) {
        app.util.enableField('debit_type');
        app.util.enableField('number_of_installments');
        app.util.disableField('installment_program');

        $('#debit_type').prop("selectedIndex", 0).trigger('change');
    } else {
        app.util.disableField('debit_type');
        app.util.disableField('installment_program');

        var cardType =  app._upoList[app.lastSelectedMethodId] && app._upoList[app.lastSelectedMethodId].cardAccountType;
        if(
            app.config.allow_installments &&
            app.config.allow_installments_for_card_type !== 'DISABLED' &&
            app.util.isEligibleCardForInstallments(cardType,  app.config.allow_installments_for_card_type) &&
            app._validationResult && !app._validationResult.cc_card_number &&
            app._cardInfo         && app._cardInfo.cardNumber_length !== 0
        ) {
            app.util.enableInstallmentsForCardType();
        } else {
            app.util.disableInstallmentsForCardType();
        }

        if(app.config.allow_installments && app.config.allow_installments_for_card_type !== 'DISABLED') {
            app.util.handleInstallmentsForCardTypeWarning(cardType,  app.config.allow_installments_for_card_type);
        }
    }
};


app.util.getMaxNumInstallmentsPerDebitType = function (debit_type) {
    debit_type = parseInt(debit_type);
    var DEBIT_TYPE = {
        REGULAR  : 1,
        PAYMENTS : 2,
        SPECIAL  : 3
    }, max = 1;
    if (debit_type === DEBIT_TYPE.PAYMENTS) {
        max = app.config.max_num_installments;
    } else if (debit_type === DEBIT_TYPE.SPECIAL) {
        max = app.config.max_num_debit_installments;
    }
    if (max < debit_type) {
        max = debit_type;
    }
    return max;
};

app.util.onInstallmentProgramFldChange = function onInstallmentProgramFldChange() {
    var installmentProgram = $(this).val();
    var numberOfInstallmentsPattern = /^[1-9][0-9]{0,}$/;
    var $installmentOptions = $();
    var $installmentsSelect = $('#number_of_installments');

    if (installmentProgram === "0") {
        $installmentsSelect
            .empty()
            .append($("<option>").attr("value", 1).text("1"))
            .trigger("change");

        app.util.disableField("number_of_installments");
        return;
    } else {
        app.util.enableField("number_of_installments");
    }

    var programConfig = _.find(app.config.installmentConfig.programs, function(program) {
        return program.value === installmentProgram;
    });

    if (programConfig) {
        var numbersOfInstallments = (programConfig.number_of_installments || "").split(";");

        for (var i = 0; i < numbersOfInstallments.length; i++) {
            if (numberOfInstallmentsPattern.test(numbersOfInstallments[i])) {
                $installmentOptions = $installmentOptions.add(
                    $("<option>")
                        .text(numbersOfInstallments[i])
                        .attr("value", numbersOfInstallments[i])
                );
            }
        }

        $installmentsSelect.html($installmentOptions).trigger("change");
    } else {
        $installmentsSelect.empty().trigger("change");
    }
};

app.util.onDebitTypeFldChange = function (e) {
    var debit_type = $(this).val();
    var min = parseInt(debit_type) || 1;
    var max = app.util.getMaxNumInstallmentsPerDebitType(debit_type);
    var $select = $('#number_of_installments');
    var payments = parseInt($select.val());
    var suggested_instalments = payments && min < payments && payments <= max ? payments : min;

    function updateOpt($_select, start, end) {
        $_select.find('option').remove();
        var html = "";
        for (var i = start; i <= end; i += 1) {
            html += '<option value="' + i + '">' + i + '</option>';
        }
        $_select.html(html);
    }

    updateOpt($select, min, max);
    $select.val(suggested_instalments);
    $select.trigger('change');
};

app.util.onPerformRedirect = function (data, skipAnalyticsEvents) {
	$('#targetIFrame').parent().hide();
	if (app.lastSelectedMethodType === 'ppp_ApplePay') {
		app.util.ApplePayTrxStatus(data);
	} else if (app.lastSelectedMethodType === app.CONSTANTS.PM_NAME.GOOGLE_PAY) {
		app.util.GooglePay.completeTrx(data);
	}
    if (app.config.useAnalytics && !skipAnalyticsEvents) {
		pubsub.publish('app.event.transactionComplete', [data]);
	}
    var pmName = (data && (data.payment_method || (data.details && data.details.payment_method))) || (app.submittedMethod && app.submittedMethod.pmName);
    if (app.config.relayAnalyticsEvents && !skipAnalyticsEvents) {
        var trxId = data && ((data.ApmReference || data.reference) || data.details && (data.details.ApmReference || data.details.reference));
        var feRef = data && data.details && data.details.feRef;
        var gwReason = data && (data.gwReason || data.details && data.details.gwReason);
        var isWs = data && (data.eventType === "websocket")
        var meta =  {feRef: app.util.FeRef.isValid(feRef) && feRef, isWS: isWs, gwReason: gwReason, source: 'onPerformRedirect'};
        var eventParams = [
            pmName,
            app.currency,
            _.has(data.details, 'amount') ? data.details.amount : $("#item_amount_1").val(),
            trxId,
            meta
        ];

        if (data.trxStatus === app.CONSTANTS.TRX_STATUS.APPROVED) {
            pubsub.publish('app.event.depositSuccess', eventParams);
        } else if (data.trxStatus === app.CONSTANTS.TRX_STATUS.PENDING) {
            pubsub.publish('app.event.depositPending', eventParams);
        } else {
            pubsub.publish('app.event.depositFailure', eventParams);
        }
    }
	var normalizedData = data;
	var lbxClassName = app.config.isRebilling ? 'subscription_status' : '';
	 data && data.isLastTrxDataModal && (lbxClassName += ' lastTrxData');
	if (app.config_transformTransactionEndData) {
		normalizedData = app.config_transformTransactionEndData(data, pmName);
	}
	var type = app.CONSTANTS.MODAL_MESSAGE_TYPE.ERROR;
	if (data.trxStatus === app.CONSTANTS.TRX_STATUS.PENDING) {
		type = app.CONSTANTS.MODAL_MESSAGE_TYPE.PENDING;
	} else if (data.trxStatus === app.CONSTANTS.TRX_STATUS.APPROVED) {
		type = app.CONSTANTS.MODAL_MESSAGE_TYPE.SUCCESS;
	}
	var handler = function () {
		app.util.sendPostMessage(type, app.config.parentUrl);
		window.location.href = data.redirectUrl;
	};
	var shouldRedirect = true;
    var modalWrapper = (data.eventType === "websocket") ? "lightbox_ws" : "";
	app.util.handleTrxCompletePopups(normalizedData, type, handler, handler, shouldRedirect, lbxClassName, modalWrapper);
};

app.util.prepareQiwiForValidation = function(){
	var val = $('#qiwi_phonenumber_suffix').val();
	var counryCode = $("#qiwi_country_code").val();
	if (val) {
		$('input[name="qiwi_phonenumber"]').val(counryCode + val).trigger("blur");
	} else {
		$('input[name="qiwi_phonenumber"]').val("").trigger("blur");
	}
};

app.util.prepareCompositePhoneForValidation = function () {
    var $suffix = $('#composite_phone_suffix');
    var phone = $suffix.val();
    var code = $("#country_phone_code").val();
    if (!$suffix.attr('data-mask')) {
        $suffix.attr('data-mask', 'num');
        $suffix.numberMask({type: 'number', beforePoint: 15, afterPoint: 0});
    }
    var fldVal = phone ? (code + "-" + phone) : "";
    $('input[data-type="composite_phone_hidden"]').val(fldVal).trigger("blur");
};

app.util.setAsOptionalFld = function (fldName) {
    app._isOptionalField[fldName] = 1;
};

app.util.unsetAsOptionalFld = function (fldName) {
    app._isOptionalField[fldName] = 0;
};

app.util.onDccPrefCurrencyChange = function (data) {
    app.util.updateCurrencySelect(app.lastCardDetected);
    app.util.triggerFldValidation('cc_card_number', 'custom');
    app.recalcUserDetailsArea();
};

app.util.onFieldBlur = function (isValid, fldName, value, extraData) {
    // console.log('>>>>>> onFieldBlur :', fldName, value, extraData);
    if ("cc_card_number" === fldName) {
        if (app.config.useDcc) {
            if(app.lastCardDetected === "master_card" && app.msg.agree_dcc_hint_mc){
                $('.dcc_container .agree_dcc_hint').addClass('dcc_hint_mc').text(app.msg.agree_dcc_hint_mc);
            } else {
                $('.dcc_container .agree_dcc_hint').removeClass('dcc_hint_mc').text(app.msg.agree_dcc_hint);
            }
        }
        if (app.config.useAsyncCardRecognition || app.lastSelectedMethodId === 'bancontact_cc_card') {
            if (utils.useDualCardBrands() && utils.checks.isCardNumber(value, {})) {
                app.util.asyncCheck.cardDetails(value, app.util.onCardRecognitionComplete);
            }
            else {
                var isValidCardNumber = isValid || utils.checks.isValidCardNumber(value,
                    app.util.normalizeValidationParamsObject(app.validators.cc_card_number.isCardAcceptable, 'isValidCardNumber')
                );
                if (isValidCardNumber) {
                    app.util.asyncCheck.cardDetails(value, app.util.onCardRecognitionComplete);
                }
            }
        }
    } else if ("payto_pay_id_type" === fldName) {
        app.util.updatePaytoPayIdFld();
    } else if ("myBank_bank_id" === fldName) {
        var $bankCode = $('#myBank_bank_id');
        if ($bankCode.val()) {
            $('#myBank_bank_name').val($bankCode.find('option[value="' + $bankCode.val() + '"]').text());
        }
    } else if ((app.CONSTANTS.DROPDOWN_VALUE_DEPENDENT_FIELDS[app.lastSelectedMethodType] || {})[fldName]) {
        app.util.handleDropDownValueDependentFields(fldName, app.lastSelectedMethodType, app.lastSelectedMethodId);
    }
};

app.util.onCardRecognitionComplete = function (r, val) {
    var newV = $('#cc_card_number').val();
    if (!r || newV !== val) {
        return;
    }
    var v = (val || '').replace(/[^\d]/g, '');
    var last_4 = app.lastCardDetected === 'nuvei_card' ? '***'+ v.substr(-1):  v.substr(-4)
    app.util.addDualBrandCardSelector(r, 'async_card_recognition');
    app.util.handleCardTypeCheck(r, 'async_card_recognition');
    pubsub.publish('app.event.card_recognition_complete', [{resp: r, last_4: last_4 /*, card: val*/}]);
    app.util.renderCardWarnMessage(r);
    app.util.validateField('cc_card_number', val, '', 'custom');
};

app.util.handlePreDepositLightboxes = function (doProceed, params) {
    var proceed = true;
    var isResubmit = (app.submittedMethod || (params && params.silent));
    if (!isResubmit) {
        if (app.config.beneficiaryOwnerAmount != null && app.config.beneficiaryOwnerAmount < app.lastSelectedAmount) {
            proceed = false;
            _showPreDepositConfirmationPopup(true);
        }
        else if (app.config.doubleConfirmByPm[app.lastSelectedMethodType] || app.config.doubleConfirmByPm.ALL) {
            proceed = false;
            _showPreDepositConfirmationPopup();
        }
    }
    return proceed;

    /***************  handlePreDepositLightboxes helpers Start  *************/
    function _showPreDepositConfirmationPopup(beneficiaryOwnerChecks) {
        app.util.closeLightbox();
        var amount = app.lastSelectedAmount;
        if (app.current_pm_feeObj) {
            var feeObj = app.util.getFeeRenderingData(app.current_pm_feeObj, app.lastSelectedAmount, app.lastSelectedCurrency);
            if (feeObj && feeObj.raw && feeObj.raw.total_amount && feeObj.raw.total_amount > amount) {
                amount = feeObj.raw.total_amount;
            }
        }
        var payload = {
            titleKey: "lightbox_title_confirm",
            msgArr: beneficiaryOwnerChecks ? ["beneficiary_owner_confirm_text"] : ["double_confirmation_text"],
            args: {0: [app.formatter.formatCurrency(amount, app.lastSelectedCurrency, null, true)]},
            confirmBtn: {
                isVisible: true,
                txt: beneficiaryOwnerChecks ? "lightbox_yes_button" : "lightbox_continue_button",
            },
            cancelBtn: {
                isVisible: true,
                txt: "lightbox_cancel_button"
            }
        };
        var onContinue = function (e) {
            if (beneficiaryOwnerChecks && (app.config.doubleConfirmByPm[app.lastSelectedMethodType] || app.config.doubleConfirmByPm.ALL)) {
                _showPreDepositConfirmationPopup();
            } else {
                app.util.closeLightbox();
                doProceed();
            }
        };
        var onCancel = beneficiaryOwnerChecks ? function (e) {
            app.util.closeLightbox();
            app.util.sendCancelOnBeneficiaryOwnerPopUpCancelBtnClick();
        } : null;
        var classes = beneficiaryOwnerChecks ? 'deposit_confirmations beneficiary_owner_confirmation' : 'deposit_confirmations pre_deposit_confirmations';
        app.showModalMessage({details: payload}, 'confirm', onContinue, onCancel, classes);
    }

    /***************  handlePreDepositLightboxes helpers End  *************/
};

app.util.sendCancelOnBeneficiaryOwnerPopUpCancelBtnClick = function() {
    return utils.notifyCancelOrderForBeneficiaryOwner();
};

app.util.handleSccLightbox = function (doProceed, params) {
    var proceed = true;
    var scc = app.config.storeCard || {};
    var isRelevantForCurrentPM = scc.supportedPMs && (scc.supportedPMs.indexOf(app.lastSelectedMethodId) > -1 || (app.CONSTANTS.PMS_WITH_DUMMY_CARD_UPO[app.lastSelectedMethodType] && scc.supportedPMs.indexOf(app.lastSelectedMethodType) > -1));
    var isResubmit = (app.submittedMethod || (params && params.silent));
    var shouldShowLightbox = !isResubmit && (scc.isActive && scc.useLightbox && scc.flow !== 'DISABLE_FEATURE');
    if (shouldShowLightbox && isRelevantForCurrentPM) {
        proceed = false;
        app.util.closeLightbox();
        var payload = {
            titleKey   : "lightbox_title_confirm",
            msgArr     : ["save_pm_details_text"],
            confirmBtn : {
                isVisible : true,
                txt       : (scc.flow === "SHOW_TEXT_ONLY" ? "lightbox_continue_button" : "lightbox_agree_button"),
            },
            cancelBtn  : {
                isVisible : true,
                txt       : (scc.flow === "SHOW_TEXT_ONLY" ? "lightbox_cancel_button" : "lightbox_disagree_button")
            }
        };
        var onContinue = function (e) {
            app.util.closeLightbox();
            $.blockUI();
            if( scc.flow === "SHOW_TEXT_ONLY") {
                doProceed();
            } else {
                var inputElm = $('[name="allowSaveCardUpo"]');
                if(!inputElm.length){
                    inputElm = $('<input type="hidden" id="allowSaveCardUpo" name="allowSaveCardUpo" >');
                    $(".PMINFO").append(inputElm);
                }
                inputElm.attr('disabled', false).val(true);
                /** {allowSaveCardUpo: true} is important in case we send via AJAX not all information from the Form !!!*/
                doProceed({allowSaveCardUpo: true});
            }
        };
        var onCancel = function (e) {
            if(scc.flow !== "SHOW_TEXT_ONLY"){
                $.blockUI();
                $('[name="allowSaveCardUpo"]').attr('disabled', true);
                doProceed();
            } else {
                $("#continueButton").off().on("click", app.continueButtonHandler);
            }
        };
        app.showModalMessage({details : payload}, 'confirm', onContinue, onCancel, 'deposit_confirmations scc');
    }
    return proceed;
};

app.util.getPoDropDownOptions = function (fld_name, data) {
    return (fld_name && data && data.dropDowns && data.dropDowns[fld_name] || []);
};

app.util.simpleDecimalFormatter = function (amount, currency, precision, toFixed) {
    precision = (precision !== undefined) ? precision : app.roundingScale;
    var thousandsSeparator = app.config.thousandsSeparator || '';
    var useFloatingFraction = (toFixed !== undefined) ? !toFixed : true;
    return utils.formatAmount(amount, precision, thousandsSeparator, useFloatingFraction);
};

app.util.simpleCurrencyFormatter = function (amount, currency, precision, toFixed) {
    var currencyIsoSeparator = app.config.currencyIsoSeparator || '';
    var cSymbol = currency ? app.util.remapCurrency(currency) : '';
    if (cSymbol && cSymbol === currency) {
        return app.util.simpleDecimalFormatter(amount, currency, precision, toFixed) + currencyIsoSeparator + cSymbol ;
    }
    return cSymbol + app.util.simpleDecimalFormatter(amount, currency, precision, toFixed);
};

app.util.getFormatter = function (useIntlFormatter) {
    if (useIntlFormatter) {
        var formatterOptions = $.extend(true, {simpleCurrencyFormatter : app.util.simpleCurrencyFormatter}, app.pluginOpts.IntlFormatter);
        return utils.getIntlFormatter(app.locale, app.currency, formatterOptions);
    } else {
        return {
            formatDecimal             : app.util.simpleDecimalFormatter,
            formatCurrency            : app.util.simpleCurrencyFormatter,
            getCurrencySymbol         : function (currency) {
                return app.util.simpleCurrencyFormatter(0, currency, 0, true).replace('0', '').trim();
            },
            isRightPositionedCurrency : function (currency) {
                return app.util.simpleCurrencyFormatter(0, currency, 0, true).startsWith('0');
            }
        };
    }
};

app.util.getPoFieldTemplate = function (fieldName, fldType) {
    var default_tpl = '<div class="row <%-name%>"><div class="pmf-icon"></div>' +
        '<input autocomplete="off" type="text" maxlength="<%-maxlength%>" id="<%-name%>" name="<%-name%>" placeholder="<%-t(label)%>" title="<%-t(label)%>">' +
        '<div id="<%-name%>_validation" class="validation_image"></div></div>';

    var default_select = '<% var opt = {lbl_class:"focusedInput", val: "",      lbl_txt: label,                                     data: dropDownOptions};                                                                     %> ' + app.CONSTANTS.DEFAULT_SELECT_TPL;

    var clickable_widget_with_dropdown_tpl = '<% var widgetEntries = (dropDownOptions || []).filter(function(o) {return o.value && o.preferred}); %>' +
    '<% widgetEntries = widgetEntries.slice(0, 6); %>' +
    '<h2 class="title <%- widgetEntries.length ? "" : "hidden" %>"><%- widget.title || "" %></h2>' +
    '<div data-id="<%- name %>" class="ob_bank_id-widget <%- widgetEntries.length ? "" : "hidden" %>">' +
        '<% for (var i = 0; i < widgetEntries.length; i++) { %>' +
            '<div data-ob-bank="<%- widgetEntries[i].value %>" title="<%- widgetEntries[i].text %>" style="background-image: url(\'<%- t(widget.logoPath, [widgetEntries[i].value]) %>\');"></div>' +
        '<% } %>' +
    '</div>' + app.CONSTANTS.DEFAULT_SELECT_TPL;

    var MPMTemplate = {
        any_other_field                : default_tpl,
        cc_exp_month                   : $('#cc-expiration-dates-template').length ? $('#cc-expiration-dates-template').text() : app.CONSTANTS.EXP_DATE_TPL,
        astro_pay_prepaid_cc_exp_month : app.CONSTANTS.EXP_DATE_TPL,

        transaction_bank_id            : '<div class="row <%-name%>"><div class="pmf-icon">&nbsp;  </div><input autocomplete="off" type="text"                      id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"    title="<%-label%>"   ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        ftnPrefix                      : '<div class="row <%-name%>"><div class="pmf-icon">&nbsp;  </div><input autocomplete="off" type="text"      maxlength="6"   id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"    title="<%-label%>"   ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        prepaidCards_card_number       : '<div class="row <%-name%>"><div class="pmf-icon">&nbsp;  </div><input autocomplete="off" type="text"      maxlength="10"  id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"    title="<%-label%>"   ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        ftnAccountNumber               : '<div class="row <%-name%>"><div class="pmf-icon">&nbsp;  </div><input autocomplete="off" type="text"      maxlength="10"  id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"    title="<%-label%>"   ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        ftnBankCode                    : '<div class="row <%-name%>"><div class="pmf-icon">&nbsp;  </div><input autocomplete="off" type="text"      maxlength="4"   id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"    title="<%-label%>"   disabled value="<%- app._poList[app.lastSelectedMethodId].attributes.bankCode %>"/><div id="<%-name%>_validation" class="validation_image"></div></div>',
        iban                           : '<div class="row <%-name%>"><div class="pmf-icon">&#xe601;</div><input autocomplete="off" type="text"      maxlength="70"  id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"    title="<%-label%>"   ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        moneta_account_id              : '<div class="row <%-name%>"><div class="pmf-icon">&#xe602;</div><input autocomplete="off" type="text"      maxlength="8"   id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"    title="<%-label%>"   ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        israeli_card_holder_id         : '<div class="row <%-name%>"><div class="pmf-icon">&nbsp;  </div><input autocomplete="off" type="text"      maxlength="9"   id="<%-name%>" name="<%-name%>" placeholder="<%-t(label)%>" title="<%-t(label)%>"><div id="<%-name%>_validation" class="validation_image"></div></div>',
        ecoPayz_account_id             : '<div class="row <%-name%>"><div class="pmf-icon">&#xe602;</div><input autocomplete="off" type="text"      maxlength="10"  id="<%-name%>" name="<%-name%>" placeholder="<%-t(name)%>"  title="<%-t(name)%>" ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        webanq_account_id              : '<div class="row <%-name%>"><div class="pmf-icon">&#xe602;</div><input autocomplete="off" type="text"      maxlength="15"  id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"    title="<%-label%>"   ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        ticket_premium_account_id      : '<div class="row <%-name%>"><div class="pmf-icon">&#xe602;</div><input autocomplete="off" type="text"      maxlength="16"  id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"    title="<%-label%>"   ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        iDebit_account_id              : '<div class="row <%-name%>"><div class="pmf-icon">&#xe602;</div><input autocomplete="off" type="text"      maxlength="30"  id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"    title="<%-label%>"   ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        cc_name_on_card                : '<div class="row <%-name%>"><div class="pmf-icon">&#xe602;</div><input autocomplete="off" type="<%-type%>" maxlength="40"  id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"    title="<%-label%>"   ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        nettelerAccount                : '<div class="row <%-name%>"><div class="pmf-icon">&#xe602;</div><input autocomplete="off" type="text"      maxlength="100" id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"    title="<%-label%>"   ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        payer_name                     : '<div class="row <%-name%>"><div class="pmf-icon">&#xe602;</div><input autocomplete="off" type="text"      maxlength="100" id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"    title="<%-label%>"   value="<%-value%>" ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        payto_pay_id                   : '<div class="row has_help <%-name%>"><div class="pmf-icon"></div><input autocomplete="off" type="text"     maxlength="<%-maxlength%>" id="<%-name%>" name="<%-name%>" placeholder="<%-t(label)%>" title="<%-t(label)%>"><div id="<%-name%>_validation" class="validation_image"></div><div class="field_help hidden" id="payto_pay_id_help"><%- t("payto_phone_hint") %></div></div>',
        molpay_buyer_name              : '<div class="row <%-name%>"><div class="pmf-icon">&#xe602;</div><input autocomplete="off" type="text"      maxlength="70"  id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"    title="<%-label%>"   value="<%-value%>" ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        promoCode                      : '<div class="row <%-name%>"><div class="pmf-icon">&#xe800;</div><input autocomplete="off" type="text"      maxlength="70"  id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"    title="<%-label%>"   ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        ob_iban                        : '<div class="row hidden <%-name%>"><div class="pmf-icon"></div><input autocomplete="off" type="text" maxlength="<%-maxlength%>" id="<%-name%>" name="<%-name%>" placeholder="<%-t(label)%>" title="<%-t(label)%>"><div id="<%-name%>_validation" class="validation_image"></div></div>',

// tel:
        cc_cvv2                        : '<div class="row <%-name%>">                                    <input autocomplete="off" type="tel"       maxlength="4"   id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"    title="<%-label%>"   ><div id="cvv_tooltip" class="tooltip" title=""  ></div><div id="cvv2_right_image" class="cvv2_image"></div><div id="<%-name%>_validation" class="validation_image"></div></div>',
        astro_pay_prepaid_cc_cvv2      : '<div class="row <%-name%>"><div class="pmf-icon">&#xe601;</div><input autocomplete="off" type="tel"       maxlength="4"   id="<%-name%>" name="<%-name%>" placeholder="<%-t(name)%>"  title="<%-label%>"   ><div id="cvv_tooltip" class="tooltip" title=""></div><div id="astro_prepaid_cvv_hint" class="tooltip_hint hidden"><%= t("cvv_hint_exact_digits", [4])%></div><div id="cvv2_right_image" class="cvv2_image"></div><div id="<%-name%>_validation" class="validation_image"></div></div>',
        cc_card_number                 : '<div class="row <%-name%>"><div class="pmf-icon">&#xe601;</div><input autocomplete="off" type="tel"       maxlength="23"  id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"    title="<%-label%>"   ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        molpay_buyer_mobile            : '<div class="row <%-name%>"><div class="pmf-icon">&#xe602;</div><input autocomplete="off" type="tel"       maxlength="16"  id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"    title="<%-label%>"   value="<%-value%>"><div id="<%-name%>_validation" class="validation_image"></div></div>',
        phone                          : '<div class="row <%-name%>"><div class="pmf-icon">        </div><input autocomplete="off" type="tel"       maxlength="20"  id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"    title="<%-label%>"   ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        phone1                         : '<div class="row <%-name%>"><div class="pmf-icon">&nbsp;  </div><input autocomplete="off" type="tel"       maxlength="70"  id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"    title="<%-label%>"   ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        giropay_bic                    : '<div class="row <%-name%>"><div class="pmf-icon">&#xe800;</div><input autocomplete="off" type="tel"       maxlength="11"  id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"    title="<%-label%>"   ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        ob_sort_code                   : '<div class="row hidden <%-name%>"><div class="pmf-icon"> </div><input autocomplete="off" type="tel"       maxlength="70"  id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"    title="<%-label%>"   ><div id="<%-name%>_validation" class="validation_image"></div></div>',
// password:
        nettelerSecureId               : '<div class="row <%-name%>"><div class="pmf-icon">&#xe606;</div><input autocomplete="off" type="password"  maxlength="<%-maxlength%>"  id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"    title="<%-label%>"   ><div id="<%-name%>_validation" class="validation_image"></div></div>',
// email:
        email                          : '<div class="row <%-name%>"><div class="pmf-icon">&#xe605;</div><input autocomplete="off" type="email"     maxlength="100" id="<%-name%>" name="<%-name%>" placeholder="<%- label%>"       title="<%- label%>"     inputmode="email"  value="<%-value%>" ><div id="<%-name%>_validation" class="validation_image"></div></div>',
// email like fields which placeholder and title can be changed with customMsg
        wd_mb_email                    : '<div class="row <%-name%>"><div class="pmf-icon">&#xe605;</div><input autocomplete="off" type="email"     maxlength="100" id="<%-name%>" name="<%-name%>" placeholder="<%- t(name)%>"     title="<%- t(name)%>"   inputmode="email"  value="<%-value%>" ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        email_no_icon                  : '<div class="row <%-name%>"><div class="pmf-icon">        </div><input autocomplete="off" type="email"     maxlength="100" id="<%-name%>" name="<%-name%>" placeholder="<%- t(name)%>"     title="<%- t(name)%>"   inputmode="email"  value="<%-value%>" ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        oktowallet_email               : '<div class="row has_help <%-name%>"><div class="pmf-icon"></div><input autocomplete="off" type="email"     maxlength="100" id="<%-name%>" name="<%-name%>" placeholder="<%- t(name)%>"     title="<%- t(name)%>"   inputmode="email"  value="<%-value%>" ><div id="<%-name%>_validation" class="validation_image"></div><div class="field_help" id="oktowallet_email_help"><a class="tooltip_trigger" tabindex="0"><%- t("oktowallet_where_can_i_find_email") %></a><div class="tooltip_content" id="oktowallet_email_tooltip"><%- t("oktowallet_email_tooltip") %></div></div></div>',
// composite phone:
        default_composite_phone        : '<% var opt = {suffix_maxlength: 15, phoneCodes: app.util.getFilteredPhoneCodes(app.phoneCodes)}; if (opt.phoneCodes.length === 2 && !opt.phoneCodes[0].phoneCode && (!value || !value.includes("-"))) { opt.phoneCodes.shift(); } %>' + app.CONSTANTS.COMPOSITE_PHONE_NUMBER_TPL,
        usr_country_preselected_composite_phone: '<% var phoneCodes = app.util.getFilteredPhoneCodes(app.phoneCodes); var countryCode = app.util.getCountryPhoneCode(phoneCodes, app.country); var opt = {suffix_maxlength: 15, phoneCode: countryCode, phoneCodes: phoneCodes}; %>' + app.CONSTANTS.COMPOSITE_PHONE_NUMBER_TPL,
        muchBetter_mobilePhone         : '<% var opt = {suffix_maxlength: 15, phoneCodes: app.util.getMuchBetterPhoneCodes(app.phoneCodes)}; %>' + app.CONSTANTS.COMPOSITE_PHONE_NUMBER_TPL,
        qiwi_phonenumber               : '<div class="row <%-name%> <%- app.config.pmSettings.apmgw_QIWI.showQiwiCountryCodes? "countryCodeVisible" : "" %>"><% if(app.config.pmSettings.apmgw_QIWI.showQiwiCountryCodes) {%><select name="qiwi_country_code" id="qiwi_country_code" data-plugin="cSelect"><% ["7", "994", "374","375","372","995","91","972","81","82","996","371","370","373","507","84","992","66","90","380","44", "1", "998"].forEach(function(v) { %><option value="<%= v%>">+<%= v%></option><%})%></select><div class="qiwi_phonenumber_input"><input type="hidden" id="<%-name%>" name="<%-name%>"><input autocomplete="off" type="text" id="qiwi_phonenumber_suffix"  name="qiwi_phonenumber_suffix" placeholder="<%-label%>" title="<%-label%>" maxlength="15"><div id="qiwi_phonenumber_validation" class="validation_image"></div></div> <%} else { %> <div class="pmf-icon">&#xe602;</div><input autocomplete="off" type="tel"   id="<%-name%>" name="<%-name%>" placeholder="<%-label%>" title="<%-label%>" maxlength="15"><div id="<%-name%>_validation" class="validation_image"></div> <%}%></div>',
        bancomatPay_mobileNumber       : '<% var phoneCodes = app.util.getFilteredPhoneCodes(app.phoneCodes); var countryCode = app.util.getCountryPhoneCode(phoneCodes, "IT"); var opt = {suffix_maxlength: 15, phoneCodes: phoneCodes, phoneCode: countryCode}; if (opt.phoneCodes.length === 2 && !opt.phoneCodes[0].phoneCode && (!value || !value.includes("-"))) { opt.phoneCodes.shift(); } %>' + app.CONSTANTS.COMPOSITE_PHONE_NUMBER_TPL,
// checkbox:
        paypalDirectFlow               : '<% var opt = {lbl_txt: t("paypal_direct_flow_description"),       checked: (app.config.pmSettings.apmgw_expresscheckout.defaultValue  ? "checked" : "")}; if(app.config.pmSettings.apmgw_expresscheckout.supportDirectFlow){  %>' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL + '<%}%>',
        postFinanceCardDirectFlow      : '<% var opt = {lbl_txt: t("postFinance_direct_flow_description"),  checked: (app.config.pmSettings.apmgw_PostFinance_Card.defaultValue ? "checked" : "")}; if(app.config.pmSettings.apmgw_PostFinance_Card.supportDirectFlow){ %>' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL + '<%}%>',
        postFinancePayDirectFlow       : '<% var opt = {lbl_txt: t("postFinancePay_direct_flow_description"),checked: (value == "true" ? "checked" : ""),    validate: 1};   %>' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL,
        paysafeCardDirectFlow          : '<% var opt = {lbl_txt: t("paysafeCardDirectFlow"),                checked: (value == "true" ? "checked" : ""),    validate: 0};   %>' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL,
        skrillDirectFlow               : '<% var opt = {lbl_txt: t("skrill_direct_flow_description"),       checked: (app.config.pmSettings.apmgw_MoneyBookers.defaultValue     ? "checked" : "")}; if(app.config.pmSettings.apmgw_MoneyBookers.supportDirectFlow){     %>' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL + '<%}%>',
        satispayDirectFlow             : '<% var opt = {lbl_txt: t("satispay_direct_flow_description"),     checked: (app.config.pmSettings.apmgw_Satispay.defaultValue         ? "checked" : "")}; if(app.config.pmSettings.apmgw_Satispay.supportDirectFlow){         %>' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL + '<%}%>',
        blik_useOneClick               : '<% var opt = {lbl_txt: t("blik_use_one_click_description"),       checked: (app.config.pmSettings.apmgw_BLIK.blikOneClickMode === "PRESELECTED" ? "checked" : "")}; if(app.config.pmSettings.apmgw_BLIK.blikOneClickMode === "PRESELECTED" || app.config.pmSettings.apmgw_BLIK.blikOneClickMode === "NOT_SELECTED"){     %>' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL + '<%} else if (app.config.pmSettings.apmgw_BLIK.blikOneClickMode === "PRESELECTED_AND_HIDDEN") {%><input type="hidden" name="<%- name %>" id="<%- name %>" value="true"><%}%>',
        ownAccount                     : '<% var opt = {lbl_txt: t("confirm_owner_checkbox_label"),         checked: (value == "true" ? "checked" : ""),    validate: 1};   %>' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL,
        saltarpay_storeCard            : '<% var opt = {lbl_txt: t("saltarpay_storeCard"),                  checked: "",                                    validate: 0};   %>' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL,
        abon_terms                     : '<% var opt = {lbl_txt: t("abon_terms"),                           checked: "checked",                             validate: 1};   %>' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL,
        ach_terms                      : '<% var opt = {lbl_txt: t("ach_terms"),                            checked: (value == "true" ? "checked" : ""),    validate: 1};   %>' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL,
        bacs_terms                     : '<% var opt = {lbl_txt: t("bacs_terms"),                           checked: (value == "true" ? "checked" : ""),    validate: 1};   %>' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL,
        bankTransfer_terms             : '<% var opt = {lbl_txt: t("bankTransfer_terms"),                   checked: (value == "true" ? "checked" : ""),    validate: 1};   %>' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL,
        ob_terms                       : '<% var languageMap = app.config.pmSettings[app.CONSTANTS.PM_NAME.OPEN_BANKING].termsLanguageMap; var filterCountry = languageMap[app.locale.substr(0, 2)] || languageMap["en"]; var opt = {lbl_txt: t("ob_terms", [filterCountry]), checked: (value == "true" ? "checked" : ""),    validate: 1};   %>' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL,
        oktocash_terms                 : '<% var opt = {lbl_txt: t("oktocash_terms"),                       checked: (value == "true" ? "checked" : ""),    validate: 1};   %>' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL,
        oktocash_termsOfUse            : '<% var opt = {lbl_txt: t("oktocash_termsOfUse"),                  checked: (value == "true" ? "checked" : ""),    validate: 1};   %>' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL,
        oktowallet_terms               : '<% var opt = {lbl_txt: t("oktowallet_terms"),                     checked: (value == "true" ? "checked" : ""),    validate: 1};   %>' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL,
        oktowallet_consent             : '<% var opt = {lbl_txt: t("oktowallet_consent"),                   checked: (value == "true" ? "checked" : ""),    validate: 1};   %>' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL,
        dankort_acq                    : '<div class="row <%-name%>"><input type="checkbox" id="<%-name%>" name="<%-name%>" value="true" class="toggle_checkbox" /><label for="<%-name%>"><span class="text" data-no="<%-t("lightbox_no_button")%>" data-yes="<%-t("lightbox_yes_button")%>"></span><%= t("dankort_acq_text")%></label></div>',
// select:
        default_select                 : default_select,
        debit_type                     : '<% var opt = {lbl_class:"focusedInput", val: 1,                                                           data: [{"value":1, "text":"regular"}]}, mni = app.config.max_num_installments; if(app.config.allow_installments &&  mni > 1){ opt.data.push({"value":2, "text":"installments"});} if(app.config.allow_special_debit &&  mni > 1){ opt.data.push({"value":3, "text":"special_debit"});} %> ' + app.CONSTANTS.DEFAULT_SELECT_TPL,
        mercado_fiscal_number_type     : '<% var opt = {lbl_class:"focusedInput", val: "",                                                          data: [{text: t("please_select"), value: ""}].concat(dropDownOptions)};                     %> ' + app.CONSTANTS.DEFAULT_SELECT_TPL,
        installment_program            : '<% var opt = {lbl_class:"focusedInput", val: 0,                                                           data: [{"value":0, "text":"STANDARD"}].concat(app.config.installmentConfig.programs)}; %> ' + app.CONSTANTS.DEFAULT_SELECT_TPL,
        number_of_installments         : '<% var opt = {lbl_class:"focusedInput", val: 1,                                                           data: [{"value":1, "text":"1"}]};                                                           %> ' + app.CONSTANTS.DEFAULT_SELECT_TPL,
        netbanking_bankCode            : '<% var opt = {lbl_class:"focusedInput", val: "",                                                          data: dropDownOptions};                                                                     %> ' + app.CONSTANTS.DEFAULT_SELECT_TPL,
        echeck_account_type            : '<% var opt = {lbl_class:"focusedInput", val: app.config.pmSettings.apmgw_eCheck.accountTypes[0].value,    data: app.config.pmSettings.apmgw_eCheck.accountTypes};                                     %> ' + app.CONSTANTS.DEFAULT_SELECT_TPL,
        echeck_country                 : '<% var opt = {lbl_class:"focusedInput", val: app.config.pmSettings.apmgw_eCheck.countries[0].value,       data: app.config.pmSettings.apmgw_eCheck.countries};                                        %> ' + app.CONSTANTS.DEFAULT_SELECT_TPL,
        saltarpay_country              : '<% var opt = {lbl_class:"focusedInput", val: app.config.country,                                          data: app.util.remapPropsAs({"iso" : "value", "name" : "text"}, app.allCountries)};            %> ' + app.CONSTANTS.DEFAULT_SELECT_TPL,
        echeck_state                   : '<% var states = [{value: "", text: "select_state"}].concat(app._countryStates["CA"]); var opt = {lbl_class:"focusedInput", val: (value || app.config.user.state || states[0].value), data: states};   %> ' + app.CONSTANTS.DEFAULT_SELECT_TPL,
        instantOb_bankId               : '<% var widget = {title: t("top_banks"), logoPath: app.config.pmSettings[app.CONSTANTS.PM_NAME.INSTANT_OPEN_BANKING].logoPath}; dropDownOptions = [{text: t("please_select_a_bank"), value: ""}].concat(dropDownOptions); var opt = {lbl_class:"focusedInput", val: "", lbl_txt: label, data: dropDownOptions, withSearch: true }; %>' + clickable_widget_with_dropdown_tpl,
        ob_bank_id                     : '<% var widget = {title: t("top_banks"), logoPath: app.config.pmSettings[app.CONSTANTS.PM_NAME.OPEN_BANKING].logoPath};         dropDownOptions = [{text: t("please_select_a_bank"), value: ""}].concat(dropDownOptions); var opt = {lbl_class:"focusedInput", val: "", lbl_txt: label, data: dropDownOptions, withSearch: true }; %>' + clickable_widget_with_dropdown_tpl,
        bankTransfer_bank_id           : '<% var widget = {title: t("top_banks"), logoPath: app.config.pmSettings[app.CONSTANTS.PM_NAME.ONLINE_BANK_TRANSFER].logoPath}; dropDownOptions = [{text: t("please_select_a_bank"), value: ""}].concat(dropDownOptions); var opt = {lbl_class:"focusedInput", val: "", lbl_txt: label, data: dropDownOptions, withSearch: true }; %>' + clickable_widget_with_dropdown_tpl,
        lean_bank                      : '<% var widget = {title: t("top_banks"), logoPath: app.config.pmSettings[app.CONSTANTS.PM_NAME.LEAN].logoPath};                 dropDownOptions = [{text: t("please_select_a_bank"), value: ""}].concat(dropDownOptions); var opt = {lbl_class:"focusedInput", val: "", lbl_txt: label, data: dropDownOptions, withSearch: true }; %>' + clickable_widget_with_dropdown_tpl,
        pix_of_bank_name               : '<% var widget = {title: t("top_banks"), logoPath: app.config.pmSettings[app.CONSTANTS.PM_NAME.PIX_OPEN_FINANCE].logoPath};     dropDownOptions = [{text: t("please_select_a_bank"), value: ""}].concat(dropDownOptions); var opt = {lbl_class:"focusedInput", val: "", lbl_txt: label, data: dropDownOptions, withSearch: true }; %>' + clickable_widget_with_dropdown_tpl,
// date:
        mazooma_dob                    : '<div class="row datePicker <%-name%>"><div class="pmf-icon"></div><input autocomplete="off" type="date" id="<%-name%>" name="<%-name%>" placeholder="<%-t(label)%>" title="<%-t(label)%>"><div id="<%-name%>_validation" class="validation_image"></div></div>',
// radio:
        default_radio                  : '<% var opt = {lbl_txt: t(name), val: value, data: dropDownOptions}; %>' + app.CONSTANTS.RADIO_BTN_FIELD_TPL,
        konbini_store                  : '<% var opt = {lbl_txt: t("store_select"), val: value, data: dropDownOptions, logoPath: app.config.pmSettings[app.CONSTANTS.PM_NAME.KONBINI].logoPath}; %>' + app.CONSTANTS.RADIO_LIST_WITH_IMGS_TPL,
// button
        lean_register_button           : '<div class="row <%-name%> generic_btn_row"><button type="button" role="button" id="<%-name%>" class="btn generic_btn <%-name%>" onclick="$(\'#continueButton\').click();"><%- t("register") %></button></div>',
// hidden:
        default_hidden                 : '<div class="row_hidden hidden <%-name%>"><input type="hidden" id="<%-name%>" name="<%-name%>" value="<%-value%>" /></div>'
    };
// Card
    MPMTemplate.astro_pay_prepaid_cc_card_number = MPMTemplate.cc_card_number;
    MPMTemplate.astro_pay_prepaidBF_cc_card_number = MPMTemplate.cc_card_number;

// CVV:
    MPMTemplate.astro_pay_prepaidBF_cc_cvv2 = MPMTemplate.astro_pay_prepaid_cc_cvv2;

// Date:
    MPMTemplate.astro_pay_prepaidBF_cc_exp_month = MPMTemplate.astro_pay_prepaid_cc_exp_month;

// Password:
    MPMTemplate.moneta_payment_password = MPMTemplate.nettelerSecureId;
    MPMTemplate.toditocash_pin_code = MPMTemplate.nettelerSecureId;
    MPMTemplate.webanq_password = MPMTemplate.nettelerSecureId;

// Phone:
    MPMTemplate.phone2 = MPMTemplate.phone1;
    MPMTemplate.phone3 = MPMTemplate.phone1;
    MPMTemplate.shippingPhone = MPMTemplate.phone1;
    MPMTemplate.elementpay_userPhone = MPMTemplate.phone;
    MPMTemplate.elementpay_nid = MPMTemplate.phone;
    MPMTemplate.interac_Combined_mobilePhone = MPMTemplate.phone;
    MPMTemplate.smart2pay_phone = MPMTemplate.phone;
    MPMTemplate.paymentasia_phone = MPMTemplate.phone;
    MPMTemplate.abon_voucherNumber = MPMTemplate.phone;
    MPMTemplate.abon_userPhone = MPMTemplate.phone;
    MPMTemplate.bacs_sort_code = MPMTemplate.phone;
    MPMTemplate.bankTransfer_sort_code = MPMTemplate.phone;
    MPMTemplate.nequi_phone_number = MPMTemplate.phone;
    MPMTemplate.codi_phone_number = MPMTemplate.phone;
    MPMTemplate.smart2pay_phone_number = MPMTemplate.phone;
    MPMTemplate.fortumo_phone_number = MPMTemplate.phone;
    MPMTemplate.classic_ach_routing_number = MPMTemplate.phone;
    MPMTemplate.airbank_accountNumber = MPMTemplate.phone;
    MPMTemplate.airbank_accountPrefix = MPMTemplate.phone;
    MPMTemplate.airbank_bankCode = MPMTemplate.phone;
    MPMTemplate.bankaCreditas_accountNumber = MPMTemplate.phone;
    MPMTemplate.bankaCreditas_accountPrefix = MPMTemplate.phone;
    MPMTemplate.bankaCreditas_bankCode = MPMTemplate.phone;
    MPMTemplate.jtBanka_accountNumber = MPMTemplate.phone;
    MPMTemplate.jtBanka_accountPrefix = MPMTemplate.phone;
    MPMTemplate.jtBanka_bankCode = MPMTemplate.phone;
    MPMTemplate.blik_code = MPMTemplate.phone;

// Composite Phone:
    MPMTemplate.mbWay_mobilePhone = MPMTemplate.default_composite_phone;
    MPMTemplate.fonix_phonenumber = MPMTemplate.default_composite_phone;
    MPMTemplate.onShopMobilePhone = MPMTemplate.default_composite_phone;
    MPMTemplate.mercado_phone_number = MPMTemplate.usr_country_preselected_composite_phone;

// Email:
    MPMTemplate.saltarpay_email = MPMTemplate.email;
    MPMTemplate.payer_email = MPMTemplate.email;
    MPMTemplate.expresscheckout_account_id = MPMTemplate.email;
    MPMTemplate.interac_Combined_email = MPMTemplate.email;
    MPMTemplate.pay4fun_account_email = MPMTemplate.email;
    MPMTemplate.paymentasia_email = MPMTemplate.email;

// email like fields which placeholder and tittle can be changed with customMsg
    MPMTemplate.molpay_buyer_email = MPMTemplate.wd_mb_email;
    MPMTemplate.confirmEmail = MPMTemplate.wd_mb_email;
    MPMTemplate.shippingMail = MPMTemplate.wd_mb_email;
    MPMTemplate.verification_email = MPMTemplate.wd_mb_email;
    MPMTemplate.interac_eTransfer_email = MPMTemplate.wd_mb_email;

// email (no pmf-icon)
    MPMTemplate.interac_instant_email = MPMTemplate.email_no_icon;
    MPMTemplate.easypay_email = MPMTemplate.email_no_icon;

// Phone hidden:
    MPMTemplate.ob_account_number = MPMTemplate.ob_sort_code;

// Select:
    MPMTemplate.myBank_bank_id = MPMTemplate.bankTransfer_bank_id;
    MPMTemplate.elementpay_bankId = MPMTemplate.bankTransfer_bank_id;
    MPMTemplate.elementpay_accountType = MPMTemplate.mercado_fiscal_number_type;
    MPMTemplate.mobi_bankCodeRetail = MPMTemplate.bankTransfer_bank_id;
    MPMTemplate.mobi_bankCodeCorporate = MPMTemplate.bankTransfer_bank_id;
    MPMTemplate.lean_country = MPMTemplate.mercado_fiscal_number_type;

// Radio:
    MPMTemplate.interac_deposit_flow_type = MPMTemplate.default_radio;
    MPMTemplate.payto_payment_type = MPMTemplate.default_radio;
    MPMTemplate.payto_pay_id_type = MPMTemplate.default_radio;
    MPMTemplate.mobi_accountType = MPMTemplate.default_radio;

// Hidden:
    MPMTemplate.myBank_bank_name = MPMTemplate.default_hidden;

    var $custom_fld_tpl, $custom_other_fld_tpl, tpl_txt;
    $custom_fld_tpl = $('#fld_' + fieldName);
    if ($custom_fld_tpl.length) {
        tpl_txt = $custom_fld_tpl.text();
    } else if (MPMTemplate.hasOwnProperty(fieldName)) {
        tpl_txt = MPMTemplate[fieldName];
    } else if (fldType === 'select') {
        tpl_txt = MPMTemplate.default_select;
    } else {
        $custom_other_fld_tpl = $('#fld_any_other_field');
        tpl_txt = $custom_other_fld_tpl.length ? $custom_other_fld_tpl.text() : default_tpl;
    }
    return _.template(tpl_txt);
};

app.util.getUpoFieldTemplate = function(tplName, view_type, fldType){

    var default_rw = '<div class="row <%-name%>"><div class="pmf-icon"></div>' +
        '<input autocomplete="off" type="text"  maxlength="<%-maxlength%>" id="<%-name%>" name="<%-name%>" placeholder="<%-t(name)%>" title="<%-t(name)%>" value="<%-value%>" >' +
        '<div id="<%-name%>_validation" class="validation_image"></div></div>';
    var UPMTemplates = {
        pix_key_rw                    : ' ',
        ftnPrefix_ro                  : ' ',
        ftnAccountNumber_ro           : ' ',
        ftnBankCode_ro                : ' ',
        vcoCallId_ro                  : ' ',
        myBank_bank_name_ro           : ' ',
        oktocash_terms_ro             : ' ',
        cardArtsUrl_ro                : '<div class="row <%-name%>"> ' +
            '<div class="img" ><% var src=(value || cssCreator.resourcePrefix+"solid-white/visa_checkout.svg");%><img src="<%-src%>"></div> ' +
            '<div class="details"><div class="issuer"><%-t(normalizedData.card_type)%></div>' +
            '<div class="cc_digits"><%-t("asterisk_template")%><% if(normalizedData.last_4_digits){%><%- normalizedData.last_4_digits%><%}%>' +
            '<% if(normalizedData.expiration){%>, <%- t("lightbox_exp_abbr")%> <%- normalizedData.expiration.mm%>/<%- normalizedData.expiration.yy%><%}%>' +
            '</div></div><div class="vco_edit"><a class="v-button" href="#"><%- t("vco_edit")%></a></div></div>',
        trustly_di_info_ro            : '<div class="row <%-name%>"> ' +
                '<% var src = (value || "").split("-|-")[0]; %>' +
                '<% if (src) { %>' +
                    '<div class="img"><img alt="bank logo" onerror="this.parentNode.remove();" src="<%- src %>"></div> ' +
                '<% } %>' +
                '<div class="details">' +
                    '<div class="info"><%- t("my_bank_account_personal_account") %></div>' +
                    '<% var digits = (value || "").split("-|-")[1] || ""; %>' +
                    '<div class="cc_digits"><%- digits %></div>' +
                '</div> ' +
                '<div class="method_logo"><img alt="method logo" src="<%- cssCreator.resourcePrefix + "solid-white/trustly.svg" %>"></div>' +
            '</div>',
        pwmb_providerName_ro         : '<div class="row cardArtsUrl <%-name%>"> ' +
                '<% var logoUrl=(app.config.pmSettings.apmgw_Online_Banking && app.config.pmSettings.apmgw_Online_Banking.logoUrl),' +
                'bankID=(normalizedData.pwmb_providerId && normalizedData.pwmb_providerId.value),' +
                'accName=(normalizedData.pwmb_bankAccountName && normalizedData.pwmb_bankAccountName.value || ""), ' +
                'accId=(normalizedData.pwmb_bankAccountId && normalizedData.pwmb_bankAccountId.value || ""),' +
                'src=(logoUrl && bankID ? t(logoUrl, [bankID]) : "https://paywithmybank.com/start/assets/institutions/defaults/icon/default_green.png"); %>' +
                '<div class="img" ><img src="<%-src%>"></div> ' +
                '<div class="details"><div class="issuer"><%-t(value)%></div><div class="cc_digits"><%-t("asterisk_template")%><%-accId%> - <%-t(accName)%></div></div>' +
            '</div>',
        mazoomaFiAcc_ro               : '<div class="row readOnly <%-name%>">' +
                '<div id="cc_name_on_card_read_only_image" class="readOnlyImage"></div>' +
                '<div id="<%-name%>_read_only_text" class="readOnlyText">' +
                    '<% var accountTypes = {"ps": "personal_savings", "pc": "personal_checking"}; %>' +
                    '<%- t("echeck_account_type") + ": " %>' +
                    '<%- t(accountTypes[(value || "").toLowerCase()] || value) %>' +
                '</div>' +
            '</div>',
        mazoomaFiName_ro               : '<div class="row readOnly <%-name%>">' +
                '<div id="cc_name_on_card_read_only_image" class="readOnlyImage"></div>' +
                '<div id="<%-name%>_read_only_text" class="readOnlyText">' +
                    '<%- t("bank_name") + ": " + value %>' +
                '</div>' +
            '</div>',
        cc_card_number_ro             : '<div class="row readOnly <%-name%>"><div id="<%-name%>_read_only_image" class="readOnlyImage"></div><div id="<%-name%>_read_only_text" class="readOnlyText"><%-"**** **** **** "+value.substr(-4)%></div></div>',
        cc_card_number_rw             : '<div class="row <%-name%>"><div class="pmf-icon">&#xe601;</div><input type="tel"  maxlength="23" id="<%-name%>" name="<%-name%>" placeholder="<%-label%>" title="<%-label%>" value="<%-value%>"><div id="<%-name%>_validation" class="validation_image"></div></div>',
        nettelerAccount_rw            : '<div class="row <%-name%>"><div class="pmf-icon">&#xe602;</div><input type="text" maxlength="100" id="<%-name%>" name="<%-name%>" placeholder="<%-label%>" title="<%-label%>" value="<%-value%>"><div id="<%-name%>_validation" class="validation_image"></div></div>',
        payer_name_rw                 : '<div class="row <%-name%>"><div class="pmf-icon">&#xe602;</div><input type="text" maxlength="100" id="<%-name%>" name="<%-name%>" placeholder="<%-label%>" title="<%-label%>" value="<%-value%>"><div id="<%-name%>_validation" class="validation_image"></div></div>',
        payer_email_rw                : '<div class="row <%-name%>"><div class="pmf-icon">&#xe605;</div><input autocomplete="off" type="email" maxlength="100" id="<%-name%>" name="<%-name%>" placeholder="<%-label%>" title="<%-label%>" value="<%-value%>"><div id="<%-name%>_validation" class="validation_image"></div></div>',
        moneta_account_id_rw          : '<div class="row <%-name%>"><div class="pmf-icon">&#xe602;</div><input type="text" maxlength="8"  id="<%-name%>" name="<%-name%>" placeholder="<%-label%>" title="<%-label%>" value="<%-value%>" ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        iDebit_account_id_rw          : '<div class="row <%-name%>"><div class="pmf-icon">&#xe602;</div><input type="text" maxlength="30" id="<%-name%>" name="<%-name%>" placeholder="<%-label%>" title="<%-label%>" value="<%-value%>" ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        qiwi_phonenumber_rw           : '<div class="row <%-name%> <%- app.config.pmSettings.apmgw_QIWI.showQiwiCountryCodes? "countryCodeVisible" : "" %>">' +
            '<% if(app.config.pmSettings.apmgw_QIWI.showQiwiCountryCodes) {%><select name="qiwi_country_code" id="qiwi_country_code" data-plugin="cSelect"><% value = value || "";["7", "994", "374","375","372","995","91","972","81","82","996","371","370","373","507","84","992","66","90","380","44", "1", "998"].forEach(function(v) { %><option value="<%= v%>"  <% if(value.startsWith(v)){ print(\'selected\'); } %>>+<%= v%></option><%})%></select>' +
            '<div class=\'qiwi_phonenumber_input\'><input type="hidden" id="<%-name%>" name="<%-name%>" value="<%-value%>"><input autocomplete="off" type="text" id="qiwi_phonenumber_suffix" name="qiwi_phonenumber_suffix" placeholder="QIWI phone number" value="<%- value.replace(/^(7|994|374|375|372|995|91|972|81|82|996|371|370|373|507|84|992|66|90|380|44|1|998)/, \'\')%>" title="<%-label%>" maxlength="15"><div id="qiwi_phonenumber_validation" class="validation_image"></div></div><%} else {%><div class="pmf-icon">&#xe602;</div><input type="tel" maxlength="15" id="<%-name%>" name="<%-name%>" placeholder="<%-label%>" title="<%-label%>" value="<%-value%>" ><div id="<%-name%>_validation" class="validation_image"></div> <%}%></div>',
        nettelerSecureId_rw           : '<div class="row <%-name%>"><div class="pmf-icon">&#xe606;</div><input autocomplete="off" type="password" maxlength="6" id="<%-name%>" name="<%-name%>" value="<%-value%>" placeholder="<%-label%>" title="<%-label%>"><div id="<%-name%>_validation" class="validation_image"></div></div>',
        moneta_payment_password_rw    : '<div class="row <%-name%>"><div class="pmf-icon">&#xe606;</div><input autocomplete="off" type="password" maxlength="5" id="<%-name%>" name="<%-name%>" value="<%-value%>" placeholder="<%-label%>" title="<%-label%>"><div id="<%-name%>_validation" class="validation_image"></div></div>',
        cc_name_on_card_ro            : '<div class="row readOnly <%-name%>"><div id="<%-name%>_read_only_image" class="readOnlyImage"></div><div id="<%-name%>_read_only_text" class="readOnlyText"><%-value%></div></div>',
        cc_name_on_card_rw            : '<div class="row <%-name%>"><div class="pmf-icon">&#xe602;</div><input autocomplete="off" maxlength="40" type="text" id="<%-name%>" name="<%-name%>" value="<%-value%>" placeholder="<%-label%>" title="<%-label%>"><div id="<%-name%>_validation" class="validation_image"></div></div>',
        expiration_period_ro          : '<div class="row readOnly expiration_period"><div id="cc_exp_month_read_only_image" class="readOnlyImage"></div>' +
            '<%var monthFld = (normalizedData[prefix + "cc_exp_month"] || normalizedData.expiration_period[prefix + "cc_exp_month"]); var yearFld = (normalizedData[prefix + "cc_exp_year"] || normalizedData.expiration_period[prefix + "cc_exp_year"]);%>' +
            '<div id="expiration_period_read_only_text" class="readOnlyText"><%-monthFld.value%> / 20<%-yearFld.value%></div></div>',
        expiration_period_rw          : ($('#cc-expiration-dates-template').length ? $('#cc-expiration-dates-template').text() : app.CONSTANTS.EXP_DATE_TPL),
        astro_pay_prepaid_expiration_period_rw  : app.CONSTANTS.EXP_DATE_TPL,
        cc_cvv2_rw                    :'<div class="row <%-name%>"><input autocomplete="off" type="tel" id="<%-name%>" maxlength="4" name="<%-name%>" placeholder="CVV2" title="<%-label%>"><div id="cvv_tooltip" class="tooltip" title=""></div><div id="cvv2_right_image" class="cvv2_image"></div><div id="<%-name%>_validation" class="validation_image"></div></div>',
        astro_pay_prepaid_cc_cvv2_rw  :'<div class="row <%-name%>"><div class="pmf-icon">&#xe601;</div><input autocomplete="off" type="tel" id="<%-name%>" maxlength="4" name="<%-name%>" placeholder="<%-t(name)%>" title="<%-label%>"><div id="cvv_tooltip" class="tooltip" title=""></div><div id="astro_prepaid_cvv_hint" class="tooltip_hint hidden"><%= t("cvv_hint_exact_digits", [4])%></div><div id="cvv2_right_image" class="cvv2_image"></div><div id="<%-name%>_validation" class="validation_image"></div></div>',
        visa_checkout_cc_cvv2_rw      :'<div class="row <%-name%>"><div class="pmf-icon">&#xe601;</div><input autocomplete="off" type="tel" id="<%-name%>" maxlength="4" name="<%-name%>" placeholder="<%-t(name)%>" title="<%-label%>"><div id="cvv_tooltip" class="tooltip" title=""></div><div id="cvv2_right_image" class="cvv2_image"></div><div id="<%-name%>_validation" class="validation_image"></div></div>',
        cc_cvv2_ro                    : ' ',

        nettelerAccount_ro            : '<div class="row readOnly <%-name%>"><div id="cc_name_on_card_read_only_image" class="readOnlyImage"></div><div id="<%-name%>_read_only_text" class="readOnlyText"><%-value%></div><div id="<%-name%>_validation" class="validation_image"></div></div>',
        moneta_account_id_ro          : '<div class="row readOnly <%-name%>"><div id="cc_name_on_card_read_only_image" class="readOnlyImage"></div><div id="<%-name%>_read_only_text" class="readOnlyText"><%-value%></div><div id="<%-name%>_validation" class="validation_image"></div></div>',
        iDebit_account_id_ro          : '<div class="row readOnly <%-name%>"><div id="cc_name_on_card_read_only_image" class="readOnlyImage"></div><div id="<%-name%>_read_only_text" class="readOnlyText"><%-value%></div><div id="<%-name%>_validation" class="validation_image"></div></div>',
        qiwi_phonenumber_ro           : '<div class="row readOnly <%-name%>"><div id="cc_name_on_card_read_only_image" class="readOnlyImage"></div><div id="<%-name%>_read_only_text" class="readOnlyText"><%-value%></div><div id="<%-name%>_validation" class="validation_image"></div></div>',
        nettelerSecureId_ro           : '<div class="row <%-name%>"><div class="pmf-icon">&#xe606;</div><input autocomplete="off" type="password" maxlength="6"  id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"   title="<%-label%>"   value="<%-value%>" ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        moneta_payment_password_ro    : '<div class="row <%-name%>"><div class="pmf-icon">&#xe606;</div><input autocomplete="off" type="password" maxlength="6"  id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"   title="<%-label%>"   value="<%-value%>" ><div id="<%-name%>_validation" class="validation_image"></div></div>',

        israeli_card_holder_id_rw     : '<div class="row <%-name%>"><div class="pmf-icon">&nbsp;  </div><input autocomplete="off" type="text"     maxlength="9"  id="<%-name%>" name="<%-name%>" placeholder="<%-t(name)%>" title="<%-t(name)%>" value="<%-value%>" ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        promoCode_rw                  : '<div class="row <%-name%>"><div class="pmf-icon">&#xe800;</div><input autocomplete="off" type="text"     maxlength="70" id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"   title="<%-label%>"><div id="<%-name%>_validation" class="validation_image"></div></div>',
        toditocash_pin_code_rw        : '<div class="row <%-name%>"><div class="pmf-icon">&#xe606;</div><input autocomplete="off" type="password" maxlength="5"  id="<%-name%>" name="<%-name%>" placeholder="<%-label%>"   title="<%-label%>"  value="<%-value%>"><div id="<%-name%>_validation" class="validation_image"></div></div>',
        paypalDirectFlow_rw           : '<% var opt = { checked: (value == "true" ? "checked" : ""), lbl_txt: (_hasRefId ? t("paypal_direct_flow_description_upo") : t("paypal_direct_flow_description"))};%> ' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL,
        postFinanceCardDirectFlow_rw  : '<% var opt = { checked: (value == "true" ? "checked" : ""), lbl_txt: (_hasRefId ? t("postFinance_direct_flow_description_upo") : t("postFinance_direct_flow_description"))};%> ' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL,
        paysafeCardDirectFlow_rw      : '<% var opt = { checked: (value == "true" ? "checked" : ""), lbl_txt: t("paysafeCardDirectFlow")};%> ' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL,
        postFinancePayDirectFlow_rw   : '<% var opt = { checked: (value == "true" ? "checked" : ""), lbl_txt: t("postFinancePay_direct_flow_description"), validate: 1};%> ' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL,
        skrillDirectFlow_rw           : '<% var opt = { checked: (value == "true" ? "checked" : ""), lbl_txt: (_hasRefId ? t("skrill_direct_flow_description_upo") : t("skrill_direct_flow_description"))};%> ' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL,
        satispayDirectFlow_rw         : '<% var opt = { checked: (value == "true" ? "checked" : ""), lbl_txt: (_hasRefId ? t("satispay_direct_flow_description") : t("satispay_direct_flow_description"))};%> ' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL,
        blik_useOneClick_rw           : '<% var opt = { checked: (value == "true" ? "checked" : ""), lbl_txt: (_hasRefId ? t("blik_use_one_click_description_upo") : t("blik_use_one_click_description"))}; if(app.config.pmSettings.apmgw_BLIK.blikOneClickMode === "PRESELECTED" || app.config.pmSettings.apmgw_BLIK.blikOneClickMode === "NOT_SELECTED"){%> ' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL + '<%} else if (app.config.pmSettings.apmgw_BLIK.blikOneClickMode === "PRESELECTED_AND_HIDDEN") {%><input type="hidden" name="<%- name %>" id="<%- name %>" value="true"><%}%>',
        ownAccount_rw                 : '<% var opt = { checked: (value == "true" ? "checked" : ""), lbl_txt: t("confirm_owner_checkbox_label"), validate: 1}; %>' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL ,
        abon_terms_rw                 : '<% var opt = { checked: (value == "true" ? "checked" : ""), lbl_txt: t("abon_terms"), validate: 1};   %>' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL,
        oktowallet_terms_rw           : '<% var opt = { checked: (value == "true" ? "checked" : ""), lbl_txt: t("oktowallet_terms"), validate: 1};   %>' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL,
        oktowallet_consent_rw         : '<% var opt = { checked: (value == "true" ? "checked" : ""), lbl_txt: t("oktowallet_consent"), validate: 1};   %>' + app.CONSTANTS.DIRECT_FLOW_CHECKBOX_TPL,
        webanq_account_id_ro          : '<div class="row readOnly <%-name%>"><div id="cc_name_on_card_read_only_image" class="readOnlyImage"></div><div id="<%-name%>_read_only_text" class="readOnlyText"><%-value%></div><div id="<%-name%>_validation" class="validation_image"></div></div>',
        webanq_password_rw            : '<div class="row <%-name%>"><div class="pmf-icon">&#xe606;</div><input autocomplete="off" type="password" maxlength="32" id="<%-name%>" name="<%-name%>" value="<%-value%>" placeholder="<%-label%>" title="<%-label%>"><div id="<%-name%>_validation" class="validation_image"></div></div>',
        dankort_acq_rw                : '<div class="row <%-name%>"><input type="checkbox" id="<%-name%>" name="<%-name%>" value="true" class="toggle_checkbox" /><label for="<%-name%>"><span class="text" data-no="<%-t("lightbox_no_button")%>" data-yes="<%-t("lightbox_yes_button")%>"></span><%= t("dankort_acq_text")%></label></div>',
        ticket_premium_account_id_rw  : '<div class="row <%-name%>"><div class="pmf-icon">&#xe602;</div><input autocomplete="off" type="text" maxlength="16" id="<%-name%>" name="<%-name%>" placeholder="<%-label%>" title="<%-label%>" value="<%-value%>"><div id="<%-name%>_validation" class="validation_image"></div></div>',
        ticket_premium_account_id_ro  : '<div class="row readOnly <%-name%>"><div id="<%-name%>_read_only_image" class="readOnlyImage"></div><div id="<%-name%>_read_only_text" class="readOnlyText"><%-"* "+ value.substr(-4) %></div></div>',
        iban_rw                       : '<div class="row <%-name%>"><div class="pmf-icon">&#xe601;</div><input autocomplete="off" type="text" maxlength="70" id="<%-name%>" name="<%-name%>" placeholder="<%-label%>" title="<%-label%>" value="<%-value%>"><div id="<%-name%>_validation" class="validation_image"></div></div>',
        iban_ro                       : '<div class="row readOnly <%-name%>"><div id="sepa_iban_read_only_image" class="readOnlyImage"></div><div id="<%-name%>_read_only_text" class="readOnlyText"><%-value%></div></div>',
        pix_bankId_ro                 : '<% var displayVal = ((dropDownOptions || [])[0] || {}).text || ""; %><div class="row readOnly <%-name%>"><div id="cc_name_on_card_read_only_image" class="readOnlyImage"></div><div id="<%-name%>_read_only_text" class="readOnlyText"><%-displayVal%></div></div>',
        molpay_buyer_name_rw          : '<div class="row <%-name%>"><div class="pmf-icon">&#xe602;</div><input autocomplete="off" type="text"  id="<%-name%>" name="<%-name%>" placeholder="<%-t(name)%>" title="<%-t(name)%>" maxlength="70" value="<%-value%>"><div id="<%-name%>_validation" class="validation_image"></div></div>',
        molpay_buyer_email_rw         : '<div class="row <%-name%>"><div class="pmf-icon">&#xe605;</div><input autocomplete="off" type="email" id="<%-name%>" name="<%-name%>" placeholder="<%-t(name)%>" title="<%-t(name)%>" maxlength="100" value="<%-value%>"><div id="<%-name%>_validation" class="validation_image"></div></div>',
        molpay_buyer_mobile_rw        : '<div class="row <%-name%>"><div class="pmf-icon">&#xe602;</div><input autocomplete="off" type="tel"   id="<%-name%>" name="<%-name%>" placeholder="<%-t(name)%>" title="<%-t(name)%>" maxlength="16" value="<%-value%>"><div id="<%-name%>_validation" class="validation_image"></div></div>',
        debit_type_rw                 : '<% var opt = {lbl_class:"focusedInput", val: 1, data: [{"value":1, "text":"regular"}]}, mni = app.config.max_num_installments; if(app.config.allow_installments &&  mni > 1){ opt.data.push({"value":2, "text":"installments"});} if(app.config.allow_special_debit &&  mni > 1){ opt.data.push({"value":3, "text":"special_debit"});} %> ' + app.CONSTANTS.DEFAULT_SELECT_TPL ,
        installment_program_rw        : '<% var opt = {lbl_class:"focusedInput", val: 0, data: [{"value":0, "text":"STANDARD"}].concat(app.config.installmentConfig.programs)}; %> ' + app.CONSTANTS.DEFAULT_SELECT_TPL ,
        number_of_installments_rw     : '<% var opt = {lbl_class:"focusedInput", val: 1, data: [{"value":1, "text":"1"}]}; %> ' + app.CONSTANTS.DEFAULT_SELECT_TPL ,
        muchBetter_mobilePhone_rw     : '<% var opt = {suffix_maxlength: 15, phoneCodes: app.util.getMuchBetterPhoneCodes(app.phoneCodes)};%>' + app.CONSTANTS.COMPOSITE_PHONE_NUMBER_TPL,
        muchBetter_mobilePhone_ro     : '<div class="row readOnly <%-name%>"><div id="cc_name_on_card_read_only_image" class="readOnlyImage"></div><div id="<%-name%>_read_only_text" class="readOnlyText"><%-value.replace("-","")%></div><div id="<%-name%>_validation" class="validation_image"></div></div>',
        bancomatPay_mobileNumber_rw   : '<% var phoneCodes = app.util.getFilteredPhoneCodes(app.phoneCodes); var countryCode = app.util.getCountryPhoneCode(phoneCodes, "IT"); var opt = {suffix_maxlength: 15, phoneCodes: phoneCodes, phoneCode: countryCode}; if (opt.phoneCodes.length === 2 && !opt.phoneCodes[0].phoneCode && (!value || !value.includes("-"))) { opt.phoneCodes.shift(); } %>' + app.CONSTANTS.COMPOSITE_PHONE_NUMBER_TPL,
        bancomatPay_mobileNumber_ro   : '<div class="row readOnly <%-name%>"><div id="cc_name_on_card_read_only_image" class="readOnlyImage"></div><div id="<%-name%>_read_only_text" class="readOnlyText"><%-"+"+ value.replace("-"," ")%></div><div id="<%-name%>_validation" class="validation_image"></div></div>',
        giropay_bic_rw 				  : '<div class="row <%-name%>"><div class="pmf-icon">&#xe800;</div><input autocomplete="off" type="tel"   maxlength="11" id="<%-name%>" name="<%-name%>" placeholder="<%-t(name)%>" title="<%-label%>"   value="<%-value%>" ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        tel_with_customizable_icon_rw : '<div class="row <%-name%>"><div class="pmf-icon">        </div><input autocomplete="off" type="tel"   maxlength="50" id="<%-name%>" name="<%-name%>" placeholder="<%-t(name)%>" title="<%-label%>"   value="<%-value%>" ><div id="<%-name%>_validation" class="validation_image"></div></div>',

        paynearme_returnUrl_ro        : '<%if(value){%><div class="row <%-name%>"><span class="info"> <%-t("paynearme_upo_redirect_hint")%></span></div><div class="row <%-name%>"><span id="<%-name%>" class="btn <%-name%>" onclick="app.util.openPmInFrameOrPopup(\'<%=value%>\')"><%-t(name)%></span></div><%}%>',

        default_rw                    : default_rw,
        default_ro                    : '<div class="row readOnly <%-name%>"><div id="cc_name_on_card_read_only_image" class="readOnlyImage"></div><div id="<%-name%>_read_only_text" class="readOnlyText"><%-value%></div></div>',
        default_select_rw        	  : '<% var opt = {lbl_class:"focusedInput", val: value, lbl_txt: label, data: dropDownOptions};     					%> ' + app.CONSTANTS.DEFAULT_SELECT_TPL,
        default_select_ro        	  : '<% var opt = {lbl_class:"focusedInput", val: value, lbl_txt: label, data: dropDownOptions, disabled:"disabled"};	%> ' + app.CONSTANTS.DEFAULT_SELECT_TPL,
        default_radio_rw              : '<% var opt = {lbl_txt: t(name),         val: value,                 data: dropDownOptions};                        %> ' + app.CONSTANTS.RADIO_BTN_FIELD_TPL,
        default_radio_ro              : '<% var valueText = (_.find(dropDownOptions, function(option) {return option.value === value;}) || {}).text || value; %><div class="row readOnly <%-name%>"><div id="cc_name_on_card_read_only_image" class="readOnlyImage"></div><div id="<%-name%>_read_only_text" class="readOnlyText"><%-valueText%></div></div>',

        echeck_account_type_rw        : '<% var opt = {lbl_class:"focusedInput", val: app.config.pmSettings.apmgw_eCheck.accountTypes[0].value, data: app.config.pmSettings.apmgw_eCheck.accountTypes};%> ' + app.CONSTANTS.DEFAULT_SELECT_TPL ,
        echeck_country_rw             : '<% var opt = {lbl_class:"focusedInput", val: app.config.pmSettings.apmgw_eCheck.countries[0].value, data: app.config.pmSettings.apmgw_eCheck.countries};%> ' + app.CONSTANTS.DEFAULT_SELECT_TPL ,
        saltarpay_country_rw          : '<% var opt = {lbl_class:"focusedInput", val: value, data: app.util.remapPropsAs({"iso" : "value", "name" : "text"}, app.allCountries)};%> ' + app.CONSTANTS.DEFAULT_SELECT_TPL,
        netbanking_bankCode_rw        : '<% var opt = {lbl_class:"focusedInput", val: value, data: dropDownOptions};     					%> ' + app.CONSTANTS.DEFAULT_SELECT_TPL,
        netbanking_bankCode_ro        : '<% var opt = {lbl_class:"focusedInput", val: value, data: dropDownOptions, disabled:"disabled"};	%> ' + app.CONSTANTS.DEFAULT_SELECT_TPL,

        echeck_state_rw               : '<% var states = [{value: "", text: "select_state"}].concat(app._countryStates["CA"]); var opt = {lbl_class:"focusedInput", val: (value || app.config.user.state || states[0].value), data: states};%> ' + app.CONSTANTS.DEFAULT_SELECT_TPL,

        coindirect_crypto_address_ro  : '<div class="row readOnly <%-name%>"><div id="<%-name%>_read_only_image" class="readOnlyImage"></div><div id="<%-name%>_read_only_text" class="readOnlyText"><% var displayValue = value; if (value && value.length > 30) {displayValue = value.substr(0, 6) + "..." + value.substr(value.length - 6)} %><%-displayValue%></div></div>',

        date_picker_rw                : '<div class="row datePicker <%-name%>"><div class="pmf-icon"></div><input autocomplete="off" type="date" id="<%-name%>" name="<%-name%>" placeholder="<%-t(name)%>" title="<%-t(name)%>" value="<%-value%>" ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        date_picker_ro                : '<div class="row datePicker disabled <%-name%>"><div class="pmf-icon"></div><input autocomplete="off" type="date" id="<%-name%>" name="<%-name%> disabled" placeholder="<%-t(name)%>" title="<%-t(name)%>" value="<%-value%>" ><div id="<%-name%>_validation" class="validation_image"></div></div>',
        konbini_store_rw              : '<% var opt = {lbl_txt: t("store_select"), val: value, data: dropDownOptions, logoPath: app.config.pmSettings[app.CONSTANTS.PM_NAME.KONBINI].logoPath}; %>' + app.CONSTANTS.RADIO_LIST_WITH_IMGS_TPL,
        default_hidden                : '<div class="row_hidden hidden <%-name%>"><input type="hidden" id="<%-name%>" name="<%-name%>" value="<%-value%>" /></div>'
    };

    // rw === ro
    UPMTemplates.vcoCallId_rw = UPMTemplates.vcoCallId_ro;
    UPMTemplates.cardArtsUrl_rw = UPMTemplates.cardArtsUrl_ro;
    UPMTemplates.trustly_di_info_rw = UPMTemplates.trustly_di_info_ro;
    UPMTemplates.pwmb_providerName_rw = UPMTemplates.pwmb_providerName_ro;
    UPMTemplates.paynearme_returnUrl_rw = UPMTemplates.paynearme_returnUrl_ro;
    UPMTemplates.oktocash_terms_rw = UPMTemplates.oktocash_terms_ro;

    // Email
    UPMTemplates.saltarpay_email_rw =  UPMTemplates.payer_email_rw;
    UPMTemplates.wd_mb_email_rw = UPMTemplates.payer_email_rw;
    UPMTemplates.expresscheckout_account_id_rw = UPMTemplates.payer_email_rw;
    UPMTemplates.interac_eTransfer_email_rw = UPMTemplates.payer_email_rw;
    UPMTemplates.interac_Combined_email_rw = UPMTemplates.payer_email_rw;
    UPMTemplates.verification_email_rw = UPMTemplates.payer_email_rw;
    UPMTemplates.pay4fun_account_email = UPMTemplates.payer_email_rw;
    UPMTemplates.paymentasia_email_rw = UPMTemplates.payer_email_rw;

    // card_number
    UPMTemplates.astro_pay_prepaid_cc_card_number_rw = UPMTemplates.cc_card_number_rw;
    UPMTemplates.astro_pay_prepaidBF_cc_card_number_rw = UPMTemplates.cc_card_number_rw;

    // expiration_period
    UPMTemplates.astro_pay_prepaid_expiration_period_ro = UPMTemplates.expiration_period_ro;
    UPMTemplates.astro_pay_prepaidBF_expiration_period_ro = UPMTemplates.expiration_period_ro;
    UPMTemplates.astro_pay_prepaidBF_expiration_period_rw = UPMTemplates.astro_pay_prepaid_expiration_period_rw;

    // CVV
    UPMTemplates.astro_pay_prepaidBF_cc_cvv2_rw = UPMTemplates.astro_pay_prepaid_cc_cvv2_rw;

    // Composite Phone:
    UPMTemplates.mbWay_mobilePhone_ro = UPMTemplates.muchBetter_mobilePhone_ro;
    UPMTemplates.mbWay_mobilePhone_rw = UPMTemplates.muchBetter_mobilePhone_rw;

    // Phone
    UPMTemplates.blik_code_rw = UPMTemplates.tel_with_customizable_icon_rw;
    UPMTemplates.elementpay_userPhone_rw = UPMTemplates.molpay_buyer_mobile_rw;
    UPMTemplates.interac_Combined_mobilePhone_rw = UPMTemplates.molpay_buyer_mobile_rw;
    UPMTemplates.paymentasia_phone_rw = UPMTemplates.molpay_buyer_mobile_rw;
    UPMTemplates.codi_phone_number_rw = UPMTemplates.molpay_buyer_mobile_rw;

    // Date picker
    UPMTemplates.mazooma_dob_rw = UPMTemplates.date_picker_rw;
    UPMTemplates.mazooma_dob_ro = UPMTemplates.date_picker_ro;

    // Other
    UPMTemplates.ibtAccountType_ro = UPMTemplates.mazoomaFiAcc_ro;
    UPMTemplates.ibtBankName_ro = UPMTemplates.mazoomaFiName_ro;
    UPMTemplates.pbaIban_ro = UPMTemplates.iban_ro;

    // Radio
    UPMTemplates.interac_deposit_flow_type_rw = UPMTemplates.default_radio_rw;
    UPMTemplates.interac_deposit_flow_type_ro = UPMTemplates.default_radio_ro;

    // Hidden
    UPMTemplates.myBank_bank_name_rw = UPMTemplates.default_hidden;

    var $custom_fld_tpl,  tpl_txt;
    var hashKey = tplName + '_' + view_type;
    $custom_fld_tpl = $('#upm_fld_' + hashKey);

    if ($custom_fld_tpl.length) {
        tpl_txt = $custom_fld_tpl.text();
    } else if (UPMTemplates.hasOwnProperty(hashKey)) {
        tpl_txt = UPMTemplates[hashKey];
    } else if (tplName && tplName.endsWith('expiration_period')) {
        tpl_txt = UPMTemplates['expiration_period_rw'];
    } else if (fldType === 'select') {
        tpl_txt = UPMTemplates['default_select_' + view_type];
    } else {
        tpl_txt = UPMTemplates['default_' + view_type];
    }

    return _.template(tpl_txt);
};
/** apmgw_PayNearMe
 * open a link with no ref to it */
app.util.openPmInFrameOrPopup = function (url) {
    if (app.config.openPmInFrame && (app.config.openPmInFrame[app._deviceType][app.lastSelectedMethodType] || app.config.openPmInFrame[app._deviceType]["ALL"])) {
        app.util.showPmRedirectIframe(url, app.lastSelectedMethodType);
    } else {
        app.util.createPopupWindow(app.lastSelectedMethodType, url, 'pop_up_window_' + Date.now());
    }
};

app.util.removeBaseValidationRules = function (data) {
    _.each(data, function (v, k) {
        if (v && v === "autoGeneratedRulesAdded") {
            delete app.validators[k];
            delete app._autoGeneratedValidationRules[k];
        }
    });
};

app.util.createBaseValidationRules = function (data) {
    var rules = {};
    _.each(data, function (item) {
        if (item && item.name
            && !app.validators[item.name]
            && (item.inputType || '').toUpperCase() !== "BUTTON"
            && (item.visibilityMode == "REQUIRED" || item.visibilityMode == "OPTIONAL")
        ) {
            app.validators[item.name] = {checks: utils.generateFieldValidationRules(item)};
            rules[item.name] = "autoGeneratedRulesAdded";
            if (item.visibilityMode === "OPTIONAL") {
                app.util.setAsOptionalFld(item.name);
            } else {
                app.util.unsetAsOptionalFld(item.name);
            }
        }
    });
    app._autoGeneratedValidationRules = $.extend(true, {}, app._autoGeneratedValidationRules, rules);
    return rules;
};

app.util.clearDOM = function () {
    $('.PMINFO').empty();
    app.util.onPreRenderClearDOM();
    app.util.handleFee({});
    pubsub.publish('billingDetailsRenderer.clearDom', [{action: 'clearDom'}]);
    app.suggestPointsPlugin && app.suggestPointsPlugin.setData([]);
    app.util.renderOtherDetails(null, []);
};

app.util.getOnRegisterClickHandler = function (pmName, fields, autoGeneratedRules, submitUrl) {
    return function _onContinue(e) {
        if (app.util.validateEvery(app['_registrationScreenFieldsForValidation'])) {
            var url = submitUrl || "/ppp/registerUser.do";
            var dataToSend = {userDetails: utils.collectRegistrationData(fields)};
            dataToSend.ssid = app.config.ssid;
            dataToSend.msid = app.config.msid;
            dataToSend.workflowType = 'DEPOSIT';
            dataToSend.paymentMethod = pmName;
            dataToSend.uniqueId = app.lastSelectedMethodId;
            if (app.currentMethodFields.globalpay_accountId) {
                dataToSend.userDetails.globalpay_accountId = app.currentMethodFields.globalpay_accountId.value;
            }
            app.util.closeLightbox();
            $.blockUI();

            $.ajax({
                type: "POST",
                url: utils.addQueryStringParams(url, {"ssid": app.config.ssid}),
                data: JSON.stringify(dataToSend),
                contentType: 'application/json',
                dataType: 'json',
                timeout: 10000
            }).done(function (_pmExtraData) {
                var pmExtraData = utils.formatExtraDetails(_pmExtraData);
                return app.util.onRegistrationComplete(pmExtraData, autoGeneratedRules);
            }).fail(function (er) {
                $.unblockUI();
                app.showFinalMessage(app.msg.session_expired);
            });
        }
    };
};

app.util.getOnCancelRegisterClickHandler = function (pmName, autoGeneratedRules, initiator) {
    function _doNothing(e) {
        // DO Nothing
    }
    function _onCancel(e) {
        app.reduceCustomValidationFieldsBy(app['_registrationScreenFieldsForValidation']);
        delete app['_registrationScreenFieldsForValidation'];
        app.util.removeBaseValidationRules(autoGeneratedRules);
    }

    return initiator === 'add_bank_account' ? _onCancel : _doNothing;
};

app.util.onRegistrationComplete = function (pmExtraData, autoGeneratedRules) {
    $.unblockUI();
    app.reduceCustomValidationFieldsBy(app['_registrationScreenFieldsForValidation']);
    delete app['_registrationScreenFieldsForValidation'];
    app.util.removeBaseValidationRules(autoGeneratedRules);
    if (pmExtraData && pmExtraData.uniqueId === app.lastSelectedMethodId) {
        if (pmExtraData.status === "OK" && pmExtraData.paymentDetails) {
            // render new extraDetails
            var isUpo = pmExtraData.paymentMethodName !== pmExtraData.uniqueId;
            var data = app.lastSelectedMethodData || (isUpo ? app._upoList[app.lastSelectedMethodId] : app._poList[app.lastSelectedMethodType]) || {};
            var element = {
                rawData: data,
                name: app.lastSelectedMethodType,
                uniqueId: app.lastSelectedMethodId,
                isIframe: data.attributes && data.attributes.isIframe
            };
            if (isUpo) {
                var upoData = app._pmFields[pmExtraData.uniqueId] || {};
                element.isIframe = upoData.isIframe;
                return app.util.processSelectedUpm(data, upoData, pmExtraData, element);
            } else {
                return app.util.processSelectedPm(data, pmExtraData, element);
            }

        } else if (pmExtraData.status === "FAIL" /*&& pmExtraData.message*/) {
            return app.showModalMessage({message: {text: pmExtraData.message}}, app.CONSTANTS.MODAL_MESSAGE_TYPE.ERROR);
        } else if(pmExtraData.status === "OK" && pmExtraData.command === "redirect" && pmExtraData.redirectUrl){
            app.util.showPmRedirectIframe(pmExtraData.redirectUrl, pmExtraData.paymentMethodName);
            return app.util.rejectedPromise(pmExtraData);
        }
    }
    return app.util.rejectedPromise('flowInterrupted');
};

app.util.showPmRedirectIframe = function (redirectUrl, pmName) {
    if (redirectUrl) {
        var pm_class = ('lbx_' + pmName).toLowerCase();
        var titleForPm = {
            'apmgw_PayNearMe': 'paynearme_pm_redirect_iframe_title'
        };
        var title = titleForPm[pmName] || 'pm_redirect_iframe_title';

        var payload = {
            message: {
                titleKey: title,
                url: redirectUrl,
                pm_class: pmName,
                closeable: 1
            }
        };
        app.showModalMessage(payload, 'pm_redirect_iframe', null, null, pm_class + " pm_redirect");
    }
};

app.util.createPopupWindow = function (pmName, url, popupName) {
    url || (url = "");
    popupName || (popupName = 'pppApmWindow_' + (new Date()).getTime());
    var max = {
        apmgw_Alipay: 1,
        apmgw_AlipayHK: 1,
        apmgw_Dana: 1,
        apmgw_iDeal: 1,
        apmgw_GCash: 1,
        apmgw_KaKaoPay: 1,
        apmgw_Truemoney: 1,
        apmgw_TouchnGo: 1
    };
    var cfg = {
        apmgw_BanContact        : {w: 800, h: 790},
        apmgw_eCheckSelect      : {w: 800, h: 700},
        apmgw_eCheckSelect_DOB  : {w: 800, h: 700},
        apmgw_iDebit            : {w: 1230, h: 880},
        apmgw_INTERAC_Instant   : {w: 800, h: 800},
        apmgw_PostFinance_Pay   : {w: 800, h: 800},
        apmgw_Trustly_DI        : {w: 600, h: 600},
        default                 : {w: 800, h: 600}
    };
    var w = max[pmName] && screen.availWidth || (cfg[pmName] || cfg.default).w;
    var h = max[pmName] && screen.availHeight || (cfg[pmName] || cfg.default).h;
    var left = (screen.width / 2) - (w / 2);
    var top = (screen.height / 2) - (h / 2);
    var opts = 'height=' + h + ',width=' + w + ',top=' + top + ',left=' + left
        + ',toolbar=yes,location=no,directories=no,status=no,menubar=no,linemenubar=no,scrollbars=yes,resizable=yes,modal=yes';
    return window.open(url, popupName, opts);
};

app.util.onAddAccountClicked = function (btn) {
    var submitUrl = $(btn).data('action') || "/ppp/registerUser.do";
    utils.getFieldsForAddingBankAccount(app.lastSelectedMethodType, app.lastSelectedMethodId).then(
        function (data) {
            var payload = utils.getAddAccountScreenPayload(data);
            var lbxClasses = 'deposit_confirmations registration';
            var initiator = 'add_bank_account';
            app.util.showModalScreenWithFields(data, payload, lbxClasses, submitUrl, initiator);
        });
};

/**
 *
 * @param data = {paymentMethodName, fields}
 * @param payload = {titleKey, header, msgArr: [], confirmBtn: {isVisible,txt}, cancelBtn: {isVisible,txt}}
 */
app.util.showModalScreenWithFields = function (data, payload, lbxClasses, submitUrl, initiator) {
    var fldNamesArr, autoGeneratedRules, _onContinue, _onCancel;
    var pmName = data && data.paymentMethodName;
    if (pmName !== app.lastSelectedMethodType) {
        return;
    }
    app.reduceCustomValidationFieldsBy(app['_registrationScreenFieldsForValidation']);
    fldNamesArr = _.keys(data && data.fields);
    if(!fldNamesArr.length){
        delete app['_registrationScreenFieldsForValidation'];
        console.log("ERROR! There is no data on how to register with the current PM!");
        return;
    }
    app['_registrationScreenFieldsForValidation'] = fldNamesArr;
    autoGeneratedRules = app.util.createBaseValidationRules(data.fields);

    lbxClasses = (lbxClasses || '') + (' lbx_' + pmName).toLowerCase();
    _onContinue = app.util.getOnRegisterClickHandler(pmName, data.fields, autoGeneratedRules, submitUrl);
    _onCancel = app.util.getOnCancelRegisterClickHandler(pmName, autoGeneratedRules, initiator);

    app.showModalMessage({details: payload}, 'confirm', _onContinue, _onCancel, lbxClasses);
    app.addCustomValidationFields(app['_registrationScreenFieldsForValidation']);
    app.applycSelectPlugin();
}

app.util.showRegistrationScreen = function (data) {
    var pmName = app.lastSelectedMethodType;
    if (_.isEmpty(data) || pmName !== data.paymentMethodName) {
        return;
    }
    /**  Prevent submit before Enrollment is done */
    app.continueButtonHandler = function () {
        app.util.showRegistrationScreen(data);
    };
    $("#continueButton").off().on("click", app.continueButtonHandler);

    app.util.clearDOM();
    app.currentMethodFields = $.extend(true, {}, data.fields);
    app.current_pm_feeObj = $.extend(true, {}, (data.fee || {}));
    app.util.showPaymentMethodHint(pmName, app.config.pmHintConfig.containerSelector);
    $('#payment_method').val(pmName);

    var userName = (app.user.firstName || '') + " " + (app.user.lastName || '');
    var payload = utils.getRegistrationScreenPayload(data, userName);
    var lbxClasses = 'deposit_confirmations registration';
    var submitUrl = "/ppp/registerUser.do";
    var initiator = "register_user";
    app.util.showModalScreenWithFields(data, payload, lbxClasses, submitUrl, initiator);
    app.util.onPMSelectedHandleBodyClasses(true);
    pubsub.publish('app.event.registrationScreenShown', [data, {isWD: false}]);
};

app.util.normalizeAmountLimitsUpTo = function (amountLimits, maxAmount) {
    var ret = amountLimits, max = parseFloat(maxAmount);
    if (_.isObject(amountLimits) && !isNaN(max)) {
        ret = $.extend(true, {}, amountLimits);
        ret.maxValue = Math.min(amountLimits.maxValue || 0, max);
        ret.minValue = Math.min(amountLimits.minValue || 0, max);
    }
    return ret;
};

app.util.extendWithLimits = function (data, limitsObj) {
    if (data && _.isObject(data) && !_.isEmpty(limitsObj)) {
        data.amountLimits = limitsObj.amountLimits && $.extend(true, {}, limitsObj.amountLimits);
        data.pricePoints = limitsObj.pricePoints && $.extend(true, [], limitsObj.pricePoints);
        data.suggestedAmounts = limitsObj.suggestedAmounts && $.extend(true, [], limitsObj.suggestedAmounts);
    }
    return data;
};

app.util.extendPmDataWithExtraData = function (data, extraData, pmUniqueId) {
    var def = new $.Deferred();
    var isUpo;

    if (extraData && extraData.uniqueId === app.lastSelectedMethodId) {
        if (extraData.blockers) {
            isUpo = app.util.isUpo(pmUniqueId);
            data.blockers = jQuery.extend(true, data.blockers || {}, extraData.blockers);

            if (isUpo && app._upoList[pmUniqueId]) {
                app._upoList[pmUniqueId].blockers = $.extend(true, app._upoList[pmUniqueId].blockers || {}, data.blockers);
            } else if (!isUpo && app._poList[pmUniqueId]) {
                app._poList[pmUniqueId].blockers = $.extend(true, app._poList[pmUniqueId].blockers || {}, data.blockers);
            }
        }

        if (extraData.paymentDetails) {
            data._extraData = extraData.paymentDetails;
            data._maxAmount = extraData.limits && extraData.limits.maxAmount && parseFloat(extraData.limits.maxAmount) || false;
            data.amountLimits = app.util.normalizeAmountLimitsUpTo(data.amountLimits || app.defaultLimits, data._maxAmount);
        }
    }
    if (pmUniqueId !== app.lastSelectedMethodId) {
        def.reject('flowInterrupted');
    } else {
        def.resolve(data);
    }
    return def.promise();
};

app.util.rejectedPromise = function (error) {
    return (new $.Deferred()).reject(error).promise();
};

app.util.processSrvLimitsAndFees = function (data, limitsAndFees) {
    if (app.config_getSrvFeesAndLimits) {
        if (limitsAndFees) {
            if (limitsAndFees[app.CONSTANTS.SRV_RESPONSE.PROP_CUSTOM_FEES]) {
                data.fee = limitsAndFees[app.CONSTANTS.SRV_RESPONSE.PROP_CUSTOM_FEES];
            }
            if (!app.ptRequestId) {
                var limits = app.util.normalizeAmountLimitsUpTo(limitsAndFees['limits'], data._maxAmount);
                app.util.updatePMLimits(limits, limitsAndFees['payment_method'], limitsAndFees['currency']);
            }
        }
        if (!app.ptRequestId && app.pmLimits[app.lastSelectedMethodType]) {
            app.util.extendWithLimits(data, app.pmLimits[app.lastSelectedMethodType]);
        }
    }
    return data;
};

app.util.getPmExtraDetails = function (pmName, params, data, element) {
    if(pmName === app.lastSelectedMethodId) {
        var isWD = false;
        var extra_data_cfg = app.CONSTANTS.PM_EXTRA_DATA_URL[pmName] || {};
        var url = extra_data_cfg.url;
        params = params || extra_data_cfg.params || {};
        params.uniqueId = pmName;
        if (pmName === app.CONSTANTS.PM_NAME.PLAY_PLUS && app.config.pmSettings[app.CONSTANTS.PM_NAME.PLAY_PLUS].autoCheckBalance) {
            params.checkBalance = "true";
        }

        data = data || app.lastSelectedMethodData || app._poList[app.lastSelectedMethodType] || {};
        element = element || {
            rawData: data,
            name: app.lastSelectedMethodType,
            uniqueId: app.lastSelectedMethodId,
            isIframe: data.attributes && data.attributes.isIframe
        };

        return utils.getPmExtraDetails(pmName, url, isWD, params)
            .then(function (_pmExtraData) {
                var pmExtraData = utils.formatExtraDetails(_pmExtraData);
                return app.util.processSelectedPm(data, pmExtraData, element);
            });
    }
};

app.util.getUpmExtraDetails = function (userPaymentOptionId, params, data, upoData, element) {
    if (userPaymentOptionId === app.lastSelectedMethodId) {
        upoData = upoData || app._pmFields[userPaymentOptionId] || {};

        var isWD = false;
        var pmName = app.lastSelectedMethodType;
        var extra_data_cfg = app.CONSTANTS.PM_EXTRA_DATA_URL[pmName] || {};
        var url = ((upoData && upoData['treatItLikePm'] && extra_data_cfg) || {}).url;
        params = params || extra_data_cfg.params || {};
        params.uniqueId = userPaymentOptionId;
        if (pmName === app.CONSTANTS.PM_NAME.PLAY_PLUS && app.config.pmSettings[app.CONSTANTS.PM_NAME.PLAY_PLUS].autoCheckBalance) {
            params.checkBalance = "true";
        }

        data = data || app.lastSelectedMethodData || app._upoList[app.lastSelectedMethodId] || {};
        element = element || {
            rawData: data,
            name: app.lastSelectedMethodType,
            uniqueId: app.lastSelectedMethodId,
            isIframe: data.attributes && data.attributes.isIframe
        };
        return utils.getPmExtraDetails(pmName, url, isWD, params)
            .then(function (_pmExtraData) {
                var pmExtraData = utils.formatExtraDetails(_pmExtraData);
                return pmExtraData;
            })
            .then(function (pmExtraData) {
                return app.util.processSelectedUpm(data, upoData, pmExtraData, element);
            });
    }
};

app.util.getUpmDetails = function (userPaymentOptionId, data, element) {

    return app.getUPODetails(data.userPaymentOptionId)
        .then(function (_upoData) {
            var upoData = _.isFunction(app.config.customSelectUpoModifier) ? app.config.customSelectUpoModifier(_upoData) : _upoData;
            app._pmFields[data.userPaymentOptionId] = upoData;
            return upoData;
        })
        .then(function (upoData) {
            return app.util.getUpmExtraDetails(userPaymentOptionId, null, data, upoData, element);
        });

};

app.util.onProcessSelectedPmError = function (uniqueId) {
    return function (er) {
        if (er && er.uniqueId === uniqueId && uniqueId === app.lastSelectedMethodId) {
            if (er.command === "registerUser") {
                return utils.registerUser(uniqueId, app.lastSelectedMethodType).then(function () {
                    pubsub.publish('app.event.registerUser.start', []);
                });
            } else if (er.command === "displayErrorMessage" && er.message) {
                app.util.clearDOM();
                app.currentMethodFields = {blocked_method: {type: 'REQUIRED'}};
                $("#continueButton").off();
                app.showModalMessage({message: {text: er.message, titleKey: 'lightbox_title_request_failed'}}, app.CONSTANTS.MODAL_MESSAGE_TYPE.ERROR, _.identity, _.identity, 'lbx_request_failed');
            } else if (er.command === "redirect" && er.redirectUrl) {
                app.util.showPmRedirectIframe(er.redirectUrl, app.lastSelectedMethodType);
            }
            // else if (er != 'flowInterrupted') { console.log("SHOULDN'T be here!", er);}
        }
    };
};

app.util.processSelectedPm = function (data, pmExtraData, element) {
    return utils.confirmNoRegistrationNeeded(data, pmExtraData, element.uniqueId)
        .then(function (d0) {
            return app.util.extendPmDataWithExtraData(data, pmExtraData, element.uniqueId);
        })
        .then(function (d1) {
            return app.config_getSrvFeesAndLimits && app.util.getCustomLimitsAndFees();
        })
        .then(function (limitsAndFees) {
            app.util.processSrvLimitsAndFees(data, limitsAndFees);
            return data;
        })
        .then(function (d2) {
            if (app.lastSelectedMethodId === element.uniqueId) {
                app.applyRestrictions(data);
                app.updateUIWithPoData(element, data);
            }
        })
        .fail(app.util.onProcessSelectedPmError(element.uniqueId));
};

app.util.processSelectedUpm = function (data, upoData, pmExtraData, element) {
    return utils.confirmNoRegistrationNeeded(upoData, pmExtraData, element.uniqueId)
        .then(function (d0) {
            app.util.extendWithLimits(upoData, data);
            return app.util.extendPmDataWithExtraData(upoData, pmExtraData, element.uniqueId);
        })
        .then(function (ud1) {
            return app.config_getSrvFeesAndLimits && app.util.getCustomLimitsAndFees();
        })
        .then(function (limitsAndFees) {
            if (app.config_getSrvFeesAndLimits && !_.isEmpty(limitsAndFees)) {
                app.util.processSrvLimitsAndFees(upoData, limitsAndFees);
            }
            return upoData;
        })
        .then(function (ud2) {
            if (app.lastSelectedMethodId === element.uniqueId) {
                app.applyRestrictions(upoData);
                app.updateUIWithUpoData(upoData, data.userPaymentOptionId, data);
            }
        })
        .fail(app.util.onProcessSelectedPmError(element.uniqueId));
};

app.util.onPMSelectedClearState = function () {
	app.bodyElm.removeClass('use_masked_amount');
    app.util.onPreRenderClearDOM();
    $('#continueButton').off();
    app.clearCustomValidationFields();
    app.util.removeBaseValidationRules(app._autoGeneratedValidationRules);
    app._validationResult = {};
    delete app['_registrationScreenFieldsForValidation'];
    app.util.resetTmpDisabledFields();
    app.util.resetPmFieldValidations(app.lastSelectedMethodType);
};

app.util.onPMSelectedHandleBodyClasses = function (isPostRender) {
    var classes = {
        toAdd: '',
        toRemove: '',
    };
    /**
     * fbt_like_pm  -> no amount
     * static_pm    -> no amount & no deposit btn
     * */
    classes[(isPostRender ? 'toRemove' : 'toAdd')] += ' changing';
    classes[(app.util.isFbtLikePm(app.lastSelectedMethodType) ? 'toAdd' : 'toRemove')] += ' fbt_like_pm';
    classes[(app.util.isStaticPm(app.lastSelectedMethodId, app.lastSelectedMethodType) ? 'toAdd' : 'toRemove')] += ' static_pm';

    app.bodyElm.removeClass(classes.toRemove).addClass(classes.toAdd);

    if (!app.config.isOpenAmount &&
            app.config.fbtLikePMsVisibleFixedAmount.indexOf(app.lastSelectedMethodType) >= 0) {
        app.bodyElm.removeClass('fbt_like_pm');
    }

    if(!isPostRender){
        app.bodyElm
            .attr('data-last_selected_method_type', app.lastSelectedMethodType)
            .attr('data-is_upo', app.util.isUpo(app.lastSelectedMethodId));
    }
};

app.util.onPMSelectedHandleUseSubpagesFlags = function(selectedMethodId){
    if (app.config.useSubpages) {
        if (app._flag.isReload) {
            app._flag.isReload = false;
            app._flag.setDefaultMethodId = false;
        } else {
            var hash = window.location.hash;
            window.location.hash = app.CONSTANTS.HASH.PM + selectedMethodId;
            if (hash !== window.location.hash && !app._flag.setDefaultMethodId) {
                window.location.hash = app.CONSTANTS.HASH.DETAILS + selectedMethodId;
            }
            app._flag.setDefaultMethodId = false;
        }
    }
};

app.util.doSomePmSpecificTask = function (pmName) {
    if (pmName === app.lastSelectedMethodId) {
        if (pmName === app.CONSTANTS.PM_NAME.PAY_WITH_MY_BANK) {
            utils.pwmb.init(app.config.pmSettings[pmName]);
            utils.pwmb.renderWidget('.PMINFO');
        } else if (pmName === 'apmgw_Venmo') {
            app.util.handleVenmoBtn();
        } else if (app.CONSTANTS.PM_CUSTOM_BTN[pmName]) {
            app.util.generateCustomBtn(app.CONSTANTS.PM_CUSTOM_BTN[pmName]);
        }
    }
};

app.util.doSomeUpmSpecificTask = function (data) {
    if (app.CONSTANTS.PM_NAME.PAY_WITH_MY_BANK === app.lastSelectedMethodType) {
        return app.util.checkForPwmbUpoToken(data);
    } else if (app.CONSTANTS.PM_NAME.GOOGLE_PAY === app.lastSelectedMethodType) {
        data._onContinueTreatItLikePm = app.lastSelectedMethodType;
    } else if ('ppp_ApplePay' === app.lastSelectedMethodType) {
        data._onContinueTreatItLikePm = app.lastSelectedMethodType;
    } else if ('apmgw_BLIK' === app.lastSelectedMethodType) {
        app.util.handleBlikOneClick();
    } else if (app.util.isCustomButtonNeededForUpo(app.CONSTANTS.PM_CUSTOM_BTN[app.lastSelectedMethodType])) {
        app.util.generateCustomBtn(app.CONSTANTS.PM_CUSTOM_BTN[app.lastSelectedMethodType]);
    }
    return data;
};

app.util.checkForPwmbUpoToken = function (data) {
    if (app.CONSTANTS.PM_NAME.PAY_WITH_MY_BANK === app.lastSelectedMethodType) {
        var upoPwmbToken = data && data.pwmb_token && data.pwmb_token.value;
        var upoPwmbPaymentProviderId = data && data.pwmb_providerId && data.pwmb_providerId.value;
        if (!upoPwmbToken) {
            var cfg = app.config.pmSettings[app.CONSTANTS.PM_NAME.PAY_WITH_MY_BANK];
            if (upoPwmbPaymentProviderId && cfg) {
                cfg = $.extend(true, {PayWithMyBankOptions: {}}, cfg);
                // cfg.PayWithMyBankOptions.hideCloseButton = false;
                cfg.PayWithMyBankOptions.hideSelectBankBack = true;
                cfg.paymentProviderId = upoPwmbPaymentProviderId;
            }
            if (cfg) {
                utils.pwmb.init(cfg);
                data._onContinueTreatItLikePm = app.lastSelectedMethodType;
            }
        }
    }
    return data;
};

/** invoked from yacoreng
 * on 'safecharge.PWMB.authorization.ready'
 * */
app.util.onPwmbAuthorizationSuccessDoSubmit = function (data) {
    // console.log('safecharge.PWMB.authorization.ready', data)
    if (app.CONSTANTS.PM_NAME.PAY_WITH_MY_BANK === app.lastSelectedMethodType
        && data
        && data.trxStatus !== 'CANCELLED'
        && data.uniqueId
        && data.uniqueId.toString() === (app.lastSelectedMethodId || '').toString()
        && data.details) {

        app.util.addTmpFormData(data.details);
        $('#inIframeMode').val('true');
        $('#inPopupMode').val('false');
        if (app.config.isRebilling) {
            if (app.validateForm()) {
                app.sub.doSubscribe();
            } else {
                pubsub.publish('submit-attempt-failed', [app.util.getSubmitAttemptFailedData(false)]);
            }
        } else {
            submitInIframe();
        }
    }
};

app.util.scanDetails = (function () {
    // {"cvv": "", "status": "OK", "expDate": “03/26", "source": "scanCard", "cardHolderName": “Some Name", "cardNumber": “4580123412341234”}
    var scanMap = {
        scanQR: {
            source: 'scanQR',
            keysFieldsMap: {
                'qrCode': 'abon_voucherNumber'
            },
            location: 'nuveicashier://scanQR',
            button: {
                translationKey: 'scan_qr_btn',
                buttonClass: 'abon-scan-qr-btn'
            }
        },
        scanCard: {
            source: 'scanCard',
            keysFieldsMap: {
                'cardNumber': 'cc_card_number',
                'expDate': 'cc-exp-date',
                'cardHolderName' : 'cc_name_on_card'
            },
            location: 'nuveicashier://scanCard',
            button: {
                translationKey: 'scan_card_button',
                buttonClass: 'scan-card-btn'
            }
        }
    }

    function _populateFields(map, resultObject) {
        _.each(map.keysFieldsMap, function (field, key) {
            var result = resultObject[key] || '';
            if (field === 'cc-exp-date') {
                var splitResult = result.split('/');
                $('#exp_date').val(result).trigger('setValue');
                $('#cc_exp_month').val(splitResult[0]).trigger('change').trigger('setValue');
                $('#cc_exp_year').val(splitResult[1]).trigger('change').trigger('setValue');
            }
            var $fld = $('#' + field);
            if (field !== 'cc_name_on_card' || !$fld.val() || app.config.allowScanCardToOverrideNameOnCard) {
                $fld.val(result).trigger('change').trigger('focus').trigger('setValue').trigger('paste');
            }
           // $('#' + field).val(result).trigger('change').trigger('focus').trigger('setValue').trigger('paste');
        });
    }

    function _getButtonTemplate() {
        var customTpl = $('#scan-button-template');
        var defaultTpl = '<div class="row"><button class="<%= buttonClass %>"><span class="scan-icon"></span><%- t(translationKey) %></button></div>';
        if (customTpl.length) {
            return _.template(customTpl.text());
        }
        return _.template(defaultTpl);
    }

    function _createAndAttachButton(map) {
        var buttonHtml = _getButtonTemplate()({
            buttonClass: map.button.buttonClass,
            translationKey: map.button.translationKey
        });
        $(app.config.scanCardParent).prepend($(buttonHtml));
    }

    function _handlePostScanEvent() {
        return window.onpopstate = function () {
            var decodedObject = {};
            var codedHash = document.location.hash.substr(1);

            if (codedHash) {
                try {
                    decodedObject = JSON.parse(atob(document.location.hash.substr(1)));
                } catch (error) {
                    console.log(error.message);
                }
            }
            _prefillScannedInformation(decodedObject);
        }
    }

    function _prefillScannedInformation (decodedObject) {
        var isAbon = _.has(decodedObject, 'qrCode');
        var isCard = _.has(decodedObject, 'cardNumber');
        var hasInfo = isAbon || isCard;

        if(isAbon) {
            decodedObject.source = "scanQR";
            decodedObject.status = "OK";
        }
        if (hasInfo) {
            var cbData = decodedObject || {};
            var currentSettings = cbData.source && scanMap[cbData.source];

            if (cbData.status && cbData.status === 'OK') {
                pubsub.publish('app.event.scanedCard', [cbData]);
                _populateFields(currentSettings, cbData);
                app.util.imsAnalytics.createAnalyticsForScanCard(currentSettings, cbData);
                if (isCard) {
                    $('#cc_cvv2').trigger('focus');
                }
            }
        }
    }

    function init(scanType) {
        var scanMapForType = scanMap[scanType];
        _createAndAttachButton(scanMapForType);
        $('.' + scanMapForType.button.buttonClass).click(function(e){
            e.preventDefault();
            pubsub.publish('app.event.scanCardBtnClicked', [{scanType: scanType}]);
            document.location = scanMapForType.location;
        });
        _handlePostScanEvent();
    }

    return {
        init: init
    }
})();

app.util.GooglePay = (function(googlePmName){
    var cfg;
    var CONST = {
        SUBMIT_TIMEOUT: 30000,
        AWAILABILITY_CHECK_TIMEOUT: 600,
        PROXY_CHECK_TIMEOUT: 600,
        SCRIPT_LOAD_TIMEOUT: 11000,
        SCRIPT_STATUS: {
            NOT_LOADED: "NOT_LOADED",
            LOAD_ERROR: "LOAD_ERROR",
            LOAD_SUCCESS: "LOAD_SUCCESS"
        },
        GOOGLE_PAY: (googlePmName || app.CONSTANTS.PM_NAME.GOOGLE_PAY),
        GOOGLE_PAY_URL: "https://pay.google.com/gp/p/js/pay.js"
    };
    var _g = {
        paymentsClient: false,
        deferred: false,
        scriptStatus : CONST.SCRIPT_STATUS.NOT_LOADED,
        loadScriptTimeoutId: false,
        submitFormTimeoutId: false,
        availabilityCheckTimeoutId: false,
        submitFormPromiseResolve: false,
        submitFormPromiseReject: false,
        isReadyToPay: false,
        isPopupShown: false
    };

    var defaults = {
        environment         : 'PRODUCTION',     // "TEST" | “PRODUCTION”,
        apiVersion          : 2,
        apiVersionMinor     : 0,
        tokenizationType    : "PAYMENT_GATEWAY",// "DIRECT" | 'PAYMENT_GATEWAY'
        protocolVersion     : "ECv2",
        // publicKey           : 'xxx',
        gateway             : 'nuveidigital',
        gatewayMerchantId   : 'googletest',
        buttonType          : 'plain',          // 'plain'  | 'buy'     | 'donate'
        buttonColor         : 'black',          // 'black'  | 'white'
        buttonSizeMode      : 'fill',           // 'fill'   | 'static'
        totalPriceStatus    : 'FINAL',
        allowedCardNetworks     : ["AMEX", "DISCOVER", "INTERAC", "JCB", "MASTERCARD", "VISA"],
        allowedCardAuthMethods  : ["PAN_ONLY", "CRYPTOGRAM_3DS"],
        /** optional */
        allowCreditCards        : true,
        allowPrepaidCards       : true,
        assuranceDetailsRequired: false,
        billingAddressRequired  : false,
        billingAddressFormat    : "MIN",
        phoneNumberRequired     : true,
        existingPaymentMethodRequired: false,
        /** nuvei flow */
        useCallbackIntents      : false,
        preDepositCheckUrl      : false
    };
    var GP = {
        NuveiSdkProxy: {
            req_id: Math.round((Math.random() + .1) * 10000)
        }
    };

    GP._logError = function (str) {
        var msg = 'GooglePay ERROR! => ' + str;
        app._logger.log(msg);
        console.error(msg);
    };

    GP._getCfgErrors = function () {
        var props = ["publicKey", "protocolVersion", "merchantName", "merchantId", "totalPriceStatus",
            /* "xxxx.externalId",*/ "allowedCardNetworks", "allowedCardAuthMethods"];
        var errors = [];
        _.each(props, function (prop) {
            var propArr = prop.split('.');
            var val;
            if (propArr.length === 2) {
                val = _.isObject(cfg[propArr[0]]) && cfg[propArr[0]][propArr[1]];
            } else {
                val = cfg[prop];
            }
            if (!val) {
                errors.push(prop);
            }
        });
        return errors;
    };

    GP._clearState = function () {
        clearTimeout(_g.submitFormTimeoutId);
        _g.submitFormTimeoutId = false;
        _g.submitFormPromiseResolve = false;
        _g.submitFormPromiseReject = false;
        _g.paymentInProgress = false;
        _g.isPopupShown = false;
    };

    GP._googlePaymentsApiExists = function () {
        return (window.google && window.google.payments && window.google.payments.api && window.google.payments.api.PaymentsClient);
    };

    GP._loadScript =  function (cb) {
        if (GP._googlePaymentsApiExists()) {
            return cb();
        } else {
            _g.loadScriptTimeoutId = setTimeout(function () {
                _g.deferred.resolve({result: false, msg: "script_load_timeout"});
                _g.scriptStatus = CONST.SCRIPT_STATUS.LOAD_ERROR;
            }, CONST.SCRIPT_LOAD_TIMEOUT);
        }
        return $.getScript(cfg.sdkUrl || CONST.GOOGLE_PAY_URL, cb);
    };

    GP._getGooglePaymentsClient = function () {
        if (!_g.paymentsClient && GP._googlePaymentsApiExists()) {
            var paymentOptions = {
                environment: cfg.environment
                //, merchantInfo: {merchantId: cfg.merchantId, merchantName: cfg.merchantName, merchantOrigin: cfg.merchantOrigin}
            };
            if (cfg.useCallbackIntents){
                paymentOptions.paymentDataCallbacks = {onPaymentAuthorized: GP._submitFormPromise /*, onPaymentDataChanged: onPaymentDataChanged*/};
            }
            _g.paymentsClient = new google.payments.api.PaymentsClient(paymentOptions);
        }
        return _g.paymentsClient;
    };

    GP._onScriptLoad = function () {
        clearTimeout(_g.loadScriptTimeoutId);
        _g.loadScriptTimeoutId = false;
        _g.scriptStatus = CONST.SCRIPT_STATUS.LOAD_SUCCESS;
        _g.paymentsClient = GP._getGooglePaymentsClient();

        if (!_g.paymentsClient) {
            _g.deferred.resolve({result: false, msg: "no_GooglePaymentsClient"});
            return;
        }

        return _g.paymentsClient.isReadyToPay(GP._createRequestData.forIsReadyToPay())
            .then(function (response) {
                _g.isReadyToPay = response.result;
                _g.deferred.resolve(response);
            })
            .catch(function (err) {
                _g.deferred.resolve({result: false, msg: "Error", err: err});
            });
    };

    GP._createRequestData = (function () {
        function isReadyToPayRequestData() {
            /** !!! A tokenizationSpecification isn't required to determine a viewer's readiness to pay. !!!*/
            var req = _getApiVersionObj();
            req.allowedPaymentMethods = [_getBaseCardPaymentMethod()];
            req.existingPaymentMethodRequired = cfg.existingPaymentMethodRequired;
            return req;
        }

        function paymentRequestData() {
            var _paymentRequest = _getApiVersionObj();
            _paymentRequest.allowedPaymentMethods = [_getCardPaymentMethod()];
            _paymentRequest.transactionInfo = _getTransactionInfo();
            _paymentRequest.merchantInfo = {
                merchantId: cfg.merchantId,
                merchantName: cfg.merchantName,
                merchantOrigin: cfg.merchantOrigin
            };
            if (cfg.useCallbackIntents) {
                _paymentRequest.callbackIntents = ["PAYMENT_AUTHORIZATION"];
            }
            return _paymentRequest;
        }

        /***************  _createRequestData helpers Start  *************/
        function _getApiVersionObj() {
            return {
                apiVersion: cfg.apiVersion,
                apiVersionMinor: cfg.apiVersionMinor
            };
        }

        function _getBaseCardPaymentMethod() {
            return {
                type: 'CARD',
                parameters: {
                    allowedAuthMethods: $.extend(true, [], cfg.allowedCardAuthMethods),
                    allowedCardNetworks: $.extend(true, [], cfg.allowedCardNetworks),
                    /** optional */
                    allowCreditCards: cfg.allowCreditCards,
                    allowPrepaidCards: cfg.allowPrepaidCards,
                    assuranceDetailsRequired: cfg.assuranceDetailsRequired,
                    billingAddressRequired: cfg.billingAddressRequired,
                    billingAddressParameters: {
                        format: cfg.billingAddressFormat,
                        phoneNumberRequired: cfg.phoneNumberRequired
                    }
                }
            }
        }

        function _getTokenizationSpecification() {
            var tokenizationSpec = {
                type: cfg.tokenizationType,
                parameters: {}
            };
            if (cfg.tokenizationType === "DIRECT") {
                tokenizationSpec.parameters.protocolVersion = cfg.protocolVersion;
                tokenizationSpec.parameters.publicKey = cfg.publicKey;
            } else {
                tokenizationSpec.parameters.gateway = cfg.gateway;
                tokenizationSpec.parameters.gatewayMerchantId = cfg.gatewayMerchantId;
            }
            return tokenizationSpec;
        }

        function _getCardPaymentMethod() {
            var cardPM = _getBaseCardPaymentMethod();
            cardPM.tokenizationSpecification = _getTokenizationSpecification();
            return cardPM;
        }

        function _getTransactionInfo() {
            var amount = app.lastSelectedAmount;
            if (app.current_pm_feeObj) {
                var feeObj = app.util.getFeeRenderingData(app.current_pm_feeObj, app.lastSelectedAmount, app.lastSelectedCurrency);
                if (feeObj && feeObj.raw && feeObj.raw.total_amount && feeObj.raw.total_amount > amount) {
                    amount = feeObj.raw.total_amount;
                }
            }
            amount = parseFloat(amount).toFixed(app.roundingScale);

            return {
                checkoutOption: cfg.checkoutOption || (cfg.totalPriceStatus === "FINAL" ? "COMPLETE_IMMEDIATE_PURCHASE" : "DEFAULT"), // "COMPLETE_IMMEDIATE_PURCHASE" == pay | "DEFAULT": Should be used only if Dynamic price is used
                countryCode: app.config.country,
                currencyCode: app.lastSelectedCurrency,
                totalPriceStatus: cfg.totalPriceStatus,
                totalPriceLabel: cfg.totalPriceLabel,
                totalPrice: amount
            };
        }
        /***************  _createRequestData helpers END  *************/

        return {
            forIsReadyToPay: isReadyToPayRequestData,
            forPayment: paymentRequestData
        };
    })();

    GP._doPreDepositCheck = function () {
        if (cfg && cfg.preDepositCheckUrl) {
            return app.util.doPreDepositCheck(cfg.preDepositCheckUrl);
        } else {
            return {};
        }
    };

    GP._handlePreDepositCheckResponse = app.util.handlePreDepositCheckResponse;

    GP._triggerGooglePopup = function () {
        return _g.paymentsClient.loadPaymentData(GP._createRequestData.forPayment());
    };

    GP._submitFormWithGooglePayToken = function (paymentData) {
        if (_g.paymentInProgress) {
            GP._logError('onPaymentAuthorized => Called a second time (already has paymentInProgress)');
        }
        clearTimeout(_g.submitFormTimeoutId);
        return new Promise(function (resolve, reject) {
            if (app.lastSelectedMethodType !== CONST.GOOGLE_PAY) {
                resolve({});
                return;
            }
            var paymentMethodData = paymentData.paymentMethodData; /* .tokenizationData.token; */
            _g.submitFormTimeoutId = setTimeout(GP.resolveSubmitFormPromise, CONST.SUBMIT_TIMEOUT, "TRX_TIMEOUT");
            _g.submitFormPromiseResolve = resolve;
            _g.submitFormPromiseReject = reject;
            var pubsub_payload = {
                cardNetwork: paymentMethodData.info.cardNetwork,
                cardDetails: paymentMethodData.info.cardDetails,
                assuranceDetails: _.cloneDeep(paymentMethodData.info.assuranceDetails)
            }
            pubsub.publish('googlepay.paymentAuthorized.info', [pubsub_payload]);
            app.util.addTmpFormData({googlePay_data: JSON.stringify(paymentMethodData)});
            $('#inIframeMode').val('true');
            $('#inPopupMode').val('false');
            _g.paymentInProgress = true;
            if (app.config.isRebilling) {
                app.sub.doSubscribe();
            } else {
                submitInIframe();
            }
        });
    };

    GP._submitFormPromise = function (paymentData) {
        return new Promise(function (resolve, reject) {
            GP._submitFormWithGooglePayToken(paymentData)
                .then(function () {
                    resolve({transactionState: 'SUCCESS'});
                })
                .catch(function (err) {
                    var msg = (err !== 'TRX_TIMEOUT') ? app.msg.lightbox_transaction_declined : 'PAYMENT DECLINED';
                    resolve({
                        transactionState: 'ERROR',
                        error: {
                            intent: 'PAYMENT_AUTHORIZATION',
                            message: msg || 'PAYMENT DECLINED',
                            reason: 'OTHER_ERROR'
                        }
                    });
                });
        });
    };

    GP._onGooglePaymentButtonClicked = function (event, silent) {
        if (event && event.stopPropagation) {
            event.stopPropagation();
            event.preventDefault();
        }
        if (!silent) {
            pubsub.publish('app.event.DepositClicked', []);
        }
        if (_g.isPopupShown || !app.validateForm()) {
            pubsub.publish('submit-attempt-failed', [app.util.getSubmitAttemptFailedData(false)]);
            return false;
        }
        var proceed = !app.customOnGoogleButtonClicked || app.customOnGoogleButtonClicked();
        if (!proceed) {
            return;
        }
        if (app.util.handlePreDepositLightboxes(doProceed, {silent: silent, customAction: ''})) {
            doProceed();
        }

        function doProceed() {
            var requestForPaymentObj;
            if (GP.NuveiSdkProxy.available && GP.NuveiSdkProxy.hasHandshake) {
                requestForPaymentObj = GP._createRequestData.forPayment();
                requestForPaymentObj.environment = cfg.environment;
                var requestForPaymentJson = JSON.stringify(requestForPaymentObj);
                GP._sendPostMessage({action: 'openGooglePay', requestForPaymentJson: requestForPaymentJson});
                _g.isPopupShown = true;
            } else if (window.NuveiCashierHelper) {
                if (!window.NuveiCashierHelper.openGooglePay) {
                    GP._logError("NativeFlow => openGooglePay method missing");
                    return;
                }
                requestForPaymentObj = GP._createRequestData.forPayment();
                requestForPaymentObj.environment = cfg.environment;
                window.NuveiCashierHelper.openGooglePay(JSON.stringify(requestForPaymentObj));
                _g.isPopupShown = true;
            } else {
                _g.isPopupShown = true;
                Promise.resolve('start_GP')
                    .then(GP._doPreDepositCheck)
                    .then(GP._handlePreDepositCheckResponse)
                    .then(GP._triggerGooglePopup)
                    .then(function (paymentData) {
                        /** if we have CallbackIntents - form is already submitted (on "PAYMENT_AUTHORIZATION")
                         otherwise we need to submit it now */
                        return cfg.useCallbackIntents ? {} : GP._submitFormPromise(paymentData);
                    })
                    .then(GP._clearState)
                    .catch(function (err) {
                        GP._clearState();
                        $.unblockUI();
                        GP._logError('onGooglePaymentButtonClicked => ' + JSON.stringify(err));
                    });
            }
        }
    };

    GP._regiserPubsubEvents = (function () {
        var _evt = {};
        return function () {
            if (!_evt['post-form-submit']) {
                _evt['post-form-submit'] = true;
                pubsub.subscribe('post-form-submit', function (data) {
                    if (_g.paymentInProgress) { // close Popup & clear state
                        GP.resolveSubmitFormPromise({trxStatus: "APPROVED"});
                    }
                });
            }
        }
    })();


    GP.init = function (config) {
        if(!config){
            GP._logError('INVALID PARAMS! => Missing_configuration_object');
            return (new $.Deferred()).resolve({result: false, msg:"Missing_configuration_object"}).promise();
        }
        if (!_g.deferred) {
            _g.deferred = new $.Deferred();
            cfg = $.extend(true, {}, defaults, config);
            var replaceables = ['allowedCardNetworks', 'allowedCardAuthMethods'];
            _.each(replaceables, function (prop) {
                if (config[prop]) {
                    cfg[prop] = _.cloneDeep(config[prop]);
                }
            });
            var errors = GP._getCfgErrors();
            if (errors.length) {
                GP._logError('INVALID PARAMS! => ' + JSON.stringify(errors));
            }
            if (GP.NuveiSdkProxy.timeoutId) {
                GP.NuveiSdkProxy._onReady = _checkGpAvailability;
            } else {
                _checkGpAvailability();
            }
        } else if (_g.scriptStatus === CONST.SCRIPT_STATUS.LOAD_ERROR) {
            /** when LOAD_ERROR => try to _loadScript again */
            _g.deferred = new $.Deferred();
            GP._loadScript(GP._onScriptLoad);
        }
        GP._regiserPubsubEvents();
        return _g.deferred.promise();
        /** helpers **/
        function _checkGpAvailability () {
            if (GP.isNativeFlow()) {
                GP._attachNativeFlowHandlers();
                GP._checkGooglePayAvailabilityNativeFlow();
            } else {
                GP._loadScript(GP._onScriptLoad);
            }
        }
    };
    GP._sendPostMessage = function (data) {
        if (_.isEmpty(data)) {
            return;
        }
        data.sender = 'gp';
        data.timestamp = Date.now();
        data.id = GP.NuveiSdkProxy.req_id++;
        app.util.sendPostMessage(data, app.config.parentUrl);
    };
    GP._initHandshake = function () {
        if (!GP.NuveiSdkProxy.hasHandshake) {
            GP.NuveiSdkProxy.seq = Math.round(Math.random() * 10000);
            GP.NuveiSdkProxy.hasHandshake = false;
            GP._sendPostMessage({action: 'gp_sync', gp_seq: GP.NuveiSdkProxy.seq});
        }
    };
    GP._onMessage = function (data, origin) {
        if ((origin !== app.config.parentUrl && app.config.parentUrl !== '*') || !data || data.sender !== "gp_proxy") {
            return;
        }
        if (data.action === 'GooglePayProxyAvailable' && GP.NuveiSdkProxy.timeoutId) {
            clearTimeout(GP.NuveiSdkProxy.timeoutId);
            GP.NuveiSdkProxy.timeoutId = false;
            GP.NuveiSdkProxy.available = true;
            if (GP.NuveiSdkProxy._onReady) {
                GP.NuveiSdkProxy._onReady();
                delete GP.NuveiSdkProxy._onReady;
            }
            GP._initHandshake();
        } else if (data.gp_ack === (GP.NuveiSdkProxy.seq + 1) && GP.NuveiSdkProxy.available) {
            GP.NuveiSdkProxy.hasHandshake = true;
            if (data.action === "gp_sync_ack" && data.gp_seq) {
                GP._sendPostMessage({action: "gp_ack", ref_id: data.id, gp_ack: data.gp_seq + 1});
            }
            if (GP.NuveiSdkProxy.postponedMsg) {
                GP.NuveiSdkProxy.postponedMsg();
                delete GP.NuveiSdkProxy.postponedMsg;
            }
        } else if(data.action === 'GoogleAvailabilityCheckResponse' && GP.NuveiSdkProxy.available){
            GP._onGoogleAvailabilityCheckResponse(data.result);
        } else if(data.action === 'handleGooglePayResult' && GP.NuveiSdkProxy.available) {
            _handleGooglePayResult(data.payload, data.error);
        }
        /** helpers **/
        function _handleGooglePayResult (payload, error) {
            GP._submitFormPromise(payload).then(GP._clearState)
                .catch(function (err) {
                    GP._clearState();
                    $.unblockUI();
                    GP._logError('NativeFlow => handleGooglePayResult => ' + JSON.stringify(err));
                });
        }
    };

    GP._attachNativeFlowHandlers = function () {
        if (GP.NuveiSdkProxy.available) {
            return;
        }
        window.handleGooglePayAvailability = function (result) {
            GP._onGoogleAvailabilityCheckResponse(result);
        }
        window.handleGooglePayResult = function (payload, error) {
            GP._submitFormPromise(payload)
                .then(GP._clearState)
                .catch(function (err) {
                    GP._clearState();
                    $.unblockUI();
                    GP._logError('NativeFlow => handleGooglePayResult => ' + JSON.stringify(err));
                });
        }
    };

    GP.addGooglePayButton =  function (color, type, size_mode, buttonWrapperSelector) {
        var isOk = cfg && (GP.isNativeFlow() || _g.paymentsClient);
        if (!isOk) {
            GP._logError('addGooglePayButton => Please, DO INIT first!');
            return;
        }
        GP._clearState();
        var button;
        var btnSettings = {
            onClick: GP._onGooglePaymentButtonClicked,
            buttonColor: (color || cfg.buttonColor),
            buttonType: (type || cfg.buttonType),
            buttonLocale: app.locale.substr(0,2),
            buttonSizeMode: (size_mode || cfg.buttonSizeMode)
        };
        if(GP.isNativeFlow()) {
            button = $('<div class="gpay-button-fill"><button type="button" aria-label="Google Pay" class="gpay-button gpay-custom-btn"></button></div>');
            button.find('button').addClass(btnSettings.buttonColor + " " + btnSettings.buttonType + " " + btnSettings.buttonLocale + " " + btnSettings.buttonSizeMode);
            button.find('button').on('click', btnSettings.onClick);
            button = button[0];
        } else {
            button = _g.paymentsClient.createButton(btnSettings);
        }

        button.setAttribute('id', 'google-pay-button');
        if (buttonWrapperSelector) {
            $(buttonWrapperSelector).append(button);
        } else {
            var $submitBtn = ($('#preSubmitButton').length) ? $('#preSubmitButton') : $('#continueButton');
            $submitBtn.after(button);
        }
    };

    GP.isNativeFlow = function () {
        var hasNuveiSDK = !!window.NuveiCashierHelper;
        if (app.openedInIframeMode) {
            hasNuveiSDK = !!GP.NuveiSdkProxy.available;
        }
        return hasNuveiSDK;
    };

    GP.checkForProxy = function () {
        // var hasNuveiSDK = !!window.NuveiCashierHelper;
        //// Yes! window.NuveiCashierHelper exists! - but it cannot work from inside an iFame!
        if (app.openedInIframeMode && /*hasNuveiSDK &&*/ GP.NuveiSdkProxy.available === undefined) {
            GP._sendPostMessage({action: 'checkForProxy'});
            GP.NuveiSdkProxy.timeoutId = setTimeout(function () {
                clearTimeout(GP.NuveiSdkProxy.timeoutId);
                GP.NuveiSdkProxy.available = false;
                GP.NuveiSdkProxy.timeoutId = false;
                if (GP.NuveiSdkProxy._onReady) {
                    GP.NuveiSdkProxy._onReady();
                    delete GP.NuveiSdkProxy._onReady;
                }
            }, CONST.PROXY_CHECK_TIMEOUT);
        }
    };

    GP.isReadyToPay = function () {
        return _g.isReadyToPay;
    };

    GP.isPopupShown = function () {
        return _g.isPopupShown;
    };

    GP.resolveSubmitFormPromise =  function (data) {
        clearTimeout(_g.submitFormTimeoutId);
        if (app.lastSelectedMethodType === CONST.GOOGLE_PAY
            && _g.submitFormPromiseResolve
            && _g.submitFormPromiseReject
            && _g.paymentInProgress) {

            if (data && data.trxStatus  === 'APPROVED' ) {
                _g.submitFormPromiseResolve({});
            } else {
                _g.submitFormPromiseReject(new Error('TRX_FAILED'));
            }
        }
    };

    GP._onGoogleAvailabilityCheckResponse = function (isReadyToPay) {
        if (_g.availabilityCheckTimeoutId) {
            clearTimeout(_g.availabilityCheckTimeoutId);
            _g.availabilityCheckTimeoutId = false;
            _g.isReadyToPay = isReadyToPay;
            _g.deferred.resolve({result: _g.isReadyToPay, msg: "onGoogleAvailabilityCheckResponse"});
        }
    };

    GP._checkGooglePayAvailabilityNativeFlow = function () {
        if(!GP.NuveiSdkProxy.available && !window.NuveiCashierHelper.checkGooglePayAvailability) {
            _g.isReadyToPay = false;
            _g.deferred.resolve({result: false, msg: "checkGoogleAvailabilityMissing"});
            return;
        }

        var timeout = CONST.AWAILABILITY_CHECK_TIMEOUT;
        var readyToPayObj = GP._createRequestData.forIsReadyToPay();
        readyToPayObj.environment = cfg.environment;
        var readyToPayJson = JSON.stringify(readyToPayObj);
        if (GP.NuveiSdkProxy.available) {
            var data = {
                action: 'checkGooglePayAvailability',
                readyToPayJson: readyToPayJson
            };
            if (GP.NuveiSdkProxy.hasHandshake) {
                timeout += 100;
                GP._sendPostMessage(data);
            } else {
                timeout += 200;
                GP.NuveiSdkProxy.postponedMsg = function () {
                    GP._sendPostMessage(data);
                };
            }
            _g.availabilityCheckTimeoutId = setTimeout(_onNativeFlowAvailabilityCheckTimeout, timeout);
        } else {
            _g.availabilityCheckTimeoutId = setTimeout(_onNativeFlowAvailabilityCheckTimeout, timeout);
            window.NuveiCashierHelper.checkGooglePayAvailability(readyToPayJson);
        }

        function _onNativeFlowAvailabilityCheckTimeout() {
            _g.isReadyToPay = false;
            _g.deferred.resolve({result: false, msg: "checkGoogleAvailabilityTimeout"});
            clearTimeout(_g.availabilityCheckTimeoutId);
            _g.availabilityCheckTimeoutId = false;
        }
    };

    return {
        init: GP.init,
        isReadyToPay: GP.isReadyToPay,
        isPopupShown: GP.isPopupShown,
        setBtn: GP.addGooglePayButton,
        completeTrx: GP.resolveSubmitFormPromise,
        onMessage: GP._onMessage,
        checkForProxy: GP.checkForProxy
    };
})(app.CONSTANTS.PM_NAME.GOOGLE_PAY);

app.util.imsAnalytics = (function () {
    var imsAnalytics = {};

    function getImsAnalyticsObj() {
        return imsAnalytics;
    }

    function attachAnalyticsToForm () {
        if(app.config.ptRequestId && imsAnalytics && !_.isEmpty(imsAnalytics)) {
            app.util.addTmpFormData({ "imsAnalytics" : JSON.stringify(imsAnalytics) });
        }
    }

    function createAnalyticsForScanCard(map, resultObject) {
        if(!app.config.ptRequestId || !imsAnalytics) {
            return;
        }

        imsAnalytics.scanCard = {};
        imsAnalytics.scanCard.scanCardUsed = true;

        _.each(map.keysFieldsMap, function(field, key) {
            var val = resultObject[key] ? true: false;

            if(field === 'cc_card_number') {
                imsAnalytics.scanCard.cardNumberScanned = val;
            }

            if(field === 'cc-exp-date') {
                imsAnalytics.scanCard.expirationDateScanned = val;
            }
        });
    }

    function deleteScanCardAnalyticsObj () {
        if(imsAnalytics && imsAnalytics.scanCard) {
            delete imsAnalytics.scanCard;
        }
    }

    return {
        getImsAnalyticsObj          : getImsAnalyticsObj,
        attachAnalyticsToForm       : attachAnalyticsToForm,
        createAnalyticsForScanCard  : createAnalyticsForScanCard,
        deleteScanCardAnalyticsObj  : deleteScanCardAnalyticsObj
    }
}());

app.util.Venmo = (function Venmo(opt /*,  */) {
    var Vnm = {};
    Vnm._g = {
        $venmoButton: null,
        venmoInstance: null,
        dataCollectorInstance: null,
        scriptLoadingStatus: 0,
        scriptLoadRetry: 0,
        scriptPromise: null,
        tmpBlocker: false,
    };
    Vnm.CONST = {
        SCRIPT_LOAD_TIMEOUT: 10000,
        SCRIPT_LOAD_MAX_RETRY: 3,
        PROXY_URL : "/ppp/venmo_proxy.html",
        EXTRA_CFG_PROPS: ['requireManualReturn', 'deepLinkReturnUrl', 'useRedirectForIOS', 'mobileWebFallBack', 'allowAndroidRecreation']
    };
    Vnm.cfg = {
        authorizationKey: 'sandbox_hct9svt3_3958k97pr67tj676',
        profileId: 'YOUR_VENMO_PROFILE_ID',
        paymentMethodUsage: 'multi_use',  // 'single_use' | 'multi_use'- available in v3.77.0+
        allowNewBrowserTab: false,
        allowDesktop: true,
        allowDesktopWebLogin: true,
        allowWebviews: true,
        sendDeviceInfo: true,
        isIosApp: null,
        origin: document.location.origin,
        sdkUrls: ["https://js.braintreegateway.com/web/3.85.3/js/client.min.js", "https://js.braintreegateway.com/web/3.85.3/js/venmo.min.js", "https://js.braintreegateway.com/web/3.85.3/js/data-collector.min.js"]
    };

    Vnm.proxy = {};
    Vnm.redirect = {};
    Vnm.proxy._initFrame = function () {
        if (Vnm.cfg.useVenmoProxy) {
            if (Vnm._g.popup) {
                Vnm.proxy._sendMessageToFrame({
                    action: 'initVenmo',
                    data: Vnm.cfg
                });
            } else {
                Vnm._g.proxyOrigin = document.location.origin;
                var url = Vnm._g.proxyOrigin + Vnm.CONST.PROXY_URL;
                Vnm._g.popup = app.util.createPopupWindow('apmgw_Venmo', url);
            }
        }
    };
    Vnm.proxy._closeFrame = function (initiator) {
        if (Vnm.cfg.useVenmoProxy && Vnm._g.popup){
            if (Vnm._g.popup) {
                Vnm.proxy._sendMessageToFrame('close_frame');
                Vnm._g.popup && Vnm._g.popup.close();
                Vnm._g.popup = false;
            }
            Vnm._g.paymentInProgress = false;
            if(initiator !== 'post-form-submit') {
                Vnm._g.$venmoButton.attr('disabled', false);
                Vnm._g.btnDisabled = false;
                pubsub.publish('app.event.userCancelation', [{pmName: 'apmgw_Venmo'}]);
            }
        }
    };
    Vnm.proxy._sendMessageToFrame = function (msg) {
        if (msg && Vnm.cfg.useVenmoProxy && Vnm._g.popup) {
            Vnm._g.popup.postMessage(JSON.stringify(msg), Vnm._g.proxyOrigin);
        }
    };
    Vnm.proxy._onMessage = function(res, origin){
        if (Vnm.cfg.useVenmoProxy && origin === Vnm._g.proxyOrigin && res){
            if (res.action === "venmo_frame_ready") {
                Vnm.proxy._sendMessageToFrame({
                    action: 'initVenmo',
                    data: Vnm.cfg
                });
            } else if (res.action === "_handleVenmoError" && res.data) {
                Vnm._handleVenmoError(res.data);
            } else if (res.action === "_submitFormWithVenmoData" && res.data) {
                Vnm._submitFormWithVenmoData(res.data);
            } else if (res.action === "info" && res.data) {
                console.log(res.data);
            } else if (res.action === "venmo_frame_unload") {
                Vnm.proxy._closeFrame('venmo_frame');
            }
        }
    };

    Vnm._logError = function (str) {
        var msg = 'Venmo ERROR! => ' + str;
        app._logger.log(msg);
        console.log(msg);
    };
    Vnm._showError = function (errorStr) {
        app.util.addSuspendedPmBlocker(app.lastSelectedMethodId, null, errorStr);
        utils.renderBlockedPMReasons(app.lastSelectedMethodData);
        app.recalcUserDetailsArea();
    };
    Vnm._handleVenmoError = function (err) {
        Vnm._logError(err && JSON.stringify(err) || 'unknown_error');
        if (err.code === 'CLIENT_AUTHORIZATION_INVALID'
            || err.code === 'CLIENT_INVALID_AUTHORIZATION'
        ) {
            Vnm._g.tmpBlocker = 'invalid_authorization';
            Vnm._showError('invalid_authorization');
        } else if (err.code === 'VENMO_CANCELED') {
            Vnm._showError('missing_app');
        } else if (err.key === 'script_load_timeout') {
            Vnm._g.tmpBlocker = 'script_load_timeout';
            Vnm._showError('script_load_timeout');
        } else if (
            err.code === 'VENMO_APP_CANCELED'
            || err.code === 'VENMO_DESKTOP_CANCELED'
            || err.code === 'VENMO_CUSTOMER_CANCELED'
            || err.code === 'FRAME_SERVICE_FRAME_CLOSED'
            || err.code === 'VENMO_MOBILE_POLLING_TOKENIZATION_CANCELED'
            || err.code === 'VENMO_MOBILE_POLLING_TOKENIZATION_TIMEOUT'
            || err.code === 'VENMO_TOKENIZATION_CANCELED_BY_MERCHANT'
        ) {
            Vnm._g.$venmoButton.attr('disabled', false);
            Vnm._g.btnDisabled = false;
            Vnm.proxy._closeFrame();
            pubsub.publish('app.event.userCancelation', [{pmName: 'apmgw_Venmo'}]);
        } else {
            Vnm._g.tmpBlocker = err.key || 'other_error';
            Vnm._showError(err.key || 'other_error');
        }
    };
    Vnm._updateCfg = function (cfg) {
        if (!Vnm._g.scriptLoadingStatus) {
            Object.keys(cfg).forEach(function (k, i, arr) {
                Vnm.cfg[k] = cfg[k];
            });
            Vnm.cfg.useVenmoProxy = app.config.useVenmoProxy;
            Vnm.cfg.useVenmoRedirect = app.config.useVenmoRedirect;
            Vnm.cfg.deepLinkReturnUrl || (Vnm.cfg.deepLinkReturnUrl = app.config.appReturnLink);
        }
    };
    Vnm._loadScripts = function () {
        if (!Vnm._g.scriptLoadingStatus ||
            (Vnm._g.scriptLoadingStatus === 500 && Vnm._g.scriptLoadRetry < Vnm.CONST.SCRIPT_LOAD_MAX_RETRY)) {
            Vnm._g.scriptLoadRetry++;
            Vnm._g.scriptLoadingStatus = 1;
            Vnm._g.scriptPromise = new Promise(function (resolve, reject) {
                var count = 0;
                Vnm.cfg.sdkUrls.forEach(function (script) {
                    $.getScript(script, function () {
                        if (++count === Vnm.cfg.sdkUrls.length) {
                            resolve({msg: "script_load_done"});
                        }
                    });
                });
                setTimeout(function () {
                    reject({key: 'script_load_timeout', msg: "Can not load scripts!"});
                }, Vnm.CONST.SCRIPT_LOAD_TIMEOUT);
            });
        }
        Vnm._g.scriptPromise.then(function () {
            Vnm._g.scriptLoadingStatus = 200;
        }).catch(function () {
            Vnm._g.scriptLoadingStatus = 500;
        });
        return Vnm._g.scriptPromise;
    };
    Vnm._createVenmoInstance = function () {
        if (Vnm._g.clientInstance && Vnm._g.venmoInstance && Vnm._g.dataCollectorInstance) {
            return;
        }
        if (!window.braintree || !braintree.venmo || !braintree.dataCollector) {
            return Vnm._handleVenmoError({key: 'no_braintree', msg: 'An error occurred: No braintree!'});
        }
        return window.braintree.client.create({
            authorization: Vnm.cfg.authorizationKey
        }).then(function (clientInstance) {
            Vnm._g.clientInstance = clientInstance;
            var venmoInstanceCfg = {
                client: clientInstance,
                profileId: Vnm.cfg.profileId,
                allowDesktop: Vnm.cfg.allowDesktop,
                allowWebviews: Vnm.cfg.allowWebviews,
                allowNewBrowserTab: Vnm.cfg.allowNewBrowserTab,
                allowDesktopWebLogin: Vnm.cfg.allowDesktopWebLogin,
                paymentMethodUsage: Vnm.cfg.paymentMethodUsage
            };
            if (Vnm.cfg.isIosApp || (Vnm.cfg.isIosApp == null && utils.getUserAgentInfo().isOpenedInIOSApp)) {
                venmoInstanceCfg.requireManualReturn = true;
                venmoInstanceCfg.useRedirectForIOS = true;
                if (Vnm.cfg.deepLinkReturnUrl) {
                    venmoInstanceCfg.deepLinkReturnUrl = Vnm.cfg.deepLinkReturnUrl;
                }
            }
            _.each(Vnm.CONST.EXTRA_CFG_PROPS, function (key, i) {
                if (Vnm.cfg[key]) {
                    venmoInstanceCfg[key] = Vnm.cfg[key];
                }
            });
            return Promise.all([
                window.braintree.dataCollector.create({
                    client: clientInstance,
                    paypal: true
                }),
                window.braintree.venmo.create(venmoInstanceCfg)
            ]);
        }).then(function (results) {
            Vnm._g.dataCollectorInstance = results[0];
            Vnm._g.venmoInstance = results[1];
            // delete window.braintree;
            if (!Vnm._g.venmoInstance.isBrowserSupported()) {
                return Vnm._handleVenmoError({key: 'no_browser_support', msg: 'Browser does not support Venmo!'});
            }
            if (Vnm._g.venmoInstance.hasTokenizationResult()) {
                // Check if tokenization results already exist. This occurs when your
                // checkout page is relaunched in a new tab. This step can be omitted
                // if allowNewBrowserTab is false.
                Vnm.tokenizeAndSubmit();
            }
        });
    };
    Vnm._displayVenmoButtonAndAttachEvents = function () {
        Vnm._g.$venmoButton = $('#venmo-button');
        var isBrowserSupported = Vnm.cfg.useVenmoProxy || Vnm.cfg.useVenmoRedirect || (Vnm._g.venmoInstance && Vnm._g.venmoInstance.isBrowserSupported());
        if (!Vnm._g.$venmoButton.length || !isBrowserSupported) {
            return;
        }
        Vnm._g.btnDisabled = false;
        Vnm._g.$venmoButton.removeClass('_invisible').off().on('click', function (event, silent) {
            if (event && event.stopPropagation) {
                event.stopPropagation();
                event.preventDefault();
            }
            if (Vnm._g.btnDisabled) {
                return;
            }
            Vnm._g.btnDisabled = true;
            if (!silent) {
                pubsub.publish('app.event.DepositClicked', []);
            }
            if (!app.validateForm()) {
                pubsub.publish('submit-attempt-failed', [app.util.getSubmitAttemptFailedData(false)]);
                Vnm._g.btnDisabled = false;
                return;
            }
            var proceed = !app.customOnVenmoButtonClicked || app.customOnVenmoButtonClicked();
            if (!proceed) {
                return;
            }
            var params = {silent: silent, customAction: ''};
            var doProceed = Vnm.cfg.useVenmoRedirect ? Vnm.redirect.getSubmitFormHandler(params) : Vnm.cfg.useVenmoProxy ? Vnm.proxy._initFrame : Vnm.tokenizeAndSubmit;
            if (app.util.handlePreDepositLightboxes(doProceed, params)) {
                doProceed();
            } else {
                Vnm._g.btnDisabled = false;
            }
        });
    };
    Vnm.redirect.getSubmitFormHandler = function (params) {
        return function () {
            submitPopupForm(params.customAction, params.silent);
        }
    };
    Vnm._submitFormWithVenmoData = function (payload) {
        if (Vnm._g.paymentInProgress || !payload) {
            return;
        }
        var vData = (/*Vnm.cfg.useVenmoProxy && */payload.vData) || {
            nonce: payload.nonce,
            deviceData: Vnm.cfg.sendDeviceInfo && Vnm._g.dataCollectorInstance && Vnm._g.dataCollectorInstance.deviceData
        };
        app.util.addTmpFormData({venmoNonce: vData.nonce, venmoDeviceData: JSON.stringify(vData.deviceData)});
        $('#inIframeMode').val('true');
        $('#inPopupMode').val('false');
        Vnm._g.paymentInProgress = vData;
        if (app.config.isRebilling) {
            app.sub.doSubscribe();
        } else {
            submitInIframe();
        }
    };
    Vnm._regiserPubsubEvents = (function () {
        var _evt = {};
        return function () {
            if (!_evt['post-form-submit']) {
                _evt['post-form-submit'] = true;
                pubsub.subscribe('post-form-submit', function (data) {
                    if (!data.silent) {
                        Vnm._g.paymentInProgress = false;
                        Vnm.proxy._closeFrame('post-form-submit');
                    }
                });
            }
            if (!_evt['select-pm']) {
                _evt['select-pm'] = true;
                pubsub.subscribe('select-pm', Vnm.proxy._closeFrame);
            }
        }
    })();
    Vnm.createBtn = function (color) {
        color || (color = 'blue');  //// (color VALUES: "blue" | "white" )
        var $vb = $('#venmo-button');
        if ($vb.length) {
            $vb.addClass('_invisible');
        } else {
            var tpl = {
                img: '<div id="venmo-button" class="_invisible" ><img alt="Venmo" class="venmo-button venmo-button-<%-color%>" role="button" src="<%-logoUrl%>"/></div>',
            };
            var btn = _.template(tpl['img'])({
                color: color,
                logoUrl: app.config.templateResourcesPath + '/img/venmo/venmo_button_' + color + '.svg'
            });
            app.util.getCustomBtnContainer().append(btn).removeClass('_invisible');
        }
    };
    Vnm.tokenizeAndSubmit = function () {
        if (Vnm.cfg.useVenmoProxy && Vnm._g.popup) {
            Vnm._g.$venmoButton.attr('disabled', true);
            Vnm._g.btnDisabled = true;
            Vnm.proxy._sendMessageToFrame({
                action: 'initVenmo',
                data: Vnm.cfg
            });
            return;
        }
        if (!Vnm._g.venmoInstance) {
            Vnm._logError('tokenizeAndSubmit>>>>Missing venmoInstance');
            Vnm._g.btnDisabled = true;
            return;
        }
        Vnm._g.$venmoButton.attr('disabled', true);
        Vnm._g.btnDisabled = true;
        Vnm._g.venmoInstance
            .tokenize()
            .then(Vnm._submitFormWithVenmoData)
            .catch(Vnm._handleVenmoError);
    };
    Vnm.initVenmo = function (cfg) {
        if (Vnm._g.tmpBlocker) {
            app.util.removePmBlocker(app.lastSelectedMethodId, Vnm._g.tmpBlocker);
            Vnm._g.tmpBlocker = false;
        }
        if (Vnm._g.venmoInstance || Vnm._g.scriptLoadingStatus === 200) {
            Vnm._displayVenmoButtonAndAttachEvents();
            return;
        }

        Vnm._updateCfg(cfg);
        if (Vnm.cfg.useVenmoRedirect || Vnm.cfg.useVenmoProxy) {
            Vnm._displayVenmoButtonAndAttachEvents();
        } else {
            Vnm._loadScripts()
                .then(Vnm._createVenmoInstance)
                .then(Vnm._displayVenmoButtonAndAttachEvents)
                .catch(Vnm._handleVenmoError);
        }
        Vnm._regiserPubsubEvents();
    }

    return {
        init: Vnm.initVenmo,
        setBtn: Vnm.createBtn,
        onMessage: Vnm.proxy._onMessage,
        _submit: function (p) {
            return app.customOnVenmoButtonClicked && app.lastSelectedMethodType === 'apmgw_Venmo' && Vnm._submitFormWithVenmoData(p);
        }
    }
})();

app.util.handleVenmoBtn = function(){
    app.bodyElm.addClass('main_venmo');
    app.util.Venmo.setBtn(app.colorSettings.venmo_btn_style);
    app.util.Venmo.init(app.config.pmSettings.apmgw_Venmo);
};

app.util.validateFixedAmountDecimalPlaces = function (decimalRestrictedCurrencies) { /** {currencyIso : decimalPlaces} */
    if (!app.config.isOpenAmount && decimalRestrictedCurrencies.hasOwnProperty(app.lastSelectedCurrency)) {
        var decimalPlaces =
            app.lastSelectedAmount &&
            app.lastSelectedAmount.trim().replace(/^0+|0+$/g, '').split('.')[1].length;
        var requiredDecimalPlaces = decimalRestrictedCurrencies[app.lastSelectedCurrency];

        if (decimalPlaces > requiredDecimalPlaces) {
            var blockerMsg = app._t('fixed_amount_decimal_limit', [requiredDecimalPlaces]);
            app.util.addSuspendedPmBlocker(app.lastSelectedMethodId, false, 'decimalLimitBlocker', blockerMsg);
            utils.renderBlockedPMReasons(app.lastSelectedMethodData);
        }
    }
};

app.util.handleGooglePayBtn = function(){
    app.bodyElm.addClass('main_google_pay');
    app.util.GooglePay.setBtn(app.colorSettings.google_btn_style, app.config.googleBtnType /*, size_mode ,buttonWrapperSelector*/);
};

app.util.handleApplePayBtn = function () {
    app.bodyElm.addClass('main_apple_pay');
    app.util.applePayCanMakePaymentsWithActiveCard().then(function (canMakePayments) {
        if (app.lastSelectedMethodType === "ppp_ApplePay") {
            var appleCfg = app.config.pmSettings.ppp_ApplePay;
            var buttonType = !canMakePayments ? "set-up" : (appleCfg && appleCfg.buttonType);
            app.util.setApplePayBtn(app.colorSettings.apple_btn_style, app.config.appleBtnWithText, buttonType);
        }
    });
};

app.util.applePayCanMakePaymentsWithActiveCard = function () {
    var cfg = app.config.pmSettings.ppp_ApplePay || {};
    if (cfg.enableInlineSetup && cfg.applePayMerchantId && !app._applePayCanMakePaymentsWithActiveCardPromise) {
        if (window.ApplePaySession && !app.openedInIframeMode && !app.applePayDeviceSupport) {
            app._applePayCanMakePaymentsWithActiveCardPromise = window.ApplePaySession.canMakePaymentsWithActiveCard(cfg.applePayMerchantId);
        } else if (app.openedInIframeMode && !app.applePayDeviceSupport) {
            app._applePayCanMakePaymentsWithActiveCardPromise = app.util.ApplePayConnector.canMakePaymentsWithActiveCard(cfg.applePayMerchantId);
        }
    }
    return app._applePayCanMakePaymentsWithActiveCardPromise || Promise.resolve(true);
};

app.util.renderCardWarnMessage = function (data) {
    if (!app.config.warnCreditCard) {
        return;
    }
    var isCreditCardUpo = (app.lastSelectedMethodData.cardAccountType === app.CONSTANTS.ASYNC_CHECK_CARD_TYPE.CREDIT_CARD);
    if (data && data.cardType === app.CONSTANTS.ASYNC_CHECK_CARD_TYPE.CREDIT_CARD && data.issuerCountry === 'US' && !isCreditCardUpo) {
        var payload = {
            uniqueId: app.lastSelectedMethodId,
            msgArr: ["credit_card_warning_text"],
            type: 'warning',
            msgId: "credit_card_warning_text"
        };
        if (!$('#warning_message').length) {
            $('<div id="warning_message">').insertBefore('.PMINFO .cc_name_on_card');
        }
        utils.showInlineMessage(payload, "#warning_message");
    } else {
        $('#warning_message').remove();
    }
};

app.util.handleCardTypeCheck = function (data, initiator) {
    var isCreditCardUpo = (data && data.cardAccountType === app.CONSTANTS.ASYNC_CHECK_CARD_TYPE.CREDIT_CARD);
    var isTypedCardCredit = (data && data.cardType === app.CONSTANTS.ASYNC_CHECK_CARD_TYPE.CREDIT_CARD);
    var isApplePayCreditCard = (initiator === "select_pm" && app.lastSelectedMethodType === 'ppp_ApplePay' && app.config.debitRestricted);

    if (isCreditCardUpo || isTypedCardCredit || isApplePayCreditCard) {
        app._flag.isCurrentCardCredit = true;
    } else {
        app._flag.isCurrentCardCredit = false;
    }
    if (app.config.maxCreditCardDepositBalance && (initiator === 'async_card_recognition' || (initiator === "select_pm" && isCreditCardUpo))) {
        app.util.triggerFldValidation('item_amount_1', 'custom');
    }
};

app.util.renderUpoMessage = function (data) {
    if (data && data.warnMessage) {
        var skipUpoMessage = app._flag.skipUpoMessage[data.userPaymentOptionId] || {};
        var msgId = "upo_warnMessage";
        if (!skipUpoMessage[msgId]) {
            var payload = {
                uniqueId: app.lastSelectedMethodId,
                msgArr: [data.warnMessage],
                type: 'warning',
                msgId: msgId
            };
            utils.showInlineMessage(payload);
        }
    }
};

app.util.onInlineMessageClose = function (payload) {
    if (payload && payload.msgId === "upo_warnMessage") {
        app._flag.skipUpoMessage[payload.uniqueId] || (app._flag.skipUpoMessage[payload.uniqueId] = {});
        app._flag.skipUpoMessage[payload.uniqueId][payload.msgId] = 1;
        utils.notifyCardUpdateMessageClosed(payload);
    }
};

app.util.handleOktoWalletConsent = function () {
    var $consentCheckbox = $("#oktowallet_consent");
    if ($consentCheckbox.is(":checked")) {
        app.bodyElm.addClass("fbt_like_pm");
    } else {
        app.bodyElm.removeClass("fbt_like_pm");
    }
    app.util.applyScrollablePlugin(); // to recalculate the height without flashing (as in app.recalcUserDetailsArea)
};

app.util.handlePayWithCryptoConsent = function () {
    var pmSettings = app.config.pmSettings[app.CONSTANTS.PM_NAME.PAY_WITH_CRYPTO];
    var provider = ((pmSettings && pmSettings.provider) || "").toLowerCase(),
        titleKey = "pwc_terms_and_conditions_title",
        termsKey = "coindirect_terms";

    if (provider === "simplex") {
        titleKey = "simplex_pwc_terms_and_conditions_title";
        termsKey = "simplex_coindirect_terms";
    }

    var payload = {
        titleKey: titleKey,
        msgArr: [termsKey],
        confirmBtn: {
            isVisible: true,
            txt: "pwc_terms_and_conditions_btn_agree",
        },
        cancelBtn: {
            isVisible: true,
            txt: "pwc_terms_and_conditions_btn_disagree",
        }
    };
    app.showModalMessage({details: payload}, 'confirm', app.util.closeLightbox, function () {
        app.bodyElm.addClass('static_pm');
    }, 'lbx_pwc_terms');
};

app.util.topBanksWidget = (function topBanksWidget() {
    function init() {
        var $widget = $('.ob_bank_id-widget');
        var fieldId = $widget.attr("data-id");

        if ($widget.length && fieldId) {
            $widget.on('click', '[data-ob-bank]', onWidgetClick);
            $("#" + fieldId).on('change', onBankChange);
        }
    }

    function onWidgetClick() {
        var bankId = $(this).attr("data-ob-bank");
        selectBank(bankId);
    }

    function onBankChange() {
        var bankId = $(this).val();
        selectBank(bankId);
        handleRequiredFields(app.lastSelectedMethodId, bankId);
    }

    function selectBank(bankId) {
        var fieldId = $(".ob_bank_id-widget").attr("data-id");
        var $dropdown = $("#" + fieldId);

        $(".ob_bank_id-widget")
            .find("[data-ob-bank]")
            .removeClass("active")
            .filter(function() {
                return $(this).attr("data-ob-bank") === bankId;
            })
            .addClass("active");

        if ($dropdown.val() !== bankId) {
            $dropdown
                .val(bankId)
                .change();
        }
    }

    function handleRequiredFields(methodId, value) {
        var availableFields = Object.keys(app._pmFields[methodId]),
            requiredFields = [],
            dropDown;

        try {
            dropDown = app._poList[methodId].dropDowns.ob_bank_id || app._poList[methodId].dropDowns.instantOb_bankId;

            if (!dropDown) {
                return;
            }

            requiredFields = (_.find(dropDown, function(o) {
                return o.value === value;
            }) || {}).requiredFields || [];

            requiredFields = requiredFields.concat(app.config.pmSettings[methodId].alwaysVisibleFields);
        } catch (err) {
            console.error(err);
            requiredFields = [];
        }

        for (var i = 0; i < availableFields.length; i++) {
            if (requiredFields.indexOf(availableFields[i]) < 0) {
                app.util.setAsOptionalFld(availableFields[i]);

                $("#" + availableFields[i]).val("").closest(".row").addClass("hidden");
            } else {
                app.util.unsetAsOptionalFld(availableFields[i]);
                if (app.currentMethodFields[availableFields[i]].type === 'OPTIONAL') {
                    app.currentMethodFields[availableFields[i]].type = 'REQUIRED';
                }

                $("#" + availableFields[i])
                    .closest(".row")
                    .removeClass("hidden valid invalid")
                    .find(".valid_field, .invalid_field")
                    .removeClass("valid_field invalid_field")
                    .find(".error")
                    .remove()
                ;
            }
        }
    }

    return {
        init: init
    }
})();

app.util.handleDropDownValueDependentFields = function (fldName, pmName, uniqueId) {
    pmName || (pmName = app.lastSelectedMethodType);
    uniqueId || (uniqueId = app.lastSelectedMethodId);
    var dropDownValueDependentFields = fldName && app.CONSTANTS.DROPDOWN_VALUE_DEPENDENT_FIELDS[pmName] && app.CONSTANTS.DROPDOWN_VALUE_DEPENDENT_FIELDS[pmName][fldName];
    if (dropDownValueDependentFields) {
        var dropDowns = app._poList[pmName] && app._poList[pmName].dropDowns && app._poList[pmName].dropDowns[fldName];
        if (!dropDowns && uniqueId === app.lastSelectedMethodId && app.currentMethodFields) {
            dropDowns = app.currentMethodFields[fldName] && app.currentMethodFields[fldName].dropDownOptions;
        }
        if (dropDowns) {
            var val = app.util.getFieldValue(fldName);
            var requiredFields = (_.find(dropDowns, function (o) {
                return o.value === val;
            }) || {}).requiredFields || [];
            _.each(dropDownValueDependentFields, function (fld, i) {
                if (requiredFields.indexOf(fld) < 0) {
                    app.util.disableField(fld, true);
                } else {
                    app.util.enableField(fld, true);
                }
            });
        }
    }
};

app.util.getCountryPhoneCode = function getCountryPhoneCode(phoneCodes, isoCode) {
    var country = _.find(phoneCodes || [], function(c) {
        return c.iso === isoCode;
    }) || {};

    return country.phoneCode || "";
};

app.util.getSuspendedPmHtml = function (payload) {
    var html = '';
    var suspendedElm = $('#suspended_pm');
    if (suspendedElm.length) {
        html = _.template(suspendedElm.text())(payload);
    }
    return html;
};

app.util.addSuspendedPmBlocker = function (pmId, hasCustomHandling, blockerKey, blockerMsg) {
    if (pmId && !hasCustomHandling) {
        var data = app[(app.util.isUpo(pmId) ? '_upoList' : '_poList')][pmId];
        if (data && _.isEmpty(data.blockers)) {
            data.blockers = utils.createSuspendedPmBlocker(blockerKey, blockerMsg);
        }
        if (pmId === app.lastSelectedMethodId && _.isEmpty(app.lastSelectedMethodData.blockers)) {
            app.lastSelectedMethodData.blockers = utils.createSuspendedPmBlocker(blockerKey, blockerMsg);
        }
    }
};

app.util.removePmBlocker = function (pmId, blockerKey) {
    if (pmId && blockerKey) {
        var data = app[(app.util.isUpo(pmId) ? '_upoList' : '_poList')][pmId];
        if (data && !_.isEmpty(data.blockers) && data.blockers[blockerKey]) {
            delete data.blockers[blockerKey];
        }
        if (pmId === app.lastSelectedMethodId && !_.isEmpty(app.lastSelectedMethodData.blockers) && app.lastSelectedMethodData.blockers[blockerKey]) {
            delete app.lastSelectedMethodData.blockers[blockerKey];
        }
    }
};

app.util.modalMessageHandlers = function () {
    var modalMessageQueue = [],
        openModals = {
            ws: false,
            synch: false
        },
        closedModals = {},
        pendingTimeout = false,
        pendingWaitingModal = false;

    function calcMilliSeconds(seconds) {
        var sec = parseInt(seconds);
        if (Number.isNaN(sec)) {
            sec = 20;
        }
        return sec * 1000;
    }
    function getDetailFromObj(obj, detail) {
        return obj && obj.data && obj.data.details && obj.data.details[detail];
    }
    function getTrxRef(obj) {
        return getDetailFromObj(obj, 'reference');
    }
    function closeSynchModal() {
        $('#lightbox .modal_close, [role="lbx_wrapper"] .modal_close').click();
    }
    function changeWsModalHandlerToRedirect(wsModal, redirectUrl) {
        var type = app.CONSTANTS.MODAL_MESSAGE_TYPE.ERROR;
        if (wsModal.trxStatus === app.CONSTANTS.TRX_STATUS.PENDING) {
            type = app.CONSTANTS.MODAL_MESSAGE_TYPE.PENDING;
        } else if (wsModal.trxStatus === app.CONSTANTS.TRX_STATUS.APPROVED) {
            type = app.CONSTANTS.MODAL_MESSAGE_TYPE.SUCCESS;
        }

        var handler = function () {
            app.util.sendPostMessage(type, app.config.parentUrl);
            location.href = redirectUrl;
        }
        wsModal.onCancel = handler;
        wsModal.onConfirm = handler;
    }

    function waitForFinalTrxStatusFromWs(modal, modalType) {
        $.blockUI();
        pendingWaitingModal = modal;
        pendingTimeout = setTimeout(function () {
            var hasModalWithSameRefInQueue = false;
            var shouldSkipTokenUpdate;
            var ref = getTrxRef(modal);
            _.each(modalMessageQueue, function(m){
                if(getTrxRef(m) === ref) {
                    hasModalWithSameRefInQueue = true;
                    if(getDetailFromObj(m, 'redirectTo')) {
                        shouldSkipTokenUpdate = true;
                    }
                }
            });

            if(hasModalWithSameRefInQueue) {
                onSkipSynchModal(modal, shouldSkipTokenUpdate);
            } else {
                showModal(modal, modalType);
            }
            $.unblockUI();
        }, calcMilliSeconds(app.config.secondsToWaitForFinalTrxStatusFromWs));
    }
    function modalMessageQueueHandler(obj) {
        var userCancelation = getDetailFromObj(obj, 'userCancelation');
        if(userCancelation) {
            pushModalToClosedModals(obj, true);
            return;
        }

        modalMessageQueue.push(obj);
    }
    function pushModalToClosedModals(modal, isSkipped) {
        var modalRef = getTrxRef(modal);
        if(modal && isSkipped) {
            modal.isSkipped = isSkipped;
        }
        if(modalRef) {
            if(!closedModals[modalRef]) {
                closedModals[modalRef] = [];
            }
            closedModals[modalRef].push(modal);
        }
    }
    function getLastClosedSynchModal(ref) {
        var lastClosedSynchModal;
        if(closedModals[ref]) {
            for (var i = closedModals[ref].length - 1; i >= 0; i--) {
                var currentModal = closedModals[ref][i];
                if (currentModal.data && currentModal.data.eventType !== 'websocket') {
                    lastClosedSynchModal = currentModal;
                    break;
                }
            }
        }
        return lastClosedSynchModal;
    }
    function hasUserCancelation(closedModalsForRef) {
        var isUserCancelation = false;
        _.each(closedModalsForRef, function(modal) {
            if (getDetailFromObj(modal, 'userCancelation')) {
                isUserCancelation = true;
            }
        });

        return isUserCancelation;
    }
    function hasPartialApproval(closedModalsForRef) {
        var isPartialApproval = false;
        _.each(closedModalsForRef, function (modal) {
            if (modal.type === 'pa_trx') {
                isPartialApproval = true;
            }
        });
        return isPartialApproval;
    }
    function showModal(_modal, modal_type) {
        openModals[modal_type] = _modal;
        app.showModalMessageDefault(_modal.data, _modal.type, _modal.onConfirm, _modal.onCancel, _modal.className, _modal.modalWrapper, _modal.onModalShows);
    }
    function isApprovedOrPending(trx_status) {
        return (trx_status === app.CONSTANTS.TRX_STATUS.APPROVED || trx_status === app.CONSTANTS.TRX_STATUS.PENDING);
    }
    function areEqualAndExist(ref_1, ref_2) {
        return (ref_1 && ref_2) && (ref_1 == ref_2);
    }
    function shouldBlockUiOnWsClose(synchModalData) {
        return (!synchModalData.isLastTrxDataModal && isApprovedOrPending(synchModalData.trxStatus) && !synchModalData.nextDepositURL);
    }
    function onSkipSynchModal(modal, shouldSkipTokenUpdate) {
        pushModalToClosedModals(modal, true);
        if (!shouldSkipTokenUpdate && isApprovedOrPending(modal.data && modal.data.trxStatus)) {
            app.nextDepositURL = modal.data.nextDepositURL;
            if (app.nextDepositURL) {
                app.util.updateCSRFToken(); // pms will be reloaded when ws is closed
            } else if (!modal.data.isLastTrxDataModal && !openModals.ws) {
                $.blockUI();
            }
        }
        invokeNextModalMessage();
    }
    function skipSynchModalHandlers (modal) {
        modal.onCancel = _.identity;
        modal.onConfirm = _.identity;
    }
    function shouldWaitForFinalTrxStatusFromWs(modal, modalType) {
        return (app.config.testWaitingForFinalTrxStatusFromWs || app.config.ws_server) && modalType === "synch" && modal.data && modal.data.trxStatus === app.CONSTANTS.TRX_STATUS.PENDING;
    }

    function invokeNextModalMessage() {
        var modal = modalMessageQueue[0];
        if (!modal) {
            return;
        }

        var modalType = modal.modalWrapper === "lightbox_ws" ? 'ws' : 'synch';
        if (openModals[modalType]) {
            return;
        }

        modal = modalMessageQueue.shift();
        var synchModalData = openModals["synch"] && openModals["synch"].data;
        // var wsModalData = openModals["ws"] && openModals["ws"].data;
        var synchModalRef = getTrxRef(openModals["synch"]);
        var wsModalRef = getTrxRef(openModals["ws"]);
        var ref = getTrxRef(modal);
        var redirectUrl = getDetailFromObj(modal, 'redirectTo');
        var shouldSkipTokenUpdate;

        if(modalType === "ws"){
            if(areEqualAndExist(ref, getTrxRef(pendingWaitingModal))) {
                clearTimeout(pendingTimeout);
                shouldSkipTokenUpdate = redirectUrl ? true : false;
                onSkipSynchModal(pendingWaitingModal, shouldSkipTokenUpdate);
                pendingWaitingModal = false;
            }

            if(redirectUrl) {
                changeWsModalHandlerToRedirect(modal, redirectUrl);
            }
        }

        if (modalType === "ws" && areEqualAndExist(ref, synchModalRef) && synchModalData.trxStatus) {
            // we have an open Sync modal
            if(redirectUrl) {
                skipSynchModalHandlers(openModals["synch"]);
            }
            showModal(modal, modalType);
            closeSynchModal();
            openModals['ws'].shouldBlockUiOnClose = shouldBlockUiOnWsClose(synchModalData);
        } else if (modalType === "synch" && areEqualAndExist(ref, wsModalRef)) {
            // we have an open WS modal
            shouldSkipTokenUpdate = redirectUrl ? true : false;

            onSkipSynchModal(modal, shouldSkipTokenUpdate);
            openModals['ws'].shouldBlockUiOnClose = shouldBlockUiOnWsClose(modal.data);
        } else if (modalType === "ws" && closedModals[ref]) {
            showModal(modal, modalType);
            var lastClosedSynchModal = getLastClosedSynchModal(ref);
            var lastData = lastClosedSynchModal && lastClosedSynchModal.data || {};
            openModals["ws"].shouldBlockUiOnClose = shouldBlockUiOnWsClose(lastData);
        } else if (modalType === "synch" && closedModals[ref]
            && !hasUserCancelation(closedModals[ref])
            && !hasPartialApproval(closedModals[ref])
        ) {
            onSkipSynchModal(modal);
        } else {
            if(shouldWaitForFinalTrxStatusFromWs(modal, modalType)) {
                waitForFinalTrxStatusFromWs(modal, modalType);
            } else {
                showModal(modal, modalType);
            }
        }
    }

    function onModalClose(type) {
        var modalForClose = openModals[type];
        pushModalToClosedModals(modalForClose);
        if (type === 'ws' && modalForClose && modalForClose.shouldBlockUiOnClose) {
            $.blockUI();
        }
        openModals[type] = false;
        var feRef = modalForClose && modalForClose.data && modalForClose.data.details && (modalForClose.data.details.feRef || modalForClose.data.details.info && modalForClose.data.details.info.feRef);
        pubsub.publish('lightbox.closed', [{type: (modalForClose && modalForClose.type), isWs: (type === 'ws'), feRef: feRef}]);
        invokeNextModalMessage();
    }

    function showModalMessageEnhanced(data, type, onConfirm, onCancel, className, modalWrapper, onModalShows) {
        var modalObj = {
            data: data,
            type: type,
            onConfirm: onConfirm,
            onCancel: onCancel,
            className: className,
            modalWrapper: modalWrapper,
            onModalShows: onModalShows
        };
        modalMessageQueueHandler(modalObj);
        invokeNextModalMessage();
    }

    function getModalsCurrentStateCopy() {
        var closedModalsCopy = $.extend(true, {}, closedModals)
        var openModalsCopy =  $.extend(true, {}, openModals);
        var modalMessageQueueCopy = modalMessageQueue.map(function(x){return x;});

        return {
            closedModalsCopy        : closedModalsCopy,
            openModalsCopy          : openModalsCopy,
            modalMessageQueueCopy   : modalMessageQueueCopy
        }
    }

    return {
        showModalMessageEnhanced: showModalMessageEnhanced,
        onModalClose:  onModalClose,
        getModalsCurrentStateCopy: getModalsCurrentStateCopy
    }
};

app.util.showLastTrxStatus = function (lastTrxData) {
    if (_.isEmpty(lastTrxData)) {
        return;
    }
    var supportedTypes = {
        "PENDING": 'pending',
        "APPROVED": 'success',
        "DECLINED": 'error'
    };
    var type = supportedTypes[lastTrxData.trxStatus] || 'error';
    var details = $.extend(true, {}, lastTrxData);
    details.payment_method = details.payment_method || details.paymentMethod || '';
    details.upo_name = details.upo_name || details.upoName || '';
    details.card_type = details.cardType;
    var data = {
        details: details,
        trxStatus: lastTrxData.trxStatus,
        isLastTrxDataModal: true
    };
    details.feRef && app.util.FeRef.setRefData(details.feRef, "trxResp", data);
    details.feRef && app.util.FeRef.setRefData(details.feRef, "submittedMethod", {
        id: details.upoId || details.payment_method,
        isUpo: !!details.upoId,
        upoName: details.upo_name,
        pmName: details.payment_method,
        pmPosition: {},
        isRebilling: app.config.isRebilling,
        card_detected: (details.card_type || "none"),
        feRef: details.feRef,
        amount: details.amount,
        currency: details.currency
    });
    var info = {feRef: details.feRef, isWS: false, source: 'lastTrxData'};
    _sendAnalyticsEvents();
    if (type === 'error' && app.config.useDeclineRecovery) {
        _showErrorDR();
    } else if (data.details.redirectURL && data.details.redirectURL.length > 3) {
        var skipAnalyticsEvents = true;
        data.redirectUrl = data.details.redirectURL;
        app.util.onPerformRedirect(data, skipAnalyticsEvents);
    } else {
        app.util.handleTrxCompletePopups(data, type, _.identity, _.identity, false, 'lastTrxData', '');
    }

    /***************  showLastTrxStatus helpers Start  *************/
    function _sendAnalyticsEvents() {
        if (app.config.useAnalytics) {
            pubsub.publish('app.event.transactionComplete', [data]);
        }
        if (app.config.relayAnalyticsEvents) {
            var eventParams = [details.payment_method, details.currency, details.amount, details.reference, info]
            if (data.trxStatus === app.CONSTANTS.TRX_STATUS.APPROVED) {
                pubsub.publish('app.event.depositSuccess', eventParams);
            } else if (data.trxStatus === app.CONSTANTS.TRX_STATUS.PENDING) {
                pubsub.publish('app.event.depositPending', eventParams);
            } else {
                pubsub.publish('app.event.depositFailure', eventParams);
            }
        }
    }

    function _showErrorDR() {
        // check this: if (app._filteredPmData && app._filteredPmData.length || app._filteredUpmData && app._filteredUpmData.length) {
        if ((app._filteredPmData || app._filteredUpmData || []).length) {
            app.showErrorDeclineRecoveryPopup(data, details.apmErrorMsg, details.reference, info);
        } else {
            var timeoutId, obj;
            var max_delay = app.config.useCsmsMessages ? 1600 : 500;
            var showDR = function () {
                app.showErrorDeclineRecoveryPopup(data, details.apmErrorMsg, details.reference, info);
                pubsub.unsubscribe(obj);
                clearTimeout(timeoutId);
            }
            obj = pubsub.subscribe('app.event.PMDataAvailable', showDR);
            timeoutId = setTimeout(showDR, max_delay);
        }
    }

    /***************  showLastTrxStatus helpers End  *************/
};

app.util.showPtWarnings = function (ptWarnings) {
    if (!_.isEmpty(ptWarnings)) {
        if (ptWarnings.showWithdrawalsOnDeposit) {
            function onModalShows() {
                var $plugin_type_lb_withdrawals = $('div[data-plugin-type="lb_withdrawals"]');
                if ($plugin_type_lb_withdrawals.length) {
                    var wd_list_opt = app.util.normalizePMWithdrawListOpts(app.pluginOpts.PMWithdrawList);
                    wd_list_opt.inLightbox = true;
                    $plugin_type_lb_withdrawals.PMWithdrawList(wd_list_opt);
                    app.util.withdrawalRequests();
                }
            }

            app.showModalMessage({details: ptWarnings}, 'pending_wd_list', null, null, null, null, onModalShows);
        } else {
            app.showModalMessage({details: ptWarnings}, ptWarnings.type.toLowerCase());
        }
    }
};

app.util.modifyConfigParam = function (param_name, param_value) {
    if (param_name) {
        app.config[param_name] = param_value;
        app[param_name] = param_value;
    }
};

app.util.getCurrentMethodInfo = function () {
    var is_upo = app.util.isUpo(app.lastSelectedMethodId);
    return {
        id: app.lastSelectedMethodId,
        isUpo: is_upo,
        upoName: is_upo ? app._upoList[app.lastSelectedMethodId].name : '',
        pmName: app.lastSelectedMethodType,
        pmPosition: app.lastSelectedMethodData.pmPosition,
        isRebilling: app.config.isRebilling,
        card_detected: app.lastCardDetected,
        feRef: app._lastFeRef,
        amount: app.lastSelectedAmount,
        currency: app.lastSelectedCurrency
    }
};

app.util.getSubmitAttemptFailedData = function (asyncCheckInProgress) {
    var dataToSend = app.util.getCurrentMethodInfo();
    dataToSend.asyncCheckInProgress = asyncCheckInProgress;
    dataToSend.errors = Object.keys(app._validationResult);
    return dataToSend;
};

app.util.getFieldValue = function (fieldName) {
    var $field = $("#" + fieldName);
    var fieldVal;
    if ($field.length) {
        fieldVal = $field.val();
    } else {
        var $radioArr = $('input[type="radio"][name="' + fieldName + '"]');
        if ($radioArr.length) {
            fieldVal = $radioArr.filter(":checked").val();
        }
    }
    return fieldVal;
};

app.util.isPartialChoiceConfirmation = function (evtData) {
    var data = evtData && (evtData.details || evtData);
    return data && data.isPartialChoiceConfirmationResponse;
};

app.util.FeRef = (function (){
    var FR = {
        _g: {
            archive: [],
            refArr: [],
            ref: {},
            pattern: 'fexxx_yyy_zzz'
        },
        _rand: Math.random() * 100000 | 0
    };
    FR._addToArchive = function (feRef) {
        FR._g.archive.push($.extend(true, {time: Date.now(), feRef: feRef}, FR._g.ref[feRef]));
    };
    FR._getCopyOf = function (val) {
        return (_.isObject(val)) ? $.extend(true, {}, {v: val}).v : val;
    };
    FR._appendRefFld = function () {
        var $pppForm = app.bodyElm.find('#PPPParametersForm');
        if ($pppForm.length && !$pppForm.find('input#feRef').length) {
            var i = $('<input id="feRef" type="hidden" name="feRef" value="">');
            $pppForm.append(i);
        }
    };
    FR.generateRef = function (last_ref) {
        var _ref = FR.getLastRef();
        var nrf;
        if (!_ref || last_ref === _ref || last_ref === $('#feRef').val()) {
            nrf = FR._g.pattern.replace('xxx', app.config.msid).replace('yyy', Date.now().toString(16)).replace('zzz', FR._rand++);
            FR.setupRef(nrf);
        }
        return nrf;
    };
    FR.setupRef = function (rf) {
        FR._g.refArr.push(rf);
        FR._g.ref[rf] = {};
        $('#feRef').val(rf);
        app._lastFeRef = rf;
    };
    FR.getLastRef = function () {
        return FR._g.refArr.length && FR._g.refArr[FR._g.refArr.length - 1];
    };
    FR.exists = function (feRef) {
        return !!(feRef && FR._g.ref[feRef]);
    };
    FR.getRefData = function (feRef) {
        return $.extend(true, {}, FR._g.ref[feRef]);
    };
    FR.setRefData = function (feRef, prop, val) {
        if (FR.exists(feRef) && prop) {
            if (FR._g.ref[feRef][prop]) {
                FR._addToArchive(feRef);
            }
            FR._g.ref[feRef][prop] = FR._getCopyOf(val);
        }
        return val;
    };
    FR.isRefUsed = function (feRef) {
        return !!(FR._g.ref[feRef] && FR._g.ref[feRef].submittedMethod);
    };
    FR.init = function (lastTrxRef) {
        if (FR._g.initDone) {
            return;
        }
        FR._g.initDone = true;
        FR._appendRefFld();
        if (lastTrxRef) {
            var prevRand = parseInt(lastTrxRef.split('_')[2]);
            FR._rand = prevRand && ++prevRand || FR._rand;
            FR.setupRef(lastTrxRef);
        } else {
            FR.generateRef(lastTrxRef);
        }
    };

    return {
        init: FR.init,
        generateNext: FR.generateRef,
        getLast: FR.getLastRef,
        isUsed: FR.isRefUsed,
        getRefData: FR.getRefData,
        setRefData: FR.setRefData,
        isValid: FR.exists
    }
})();

app.util.updatePaytoPayIdFld = function() {
    var payIdType = app.util.getFieldValue("payto_pay_id_type");
    var $payId = $("#payto_pay_id");
    var payIdLabel = getPayIdLabel(payIdType);

    function getPayIdLabel(payIdType) {
        var option;
        if (app.lastSelectedMethodData &&
                app.lastSelectedMethodData.dropDowns &&
                app.lastSelectedMethodData.dropDowns.payto_pay_id_type) {
            option = app.lastSelectedMethodData.dropDowns.payto_pay_id_type.find(function(option) {
                return option.value === payIdType;
            });
        }
        return option && option.text || "";
    }

    if ($payId.val()) {
        app.util.triggerFldValidation("payto_pay_id", "custom");
    }
    if (payIdLabel) {
        $("label[for='payto_pay_id']").text(payIdLabel);
        if ($payId.attr("placeholder")) {
            $payId.attr("placeholder", payIdLabel);
        }
    }
    if (payIdType === "PhoneNumber") {
        $payId.attr("type", "tel");
        $payId.closest(".row").find(".field_help").removeClass("hidden");
    } else {
        $payId.attr("type", payIdType === "Email" ? "email" : "text");
        $payId.closest(".row").find(".field_help").addClass("hidden");
    }
};

app.util.getFunctionByName = function (string) {
    var a = (string || '').split(".");
    var f = window;
    a.forEach(function (v, i) {
        if (f && v && f[v]) {
            f = f[v];
        } else {
            f = false;
        }
    });
    return (f && f !== window && _.isFunction(f)) ? f : false;
};

app.util.checkIsUpoRedirect = function (upoId) {
    var isIframeStr = app._pmFields[upoId] && app._pmFields[upoId].isIframe && app._pmFields[upoId].isIframe.toString() || '';
    return (isIframeStr !== 'true');
};

app.util.isCustomButtonNeededForUpo = function (cfg) {
    var shouldUseCustomBtn = cfg && cfg.forUpo;
    if (shouldUseCustomBtn && _.isString(cfg.forUpo)) {
        var fn = app.util.getFunctionByName(cfg.forUpo);
        shouldUseCustomBtn = fn && fn(app.lastSelectedMethodId);
    }
    return shouldUseCustomBtn;
};

app.util.generateCustomBtn = function (params) {
    if (params && params.fn) {
        var f = app.util.getFunctionByName(params.fn);
        if (f && _.isFunction(f)) {
            app.bodyElm.addClass(params.bodyClassName || 'custom_btn');
            var opt = params.args && params.args[0];
            if (_.isObject(opt) && opt.pmName && !opt.cfg) {
                opt.cfg = $.extend(true, {}, app.config.pmSettings[opt.pmName]);
            }
            return f.apply(null, params.args);
        }
    }
};

app.util.getCustomBtnContainer = function () {
    var $c = $('#customBtnContainer');
    if ($c.length) {
        $c.empty();
    } else {
        $c = $('<div id="customBtnContainer"></div>');
        var $submitBtn = ($('#preSubmitButton').length) ? $('#preSubmitButton') : $('#continueButton');
        $submitBtn.after($c);
    }
    $c.addClass('_invisible');
    return $c;
};

app.util.Ppl = (function IIFE() {
    var Ppl = {
        _g: {
            scriptLoadingStatus: 0,
            scriptLoadRetry: 0,
            attemptsCount: 0,
            scriptPromise: null,
            tmpBlocker: false,
            lastFundingSource: false,
            'venmo': {_flag: {}},
            'paypal': {_flag: {}},
            'paylater': {_flag: {}},
            paymentInProgress: false
        },
        cfg: {
            sdkUrls: [],
            apmgw_VenmoPP: {},
            apmgw_PayPal_SDK: {},
            apmgw_Pay_Later: {},
        },
        CONST: {
            SCRIPT_LOAD_TIMEOUT: 10000,
            SCRIPT_LOAD_MAX_RETRY: 3,
            INITIATOR: {
                ON_APPROVE: 'on_approve',
                ON_CANCEL: 'on_cancel',
                ON_ERROR: 'on_error'
            },
            PM_2_BTN: {
                apmgw_VenmoPP: 'venmo',
                apmgw_PayPal_SDK: 'paypal',
                apmgw_Pay_Later: 'paylater'
            },
            BTN_2_PM: {
                'venmo': 'apmgw_VenmoPP',
                'paypal': 'apmgw_PayPal_SDK',
                'paylater': 'apmgw_Pay_Later'
            }
        }
    };

    Ppl._logError = function (str) {
        var msg = 'PayPal script ERROR! => ' + str;
        app._logger.log(msg);
        console.log(msg, str);
    };
    Ppl._showError = function (errorStr) {
        errorStr === 'script_load_timeout' && (Ppl._g.tmpBlocker = 'script_load_timeout');
        app.util.addSuspendedPmBlocker(app.lastSelectedMethodId, null, errorStr);
        utils.renderBlockedPMReasons(app.lastSelectedMethodData);
        app.recalcUserDetailsArea();
    };
    Ppl._updateCfg = function (pmName, cfg) {
        var btn = Ppl.CONST.PM_2_BTN[pmName]
        if (cfg && btn && !Ppl._g[btn]._flag.cfgUpdated) {
            Ppl._g[btn]._flag.cfgUpdated = true;
            Object.keys(cfg).forEach(function (k, i, arr) {
                if (k === 'sdkUrls') {
                    // Don't update sdkUrls after the script is loaded
                    if (!Ppl._g.scriptLoadingStatus || (Ppl._g.scriptLoadingStatus === 500 && Ppl._g.scriptLoadRetry < Ppl.CONST.SCRIPT_LOAD_MAX_RETRY)) {
                        Ppl.cfg[k] = cfg[k];
                    }
                } else {
                    Ppl.cfg[pmName][k] = cfg[k];
                }
            });
        }
    };
    Ppl._hasButton = function (fundingSource) {
        if (fundingSource && Ppl._g[fundingSource] && Ppl._g[fundingSource].btn && Ppl._g[fundingSource].btn.isEligible()) {
            return Ppl._g[fundingSource].btnContainer && Ppl._g[fundingSource].btnContainer.length && Ppl._g[fundingSource].btnContainer.find('.paypal-buttons').length;
        }
        return false;
    };
    Ppl._getNormalizedCfg = function (pmName, amount, initiator) {
        var cfg = Ppl.cfg[pmName] || {};
        if (pmName === "apmgw_Pay_Later"
            && amount
            && cfg.btn_message
            && cfg.btn_message.amount !== amount
        ) {
            cfg = $.extend(true, {}, cfg, {btn_message: {amount: amount}});
            if (!cfg.btn_message.color) {
                cfg.btn_message.color = app.colorSettings.apple_btn_style;
            }
        }
        return cfg;
    };
    Ppl._handleBtnState = function (initiator, field, amount) {
        var fundingSource = Ppl.CONST.PM_2_BTN[app.lastSelectedMethodType];
        var buttonState = Ppl._g[fundingSource];
        if (!buttonState || (initiator === 'fieldBlurSuccess' && buttonState.isEnabled) || (initiator === 'fieldBlurFail' && !buttonState.isEnabled)) {
            return;
        } else if (Ppl._hasButton(fundingSource) && window.paypal && buttonState.enableBtn && buttonState.disableBtn) {
            var isValid = app.validateForm(null, true);
            Ppl._setBtnState(fundingSource, isValid);

            if (app.lastSelectedMethodType === "apmgw_Pay_Later"
                && isValid
                && amount
                && buttonState.btn
                && Ppl.cfg[app.lastSelectedMethodType]
                && Ppl.cfg[app.lastSelectedMethodType].btn_message
                && Ppl.cfg[app.lastSelectedMethodType].btn_message.amount !== amount
            ) {
                var new_msg = $.extend(true, {}, Ppl.cfg[app.lastSelectedMethodType].btn_message, {amount: amount});
                if (!new_msg.color) {
                    new_msg.color = app.colorSettings.apple_btn_style; // black | white
                }
                buttonState.btn.updateProps({message: new_msg});
            }
        }
    };
    Ppl._setBtnState = function (fundingSource, isValid) {
        var buttonState = Ppl._g[fundingSource];
        if (Ppl._hasButton(fundingSource) && window.paypal && buttonState.enableBtn && buttonState.disableBtn) {
            if (isValid && !buttonState.isEnabled) {
                buttonState.enableBtn();
            } else if (!isValid && buttonState.isEnabled) {
                buttonState.disableBtn();
            }
            buttonState.isEnabled = isValid;
        }
    };
    Ppl._clearBtnState = function (fundingSource, isValid) {
        Ppl._g[fundingSource] && (Ppl._g[fundingSource] = {_flag: {}});
    };

    Ppl._renderBtn = function fs(opt) {
        var button;
        var pmName = opt && opt.pmName;
        var fundingSource = Ppl.CONST.PM_2_BTN[pmName];
        if (app.lastSelectedMethodType !== pmName || !fundingSource || !Ppl.isFundingEligible(pmName, opt)) {
            return;
        }
        if (Ppl._g.tmpBlocker) {
            // tmpBlocker is not relevant anymore
            app.util.removePmBlocker(app.lastSelectedMethodId, Ppl._g.tmpBlocker);
        }
        if (!Ppl._hasButton(fundingSource)) {
            var cfg = Ppl._getNormalizedCfg(pmName, app.lastSelectedAmount, 'renderBtn');
            var opts = {
                fundingSource: fundingSource,
                style: cfg.btn_style,
                message: cfg.btn_message,
                onInit: function (data, actions) {
                    Ppl._g[fundingSource].disableBtn = actions.disable;
                    Ppl._g[fundingSource].enableBtn = actions.enable;
                    Ppl._g[fundingSource].isEnabled = true;
                    var isValid = app.validateForm();
                    Ppl._setBtnState(fundingSource, isValid);
                },
                onClick: function (data) {
                    Ppl._g.lastFundingSource = data.fundingSource;
                    var isValid = app.validateForm();
                    pubsub.publish('app.event.DepositClicked', [{pmName: Ppl.CONST.BTN_2_PM[data.fundingSource]}]);
                    if (!isValid) {
                        pubsub.publish('submit-attempt-failed', [app.util.getSubmitAttemptFailedData(false)]);
                    }
                    Ppl._setBtnState(data.fundingSource, isValid);
                    return isValid;
                },
                onApprove: function (data, actions) {
                    Ppl.finalizeTransaction(Ppl._g[fundingSource].beResponse, Ppl.CONST.INITIATOR.ON_APPROVE, data);
                },
                onCancel: function (data) {
                    Ppl.finalizeTransaction(Ppl._g[fundingSource].beResponse, Ppl.CONST.INITIATOR.ON_CANCEL, data);
                },
                onError: function (err) {
                    Ppl.finalizeTransaction(Ppl._g[fundingSource].beResponse, Ppl.CONST.INITIATOR.ON_ERROR, err);
                }
            };
            var isAuthOnly = !parseFloat(app.lastSelectedAmount);
            opts[(isAuthOnly ? "createVaultSetupToken" : "createOrder")] = function (data, actions) {
                var promise1 = new Promise(function(resolve, reject) {
                    Ppl._g[fundingSource].pResolve = resolve;
                    Ppl._g[fundingSource].pReject = reject;
                }).then(function (orderId) {
                    return orderId; // ~ return orderId || token
                }).catch(function (err) {
                    return false;
                });
                Ppl._submitFormWithPplData();
                return promise1;
            };
            button = paypal.Buttons(opts);
            Ppl._g[fundingSource].btn = button;
        }
        if (button && button.isEligible()) {
            if (!opt.btnContainer) {
                Ppl._g[fundingSource].btnContainer = app.util.getCustomBtnContainer();
                opt.btnContainer = Ppl._g[fundingSource].btnContainer.attr('id');
            } else {
                Ppl._g[fundingSource].btnContainer = $('#' + opt.btnContainer);
            }
            button.render(Ppl._g[fundingSource].btnContainer[0]);
            Ppl._g[fundingSource].btnContainer.removeClass('_invisible');
        } else {
            Ppl._showError('po_not_eligible');
        }
    };

    Ppl._regiserPubsubEvents = (function () {
        var _evt = {};
        return function () {
            if (!_evt['select-pm']) {
                _evt['select-pm'] = true;
                pubsub.subscribe('select-pm', function (data) {
                    if (Ppl._g.paymentInProgress) {
                        Ppl._clearBtnState(Ppl._g.paymentInProgress.fundingSource);
                        Ppl._g.paymentInProgress = false;
                    }
                });
            }
            if (!_evt['safecharge.transaction.complete']) {
                _evt['safecharge.transaction.complete'] = true;
                pubsub.subscribe('safecharge.transaction.complete', function (data) {
                    var pmName = data && data.details && data.details.payment_method;
                    if (Ppl._g.paymentInProgress
                        && Ppl._g.paymentInProgress.fundingSource === Ppl.CONST.PM_2_BTN[pmName]
                        && Ppl._g.paymentInProgress.step === 2
                    ) {
                        Ppl._clearBtnState(Ppl._g.paymentInProgress.fundingSource);
                        Ppl._g.paymentInProgress = false;
                    }
                });
            }
            if (!_evt['safecharge.createOrder.response']) {
                _evt['safecharge.createOrder.response'] = true;
                pubsub.subscribe('safecharge.createOrder.response', Ppl._onBeResponse);
            }
            if (!_evt['app.event.AmountChange']) {
                _evt['app.event.AmountChange'] = true;
                pubsub.subscribe('app.event.AmountChange', function (amount, ev_type, tag_name) {
                    if (Ppl.CONST.PM_2_BTN[app.lastSelectedMethodType]) {
                        Ppl._handleBtnState('AmountChange', 'item_amount_1', amount);
                    }
                });
            }
            if (!_evt['safecharge.generalFieldChange']) {
                _evt['safecharge.generalFieldChange'] = true;
                pubsub.subscribe('app.event.directFlowCheckbox.change', function (data) {
                    Ppl._handleBtnState('directFlowCheckbox', data['field']);
                    // 'checkbox_state': data['isChecked'] ? 'on' : 'off'
                });
                pubsub.subscribe('app.event.fieldBlurFail', function (field, errKey, eventType) {
                    if (eventType === 'blur' || (eventType === 'change' && field.startsWith("expiration_period"))) {
                        Ppl._handleBtnState('fieldBlurFail', field);
                    }
                });
                pubsub.subscribe('app.event.fieldBlurSuccess', function (field, eventType) {
                    if (eventType === 'blur' || (eventType === 'change' && field.startsWith("expiration_period"))) {
                        Ppl._handleBtnState('fieldBlurSuccess', field);
                    }
                });
            }
        }
    })();
    Ppl._submitFormWithPplData = function (payload) {
        if (Ppl._g.paymentInProgress) {
            return;
        }
        if (payload) {
            app.util.addTmpFormData({ppData: JSON.stringify(payload)});
        }
        $('#inIframeMode').val('true');
        $('#inPopupMode').val('false');
        var fundingSource = Ppl.CONST.PM_2_BTN[app.lastSelectedMethodType];
        Ppl._g.paymentInProgress = {payload: payload, fundingSource: fundingSource, step: 1};
        if (app.config.isRebilling) {
            app.sub.doSubscribe();
        } else {
            submitInIframe();
        }
    };
    Ppl._onBeResponse = function (payload) {
        var details = payload && payload.details || {};
        var orderId = details.orderId;
        var pmName = details.payment_method;
        var fundingSource = Ppl.CONST.PM_2_BTN[pmName];
        if (!fundingSource || !Ppl._g[fundingSource]) {
            return;
        }
        Ppl._g[fundingSource].beResponse = details;
        details.feRef && app.util.FeRef.setRefData(details.feRef, "createOrderResp", payload);
        if (orderId) {
            Ppl._g[fundingSource].pResolve(orderId);
        } else {
            Ppl._g[fundingSource].pReject(payload);
            Ppl._showError('cantFinalizeTransaction');
        }
    };
    Ppl.finalizeTransaction = function (data, initiator, ppl_dta) {
        var pplOrderId = ppl_dta && ppl_dta.orderID;
        var url;
        if (initiator === Ppl.CONST.INITIATOR.ON_APPROVE) {
            url = data && data.successUrl;
        } else if (initiator === Ppl.CONST.INITIATOR.ON_ERROR || initiator === Ppl.CONST.INITIATOR.ON_CANCEL) {
            url = data && data.errorUrl;
        }
        if (url && (!pplOrderId || pplOrderId === data.orderId)) {
            Ppl._g.paymentInProgress.step = 2;
            var _url = utils.addQueryStringParams(url, {
                'orderId': data.orderId,
                'payment_method': data.payment_method,
                'uniqueId': data.uniqueId,
                'feRef': data.feRef,
                'ssid': app.config.ssid
            });
            app.util.setupTargetIFrame();
            $('#targetIFrame').attr('src', _url);
        } else {
            Ppl._logError('finalizeTransaction: No URL to navigate to! orderID= ' + pplOrderId);
            Ppl._showError("cantFinalizeTransaction");
            Ppl._g.paymentInProgress = false;
        }
    };
    Ppl.isFundingEligible = function (pmName, opt) {
        if (Ppl._g.scriptLoadingStatus === 200 && window.paypal) {
            var fundingSource = Ppl.CONST.PM_2_BTN[pmName];
            return fundingSource && paypal.isFundingEligible(fundingSource);
        } else {
            return false;
        }
    };
    Ppl.createBtn = function (opt) {
        var fundingSource = Ppl.CONST.PM_2_BTN[opt && opt.pmName];
        if (!opt || !opt.pmName || !fundingSource) {
            return;
        }
        Ppl._g.lastFundingSource = fundingSource;
        if (Ppl._g.scriptLoadingStatus === 200 && window.paypal) {
            if (app.lastSelectedMethodType === opt.pmName) {
                Ppl._updateCfg(opt.pmName, opt.cfg);
                Ppl._renderBtn(opt);
            }
        } else if (opt.pmName && opt.cfg) {
            Ppl._init(opt.pmName, opt.cfg).then(function (d) {
                if (app.lastSelectedMethodType === opt.pmName) {
                    Ppl._renderBtn(opt);
                }
            }).catch(Ppl._handlePplError);
        } else {
            Ppl._handlePplError('missing_cfg');
        }
    };
    Ppl._handlePplError = function (err) {
        Ppl._logError(err && JSON.stringify(err) || 'unknown_error');
        err = err || {};
        if (err.code === 'CLIENT_AUTHORIZATION_INVALID') {
            Ppl._showError('invalid_authorization');
        } else if (err.key === 'script_load_timeout') {
            Ppl._showError('script_load_timeout');
        } else {
            Ppl._showError(err.key || 'other_error');
        }
    };

    Ppl._loadScripts = function () {
        if (Ppl.cfg.sdkUrls.length &&
            (!Ppl._g.scriptLoadingStatus || (Ppl._g.scriptLoadingStatus === 500 && Ppl._g.scriptLoadRetry < Ppl.CONST.SCRIPT_LOAD_MAX_RETRY))
        ) {
            Ppl._g.scriptLoadRetry++;
            Ppl._g.scriptLoadingStatus = 1;
            Ppl._g.scriptPromise = new Promise(function (resolve, reject) {
                var count = 0;
                Ppl.cfg.sdkUrls.forEach(function (script) {
                    $.ajax({
                        type: "GET",
                        url: script,
                        success: function () {
                            if (++count === Ppl.cfg.sdkUrls.length) {
                                resolve({msg: "script_load_done"});
                            }
                        },
                        dataType: "script",
                        cache: true
                    });
                });
                setTimeout(function () {
                    reject({key: 'script_load_timeout', msg: "Can not load scripts!"});
                }, Ppl.CONST.SCRIPT_LOAD_TIMEOUT);
            });
            Ppl._g.scriptPromise.then(function () {
                Ppl._g.scriptLoadingStatus = 200;
                app.util.removePmBlocker(app.lastSelectedMethodId, Ppl._g.tmpBlocker);
            }).catch(function () {
                Ppl._g.scriptLoadingStatus = 500;
            });
        } else {
            Ppl._g.scriptLoadingStatus = 500;
            Ppl._g.scriptPromise = Promise.reject({key: "script_load_timeout", msg: "Missing script url!"});
        }
        return Ppl._g.scriptPromise;
    };
    Ppl._init = function (pmName, cfg) {
        Ppl._updateCfg(pmName, cfg);
        if (Ppl._g.scriptLoadingStatus === 200) {
            return Ppl._g.scriptPromise;
        }
        Ppl._regiserPubsubEvents();
        return Ppl._loadScripts()
            // .then(function (d) {...})
            .catch(Ppl._handlePplError);
    };

    return {
        createBtn: Ppl.createBtn,
        isFundingEligible: Ppl.isFundingEligible,
    }
})();

app.util.Bancontact = (function () {
    var Bct = {
        _g: {
            frame: false,
            origin: document.location.origin,
            last_val: ''
        }
    };
    Bct._sendMessageToFrame = function (msg) {
        if (msg && Bct._g.frame) {
            Bct._g.frame.postMessage(JSON.stringify(msg), Bct._g.origin);
        }
    };
    Bct._sendNOK = function (errors) {
        errors || (errors = {
            cc_card_number: {
                message: "Please enter a valid card number.",
                validatorKey: "isValidCardNumber"
            }
        });
        Bct._sendMessageToFrame({action: "submitCardDetailsResult", status: "nok", errors: errors});
    };
    Bct._onCardRecognitionComplete = function (r, val) {
        if (!r || Bct._g.last_val !== val) {
            return;
        }

        if (r.isCardAllowed
            && (r.cardBrand === 'bancontact' || r.cardBrand2 === 'bancontact')
            && app.lastSelectedMethodType === "apmgw_Bancontact_DI"
            && app.util.validateField('cc_card_number', val, '', 'custom')
        ) {
            var pubsubObj = pubsub.subscribe('post-pm-render', function (data) {
                pubsub.unsubscribe(pubsubObj);
                Bct._populateAndSubmit(Bct._g._card);
            });
            app.selectPM("bancontact_cc_card");
        } else {
            Bct._sendNOK();
        }
    };
    Bct._populateAndSubmit = function (card) {
        if (app.lastSelectedMethodId !== "bancontact_cc_card") {
            return;
        }
        $('#cc_exp_year').val((card.cc_exp_year || '').substr(-2));
        $('#cc_exp_month').val(card.cc_exp_month);
        $('#cc_card_number').val(card.cc_card_number);
        $('#cc_name_on_card').val(card.cc_name_on_card);
        if (app.validateForm()) {
            app.util.FeRef.setRefData(app._lastFeRef, "trxAborted", {message: "switch to bancontact_cc_card"});
            submitForm();
        } else {
            Bct._sendNOK(app._validationResult);
        }
    };

    Bct.onMessage = function (data, origin) {
        if (!data
            || data.sender !== 'bancontact_page'
            || app.lastSelectedMethodType !== "apmgw_Bancontact_DI"
            || origin !== Bct._g.origin
        ) {
            return;
        }
        var ifrm = $('#targetIFrame')[0];
        Bct._g.frame = ifrm && ifrm.contentWindow;
        if (data.action === 'isPmEnabled' && data.pm === "bancontact_cc_card") {
            var resp = {
                pm: "bancontact_cc_card",
                action: "isPmEnabledResult",
                enabled: !!app._poList.bancontact_cc_card
            };
            Bct._sendMessageToFrame(resp);
        } else if (data.action === 'submitCardDetails' && data.card) {
            var val = data.card.cc_card_number;
            Bct._g._card = data.card;
            Bct._g.last_val = val;
            if (!app._poList.bancontact_cc_card) {
                Bct._sendNOK({general: {validatorKey: "missing_pm"}});
            } else if (
                utils.useDualCardBrands() && utils.checks.isCardNumber(val, {})
                || utils.checks.isValidCardNumber(val, app.util.normalizeValidationParamsObject(app.validators.cc_card_number.isCardAcceptable, 'isValidCardNumber'))
            ) {
                app.util.asyncCheck.cardDetails(val, Bct._onCardRecognitionComplete);
            } else {
                Bct._sendNOK();
            }
        }

    };
    return {
        onMessage: Bct.onMessage
    }
})();

app.util.getLoadScriptPromise = function loadScriptPromise(url, timeout) {
    timeout || (timeout = 3000);
    var d = new $.Deferred();
    var tId = setTimeout(function () {
        clearTimeout(tId);
        d.reject({result: false, msg: "script_load_timeout"});
    }, timeout);
    $.getScript(url, _cb);

    function _cb(script, textStatus) {
        clearTimeout(tId);
        d.resolve({result: true, msg: "script_loaded", status: textStatus});
    }
    return d.promise();
};
